module.exports = {
  Cargo_CreatBy: 'Автор котировки',
  Cargo_TrunkLine: 'Магистраль',
  Cargo_Inquiry_MissingBusinessCannotSubmit: 'Для типа {0} не выбран бизнес, отправка невозможна',
  Cargo_100Million: 'Миллиарды',
  Cargo_10Cents: 'Угол',
  Cargo_1St: 'Первый.',
  Cargo_1StInvoiceNo: 'Номер первого счета.',
  Cargo_1Year: 'Год',
  Cargo_2NdDispatch: 'Вторичная доставка',
  Cargo_2NdDispatchTime: 'Время вторичной отправки',
  Cargo_2NdReleaseTime: 'Время вторичного выпуска',
  Cargo_2NdTransitAirportAir: 'Транзитный рейс 2 (аэропорт)',
  Cargo_2StUnit: 'Вторая единица',
  Cargo_2Years: 'Два года',
  Cargo_30DaysShpt: '30 дней (Билеты)',
  Cargo_3RdParty: 'Третья сторона',
  Cargo_3RdTransitAirportAir: 'Три транзита (аэропорт)',
  Cargo_3Years: 'Три года',
  Cargo_60DaysShpt: '60 дней (Билеты)',
  Cargo_90DaysShpt: '90 дней (Билеты)',
  Cargo_AAPACRIG: 'В качестве аванса создайте соответствующую запись!',
  Cargo_AbandonThisVoucher: 'Подтвердить отказ от этого документа?',
  Cargo_Abbreviation: 'Сокращения',
  Cargo_AbbreviationOfConsignor: 'Подразделение - заказчик (сокращенно)',
  Cargo_ABCDC: 'Подтверждаются, из которых {0} подтверждены.',
  Cargo_MessageTip1: 'У вас есть',
  Cargo_MessageTip2: 'Статья Непрочитанное напоминание.',
  Cargo_Abstract: 'Резюме',
  Cargo_AbstractRuleOfJournalEntry: 'Правило составления резюме',
  Cargo_ABYBPSTCI23M: 'АА - Ежегодные торги, в зависимости от ситуации можно посмотреть в течение 2 - 3 месяцев.',
  Cargo_Accepted: 'Принято',
  Cargo_AccordingBillExchangeRate: 'По курсу счета',
  Cargo_AccordingForStatementFxRate: 'По курсу счета - фактуры',
  Cargo_AccountClosedSuccessfully: 'Закрытие счетов завершено.',
  Cargo_AccountInForeignCurrency: 'Учет в первоначальной валюте?',
  Cargo_AccountingMethod: 'Порядок учета',
  Cargo_AccountingOrganizationCode: 'Код организации учета',
  Cargo_AccountingQuantity: 'Количественный учет',
  Cargo_AccountingVoucher: 'Бухгалтерская документация',
  Cargo_AccountPeriod: 'Период',
  Cargo_AccountPeriodDay: 'Период счета (дней)',
  Cargo_AccountQuantityOrNot: 'Учитываются ли они количественно?',
  Cargo_AccountsReconciliation: 'Выверка операций',
  Cargo_AccountsReconciliation2: 'Выверка счетов 2',
  Cargo_AccountStatement: 'Счета - фактуры',
  Cargo_AccountStatementNo: 'Номер выверки',
  Cargo_AccountStatementNoP: 'Номер выверки:',
  Cargo_AccountTitle: 'Предметы',
  Cargo_AccountTitle2: 'Предметы 2',
  Cargo_AccountTitleCanTBeEmpty: 'Предметы не могут быть пустыми',
  Cargo_AccountTitleCategory: 'Категории предметов',
  Cargo_AccountTitleClassification: 'Классификация предметов',
  Cargo_AccountTitleClassificationRule: 'Правила классификации предметов',
  Cargo_AccountTitleCode: 'Код предмета',
  Cargo_AccountTitleCodeCanTBeEmpty: 'Код предмета не может быть пустым.',
  Cargo_AccountTitleCodeP: 'Код предмета:',
  Cargo_AccountTitleGroupingCondition1: 'Условия группирования предметов 1.',
  Cargo_AccountTitleGroupingCondition2: 'Условия группирования предметов 2.',
  Cargo_AccountTitleGroupingCondition3: 'Условия группирования предметов 3.',
  Cargo_AccountTitleGroupingCondition4: 'Условия группирования предметов 4.',
  Cargo_AccountTitleGroupingCondition5: 'Условия группирования 5.',
  Cargo_AccountTitleGroupingCondition6: 'Условия группирования предметов 6.',
  Cargo_AccountTitleLevel: 'Уровень предмета',
  Cargo_AccountTitleMapping: 'Отображение предметов',
  Cargo_AccountTitleName: 'Название предмета',
  Cargo_AccountTitleNameCanTBeEmpty: 'Название предмета не может быть пустым.',
  Cargo_AccountTitleNameP: 'Название предмета:',
  Cargo_AccountTitleOfProfitNotAllocated: 'Статья нераспределенной прибыли',
  Cargo_AccountTitleOfProfitNotAllocatedP: 'Нераспределенная прибыль:',
  Cargo_AccrualDate: 'Дата представления',
  Cargo_JobAccrualDate: 'Дата оперативного предложения',
  Cargo_AccrualReview: 'Запланированный аудит',
  Cargo_AccrualStatus: 'Состояние вычисления',
  Cargo_Accrue: 'А',
  Cargo_Accrued: 'Запланировано',
  Cargo_UsersAlreadyProvisionedToday: 'Существуют пользователи, которые уже были начислены сегодня, пожалуйста, проверьте',
  Cargo_AccumulatedCommissionProfit: 'Накопленная прибыль',
  Cargo_AConsiderChangeIfOffersCheap: 'А - Подумайте, пока дешево.',
  Cargo_ACPCOIM: 'Система закрывает счет, будьте терпеливы и попробуйте позже.',
  Cargo_Acquired: 'Принято',
  Cargo_AcquireFilteredExpenseList: 'Получение списка расходов на фильтрацию',
  Cargo_Acquirer: 'Работодатель',
  Cargo_AcquirerCanTBeEmpty: 'Руководитель не может быть пустым.',
  Cargo_AcquireSelectedItems: 'Получение выбранного объекта',
  Cargo_AcquireTotalAROrAPAmount: 'Получение общей суммы к получению',
  Cargo_Acquisition: 'Доступ',
  Cargo_AcquisitionRecord: 'Доступ к записям',
  Cargo_AcquisitionTime: 'Время получения',
  Cargo_AcquisitionTimeCanTBeEmpty: 'Время получения не может быть пустым.',
  Cargo_ACSWASRATBTSWEAC: 'После подтверждения система автоматически установит выверенную сумму на ту же сумму, что и стоимость, и будет ли она продолжаться?',
  Cargo_ACSWASRATBTSWEANCOWOEWNBPC: 'Все выверенные суммы будут устанавливаться в зависимости от суммы расходов, а подтвержденные или списанные расходы будут игнорироваться и будут ли продолжаться?',
  Cargo_ThereAreAlreadyExportedVouchers: 'Существуют экспортированные сертификаты.',
  Cargo_ActualChargedWeight: 'Фактический вес',
  Cargo_ActualGrossWeight: 'Фактический вес брутто',
  Cargo_ActualQuantity: 'Фактическое число',
  Cargo_ActualReceiptAmount: 'Полученные суммы',
  Cargo_ActualReceiptAndPayment: 'Полученные платежи',
  Cargo_ActualVolume: 'Фактический объем',
  Cargo_ActualWeight: 'Фактический вес',
  Cargo_ActualWriteOffAmountRequired: 'Фактические потребности в списании',
  Cargo_OnlyImportedCurrentBranch: 'Импортировать только расходы операционного филиала для текущего филиала',
  Cargo_Add: 'Дополнительные',
  Cargo_AddAdjustBill: 'Увеличение корректировки (счет)',
  Cargo_AddAirBooking: 'Дополнительные заказы на воздушные перевозки',
  Cargo_AddRailwayBooking: 'Дополнительный железнодорожный резерв',
  Cargo_RailwayBooking: 'Железнодорожный резерв',
  Cargo_AddAirFreightServiceItems: 'Дополнительные услуги по авиаперевозкам',
  Cargo_AddAssetAccountTitle: 'Дополнительные статьи активов',
  Cargo_AddAssociatedPort: 'Дополнительные ассоциированные порты',
  Cargo_AddAwbSurcharge: 'Дополнительные расходы на воздушные перевозки',
  Cargo_AddBasePort: 'Добавить базовый порт',
  Cargo_AddBill: 'Дополнительные счета',
  Cargo_AddBillCharge: 'Расходы на присоединение',
  Cargo_AddBLType: 'Новые виды коносаментов',
  Cargo_AddCashFlowItem: 'Дополнительные статьи движения денежной наличности',
  Cargo_AddCharges: 'Дополнительные расходы',
  Cargo_AddCostType: 'Добавить тип затрат',
  Cargo_EditFeeType: 'Редактировать тип сбора',
  Cargo_DeleteFeeType: 'Удалить тип сбора',
  Cargo_ImportFeeType: 'Импортировать тип сбора',
  Cargo_SelectBusinessOperation: 'Пожалуйста, выберите правильную операцию бизнеса',
  Cargo_SelectSameDelegateUnit: 'Пожалуйста, выберите бизнес с тем же делегированным подразделением',
  Cargo_SelectSameBusinessType: 'Пожалуйста, выберите бизнес с тем же типом бизнеса',
  Cargo_SelectSameFbaStatus: 'Пожалуйста, выберите бизнес с одинаковым статусом FBA',
  Cargo_SelectSameBusinessTypeWithJobNo: 'Тип бизнеса не совпадает: {baseJobNo} и {currentJobNo}. Пожалуйста, выберите бизнес с одинаковым типом',
  Cargo_SelectSameFbaStatusWithJobNo: 'Статус FBA не совпадает: {baseJobNo} и {currentJobNo}. Пожалуйста, выберите бизнес с одинаковым статусом FBA',
  Cargo_SelectFeeType: 'Пожалуйста, выберите тип сбора!',
  Cargo_ReceivablePayableLocked: 'Выбранный бизнес имеет заблокированные дебиторскую и кредиторскую задолженность, данная операция не может быть выполнена!',
  Cargo_ReceivableLocked: 'Выбранный бизнес имеет заблокированную дебиторскую задолженность, данная операция не может быть выполнена!',
  Cargo_PayableLocked: 'Выбранный бизнес имеет заблокированную кредиторскую задолженность, данная операция не может быть выполнена!',
  Cargo_PleaseSelectTheManifestYouWishToDelete: 'Выберите манифест, который нужно удалить',
  Cargo_TheManifestYouWishToDeleteTips: '* Теплый совет: упаковочный лист удаления, должен быть удален в коробке вместе, поэтому манифест не может быть удален отдельно!',
  Cargo_ConfirmDelete: 'Подтвердить удаление',
  Cargo_AddCirculationDocumentType: 'Новые типы файлов потока',
  Cargo_AddClientType: 'Новые типы клиентов',
  Cargo_AddCollectionRecord: 'Регистрация дополнительного инкассо',
  Cargo_AddCommissionRules: 'Новые правила начисления',
  Cargo_AddContinent: 'Новые континенты',
  Cargo_AddContract: 'Дополнительные контракты',
  Cargo_AddCustomizedServiceType: 'Дополнительный тип бизнеса',
  Cargo_AddedAlreadyDoNotRepeat: '{0} Добавлены, не могут быть добавлены повторно.',
  Cargo_AddedSuccessfully: 'Новые успехи.',
  Cargo_AddFees: 'Дополнительные расходы',
  Cargo_AddHeadquartersToTheList: 'Включите штаб.',
  Cargo_AddJournalEntry: 'Добавить запись',
  Cargo_AddKeyword: 'Новые чувствительные слова',
  Cargo_AddMscService: 'Новая MSC Service',
  Cargo_AddNewSoaOrNot: 'Дополнительные счета',
  Cargo_AddRailwayStation: 'Добавить железнодорожную станцию',
  Cargo_AddressTelNo: 'Адрес / телефон',
  Cargo_AddressTelNoP: 'Адрес, телефон:',
  Cargo_AddRoute: 'Дополнительные маршруты',
  Cargo_AddSave: 'Добавить Сохранить',
  Cargo_AddSeaBooking: 'Дополнительные заказы на морские перевозки',
  Cargo_IntelligentDocumentRecognition: 'Интеллектуальное распознавание книг',
  Cargo_AddSoa: 'Дополнительные счета',
  Cargo_AddToBlackList: 'Присоединяйтесь к черному списку',
  Cargo_AdjustBillDate: 'Корректировка даты счета',
  Cargo_AdjustDate: 'Дата корректировки',
  Cargo_AdjustedItem: 'Корректировка',
  Cargo_AdjustedOrNot: 'Корректировка',
  Cargo_AdjustedSuccessfully: 'Корректировка прошла успешно.',
  Cargo_AdjustedValue: 'Корректировка',
  Cargo_AdjustExpenseOrNot: 'Корректировка расходов',
  Cargo_AdjustFxRateEndOfPeriod: 'Корректировка обменных курсов (на конец периода)',
  Cargo_AdjustmentDateCanTBeEmpty: 'Дата корректировки не может быть пустой.',
  Cargo_AdjustmentExpense: 'Расходы на корректировку',
  Cargo_AdjustmentExpenseState: 'Настройка состояния',
  Cargo_Advance: 'Авансовые платежи',
  Cargo_AdvanceAP: 'Авансы к выплате',
  Cargo_AdvanceAPDifferential: 'Разница между авансом и кредиторской задолженностью',
  Cargo_AdvanceChargeInfo: 'Авансы по инкассации',
  Cargo_AdvancedSearch: 'Дополнительный запрос',
  Cargo_AdvanceMoneyForAnotherOrNot: 'Является ли прокладка',
  Cargo_AdvanceOrNot: 'Предоплата',
  Cargo_AdvancePayment: 'Авансы',
  Cargo_AdvancePaymentAmount: 'Сумма аванса',
  Cargo_AdvancePaymentItem: 'Авансы',
  Cargo_AdvanceReceiptOrNot: 'Получено ли авансом',
  Cargo_AdvanceReceivedAmount: 'Сумма, полученная авансом',
  Cargo_AdvanceReceivedAmountIs: 'Сумма аванса составляет:',
  Cargo_AEBPWTCW1Y: 'AAA - Внутренние отношения с постоянным агентом по сотрудничеству не меняются в течение года',
  Cargo_AEFTSIST: 'Экспорт самолетов из Шанхая аналогичен',
  Cargo_AEIMBOUF: 'Обновление не удалось, стоимость была изменена другими.',
  Cargo_AEIMBOUFM: '{0} Обновление статьи не удалось, стоимость была изменена другими.',
  Cargo_AGEBDAWI: 'Расходы, автоматически возникающие в связи с корректировкой разницы при выставлении счетов.',
  Cargo_AgentBillNo: 'Номер счета',
  Cargo_Aging: 'Срок давности (дней)',
  Cargo_AgingOfCurrentBill: 'Срок действия векселя',
  Cargo_Agree: 'Согласен.',
  Cargo_AILCNETOCERCTS: 'Сумма в местной валюте не равна обменному курсу в оригинальной валюте *, сохраняется ли она?',
  Cargo_Air: 'Воздушные перевозки',
  Cargo_AirExport: 'Экспорт по воздуху',
  Cargo_AirImport: 'Импорт воздушным транспортом',
  Cargo_AirImportExport: 'Доступ воздушным транспортом',
  Cargo_Airline: 'Маршрут',
  Cargo_AirlineCode: 'Маршрутный код',
  Cargo_AirlineCompany: 'Авиакомпании',
  Cargo_ShippingCompanyName: 'Название судоходной компании на английском языке',
  Cargo_ShippingCompanyCode: 'Код судоходной компании',
  Cargo_ShippingCompanyScacCode: 'Компания SCAC CODE',
  Cargo_ShippingCompanyChineseName: 'Название компании на китайском языке',
  Cargo_ShippingCompanyEnglishName: 'Название судоходной компании на английском языке',
  Cargo_DataDuplication: 'Данные уже существуют, не добавляйте их повторно',
  Cargo_AdditionFailed: 'Новые неудачи',
  Cargo_DeleteShipCompany: 'Удалить выделенное сообщение? <br> Теплый совет: после удаления ссылок в арендаторе Удалить отдел по умолчанию',
  Cargo_AssociatedPlatformShippingCompany: 'Ассоциированная судоходная компания & lt; & lt; Платформа & gt; & gt;',
  Cargo_ShipCompanyThirdPartyCode: 'Код сторонней системы судоходной компании',
  Cargo_MblCode: 'Код коносамента',
  Cargo_AirlinePerson: 'Руководитель маршрута',
  Cargo_Airport: 'Аэропорт',
  Cargo_AirportOfDischarge: 'Порт разгрузки (аэропорт)',
  Cargo_AirService: 'Услуги по авиаперевозкам',
  Cargo_AlertConfiguration: 'Настройка напоминаний',
  Cargo_AlertDaysPriorToExpiryDate: 'До истечения срока * дней напоминания',
  Cargo_All: 'Все.',
  Cargo_AllB: '(Все)',
  Cargo_AllP: '【Все.】',
  Cargo_AllAmount: 'Всего',
  Cargo_AllAmountP: 'Всего:',
  Cargo_AllCurrencies: 'Все валюты',
  Cargo_AllForeignCurrencies: 'Все валюты',
  Cargo_AllSelectedBillsWrittenOff: 'Все отобранные счета были списаны.',
  Cargo_AllSelectedRecordsConfirmed: 'Все отобранные документы были подтверждены.',
  Cargo_AllSelectedSoaWrittenOff: 'Все отобранные выверки были списаны.',
  Cargo_WithoutDiscrepancies: 'Без разницы',
  Cargo_AllWithWithoutDiscrepancies: 'Все разница / нет разницы',
  Cargo_AllWrittenOff: 'Все распроданы.',
  Cargo_AlreadyAddedOrNot: 'Добавлено ли',
  Cargo_AmendmentFee: 'Расходы на перевод',
  Cargo_Amount: 'Сумма',
  Cargo_AmountF: 'Сумма в долл США.',
  Cargo_AmountCanTBeEmpty: 'Сумма не может быть пустой.',
  Cargo_AmountCanTBeZero: 'Сумма не может быть нулевой.',
  Cargo_AmountCNY: 'Сумма (CNY)',
  Cargo_AmountCNYP: 'Сумма CNY:',
  Cargo_AmountEnteredForReconciliation: 'Ввод выверенных сумм',
  Cargo_AmountIncurredOfCurrentPeriod: 'Текущий период',
  Cargo_AmountInOriginalCurrency: 'Сумма в первоначальной валюте',
  Cargo_AmountNotWrittenOff: 'Неизрасходованная сумма',
  Cargo_AmountNumber: 'Количество',
  Cargo_AmountNumberP: 'Количество:',
  Cargo_AmountOfActualCollectionPayment: 'Полученная сумма',
  Cargo_AmountOfCurrentMonth: 'Сумма за текущий месяц',
  Cargo_AmountOfPaidInOutOfPocket: 'Фактические поступления',
  Cargo_AmountOfPaymentApplication: 'Сумма заявки',
  Cargo_AmountRange: 'Диапазон сумм',
  Cargo_AmountRemark: 'Примечания к расходам',
  Cargo_AmountSum: 'Общая сумма',
  Cargo_AmountTo: 'Всего',
  Cargo_AmountToDetail: 'Общая информация',
  Cargo_CurrentMonthAmountTo: 'Всего за текущий месяц',
  Cargo_CurrentYearAmountTo: 'Всего за текущий год',
  Cargo_TotalReportingCurrencyOfThisMonth: 'Валюта в текущем месяце',
  Cargo_TotalReportingCurrencyOfThisYear: 'Валюта в текущем году',
  Cargo_AmountToCNY: 'Итого (CNY)',
  Cargo_AmountToP: 'Итого:',
  Cargo_AmountToUSD: 'Итого (USD)',
  Cargo_AmountUSD: 'Сумма USD',
  Cargo_AmountUSDP: 'Сумма USD:',
  Cargo_AmsEnsCyCutOffDate: 'Дата закрытия AMS / ENS',
  Cargo_Annual: 'Год',
  Cargo_AolAir: 'аэродром АЭР отправления',
  Cargo_AOPLVCTBE: 'Резюме документов о прибылях и убытках не может быть пустым',
  Cargo_APAR: 'К получению',
  Cargo_APBill: 'Счета к оплате',
  Cargo_APEOFINNPPARFV: 'Проверьте, пожалуйста, следующие номера счетов - фактур, подлежащие оплате, не были завершены для утверждения платежа: \ \ n',
  Cargo_APInclusive: 'Включая кредиторскую задолженность',
  Cargo_APInvoice: 'Счета к оплате',
  Cargo_Appendix: 'Приложение',
  Cargo_Applicant: 'Заявитель',
  Cargo_ApplicationDateApplicationDate: 'Дата подачи заявки',
  Cargo_ApplicationDateBusinessDate: 'Дата подачи заявки',
  Cargo_ApplicationFormSavedSuccessfully: 'Заявка успешно сохранена!',
  Cargo_ApplicationNo: 'Номер заявки',
  Cargo_ApplicationNoBill: '{0} Расходы по заявке № 1 не имеют счета - фактуры, номер операции - {1}',
  Cargo_ApplicationPermission: 'Права доступа',
  Cargo_ApplicationStatus: 'Статус заявки',
  Cargo_AppliedForPaymentOrNot: 'Были ли запрошены платежи',
  Cargo_ApplyForPayment: 'Заявки на оплату',
  Cargo_Approval: 'Утверждено',
  Cargo_ApprovalStatus: 'Статус утверждения',
  Cargo_Approved: 'Проверено',
  Cargo_ApprovedBy: 'Рецензор',
  Cargo_ApprovedStatue: 'Статус проверки',
  Cargo_April: 'Апрель',
  Cargo_APWriteOff: 'Счета кредиторов',
  Cargo_APWriteOffAmount: 'Сумма списанной кредиторской задолженности',
  Cargo_APWrittenOff: 'Средства, подлежащие списанию',
  Cargo_APWrittenOffP: 'Средства, подлежащие списанию:',
  Cargo_ARAges: 'Срок давности',
  Cargo_ARAmountCanTExceedAPAmount: 'Дебиторская задолженность не может превышать суммы подлежащей выплате.',
  Cargo_ARAP: 'Дебиторская задолженность',
  Cargo_ARAPItemsMustBeComplete: 'Дебиторская задолженность должна быть полностью учтена.',
  Cargo_ARBill: 'Счета дебиторов',
  Cargo_ARegularExportVolume20TeuMonthly: 'А. Стабилизация экспорта товаров на уровне 20 TEU в месяц.',
  Cargo_ARInvoice: 'Счета к получению',
  Cargo_ARIPFCSC: 'Ошибка выставления счетов - фактур к получению:',
  Cargo_ARNotWrittenOff: 'Дебиторская задолженность',
  Cargo_ARNotWrittenOffP: 'Дебиторская задолженность:',
  Cargo_AROrNot: 'Дебиторская задолженность',
  Cargo_InvoiceAROrNot: 'Счета к получению',
  Cargo_ArrivalDate: 'Дата прибытия',
  Cargo_ArrivalTime: 'Время прибытия',
  Cargo_ARWriteOffAmount: 'Сумма списанной дебиторской задолженности',
  Cargo_ARWrittenOff: 'Дебиторская задолженность списана',
  Cargo_ARWrittenOffP: 'Дебиторская задолженность списана:',
  Cargo_ASRCCTD: 'Выбранные записи полностью подтверждены и не могут быть отклонены',
  Cargo_AssessedClientLevel: 'Оценка клиентов',
  Cargo_AssignedClientsSuccessfully: 'Успешное распределение 0 клиентов',
  Cargo_AssignmentDate: 'Дата распределения',
  Cargo_AssignToMe: 'Выделите мне.',
  Cargo_AssociatedPort: 'Связанные порты',
  Cargo_ATCIJECTBE: 'Код предмета не может быть пустым.',
  Cargo_AttachedDocuments: 'Приложение',
  Cargo_Attachment: 'Приложение',
  Cargo_AttachmentP: 'Приложение:',
  Cargo_AttachmentInvoice: 'Приложение к счету - фактуре',
  Cargo_AttachmentStorage: 'Хранение вложений',
  Cargo_Audit: 'Проверка',
  Cargo_AuditDate: 'Дата проверки',
  Cargo_Auditor: 'Аудитор',
  Cargo_AuditorP: 'Аудитор:',
  Cargo_AuditStatus: 'Статус аудита',
  Cargo_AuditSuccessfully: 'Проверка прошла успешно',
  Cargo_AuditSuccessfullyF: 'Проверка прошла успешно.',
  Cargo_Guarantee: 'Гарантия',
  Cargo_GuaranteeName: 'Название гарантии',
  Cargo_GuaranteeType: 'Тип гарантии',
  Cargo_August: 'Август',
  Cargo_AuthorizedClient: 'Подразделение - заказчик',
  Cargo_AvailableBranch: 'Доступные филиалы',
  Cargo_AuthorizedCubage: 'Объем заказа',
  Cargo_AuthorizedQuantity: 'Число поручений',
  Cargo_AutomaticallyEnterInvoiceNumber: 'Автоматический ввод номера счета',
  Cargo_AutomaticGenerated: 'Автогенерирование',
  Cargo_AvailableOrNot: 'Доступно',
  Cargo_AverageMonthlyCargoVolume: 'Среднемесячный объем поставок',
  Cargo_AwaitBusinessApproval: 'Ожидает оперативного утверждения',
  Cargo_AwaitFinancialApproval: 'Ожидает утверждения в финансовом отношении',
  Cargo_Back: 'Возвращение',
  Cargo_BackgroundParameter: 'Фоновые параметры',
  Cargo_BackgroundProcessing: 'Фоновая обработка.',
  Cargo_BackgroundReturnedErrorStatus: 'Назад в неправильное состояние',
  Cargo_BackToCancel: 'Вернуться Отменить',
  Cargo_BackToInvoicingStatus: 'Возврат к списку',
  Cargo_BackToProcessingMethod: 'Обработка возврата',
  Cargo_BackToSearchResults: 'Вернуться к результатам запроса',
  Cargo_BaiwangInvoiceExport: 'InvoiceExport(Baiwang).xml',
  Cargo_Balance: 'Остаток',
  Cargo_BalanceCalculation: 'Расчет остатка',
  Cargo_BalanceCNY: 'Сальдо (в юанях)',
  Cargo_BalanceDirection: 'Направление сальдо',
  Cargo_BalanceOfActualCollectionPayment: 'Полученный остаток',
  Cargo_BalanceSheet: 'Ведомость активов и пассивов',
  Cargo_BalanceSheet2: 'Ведомость активов и пассивов2',
  Cargo_BalancesOfAccountTitle: 'Таблица остатков средств',
  Cargo_BalancesOfAccountTitle2: 'Таблица 2',
  Cargo_BalanceUSD: 'Сальдо (долл. США)',
  Cargo_BangPic: 'Фотографии склада',
  Cargo_Bank: 'Банки',
  Cargo_BankAccount: 'Номер банковского счета',
  Cargo_BankAccountBalance: 'Банковский баланс',
  Cargo_BankAccountNo: 'Номер банковского счета',
  Cargo_BankOfPayment: 'Платежный банк',
  Cargo_BankReceiptDetails: 'Водные накладные Подробнее',
  Cargo_BankReceiptNo: 'Банковский счет.',
  Cargo_ReceiptNo: 'Водная накладная',
  Cargo_BankReceiptRecord: 'Регистрация водяной накладной',
  Cargo_BankReceiptStatus: 'Состояние водяной накладной',
  Cargo_BaseCurrency: 'Базовая валюта',
  Cargo_BasePort: 'Базовый порт',
  Cargo_Basic: 'Основные',
  Cargo_ExternalInterface: 'Внешний интерфейс',
  Cargo_Blacklisted: 'Добавлен в черный список!',
  Cargo_BasicInfo: 'Основная информация',
  Cargo_BasicInformation: 'Базовая информация',
  Cargo_BasisForGrouping: 'Условия группировки',
  Cargo_BatchAudit: 'Массовая проверка',
  Cargo_BatchCancelAudit: 'Массовая отмена аудита',
  Cargo_BatchCancelConfirmation: 'Подтверждение отмены партии',
  Cargo_BatchConfirm: 'Подтверждение пакетов',
  Cargo_BatchDelete: 'Удаление пакетов',
  Cargo_BatchDownload: 'Загрузка пакетов',
  Cargo_BatchEnterModifyBusinessOrderNo: 'Пакетный ввод',
  Cargo_BatchNo: 'Номер партии',
  Cargo_BatchNoOfCollection: 'Номер партии',
  Cargo_BatchNoP: 'Номер партии:',
  Cargo_BatchPrint: 'Массовая печать',
  Cargo_BatchProcessing: 'Массовые операции',
  Cargo_BatchRetrieval: 'Массовое возвращение',
  Cargo_BatchRetrievalButtonTrigger: 'Запуск кнопки возврата пакетов',
  Cargo_BatchRevokeRetrieval: 'Отзыв пакетов',
  Cargo_BatchTransfer: 'Массовая доставка',
  Cargo_BelowBillingAmountsIncorrect: 'Ошибка в следующих счетах:',
  Cargo_Bill: 'Счет',
  Cargo_BillCanTBeEmpty: 'Счет не может быть пустым.',
  Cargo_BillConfirmed: 'Счет подтвержден.',
  Cargo_BillConfirmedM: '[{0}] Счет подтвержден.',
  Cargo_BillDate: 'Дата счета',
  Cargo_DueDate: 'Срок оплаты счетов',
  Cargo_BillDeleteAdjustment: 'Счет - Удалить корректировку',
  Cargo_BillDeletedSuccessfully: 'Удалить {0} счет',
  Cargo_BilledOrNot: 'Были ли выставлены счета',
  Cargo_BillingAmount: 'Сумма счета',
  Cargo_BillingCurrency: 'Валюта счета',
  Cargo_BillingData: 'Данные счета',
  Cargo_BillingDetails: 'Описание счета',
  Cargo_BillingExpenditure: 'Расходы по счетам',
  Cargo_BillingExpenditureDetails: 'Разбивка расходов по счетам',
  Cargo_BillingExpense: 'Стоимость счетов',
  Cargo_BillingMethod: 'Способ выставления счетов',
  Cargo_BillingRevenue: 'Поступления по счетам',
  Cargo_BillingRevenueExpenseDetails: 'Подробная разбивка поступлений по счетам',
  Cargo_BillInvoiced: '[{0} Счет выставлен',
  Cargo_BillIssued: 'Счет выставлен',
  Cargo_BillList: 'Список счетов',
  Cargo_BillNo: 'Номер счета',
  Cargo_BillNoP: 'Номер счета:',
  Cargo_BillNotSelected: 'Счет не выбран.',
  Cargo_BillPaidInFullCanTRepeatWriteOff: 'Счет полностью оплачен и не может быть списан снова.',
  Cargo_BillStatus: 'Состояние счета',
  Cargo_BillTo: 'Предмет счета',
  Cargo_BillType: 'Тип счета',
  Cargo_BillWrittenOff: '[{0} Счета были списаны',
  Cargo_Blacklist: 'Черный список',
  Cargo_BLControl: 'Управление коносаментами',
  Cargo_BLMAEONRS: 'Форма коносамента существует или не выбрана',
  Cargo_BLMethodMaintenance: 'Техническое обслуживание коносамента',
  Cargo_BLMode: 'Форма коносамента',
  Cargo_BLNo: 'Номер коносамента',
  Cargo_BLReleaseManagement: 'Управление размещением заказов',
  Cargo_MBLReleaseManagement: 'Управление основными коносаментами',
  Cargo_HBLReleaseManagement: 'Управление коносаментами',
  Cargo_BLReleaseReview: 'Проверка накладных',
  Cargo_MBLReleaseReview: 'Проверка основного листа',
  Cargo_HBLReleaseReview: 'Проверка по отдельности',
  Cargo_BLReleaseReviewStatus: 'Статус проверки листа',
  Cargo_BlReleasingNo: 'Поместить номер',
  Cargo_BlReleasingNoP: 'Поставьте номер:',
  Cargo_BLRemoteReleaseFee: 'Плата за перевод',
  Cargo_BLRetrieved: 'Возврат коносамента',
  Cargo_BLType: 'Тип коносамента',
  Cargo_HBLType: 'Тип коносамента HBL',
  Cargo_BNASPCTBBE: 'Бизнес - номера и расчеты не могут быть пустыми.',
  Cargo_BNTTPRS: 'Номер партии {0} успешно переведен в реестр предоплаты',
  Cargo_BOECTBCIWBII: 'Пожалуйста, унифицируйте выбор внутренних / иностранных расходов для создания счета',
  Cargo_Booking: 'Бронирование',
  Cargo_BookingAgent: 'Агент по бронированию',
  Cargo_BookingAgentAbbreviation: 'Агент по бронированию (сокращенно)',
  Cargo_BookingAgentCode: 'Агент бронирования (код)',
  Cargo_BookingNo: 'Номер бронирования',
  Cargo_BookingOrderNotExistCanTBeAdded: 'Новые неудачи, бронирование не существует.',
  Cargo_BookingWindow: 'Оформление / замена окон',
  Cargo_BookKeeper: 'Счетчик',
  Cargo_BookKeepingDate: 'Дата регистрации',
  Cargo_BookKeepingMethod: 'Порядок учета',
  Cargo_BookKeepingVoucher: 'Бухгалтерские документы',
  Cargo_BOPIOOPCTBLT: 'Фактический остаток не может быть меньше {0}',
  Cargo_BOPIOOPCTBLTCWOA: 'Фактический остаток средств не может быть меньше суммы списания.',
  Cargo_BPHCCTBWO: 'Счета {0} ожидают списания в Центральных учреждениях и в настоящее время не могут быть списаны.',
  Cargo_BranchBill: 'Счет филиала',
  Cargo_BranchCMP: 'Филиал',
  Cargo_BranchCMPP: 'Филиал:',
  Cargo_BranchCompany: 'Филиал',
  Cargo_BranchConfirmation: 'Подразделение подтвердило',
  Cargo_BranchConfirmed: 'Подразделение подтвердило',
  Cargo_BranchFilter: 'Фильтрация филиалов',
  Cargo_BREVB20TM: 'В. Более стабильный экспорт при 20 TEU',
  Cargo_BRNPNACW: 'Оперативный справочный номер / номер проекта / фактический вес',
  Cargo_BrokenDesc: 'Описание ущерба',
  Cargo_BrokenNumberDetection: 'Контрольный номер',
  Cargo_Browse: 'Просмотр...',
  Cargo_BRTSIOC: 'Б. Посоветуйте своего босса дешево.',
  Cargo_BSNMIR: 'Несоблюдение требований к выставлению счетов',
  Cargo_BSNMPCR: 'Бизнес - статус не соответствует требованиям к оплате.',
  Cargo_BSNMWOR: 'Несоблюдение требований к списанию',
  Cargo_BulkCargo: 'Раскладные продукты',
  Cargo_BURCNBE: 'Проверенные операции не могут быть отредактированы',
  Cargo_Business: 'Операции',
  Cargo_BusinessAdjustment: 'Оперативные корректировки',
  Cargo_BusinessAdjustmentLog: 'Журнал корректировки операций',
  Cargo_BusinessApproval: 'Утверждение операций',
  Cargo_BusinessApprovalDate: 'Дата утверждения',
  Cargo_BusinessApproved: 'Утвержденные операции',
  Cargo_OfficeApproved: 'Коммерческое одобрение',
  Cargo_BusinessCategory: 'Вид деятельности',
  Cargo_BusinessCharacteristic: 'Оперативные характеристики',
  Cargo_BusinessCommission: 'Эксплуатационные отчисления',
  Cargo_BusinessCreateDate: 'Дата создания бизнеса',
  Cargo_BusinessCreator: 'Основатель бизнеса',
  Cargo_BusinessDate: 'Дата операции',
  Cargo_BusinessDateBusinessDate: 'Дата операции',
  Cargo_BusinessDateP: 'Дата операции:',
  Cargo_BusinessDocNo: 'Оперативный номер',
  Cargo_BusinessDocNo2: 'Оперативный номер 2',
  Cargo_BusinessDocNoP: 'Номер бизнес - листа:',
  Cargo_BusinessHappenDate: 'Дата начала операции',
  Cargo_BusinessHappenDateP: 'Дата операции:',
  Cargo_BusinessInformation: 'Оперативная информация',
  Cargo_BusinessModel: 'Бизнес - модель',
  Cargo_BusinessNo: 'Номер операции',
  Cargo_BusinessNoInBill: '(Счет) Номер операции',
  Cargo_BusinessNotSelected: 'Не выбран бизнес.',
  Cargo_BusinessReferenceNo: 'Оперативный справочный номер',
  Cargo_GenerateNumberOfBusiness: 'Количество генерируемых операций',
  Cargo_UpdateBusinessAgain: 'Повторное изменение генерирующих операций',
  Cargo_Business_CustomerRefNo: 'Номер операции / клиента',
  Cargo_BusinessStatus: 'Оперативный статус',
  Cargo_BusinessStatusChangeLog: 'Журнал изменений бизнес - статуса',
  Cargo_DataPushResultRecords: 'Запись результатов Push Data',
  Cargo_SendType: 'Тип отправки',
  Cargo_ReissueFees: 'Повторные расходы',
  Cargo_ReissueFeesTips: 'Нажмите на эту кнопку, чтобы отправить все сборы за неудачную отправку.',
  Cargo_BusinessType: 'Вид деят.',
  Cargo_BusinessTypeP: 'Тип операции:',
  Cargo_BusinessTypeCanTBeEmpty: 'Тип операции не может быть пустым',
  Cargo_BusinessTypeInconsistent: 'Несоответствие видов деятельности',
  Cargo_ButtonPermissionControl: 'Права кнопок',
  Cargo_BuyingPrice: 'Покупательная цена',
  Cargo_BWNBCAED: 'По истечении срока действия контракта больше не будет возможности создавать бизнес.',
  Cargo_ByBill: 'По счету',
  Cargo_ByDetail: 'По деталям',
  Cargo_ByInvoice: 'По счетам',
  Cargo_ByInvoiceFxRate: 'По курсу счета - фактуры',
  Cargo_ByJob: 'По операциям',
  Cargo_ByJobNo: 'По оперативным номерам',
  Cargo_ByPaymentRequestFxRate: 'Обменный курс по заявке на оплату',
  Cargo_BySettlementAgent: 'Посредством расчетного агента',
  Cargo_CAEONRS: 'Учет существующих или не выбранных валют',
  Cargo_CAIFCINFCAUU: 'Отметить счета в иностранной валюте. В случае отсутствия иностранной валюты оценка производится в долларах США.',
  Cargo_CAIOCPCRY: 'Кредиторы текущего периода (в юанях)',
  Cargo_CAIOCPUSD: 'Кредиты, относящиеся к текущему периоду (в долл. США)',
  Cargo_CalculateBalance: 'Расчетный остаток',
  Cargo_CalculateBalanceTotalToWriteOff: 'Расчет общей суммы подлежащих списанию остатков',
  Cargo_CalculateBillingAmount: 'Расчет суммы счета',
  Cargo_CalculatedInOriginalCurrency: 'Расчет в первоначальной валюте',
  Cargo_CalculateTaxRate: 'Расчетная ставка',
  Cargo_CallbackFunction: 'Функция обратного вызова',
  Cargo_CanBeConfirmedOrNot: 'Можно ли подтвердить',
  Cargo_CanBeDeletedOrNot: 'Можно ли удалить',
  Cargo_CanBePrintedOrNot: 'Можно ли распечатать',
  Cargo_CanBeVoidedOrNot: 'Можно ли отменить',
  Cargo_CANCA: 'Непосредственные авансы',
  Cargo_Cancel: 'Отменить',
  Cargo_CancelAccrue: 'Отменить ссылку',
  Cargo_CancelAudit: 'Отменить аудит',
  Cargo_NewCustomerApplication: 'Заявка на нового клиента',
  Cargo_NewSupplierApplication: 'Заявка на нового поставщика',
  Cargo_RequiredFields: 'Пожалуйста, заполните соответствующие обязательные поля формы',
  Cargo_SelectTradeType: 'Пожалуйста, выберите тип торговли',
  Cargo_CancelCheckOfSelectedRecord: 'Подтверждается ли запись об отмене решения о пересмотре?',
  Cargo_CancelClosure: 'Отменить закрытие',
  Cargo_CancelConfirm: 'Отменить подтверждение',
  Cargo_CancelCurrentModification: 'Отменить текущее изменение',
  Cargo_CancelDefaultsInBatch: 'Отмена пакетов по умолчанию',
  Cargo_CancelEditing: 'Отменить редактирование',
  Cargo_CancelGetBack: 'Отзыв',
  Cargo_CancelIgnore: 'Отменить игнорирование',
  Cargo_CancelMark: 'Отменить метку',
  Cargo_CancelMerging: 'Отменить слияние',
  Cargo_CancelModification: 'Отменить текущие изменения?',
  Cargo_CancelPublishment: 'Отменить публикацию',
  Cargo_DownloadImportTemplate: 'Загрузить шаблон импорта',
  Cargo_CancelReconciliation: 'Отмена выверки',
  Cargo_CancelReturn: 'Отменить возвращение',
  Cargo_CancelSuccessfully: 'Отмена прошла успешно.',
  Cargo_CancelTheChargesAudit: 'Отмена проверки расходов',
  Cargo_CancelWriteOff: 'Аннулирование счетов',
  Cargo_CanNotProcessUnsavedNewExpense: 'Дополнительные неучтенные расходы не могут быть покрыты.',
  Cargo_CanNotRedoCancellation: 'Невозможно повторить списание.',
  Cargo_CanNotRemoveAllBills: 'Невозможно удалить все счета.',
  Cargo_CanOnlyRetrieveAfterDelivered: 'Отправлено, чтобы вернуть!',
  Cargo_CanTDeleteItemsWithInvoiceNo: 'Введён номер счета, его нельзя удалить.',
  Cargo_CanTDeleteWrittenOffItem: 'Списаны, не могут быть удалены',
  Cargo_CanTEditClosedItem: 'Счет уже закрыт и не может быть отредактирован.',
  Cargo_CanTRepeatVoiding: '【{0}】 Отменено и не может быть отменено',
  Cargo_CanTSelectInvoiceNoForEInvoice: 'Электронный счет не может выбрать номер счета.',
  Cargo_CanTSplitInvoicedItem: 'Билеты уже выставлены, их нельзя разделить!',
  Cargo_CanTVoidInvoiceWithoutInvoiceNo: 'Без номера счета - фактуры нельзя аннулировать счет - фактуру!',
  Cargo_CanTVoidWrittenOffItem: '【{0}】 Списан и не может быть аннулирован.',
  Cargo_CAOPWWT: 'Расчетная сумма без учета налогов',
  Cargo_Cargo: 'Товары',
  Cargo_Remark: 'Примечание к грузу',
  Cargo_Remark_Check: 'В примечании к грузу можно ввести только 3999 символов: прописные/строчные буквы, цифры и специальные символы: !"#%&\'()*+,-./:;<=>?@_0-9a-zA-Z\n\s',
  Cargo_CargoDetention: 'Арест',
  Cargo_CargoInfo: 'Информация о грузе',
  Cargo_CargoName: 'Название груза',
  Cargo_CargoNature: 'Свойства груза',
  Cargo_CargoType: 'Тип груза',
  Cargo_CAROJE: 'Настройка правил разделения резюме',
  Cargo_CarriedOver: 'Перенесено',
  Cargo_Carrier: 'Перевозчик',
  Cargo_Carrier_Ship: 'Перевозчик (судоходная компания)',
  Cargo_Carrier_Air: 'Перевозчик (авиакомпания)',
  Cargo_Carrier_Railway: 'Перевозчик (агент порта)',
  Cargo_CarrierAgent: 'Судоходство',
  Cargo_CarrierShip: 'Судоходная компания',
  Cargo_CarryOverForeignExchange: 'Перенос средств',
  Cargo_CarryOverInitialized: 'Перенос инициализирован',
  Cargo_CarryOverProfitLoss: 'Перенос прибылей и убытков',
  Cargo_CarryOverProfitLoss2: 'Перенос прибылей и убытков2',
  Cargo_CarryOverToNextPeriod: 'Перенесено на следующий период',
  Cargo_CartonQuantity: 'Размер ячейки',
  Cargo_TicketCount: 'Количество',
  Cargo_Cash: 'Наличные средства',
  Cargo_CasualClientNonCasualClient: 'Рассеянные / не рассеянные',
  Cargo_NonCasualClient: 'Непосредственные клиенты',
  Cargo_CasualClientOrNot: 'Рассеяны ли',
  Cargo_Category: 'Категория',
  Cargo_CategoryOfPartner: 'Тип партнера',
  Cargo_CATISExport: 'Экспорт налогов',
  Cargo_CATISInvalid: 'Золотой налог отменен',
  Cargo_CATISPrint: 'Налоговая печать',
  Cargo_CBEIPCPTSINACSRANMPC: 'Текущий электронный счет - фактура филиала: код платформы / пароль / идентификационный номер налогоплательщика / код разрешения / адрес запроса на обслуживание не поддерживается, пожалуйста, проверьте.',
  Cargo_CBEIPCTSINACSRANMPC: 'Текущий электронный счет - фактура филиала: код платформы / идентификационный номер налогоплательщика / код разрешения / адрес запроса на обслуживание не поддерживается, пожалуйста, проверьте.',
  Cargo_CBFCEBD: 'Создание по умолчанию подтвержденных счетов',
  Cargo_CBISAWTSNM: 'В настоящее время адрес интерфейса налоговой системы филиала не поддерживается.',
  Cargo_CBTSINNM: 'В настоящее время идентификационный номер налогоплательщика филиала не поддерживается.',
  Cargo_CCOCM: 'Отменить текущее изменение?',
  Cargo_CCOPLV: 'Удостоверение перенесенных прибылей и убытков успешно подготовлено:',
  Cargo_CCRAIOC: 'С - Дешевле Подумайте о подготовке к смене агента',
  Cargo_CCS: 'Отмена подтверждена успехом.',
  Cargo_CDOPRI: 'Информация об отклонении заявки на оплату',
  Cargo_Cent: 'Б',
  Cargo_AndTo: 'И {0} {1}',
  Cargo_AlreadyHere: 'Уже здесь.',
  Cargo_IsOver: '{0} Прошло {1}',
  Cargo_CERNM: 'Валютный курс ({0}) не поддерживается',
  Cargo_CFCNAPM: 'Предмет не учитывает текущую иностранную валюту: {0}, пожалуйста, измените.',
  Cargo_CGS1RV: 'Продажа Успешное ограбление клиентов! Успешный аудит {0} записи.',
  Cargo_ChangeContent: 'Изменить содержание',
  Cargo_ChangeInvoiceTitle: 'Изменить счет - фактуру',
  Cargo_ChangeInvoiceTitleP: 'Изменение верхней части счета:',
  Cargo_ChangeSob: 'Изменить счет',
  Cargo_ChangeTo: 'Изменить на',
  Cargo_ChangeToP: 'Изменить следующим образом:',
  Cargo_Charge: 'Получение',
  Cargo_Chargeback: 'Платежи',
  Cargo_ChargebackFile: 'Документ о возврате',
  Cargo_ChargeDetails: 'Разбивка расходов',
  Cargo_ChargedWeight: 'Расчетный вес',
  Cargo_ChargeName: 'Название расходов',
  Cargo_ChargeOriginalAmount: 'Первоначальная сумма расходов',
  Cargo_ChargeOriginalCurrency: 'Расходы в первоначальной валюте',
  Cargo_ChargeOriginalExchangeRate: 'Первоначальный обменный курс',
  Cargo_ChargesAudit: 'Проверка расходов',
  Cargo_ChargesContactPerson: 'Контактные данные по расходам',
  Cargo_ChargesReject: 'Расходы отклонены',
  Cargo_ChargeStatus: 'Состояние расходов',
  Cargo_ChargesTotalAmount: 'Общая сумма расходов',
  Cargo_ChargeType: 'Тип расходов',
  Cargo_ChargeTypeP: 'Тип расходов:',
  Cargo_CHBRNFOA: 'Контракт был продлен, эксплуатация запрещена.',
  Cargo_CheckAccountInForeignCurrency: 'Учет в иностранной валюте',
  Cargo_CheckChargeDetailBranch: 'Действующие данные находятся в филиале, который не принадлежит текущему филиалу или филиалу более высокого уровня.',
  Cargo_CheckCreateBillWay: 'Расчетный объект или расчетный агент должны соответствовать одному и тому же',
  Cargo_CheckInvoiceQueryBranch: 'В настоящее время работает филиал, который не согласуется с филиалом, принадлежащим данным, пожалуйста, обратитесь к повторной обработке данных.',
  Cargo_CheckClientToExtendValidPeriod: 'Пожалуйста, выберите клиента, который нуждается в продлении срока.',
  Cargo_CheckIfSoaFullyWrittenOff: 'Проверьте все ли счета списаны',
  Cargo_CheckingStatus: 'Статус подтверждения коносамента',
  Cargo_HblCheckingStatus: 'Статус подтверждения коносамента HBL',
  Cargo_CheckingURLStatus: 'Однозначное состояние',
  Cargo_CheckInvoice: 'Оформление квитанции',
  Cargo_CheckWriteOffDetails: 'Проверьте данные о списании',
  Cargo_ChineseCargoName: 'Китайские названия',
  Cargo_StatusUpdateTime: 'Время изменения состояния коносамента',
  Cargo_StatusUpdateUser: 'Изменение состояния коносамента',
  Cargo_ChineseFirstVesselName: 'Название судна',
  Cargo_ChineseName: 'Китайское имя',
  Cargo_ChineseNameCanTBeEmpty: 'Китайские имена не могут быть пустыми',
  Cargo_ChineseNameOfSettlingParty: 'Китайское имя расчетного объекта',
  Cargo_Choose0P: 'Выбрать 0:',
  Cargo_ChooseByText: 'Выбор текста',
  Cargo_ChooseFee: 'Стоимость выбора',
  Cargo_ChooseFeeCNY: 'Стоимость выбора RMB',
  Cargo_ChooseFeeUSD: 'Стоимость выбора USD',
  Cargo_ChooseInvoicedFee: 'Выберите стоимость счета - фактуры',
  Cargo_ChooseP: 'Выбор {0}:',
  Cargo_TicketCount: 'Количество: ',
  Cargo_CIIRSBATTB: 'Проверьте, следует ли добавлять требования к выставлению счетов',
  Cargo_CIMJ: 'Информация должна быть проверена.',
  Cargo_CIMS: 'Информация о инкассо успешно изменена.',
  Cargo_City: 'Города',
  Cargo_CityCode: 'Городской код',
  Cargo_CityMaintenance: 'Городское обслуживание',
  Cargo_CityName: 'Название города',
  Cargo_CityNotSelected: 'Город не выбран',
  Cargo_CityP: 'Города',
  Cargo_Claim: 'Признание',
  Cargo_ClaimAdvanceReceipt: 'Требование о получении аванса',
  Cargo_ClaimAR: 'Требования к дебиторской задолженности',
  Cargo_ClaimBankReceipt: 'Водная накладная',
  Cargo_ClaimDate: 'Дата получения',
  Cargo_ClaimedBy: 'Претендент',
  Cargo_ClaimInformation: 'Получение информации',
  Cargo_ClaimOrNot: 'Требуется ли',
  Cargo_ClaimState: 'Статус признания',
  Cargo_ClaimStatusOfAdvanceReceipt: 'Статус признания (предварительно получен)',
  Cargo_ClaimStatusOfAR: 'Статус признания (к получению)',
  Cargo_Clear: 'Очистить',
  Cargo_ClearData: 'Очистить данные',
  Cargo_ClearFilter: 'Очистить фильтр',
  Cargo_ClickToFilter: 'Нажмите фильтр',
  Cargo_ClickToLoadParameter: 'Нажмите кнопку для загрузки параметров запроса',
  Cargo_ClickToQuery: 'Нажмите кнопку для запроса',
  Cargo_ClientAllocationStatus: 'Состояние распределения клиентов',
  Cargo_CLientCantBeEmpty: 'Клиент не может быть пустым.',
  Cargo_ClientContract: 'Контракты с клиентами',
  Cargo_ClientEventNotSelected: 'События клиента не выбраны',
  Cargo_ClientList: 'Список клиентов',
  Cargo_ClientMovedToRecycleBin: 'Клиент был переведен в пункт сбора клиентов.',
  Cargo_ClientNo: 'Номер клиента',
  Cargo_ClientOverseasAgent: 'Клиенты / зарубежные агенты',
  Cargo_ClientStatus: 'Статус клиента',
  Cargo_ClientSVisit: 'Клиенты посещают',
  Cargo_ClientVendor: 'Клиенты / поставщики',
  Cargo_Close: 'Закрыть',
  Cargo_Close2: 'Убрать',
  Cargo_CloseAccount: 'Закрытие счетов',
  Cargo_CloseAccount2: 'Закрытие счетов 2',
  Cargo_CloseAccountOrNot: 'Закрытие счетов',
  Cargo_CloseDateOfContainerReturn: 'Дата окончания возврата',
  Cargo_CloseDetailWindow: 'Закрыть подробное окно',
  Cargo_CloseWindow: 'Закрыть окно',
  Cargo_ClosureNo: 'Конечный номер',
  Cargo_ClosureTimeSelection: 'Время окончания',
  Cargo_ClosureTitleOfAccount: 'Конец предмета',
  Cargo_CNY: 'Юань',
  Cargo_CNYHKD: 'Жэньминьби / гонконгский доллар',
  Cargo_CNYInvoiceNo: 'Номер счета - фактуры в юанях',
  Cargo_CNYP: 'Юань:',
  Cargo_COACP: 'Денежные средства, полученные и выплаченные',
  Cargo_Code: 'Код',
  Cargo_CodeCanTBeEmpty: 'Код не может быть пустым.',
  Cargo_DuplicateCode: 'Код повторяется, введите заново.',
  Cargo_CodeNotMaintained: 'Код не поддерживается.',
  Cargo_CodeOfExpenseDescription: 'Код наименования расходов',
  Cargo_CodeSearching: 'Поиск кода',
  Cargo_CodeType: 'Тип кода',
  Cargo_CodeTypeP: 'Тип кодирования:',
  Cargo_Coding: 'Код',
  Cargo_ApCoding: 'Код кредитора',
  Cargo_ArCoding: 'Код дебиторской задолженности',
  Cargo_CodingMapping: 'Кодированное отображение',
  Cargo_CodingP: 'Код:',
  Cargo_Collect: 'Б',
  Cargo_CollectAndPrepaidOrNot: 'Получается ли аванс',
  Cargo_CollectedExpenseDetails: 'Подробная разбивка взысканных расходов',
  Cargo_CollectedExpenseDetailsP: 'Подробная информация о взимаемых сборах:',
  Cargo_CollectedInFull: 'Получено',
  Cargo_CollectedNotCollectedInFull: 'Получено / не получено',
  Cargo_CollectFormation: 'Информация о поступлениях',
  Cargo_CollectInvoice: 'Получение билетов',
  Cargo_Collection: 'инкассо',
  Cargo_CollectionCNY: 'Сбор CNY',
  Cargo_CollectionDetails: 'Разбивка расходов на инкассо',
  Cargo_CollectionDifference: 'Разница в инкассо',
  Cargo_CollectionInformation: 'Информация о инкассо',
  Cargo_CollectionPayment: 'Полученные платежи',
  Cargo_CollectionPaymentCleared: 'Полученные платежи оплачены',
  Cargo_CollectionPaymentDate: 'Дата получения платежа',
  Cargo_CollectionPaymentInformation: 'Информация о получении платежей',
  Cargo_CollectionPaymentMethod: 'Способы получения платежей',
  Cargo_CollectionPaymentTypeFilter: 'Фильтрация типов платежей',
  Cargo_CollectionRecordByCarrier: 'Регистрация судоходной компании',
  Cargo_CollectionSituation: 'Поступления',
  Cargo_CollectionStatus: 'Статус инкассо',
  Cargo_CollectionUSD: 'Сбор USD',
  Cargo_CoLoadConsol: 'Делегированный ящик',
  Cargo_ColorOfControllingRow: 'Цвет контрольной строки',
  Cargo_CombinedInvoicing: 'Совокупное выставление счетов',
  Cargo_CombinedListNo: 'Номер списка билетов',
  Cargo_Commission: 'Комиссионные',
  Cargo_CommissionAmount: 'Сумма отчислений',
  Cargo_CommissionedGrossWeight: 'Поручить вес брутто',
  Cargo_CommissionItems: 'Комиссия',
  Cargo_CommissionOrNot: 'Является ли комиссия',
  Cargo_CommissionPercentage: 'Доля отчислений',
  Cargo_CommissionRules: 'Правило отчисления',
  Cargo_CommodityCode: 'Коды товаров',
  Cargo_CommodityInspection: 'Коммерческая инспекция',
  Cargo_CommonlyUsedTradeTerms: 'Общие торговые условия',
  Cargo_Company: 'Компания',
  Cargo_CompanySelfRelease: 'Корпоративный заказ.',
  Cargo_CompanySReceivingAccountNumber: 'Номер счета компании',
  Cargo_CompanySReceivingBank: 'Корпоративный кассовый банк',
  Cargo_Competitor: 'Конкурентная компания',
  Cargo_Completed: 'Завершено',
  Cargo_CompleteDate: 'Дата окончания',
  Cargo_CompletedOrNot: 'Выполнено',
  Cargo_CompleteWriteOff: 'Полное списание',
  Cargo_CompletionTime: 'Время завершения',
  Cargo_ConditionOfSearch: 'Условия поиска',
  Cargo_ConditionType: 'Тип условия',
  Cargo_ConfiCNYill: 'Подтверждение счетов',
  Cargo_ConfigureAccountTitle: 'Параметры',
  Cargo_Confirm: 'Определение',
  Cargo_AMSEnsChannel: 'Контртеррористический манифест ENS Идентификация поставщиков',
  Cargo_SkipAll: 'Пропустить все',
  Cargo_SecondFlightSchedule: 'Время второго рейса.',
  Cargo_TwoWayFreighter: 'Второй грузовой самолет',
  Cargo_EmailFormatError: 'Ошибка формата почтового ящика',
  Cargo_CountryOfShipment: 'Страна отправления',
  Cargo_AirFreightRateDetails: 'Подробная информация о тарифах на воздушные перевозки',
  Cargo_ConfirmAndCheckSelectedRecord: 'Подтверждается ли запись о выборе варианта пересмотра?',
  Cargo_ConfirmAP: 'Подтверждение причитающихся сумм',
  Cargo_ConfirmCancellationOfRecord: 'Удалить запись?',
  Cargo_ConfirmCombinedInvoice: 'Определение единого счета',
  Cargo_ConfirmDate: 'Дата подтверждения',
  Cargo_Confirmed: 'Подтверждено',
  Cargo_ConfirmedSuccessfully: 'Подтверждение успеха.',
  Cargo_ConfirmExpenses: 'Учет расходов',
  Cargo_ConfirmNotification: 'Подтвердить напоминание',
  Cargo_ConfirmOffset: 'Подтвердить штифт',
  Cargo_ConfirmOrNot: 'Подтвердить',
  Cargo_ConfirmPartial: 'Подтверждается частично',
  Cargo_ConfirmR: 'Подтверждение',
  Cargo_ConfirmRQ: 'Подтвердить?',
  Cargo_ConfirmRemarks: 'Подтвердить примечание',
  Cargo_ConfirmSelectedItem: 'Подтвердить выделение',
  Cargo_ConfirmStatus: 'Статус подтверждения',
  Cargo_ConfirmSubmissionOfPaymentOrder: 'Удостовериться в представлении платежного извещения?',
  Cargo_ConfirmWriteOff: 'Подтверждение факта списания',
  Cargo_ConfirmWriteOffQ: 'Подтвердить списание?',
  Cargo_ConfirmWrittenOffExpense: 'Подтверждение стоимости списания',
  Cargo_ConflictExpenseDetails: 'Разбивка конфликтных расходов',
  Cargo_Consignation: 'Поручение',
  Cargo_ConsignationCompanyCannotBeNull: 'Подразделение не может быть пустым.',
  Cargo_Consignee: 'Получатель',
  Cargo_ConsigneeId: 'Код грузополучателя',
  Cargo_ConsigneeInfo: 'Информация о грузополучателе',
  Cargo_ConsigneeSName: 'Наименование грузополучателя',
  Cargo_ConsignorSCode: 'Доверительная единица (код)',
  Cargo_ConsolidatedCNY: 'Сводный (юань)',
  Cargo_ConsolidatedCurrency: 'Объединение валют',
  Cargo_ConsolidatedLocalCurrency: 'Интегрированные стандартные валюты',
  Cargo_ConsolidatedLocalCurrencyCNY: 'Интегрированная стандартная валюта (юань)',
  Cargo_ConsolidatedProfitLossIs: 'Курсовые прибыли и убытки включают:',
  Cargo_ConsolidateOrNot: 'Объединение',
  Cargo_Contact: 'Контактные лица',
  Cargo_ContactNumber: 'Контактный телефон',
  Cargo_ContainerAmount: 'Количество ящиков',
  Cargo_ContainerDescription: 'Описание размера ящика',
  Cargo_ContainerInfo: 'Сведения об упаковке',
  Cargo_ContainerNo: 'Номер ящика',
  Cargo_ContainerSize: 'Ящик',
  Cargo_ContainerType: 'Ящик',
  Cargo_ContainerRule: 'футляр',
  Cargo_ContainerTypeCanTBeEmpty: 'Ящик не может быть пустым.',
  Cargo_ContainerTypeMaintenance: 'Эксплуатация контейнеров',
  Cargo_ContainerTypeSea: 'Тип целой сборки (морская перевозка)',
  Cargo_ContentDescription: 'Содержание',
  Cargo_ContentFailedToLoad: 'Ошибка загрузки содержимого',
  Cargo_ContentFailedToLoadP: 'Ошибка загрузки содержимого:',
  Cargo_ContentOfAmount: 'Содержание суммы',
  Cargo_ContentOfExpenseDescription: 'Название расходов',
  Cargo_ContentPreviewOfPaymentNotice: 'Предварительный просмотр содержания уведомления',
  Cargo_Continent: 'Континенты',
  Cargo_ContinueToAddData: 'Продолжать добавлять данные',
  Cargo_ContinueToSave: 'Сохранить',
  Cargo_ContinuousFilter: 'Непрерывная фильтрация',
  Cargo_Contra: 'Списание',
  Cargo_ContraAmount: 'Сумма списания',
  Cargo_ContraAmountP: 'Сумма списания:',
  Cargo_ContraBalance: 'Сальдо списания',
  Cargo_ContractAdministrator: 'Сотрудник по контрактам',
  Cargo_ContractConfiguration: 'Состав контрактов',
  Cargo_Contracted: 'Подписан',
  Cargo_ContractedClientInformation: 'Информация о клиенте',
  Cargo_ContractExpired: 'Срок действия контракта',
  Cargo_ContractNumber: 'Номер контракта',
  Cargo_ContractNumberCanTBeEmpty: 'Номер контракта не может быть пустым',
  Cargo_ContractRateProperty: 'Договорный характер',
  Cargo_ContractSignedSuccessfully: 'Подпись удалась.',
  Cargo_ContractStatus: 'Статус контрактов',
  Cargo_RiskReason: 'Причина контроля рисков',
  Cargo_ContractValidStatus: 'Действителен ли контракт',
  Cargo_ContractTerms: 'Условия контракта',
  Cargo_CurrentCredit: 'Текущий контроль',
  Cargo_ContractCredit: 'Контроль за исполнением контрактов',
  Cargo_ContractType: 'Тип контракта',
  Cargo_ConversionAmountContent: 'Компонент пересчета',
  Cargo_ConversionAmountInCNY: 'Сумма в юанях',
  Cargo_ConversionRMB: 'Эквивалент RMB',
  Cargo_ConversionAP: 'Кредиторская задолженность',
  Cargo_ConversionAPCNY: 'Компенсация CNY',
  Cargo_ConversionPaidCNY: 'Выплачено CNY',
  Cargo_ConversionAPCurrency: 'Эквивалентная {0} кредиторская задолженность',
  Cargo_ConversionAR: 'Дебиторская задолженность',
  Cargo_ConversionARCNY: 'Дебиторская задолженность CNY',
  Cargo_ConversionReceivedCNY: 'Получено CNY',
  Cargo_ConversionARCurrency: 'Эквивалент {0} к получению',
  Cargo_ConversionCurrencyAmount: 'Сумма в пересчете на валюту',
  Cargo_ConversionOutstandingAR: 'Эквивалент к получению',
  Cargo_ConversionOutstandingARCNY: 'Суммы, причитающиеся от CNY',
  Cargo_ConversionOutstandingARCurrency: 'Эквивалент {0} Не получен',
  Cargo_ConversionOutstandingReceivedCurrency: 'Эквивалент {0} получен',
  Cargo_ConversionProfit: 'Эквивалентная прибыль',
  Cargo_ConversionProfitCNY: 'Прибыль CNY',
  Cargo_ConversionProfitCNYP: 'Прибыль CNY:',
  Cargo_ConversionWriteOffAmountInCNY: 'Сумма списания в юанях',
  Cargo_COPLOCP: 'Перенос текущих прибылей и убытков',
  Cargo_Copy: 'Копирование',
  Cargo_CopyAndAddPoItems: 'Копировать Добавить',
  Cargo_CopyExchangeRate: 'Копирование обменных курсов',
  Cargo_CopyFromExisting: 'Создано на основе существующих счетов',
  Cargo_InitializeLevelOneSubject: 'Инициализация предметов первого уровня',
  Cargo_InitializeReport: 'Инициализация отчетов',
  Cargo_Cost: 'Расходы',
  Cargo_CostInvoiceNo: 'Номер счета - фактуры',
  Cargo_CounterpartySBankAccount: 'Номер счета другой стороны',
  Cargo_CounterpartySBillingNo: 'Номер счета',
  Cargo_Country: 'Страна',
  Cargo_CountryMaintenance: 'Государственное обслуживание',
  Cargo_CountryRegion: 'Страна (регион)',
  Cargo_CountryRegionCode: 'Код страны (региона)',
  Cargo_CourierOrderNo: 'Экспедиционный номер.',
  Cargo_CPIOOPRCCTBV: 'Текущий отчет о получении и оплате был пересмотрен и не может быть отменен.',
  Cargo_CPIOOPRVCTBM: 'В настоящее время фактическая платежная запись аннулирована и не может быть изменена!',
  Cargo_CPIOOPRWOCTBV: 'В настоящее время записи о фактическом получении и платежах уже списаны и не могут быть аннулированы.',
  Cargo_Create: 'Создание',
  Cargo_uploadErr: 'Ошибка загрузки',
  Cargo_CreateAndExportDirectly: 'Прямой экспорт после генерации',
  Cargo_CreateBill: 'Создать счет',
  Cargo_BatchCreateBill: 'Пакетное генерирование счетов',
  Cargo_BatchCreateBillTitle: 'Выберите диапазон данных',
  Cargo_BatchCreateBillBySame: 'Стоимость одного и того же объекта будет составлять счет.',
  Cargo_BatchCreateBillByAll: 'Все обнаруженные записи',
  Cargo_BatchCreateBillBySelected: 'Выделенные записи',
  Cargo_BatchCreateBillSuccess: 'Операция выполнена успешно: всего создано {0} счетов',
  Cargo_CreateBillQ: 'Создать счет',
  Cargo_CreateCombination: 'Создание слияния',
  Cargo_CreateCostInvoice: 'Наличие счета - фактуры на покрытие расходов',
  Cargo_CreatedBy: 'Входящие сотрудники',
  Cargo_CreatedDate: 'Дата создания',
  Cargo_CreatedSuccessfully: 'Новое успешно!',
  Cargo_CreateInvoice: 'Формирование счета - фактуры',
  Cargo_CreateListOfCombinedInvoices: 'Составление списка билетов',
  Cargo_CreateOffsetExpense: 'Возникновение расходов на хеджирование',
  Cargo_CreatePaymentRequest: 'Создание платежной заявки',
  Cargo_CreatePaymentRequestChooseFees: 'Создание заявки на оплату - расходы на выбор',
  Cargo_CreatePaymentRequestDetails: 'Создание платежной заявки - подробная информация',
  Cargo_BasicPaymentRequest: 'Заявка на оплату (базовая версия)',
  Cargo_PendingSupervisorApproval: 'Ожидает одобрения руководителя',
  Cargo_PaymentRequestSettings: 'Настройки заявок на оплату',
  Cargo_EnableUICustomization: 'Включить пользовательский интерфейс',
  Cargo_AdditionalApprovalNode: 'Дополнительный узел согласования',
  Cargo_DepartmentApprovalTab: 'Согласование отдела (показать вкладку ожидания)',
  Cargo_SupervisorApprovalTab: 'Согласование руководителя (показать вкладку ожидания)',
  Cargo_PreApproval: 'Предварительное согласование',
  Cargo_FinanceApproval: 'Финансовое согласование',
  Cargo_OperationReview: 'Операционный обзор',
  Cargo_DepartmentReview: 'Обзор отдела',
  Cargo_SupervisorReview: 'Проверка руководителя',
  Cargo_RuleBasedApproval: 'Только соответствующие правилам документы проходят дополнительное согласование',
  Cargo_NonRuleBypass: 'Разрешить обход согласования руководителем для несоответствующих правилам документов',
  Cargo_Settings: 'Настройки',
  Cargo_PendingDepartmentApproval: 'Ожидает одобрения отдела',
  Cargo_AllPaymentRequests: 'Заявки на оплату (все)',
  Cargo_SupervisorReviewer: 'Рецензент руководителя',
  Cargo_SupervisorReviewDate: 'Дата проверки руководителем',
  Cargo_SettlementUnitContractStatus: 'Статус контракта единицы расчёта',
  Cargo_ReturnToPreviousApprovalNode: 'Возврат к предыдущему узлу утверждения',
  Cargo_CreateSoa: 'Создать счет',
  Cargo_CreateVoucher: 'Создание сертификата',
  Cargo_Creator: 'Создатель',
  Cargo_Credit: 'Кредиты',
  Cargo_CreditAmount: 'Сумма кредита',
  Cargo_CreditAmount2: 'Сумма кредита',
  Cargo_CreditAmountCNY: 'Кредитор (в юанях)',
  Cargo_CreditAmountOccurred: 'Сумма кредита',
  Cargo_CreditAmountOccurredCNY: 'Возникновение кредитора (в юанях)',
  Cargo_CreditAmountOccurredP: 'Сумма кредита:',
  Cargo_CreditAmountOccurredUSD: 'Возникновение кредита (в долл. США)',
  Cargo_CreditAmountTo: 'Итого, кредит',
  Cargo_CreditAmountToP: 'Всего кредитов:',
  Cargo_CreditAmountUSD: 'Кредиторы (в долл. США)',
  Cargo_CreditControlDetails: 'Подробная информация о кредитном контроле',
  Cargo_CreditControlSettings: 'Параметры управления сообщениями',
  Cargo_CreditLimitExceeded: 'Превышение',
  Cargo_CreditLimitRange: 'Границы',
  Cargo_CreditLocalCurrency: 'Кредитная валюта',
  Cargo_CreditNotWrittenOff: 'Кредиты не распроданы',
  Cargo_CreditOriginalAmount: 'Первоначальная сумма кредита',
  Cargo_CreditSide: 'Кредиторы',
  Cargo_CreditUsed: 'Использованная сумма',
  Cargo_CreditWriteOffAmount: 'Списанные суммы',
  Cargo_CREVB5TM: 'Стабилизация экспорта в пределах 5 TEU в месяц',
  Cargo_CRPI: 'Вы уверены, что хотите сделать предоплату?',
  Cargo_CSNPM: 'Техническое обслуживание приемопередающей информации',
  Cargo_CSR: 'Оператор',
  Cargo_CSRGTIDDDI: 'Результаты текущего запроса больше, чем количество полос отображения, и данные отображаются неполно.',
  Cargo_CSWTCSTR: 'Клиент подписал договор, и может выбрать его для продления.',
  Cargo_CTMCWOPCCF: 'Проверенные счета не могут быть изменены, сначала отмените обзор.',
  Cargo_CTOPR: 'Подтверждаете перевод в реестр предоплаты?',
  Cargo_CTORI: 'Уверены в обратном переводе?',
  Cargo_CTRCWOPCCF: 'Проверенные счета не могут быть отозваны, сначала отмените обзор.',
  Cargo_CTRLSPFCC: 'Подтверждается ли продажа, связанная с освобождением клиента',
  Cargo_Cubage: 'Объем',
  Cargo_Currency: 'Валюта',
  Cargo_CurrencyCanTBeEmpty: 'Валюта не может быть пустой',
  Cargo_CurrencyFXRateNoMaintained: 'Валютный курс 【{0}】 не поддерживается!',
  Cargo_CurrencyInconsistent: 'Несоответствие валют.',
  Cargo_CurrencyMaintenance: 'Сохранение валюты',
  Cargo_CurrencyOfPayment: 'Валюта платежа',
  Cargo_CurrencyOfTotal: 'Валюта',
  Cargo_CurrencyP: 'Валюта:',
  Cargo_CurrentClientIsContracted: 'Клиент уже подписал',
  Cargo_CurrentExchangeRate: 'Текущий обменный курс',
  Cargo_CurrentLoginUser: 'Текущий регистратор',
  Cargo_CurrentMonth: 'Текущий месяц',
  Cargo_CurrentSelected: 'Текущие параметры',
  Cargo_Reefer: 'Reefer',
  Cargo_ShowCharacteristics: 'Показать характеристики груза',
  Cargo_ShowCharacteristicsTip: 'При выборе текущего типа груза на основной странице дополнительно отображается галочка "заряженная" "Жидк. с магнитным" "Пор."',
  Electric: 'Под напряжением',
  Magnetic: 'Магнитная лента',
  Powder: 'Пор.',
  Liquid: 'Жидк.',
  Cargo_CurrentSelectedExpense: 'Выбранные расходы {0}',
  Cargo_CurrentSelectedSobIs: 'Текущий выбранный набор счетов: {0}',
  Cargo_CurrentSettlingParty: 'Текущий расчетный объект',
  Cargo_CurrentWriteOffSerialNoCompleted: 'Номер дебетового потока - {0}, счет успешно распродан.',
  Cargo_CurrentYearAccumulatedAmount: 'Совокупная сумма за текущий год',
  Cargo_CurrentYearProfitAccount: 'Прибыль в текущем году',
  Cargo_CurrentYearProfitAccountP: 'Прибыль в текущем году:',
  Cargo_CurrentYearTotal: 'Всего за год',
  Cargo_CurrentYearTotalAmout: 'Совокупные расходы за текущий год',
  Cargo_CurrentYearTotalAmoutCreditCNY: 'Совокупное количество кредитов в текущем году (в юанях)',
  Cargo_CurrentYearTotalAmoutCreditUSD: 'Кредиты, накопленные в текущем году (в долл. США)',
  Cargo_CurrentYearTotalAmoutDebitCNY: 'Совокупный дебет за текущий год (в юанях)',
  Cargo_CurrentYearTotalAmoutDebitUSD: 'Совокупные дебетовые обязательства за текущий год (долл. США)',
  Cargo_CursorPointedInvoiceNo: 'Номер счета - фактуры',
  Cargo_Customer: 'Клиенты',
  Cargo_CustomerAddress: 'Адрес клиента',
  Cargo_CustomerHasConfirm: '{0} Номер, Клиент подтвержден.',
  Cargo_CustomerLevel: 'Уровень клиента',
  Cargo_CustomerName: 'Название клиента',
  Cargo_CustomerP: 'Клиент:',
  Cargo_CustomerProperty: 'Свойства клиента',
  Cargo_CustomerReferenceNumber: 'Справочный номер клиента',
  Cargo_CustomerSelfRelease: 'Заказчик самостоятельно',
  Cargo_CustomerService: 'Обслуживание клиентов',
  Cargo_CustomerSpace2: 'Назначенные товары',
  Cargo_CustomerSpace3: 'Собственные товары',
  Cargo_CustomerType: 'Тип клиента',
  Cargo_Customized: 'Настройка',
  Cargo_CustomizedField1: 'Настройка поля 1',
  Cargo_CustomizedField2: 'Настройка поля 2',
  Cargo_CustomizedField3: 'Настройка поля 3',
  Cargo_CustomizedField4: 'Пользовательское поле 4',
  Cargo_CustomJobType: 'Пользовательский тип бизнеса',
  Cargo_CustomJobTypeP: 'Пользовательский тип бизнеса',
  Cargo_CustomsApproval: 'Таможенная экспертиза',
  Cargo_CustomsBroker: 'Таможенная служба',
  Cargo_CustomsBrokerFilter: 'Фильтрация таможенной строки',
  Cargo_CustomsDeclaration: 'Таможенная декларация',
  Cargo_CustomsDeclarationSearchFailed: 'Ошибка запроса таможенной информации:',
  Cargo_CustomsNo: 'Таможенный номер',
  Cargo_CWOIFCTTTEPRCOEA: 'Поступления были полностью списаны, и они больше не могут быть переведены на счет. Просьба представить отдельную заявку на инкассо или сбор.',
  Cargo_CYCutOffDate: 'Дата закрытия',
  Cargo_CYSPATIPLVCTBE: 'Счет прибыли за текущий год не может быть пустым',
  Cargo_CYWRYTTPPATDWBMTRS: 'Нажмите"Да."Перейти на страницу печати и изменить файл как"Возмещено"Статус',
  Cargo_CYWRYTTPPATRDWBCTRS: 'Нажмите"Да."Перейти на распечатанную страницу и заменить полученный документ следующим текстом:"Возмещено"Статус',
  Cargo_DAIIUCTBD: '【Корректировка разницы】 Используется в бизнесе и не может быть удален',
  Cargo_DAIOCPCNY: 'Заимствование текущего периода (в юанях)',
  Cargo_DAIOCPUSD: 'Дебетовые обязательства за текущий период (долл. США)',
  Cargo_DataExport: 'Экспорт',
  Cargo_DataExportPDF: 'Экспорт PDF',
  Cargo_DataSent: 'Распространенная информация',
  Cargo_DataTransmissionStatus: 'Состояние передачи данных',
  Cargo_DataType: 'Тип данных',
  Cargo_DataTypeP: 'Тип данных:',
  Cargo_Date: 'Дата',
  Cargo_DateCanTBeEmpty: 'Дата не может быть пустой',
  Cargo_DateFrom: 'Дата начала',
  Cargo_DateFunction: 'Дата',
  Cargo_DateNotInPeriod: 'В отсутствие даты',
  Cargo_DateOfApplication: 'Дата подачи заявления',
  Cargo_DateOfCollectionCanTBeEmpty: 'Дата получения не может быть пустой.',
  Cargo_DateOfDeclaration: 'Дата объявления',
  Cargo_DateOfDepartureCannotBeNull: 'Дата отправления не может быть пустой.',
  Cargo_DateOfDocument: 'Дата оформления',
  Cargo_DateOfInvoicingList: 'Дата выставления счета',
  Cargo_DateP: 'Дата:',
  Cargo_DateType: 'Тип даты',
  Cargo_DateType2: 'Тип даты 2',
  Cargo_Days: 'Боже.',
  Cargo_DaysFromContractSigned: 'Количество дней подписания',
  Cargo_DaysOfSleep: 'Количество дней сна',
  Cargo_DaysOverdue: 'Количество просроченных дней',
  Cargo_DaysToContractExpiry: 'Количество дней, истекающих в ближайшее время',
  Cargo_DBASBEICS: 'При выборе наличных номер банковского счета должен быть пустым по умолчанию',
  Cargo_Deadline: 'Крайний срок',
  Cargo_TempCredit: 'Временный контроль',
  Cargo_EtdDays: 'Расчетное время отправления',
  Cargo_EtdExceedsDays: 'Превышение ETD на {0} дней, невозможен выпуск номера.',
  Cargo_EtdExceedsDaysOrder: 'ETD превышен на {0} дней, отгрузочные документы не могут быть выпущены.',
  Cargo_ShippingDocumentsNotBeReleased: 'Отгрузочные документы не будут выдаваться до полной оплаты всех транспортных расходов.',
  Cargo_SpecialFeePaymentLimit: 'Ограничения на заявки об оплате специальных расходов',
  Cargo_PaymentOnlySpecificCosts: 'Заявки на оплату специальных расходов должны включать только эти целевые расходы и не должны содержать никаких других затрат.',
  Cargo_ThePaymentNotSettled: 'Платеж за {0} месяц(а/ев) не погашен.',
  Cargo_UnconfirmedSum: '{0}+{1}+{2}+{3} не подтверждено, пожалуйста, подтвердите сначала!',
  Cargo_SpecialApproval2: 'Специальное одобрение',
  Application_Item: 'Пункт заявки',
  Application_Content: 'Содержание заявки',
  Application_Reason: 'Причина подачи заявки',
  Cargo_DomesticOverseas: 'Внутренний/Зарубежный',
  Cargo_IncludeOverseasWarehouse: 'Включая зарубежный склад',
  Cargo_SignContract2: 'Заключение договора',
  Cargo_LatestContractDate: 'Последняя дата заключения договора',
  Cargo_CreditControlSelfAssessment: 'Таблица самооценки кредитного лимита',
  Cargo_CustomerFile: 'Карточка клиента',
  Cargo_CustomerConsignmentNote: 'Товарно-транспортная накладная клиента',
  Cargo_HasContract: 'Есть договор',
  Cargo_NoContract: 'Нет договора',
  Cargo_ContractStatus2: 'Наличие договора',
  Cargo_SupplierFile: 'Файл поставщика',
  Cargo_ApprovalSummary: 'Краткое содержание утверждения',
  Cargo_AlreadyExistsCannotSubmit: '{0} уже существует, невозможно отправить заявку!',
  Action_AddAttachment: 'Добавить вложение',
  Validation_ApplicationContentRequired: 'Содержание заявки не может быть пустым.',
  Validation_ApplicationReasonRequired: 'Причина подачи заявки не может быть пустой.',
  Cargo_AutoReceivablesWriteOff: 'Автоматический зачёт дебиторской задолженности',
  Cargo_WhetherIgnore: 'Игнорировать',
  Cargo_TempCreditNotBeCross: 'Временный срок действия не может пересекаться.',
  Cargo_TempCreditNotice: 'Примечание: Сумма / расчетная единица временного требования к единице контракта (вступает в силу на следующий день)',
  Cargo_CurrentCreditNotice: 'Примечание: Период / сумма, соответствующая требованиям в текущем времени, будет синхронизирована с временным контроллером, поддерживаемым в тот же день, на следующий день с партнером',
  Cargo_CurrentAvailableNotEntered: 'Текущее доступное количество не введено',
  Cargo_Debit: 'Одолжи.',
  Cargo_DebitAmount: 'Дебит суммы',
  Cargo_DebitAmount2: 'Заимствованная сумма',
  Cargo_DebitAmountCNY: 'Дебетовая сумма (в юанях)',
  Cargo_DebitAmountOccurred: 'Дебетовые обязательства',
  Cargo_DebitAmountOccurredCNY: 'Дебетовые платежи (в юанях)',
  Cargo_DebitAmountOccurredP: 'Дебетовые платежи:',
  Cargo_DebitAmountOccurredUSD: 'Дебетовые платежи (долл. США)',
  Cargo_DebitAmountTo: 'Итого, Debit',
  Cargo_DebitAmountToP: 'Итого, Debit:',
  Cargo_DebitAmountUSD: 'Дебетовая сумма (в долл. США)',
  Cargo_DebitLocalCurrency: 'Дебетовая валюта',
  Cargo_DebitNotWrittenOff: 'Дебит не продается',
  Cargo_DebitOriginalAmount: 'Оригинальная сумма Debit',
  Cargo_DebitSide: 'Заемщик',
  Cargo_DebitSideCNY: 'Заимствование (в юанях)',
  Cargo_DebitSideCreditSide: 'Заимствование / кредитование',
  Cargo_DebitSideCreditSideP: 'Заемщик / кредитор:',
  Cargo_DebitSideUSD: 'Заимствование (долл. США)',
  Cargo_DebitWriteOffAmount: 'Списанные суммы',
  Cargo_December: 'Декабрь',
  Cargo_DeclareWarehouseLoadingContainer: 'Таможенная декларация',
  Cargo_DeemedPrinted: '& Печать',
  Cargo_VGMLog: 'Журнал VGM',
  Cargo_SendVGM: 'Отправить VGM',
  Cargo_VGMChannel: 'Канал VGM',
  Cargo_VGMBasicInfo: 'Основные сведения о VGM',
  Cargo_FriendlyReminder: 'Теплый совет: пожалуйста, заполните основной номер',
  Cargo_VGMCutOffDate: 'Дата VGM',
  Cargo_ContainerHolder: 'Владелец ящика',
  Cargo_NotFilledIn: 'Без заполнения, пожалуйста, заполните после отправки.',
  Cargo_NotSelected: 'Не выбрано, заполните после отправки после завершения.',
  Cargo_PleaseMaintainCargoInfo: 'Поддерживайте информацию о контейнере.',
  Cargo_IfYouHaveSentPreStowageManifest: 'Если вы отправили предварительный манифест через канал морской экономки, синхронизация будет подписана со страницы предварительной информации;',
  Cargo_IfYouHaveNotSentPreStowageManifest: 'Если предварительная накладная не была отправлена через канал морской экономки, синхронизация будет подписана с основной страницы бронирования.',
  Cargo_FriendlyReminderWithPort: 'Теплый совет: порт Шанхая, рекомендуется отправить сообщение VGM после завершения предварительного ввода, баржа принимает большой корабль, в зависимости от времени баржи',
  Cargo_TerminalInfoForReferenceOnly: 'Информация о пристани только для справки, пожалуйста, используйте люк бронирования!',
  Cargo_TerminalInfoForReferenceWse: 'Если информация о причале заказа не соответствует нашей справочной информации о причале, пожалуйста, свяжитесь с гостевым сервисом, спасибо!',
  Cargo_IfBookingPortTerminalInfoDoesNotMatchPleaseContactCustomerService: 'Если информация о терминале заказа не соответствует нашей справочной информации о терминале, пожалуйста, свяжитесь с службой обслуживания клиентов.',
  Cargo_FriendlyReminderWithCutOffTime: 'Теплый совет: Пожалуйста, заполните правильное время перехвата, мы отправим его несколько раз в соответствии с этой датой, если плата за задержку из - за информационной ошибки, платформа не будет нести.',
  Cargo_TheShipperDeclares: 'Грузоотправитель по договору заявляет, что информация о весе грузового контейнера, содержащаяся в документе, была получена в соответствии с методикой, изложенной в Международной конвенции по охране человеческой жизни на море 1974 года, и что основные измерительные приборы получили сертификат метрологической проверки, выданный техническим органом по метрологии, и что дата получения веса находится в пределах действия сертификата.',
  Cargo_RepeatedlySendingVGMWithTheSameContainerTips: 'Повторная отправка VGM с одним и тем же номером ящика будет платной несколько раз, если вам нужно отправить еще раз {0}S После отправки.',
  Cargo_Send_VGM_Reminder: 'Плата за отправку VGM взимается один раз за каждый номер ящика, а многократная отправка одного и того же номера ящика повторяется. Если сообщение VGM изменяется, просто отправьте сообщение VGM измененного ящика. < / / br > Пожалуйста, убедитесь, что отправка продолжается?',
  Cargo_ContinueSending: 'Продолжить отправку',
  Cargo_ResendAfterS: 'S После пересылки',
  Cargo_ExternalAssociationCode: 'Код внешней связи',
  Cargo_ExternalAssociationCodeValidMessage: 'Внешний код может быть только буквой или цифрой.',
  Cargo_ShippingCompanyReceiptStatus: 'Паромная компания',
  Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'В поле порта отправления не найдена информация, соответствующая морской экономке, пожалуйста, отметьте.',
  Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'В поле судоходной компании не найдена информация, соответствующая морской экономке, пожалуйста, отметьте.',
  Cargo_CharLengthWithRange: 'Длина от {0} до {1} символов',
  Cargo_TheBoxNumberMustBe: 'Номер ячейки должен быть 4 буквы + 7 цифр.',
  Cargo_LoadWharfTips: 'Информация о пристани только для справки, пожалуйста, используйте люк бронирования! Если информация о причале заказа не соответствует нашей справочной информации о причале, пожалуйста, свяжитесь с гостевым сервисом, спасибо!',
  Cargo_WhetherToContinueSendingVGM: 'Продолжить отправку VGM?',
  Cargo_Default: 'По умолчанию',
  Cargo_DefaultAPUnitPrice: 'Удельная стоимость по умолчанию',
  Cargo_DefaultARCurrency: 'Денежная задолженность по умолчанию',
  Cargo_DefaultAPCurrency: 'Кредиторская задолженность по умолчанию',
  Cargo_DefaultARUnitPrice: 'Цена единицы дебиторской задолженности по умолчанию',
  Cargo_DefaultDecimalPlaces: 'Число десятичных знаков по умолчанию',
  Cargo_DefaultLine: 'Строка по умолчанию',
  Cargo_DefaultMenuItems: 'Элементы меню по умолчанию',
  Cargo_DefaultOrNot: 'По умолчанию',
  Cargo_DefaultPayee: 'Объект по умолчанию',
  Cargo_DefaultPayer: 'Объект к получению по умолчанию',
  Cargo_DefaultSearchCondition: 'Условия запроса по умолчанию',
  Cargo_DefaultValue: 'Значение по умолчанию',
  Cargo_SeDefaultValue: 'Океан по умолчанию',
  Cargo_SiDefaultValue: 'Значение по умолчанию',
  Cargo_AeDfaultValue: 'Очистить значение по умолчанию',
  Cargo_AiDfaultValue: 'Значение по умолчанию',
  Cargo_ReDfaultValue: 'Выйти из значения по умолчанию',
  Cargo_RiDfaultValue: 'Железо по умолчанию',
  Cargo_EditDefaultValue: 'Изменить значение по умолчанию',
  Cargo_EditJobDefaultValueTip: `Если значения по умолчанию для каждого типа бизнеса различны, поддерживайте их в текстовом поле соответствующего типа бизнеса;
Если текстовое поле бизнес - типа и значение по умолчанию поддерживают значение, приоритет отдается значению соответствующего бизнес - типа текстового поля;`,
  Cargo_DefaultWriteOffCurrency: 'Валюта по умолчанию',
  Cargo_DelayedTaxRefund: 'Это просроченный налог.',
  Cargo_DelegationTypeRailway: 'Тип поручения (железная дорога)',
  Cargo_Delete: 'Удалить',
  Cargo_DeleteConfirmation: 'Вы уверены, что хотите удалить выбранную запись?',
  Cargo_DeleteBill: 'Удалить счет',
  Cargo_DisplayRules: 'Показать правила',
  Cargo_ViewAttachments: 'Посмотреть вложение',
  Cargo_DeleteCollectionRecord: 'Удалить регистрацию инкассо',
  Cargo_DeletedBillList: 'Удален список счетов',
  Cargo_DeletedSuccessfully: 'Удалить успешно.',
  Cargo_WithdrawSuccessfully: 'Снятие успешно.',
  Cargo_DeletedNotHavePermission: 'Вы не имеете права удалять это предложение.',
  Cargo_DeletedNotIntoBusiness: 'Предложение включено в стоимость бизнеса и не может быть удалено!',
  Cargo_DeleteEntry: 'Удалить запись',
  Cargo_DeleteFailed: 'Ошибка удаления.',
  Cargo_DeleteFee: 'Удалить расходы',
  Cargo_DeleteFeeConfirmedListSync: 'Удалить подтверждение расходов',
  Cargo_DeleteInvoice: 'Удалить счет',
  Cargo_DeleteNotification: 'Удалить подсказку',
  Cargo_DeleteOrNot: 'Удалить?',
  Cargo_DeleteVoucher: 'Удалить сертификат',
  Cargo_Delivered: 'Отправлено',
  Cargo_DeliveredButNotRetrieved: 'Отправлено (не возвращено)',
  Cargo_DeliveredSuccessfully: 'Отправить успешно.',
  Cargo_DeliveredToBranch: 'Отправить ли чрезмерную компанию',
  Cargo_DeliverPartial: 'Отправить частично',
  Cargo_DeliverySigned: 'Подписано',
  Cargo_DenialReason: 'Причины отказа',
  Cargo_DenialReasonP: 'Причины отказа:',
  Cargo_Denied: 'Отказано',
  Cargo_DeniedSuccessfully: 'Отказ от успеха.',
  Cargo_DenyApplication: 'Отказ в просьбе',
  Cargo_DenyPaymentApplication: 'Отказ в оплате',
  Cargo_Department: 'Сект.',
  Cargo_DepartmentApproval: 'Утверждение департаментом',
  Cargo_DepartmentP: 'Сектор:',
  Cargo_DepartureTime: 'Время отправления',
  Cargo_DepositBank: 'Банк - депозитарий',
  Cargo_DepositBankAccountNo: 'Счет в банке',
  Cargo_DepositBankAndAccountNo: 'Счет и номер счета',
  Cargo_DepositBankAndAccountNoP: 'Счет и номер счета:',
  Cargo_DesCharge: 'Расходы по назначению',
  Cargo_DescriptionCanTBeEmpty: 'Описание содержимого не может быть пустым',
  Cargo_DescriptionOfCharge: 'Содержание платы',
  Cargo_DescriptionOfExpenseItem: 'Название статьи расходов',
  Cargo_DescriptionOfExpenseItemCNY: 'Название статьи расходов',
  Cargo_DescriptionOfExpenseItemUSD: 'Название статьи расходов USD',
  Cargo_DescriptionOfExpenseItemJPY: 'Название статьи расходов JPY',
  Cargo_DescriptionOfExpenseItemEUR: 'Название статьи расходов EUR',
  Cargo_DescriptionOfPlan: 'Описание программы',
  Cargo_DescriptionOfQuantity: 'Количество',
  Cargo_DescriptionOfVoucherType: 'Тип документа',
  Cargo_DesignatedDepartment: 'Назначенные органы',
  Cargo_DesignSubTitlesOfAccount: 'Подпредметы дизайна',
  Cargo_Destination: 'Пункт назначения',
  Cargo_ChargeItemMaintenance: 'Техническое обслуживание платных проектов',
  Cargo_ZeroTaxRate: 'Нулевая ставка налога',
  Cargo_DestinationAgent: 'Агент порта назначения',
  Cargo_DestinationAgent1: 'Зарубежные агенты',
  Cargo_DestinationChargeOrNot: 'Расходы по назначению',
  Cargo_DestinationPort: 'Порт назначения',
  Cargo_DestinationPortSea: 'Порт назначения (морские перевозки)',
  Cargo_DestinationPortAir: 'Порт назначения (воздушный транспорт)',
  Cargo_OverseaWarehouse: 'Зарубежные склады',
  Cargo_NoRestriction: 'Без ограничений',
  Cargo_Details: 'детальный',
  Cargo_DetailsOfOutOfPocketRecord: 'Подробная информация о произведенных платежах',
  Cargo_DetailsOfSingleWriteOff: 'Подробная информация об отдельных списаниях',
  Cargo_DetailsOfSingleWriteOffPDF: 'Подробная информация о списании.pdf',
  Cargo_DetailsOfSingleWriteOffXLS: 'Подробная информация о списании.xls',
  Cargo_DevelopedAtExhibitions: 'Выставка развивается',
  Cargo_Difference: 'Разница',
  Cargo_DifferenceAdjustment: 'Корректировка разницы',
  Cargo_DifferenceCNYCNY: 'Разница CNY',
  Cargo_DifferenceUSD: 'Разница USD',
  Cargo_DifferentialAdjustedSuccessfully: 'Корректировка разницы произведена успешно',
  Cargo_DifferentialIs: 'Разница составляет: {0}',
  Cargo_DifferentialProcessing: 'Учет разницы',
  Cargo_DifficultyIndex: 'Индекс сложности преодоления',
  Cargo_DIITRLNLTSIT: 'Список справа не связан с выбранным типом счета - фактуры',
  Cargo_DirectAssign: 'Прямое распределение',
  Cargo_DirectBusiness: 'Прямой список',
  Cargo_DirectConsol: 'Автосборка',
  Cargo_DirectConsolContainerNo: 'Номер ящика',
  Cargo_Direction: 'Направление',
  Cargo_DirectServiceOrNot: 'Является ли прямой',
  Cargo_DiscrepancyExist: 'Есть разница',
  Cargo_DiscrepancyFound: 'Есть разные.',
  Cargo_DisplayAmountOfDifferential: 'Показать разницу',
  Cargo_DisplayAmountOfReconciliation: 'Показывать выверенные суммы',
  Cargo_DisplayBatchOperation: 'Показывать пакетные операции',
  Cargo_DisplayCashFlowItems: 'Наличные средства',
  Cargo_DisplayExpenseDetails: 'Показать разбивку расходов',
  Cargo_DisplayMonthSelector: 'Показать выбранный месяц',
  Cargo_DisplayOrder: 'Показать последовательность',
  Cargo_DisplayTotalCost: 'Показать общую стоимость',
  Cargo_DisplayTotalIncome: 'Показать общий объем поступлений',
  Cargo_DisplayUnCodedRecordsOnly: 'Просмотреть код как пустой',
  Cargo_DisplayUnInvoicedAmount: 'Показать сумму неоплаченного счета',
  Cargo_DistributedReconciliationAmount: 'Выверка начисленных взносов',
  Cargo_DistributionCostOrNot: 'Распределение расходов',
  Cargo_District: 'Районы',
  Cargo_DLCCLCCTBE: 'Дебетовая / кредитная валюта не может быть пустой.',
  Cargo_DMROITE: 'Тип счета - фактуры {0} Записи о повторном обслуживании',
  Cargo_DNBTCBOHC: 'Работающие данные, где филиал не принадлежит текущему филиалу или филиалу предыдущего уровня, вы уверены, что хотите продолжить?',
  Cargo_DORMBGTTDOR: 'Дата возврата должна быть больше, чем дата возврата.',
  Cargo_InvoiceNature: 'Тарифная маркировка',
  Cargo_InvoiceNatureTip: 'Налоговые ставки могут быть скорректированы только тогда, когда они обозначены как нормальные',
  Cargo_DOCOTS: 'Наименование товаров или облагаемых налогом услуг',
  Cargo_DocReleaseAgainstPayment: 'Платежи',
  Cargo_DocumentationType: 'Выход одного типа',
  Cargo_DocumentCirculation: 'Передача документов',
  Cargo_Documents: 'Документация',
  Cargo_DOEICTBE: 'Название статьи расходов не может быть пустым',
  Cargo_Domestic: 'Внутренние',
  Cargo_DomesticBill: 'Внутренние счета',
  Cargo_DomesticChargeInformation: 'Внутренние сборы',
  Cargo_DomesticCollection: 'Внутренние поступления',
  Cargo_DomesticDirectClient: 'Внутренние клиенты',
  Cargo_DomesticDirectClientOrNot: 'Являются ли отечественные клиенты',
  Cargo_DomesticOrInternational: 'Внутренний / внешний',
  Cargo_DomesticPayment: 'Внутренние платежи',
  Cargo_DomesticTrade: 'Внутренняя торговля',
  Cargo_DoNotSelectMultipleItems: 'Не выбирайте несколько',
  Cargo_Door: 'Точка входа',
  Cargo_DoorAddress: 'Адрес точки входа',
  Cargo_DoorLoadingDelivery: 'Упаковка / доставка через ворота',
  Cargo_DoorPickup: 'Доставка через ворота.',
  Cargo_DOPNCTBLTAC: 'Положительная разница не может быть меньше 1 цента.',
  Cargo_DoubleClickToView: 'Двойной щелчок для просмотра',
  Cargo_DownloadCompleted: 'Скачать успешно!',
  Cargo_DownloadFailed: 'Скачать не удалось!',
  Cargo_DrawABillOrNot: 'Все ли выставлены счета',
  Cargo_DRIRORIOCA: 'Дебиторская задолженность по дивидендам Проценты к получению Прочая дебиторская задолженность Инвентарные запасы Прочие текущие активы',
  Cargo_DSAIM: 'Показать способ расчета и выставления счета',
  Cargo_DSCSDSCS: 'Заемщик',
  Cargo_Dues: 'К оп.',
  Cargo_DuesB: '(К оплате)',
  Cargo_DuesToCNY: 'Эквивалент CNY должен:',
  Cargo_EquivalentCNY: 'Эквивалент CNY:',
  Cargo_DuesCNY: 'CNY Ответить',
  Cargo_DuesEUR: 'EUR Ответить',
  Cargo_DuesGBP: 'GBP Ответить',
  Cargo_DuesHKD: 'HKD Ответить',
  Cargo_DuesJPY: 'JPY справляется',
  Cargo_DuesNGN: 'NGN Ответить',
  Cargo_DuesP: 'Причитается:',
  Cargo_DuesUSD: 'USD Ответить',
  Cargo_DuplicateCodePleaseTryItAgain: 'Код повторяется, пожалуйста, введите заново.',
  Cargo_DuplicateContent: 'Копировать содержимое',
  Cargo_DutyFree: 'Освобождение от налогов',
  Cargo_Uncertain: 'Не уверен.',
  Cargo_DynamicCurrencyDisplayColumn: 'Динамика Показать валюту',
  Cargo_ECDICA: 'Очистить содержимое промежуточной области',
  Cargo_ECNETSFS: 'Введите имя кода и ждите возврата к нечеткому запросу.',
  Cargo_ECSNMIR: 'Статус учета расходов не соответствует требованиям к выставлению счетов',
  Cargo_ECSNMPAR: 'Статус учета расходов не соответствует требованиям к оплате',
  Cargo_ECSNMWOR: 'Статус учета расходов не соответствует требованиям к списанию',
  Cargo_EdiCode: 'Код EDI',
  Cargo_EdiInterfaceTypeOfEInvocing: 'Тип внешнего интерфейса электронного выставления счетов',
  Cargo_EdiInterfaceTypeOfInvoicing: 'Тип внешнего интерфейса',
  Cargo_Edit: 'Редактирование',
  Cargo_EditAdjustment: 'Изменения',
  Cargo_EditAirFreightServiceItems: 'Редактирование услуг по авиаперевозкам',
  Cargo_EditAssociatedPort: 'Изменить ассоциированный порт',
  Cargo_EditAwbSurcharge: 'Редактирование авианакладных',
  Cargo_EditBill: 'Изменить счет',
  Cargo_EditBLType: 'Изменить тип коносамента',
  Cargo_EditChargeFinancialDate: 'Изменение финансовых дат',
  Cargo_EditCirculationDocumentType: 'Изменить тип файла потока',
  Cargo_CirculationDocumentType: 'Тип файла потока',
  Cargo_EditClientType: 'Изменить тип клиента',
  Cargo_EditCommissionRules: 'Правила редактирования',
  Cargo_EditContract: 'Редактирование контрактов',
  Cargo_EditCustomizedServiceType: 'Изменить свой тип бизнеса',
  Cargo_EditedSuccessfully: 'Изменения были успешными.',
  Cargo_EditField: 'Изменить поле',
  Cargo_EditFinancialDate: 'Изменение финансовых дат',
  Cargo_EditFormula: 'Изменить формулу -',
  Cargo_EditKeyWord: 'Редактирование конфиденциальных слов',
  Cargo_EditMscService: 'Редактирование MSC Service',
  Cargo_EditOppositeVoucherNo: 'Изменить номер сертификата',
  Cargo_EditOrNot: 'Редактировать',
  Cargo_EditRemarks: 'Изменить примечание',
  Cargo_EditRoute: 'Изменить маршрут',
  Cargo_EDTTTC: 'Подробная разбивка расходов, подлежащих переводу на инкассо',
  Cargo_EDTTTCP: 'Разбивка расходов, подлежащих переводу на инкассо:',
  Cargo_EffectiveDate: 'Дата вступления в силу',
  Cargo_EffectiveMonth: 'Эффективный месяц',
  Cargo_EICCMBU: '\'КолоннаColumn \'Входные значения Currency нарушают ограничения уникальности',
  Cargo_EINDWI: 'Вводится ли счет непосредственно в номер счета',
  Cargo_EInvoiceCanTBePrinted: 'Электронные счета - фактуры не могут быть напечатаны.',
  Cargo_EInvoiceCanTBeVoided: 'Электронные счета не могут быть аннулированы.',
  Cargo_EInvoicePaperInvoice: 'Электронные счета - фактуры',
  Cargo_EmailAddress: 'Электронная почта',
  Cargo_EMailAlertForTestOnly: 'Почтовые напоминания (специально для тестирования)',
  Cargo_EmailSent: 'Почта отправлена.',
  Cargo_Empty: 'Очистить',
  Cargo_EmptyData: 'Очистить данные',
  Cargo_EmptyEntries: 'Очистить вход',
  Cargo_EmptyOriginalCurrency: 'Очистить валюту',
  Cargo_EMSSCM: 'Почта отправлена успешно, обратите внимание на проверку',
  Cargo_EndDate: 'Крайний срок',
  Cargo_EnglishCargoName: 'Английское название',
  Cargo_EnglishCommodityNameMsc: 'Английское название (MSC)',
  Cargo_EnglishName: 'Английское имя',
  Cargo_EnglishNameCanTBeEmpty: 'Английское название не может быть пустым.',
  Cargo_Enter: 'Введите',
  Cargo_CannotDeleteUsedCustomerType: 'Не разрешается удалять используемые типы клиентов',
  Cargo_CannotDeleteUsedCustomerContactChannel: 'Запрещается удалять используемые каналы связи с клиентами',
  Cargo_CannotDeleteUsedCustomerRating: 'Не разрешается удалять используемые оценки клиентов',
  Cargo_EnterBusinessTypeToStartSearch: 'Введите запрос типа операции',
  Cargo_EnterExpenseName: 'Имя входной платы',
  Cargo_EnterInvoiceNo: 'Номер счета - фактуры',
  Cargo_EnterInvoiceNoDirectly: 'Введите номер счета напрямую',
  Cargo_EnterKeyWordsToStartFuzzySearch: 'Введите конфиденциальные слова для нечеткого запроса.',
  Cargo_EnterManually: 'РВ',
  Cargo_EnterSpecialInvoiceNo: 'Введите номер счета - фактуры',
  Cargo_EnterVoucherInformation: 'Введите информацию о сертификате',
  Cargo_Entity: 'Субъекты',
  Cargo_EntryDate: 'Дата ввода',
  Cargo_EntryOfNumber: 'Ввод номера',
  Cargo_EqualTo: 'Равно',
  Cargo_Error: 'Ошибка.',
  Cargo_ErrorNoDataFound: 'Ошибка, данных нет.',
  Cargo_ESNMIR: 'Статус оплаты не соответствует требованиям к выставлению счетов',
  Cargo_ESNMPAR: 'Статус расходов не соответствует требованиям к оплате',
  Cargo_ESNMWOR: 'Статус расходов не соответствует требованиям к списанию',
  Cargo_EstTimeOfWarehouseIn: 'Ожидаемое время ввода',
  Cargo_EventOfSettlingParty: 'Расчетное событие',
  Cargo_EventRecord: 'Запись событий',
  Cargo_EventTime: 'Время событий',
  Cargo_EverCancelledWriteOff: 'Осуществлялась ли отмена списания',
  Cargo_ExcelExport: 'Экспорт Excel',
  Cargo_ExcessiveOrNot: 'Превышение',
  Cargo_ExchangeCode: 'Код коммутации',
  Cargo_ExchangeCodeCanTBeEmpty: 'Код обмена не может быть пустым',
  Cargo_ExchangeCurrency: 'Обмен валюты',
  Cargo_ExchangeGainsAndLosses: 'Курсовые прибыли и убытки',
  Cargo_ExchangeRate: 'Обменный курс',
  Cargo_ExchangeRateAdjustmentTable: 'Таблица 1',
  Cargo_ExchangeRateAdjustmentTableP: 'Таблица корректировки обменных курсов:',
  Cargo_ExchangeRateCanTBeEmpty: 'Обменный курс не может быть пустым',
  Cargo_ExchangeRateDifference: 'Перевод средств',
  Cargo_ExchangeRateHKD: 'Валютный курс HKD',
  Cargo_ExchangeRateList: 'Список обменных курсов',
  Cargo_ExchangeRateOfHKD: 'Обменный курс Гонконгской валюты',
  Cargo_ExchangeRateP: 'Обменный курс:',
  Cargo_ExchangeRateUSD: 'Обменный курс USD',
  Cargo_ExclusionFilter: 'Фильтрация отталкивания',
  Cargo_ExecutionMethodOfWindowClosure: 'Метод выполнения закрытия окна',
  Cargo_Existed: 'Уже существует.',
  Cargo_ExpectedReviewDate: 'Предполагаемая дата проверки',
  Cargo_Expenditure: 'Расходы',
  Cargo_ExpenseAdjustment: 'Корректировки расходов',
  Cargo_ExpenseAdjustmentOfCollection: 'Корректировки на инкассо',
  Cargo_ExpenseApprovalProcedure: 'Процесс утверждения расходов',
  Cargo_ExpenseDescriptionCanTBeEmpty: 'Название расходов не может быть пустым.',
  Cargo_ExpenseItemsCanTBeEmpty: 'Расходы в счете не могут быть пустыми.',
  Cargo_ExpenseListNonEntity: 'Таблица расходов',
  Cargo_ExpenseNotSelected: 'Расходы не выбраны.',
  Cargo_ExpenseRejectedSuccessfully: 'Расходы отклонены.',
  Cargo_ExpenseRelated: 'Соответствие расходов',
  Cargo_ExpenseReviewedBy: 'Аудитор расходов',
  Cargo_ExpenseSearch: 'Запросы о расходах',
  Cargo_ExpenseSelection: 'Выбор стоимости',
  Cargo_ExpenseSettlingParty: 'Объект расчетов',
  Cargo_ExpenseWriteOffCanTBeEmpty: 'Расходы на списание не могут быть пустыми.',
  Cargo_ExpenseWrittenOffCanTBeSplit: 'Затраты распроданы, их нельзя разделить!',
  Cargo_ExpiryDateCanTBeEmpty: 'Дата истечения срока действия не может быть пустой',
  Cargo_Export: 'Экспорт',
  Cargo_ExportBaiwangInvoice: 'Экспорт счета - фактуры',
  Cargo_ExportClientSuccessfully: 'Экспортировать клиента успешно',
  Cargo_ExportedSuccessfully: 'Экспорт удался.',
  Cargo_ExportExcel: 'Экспорт EXCLE',
  Cargo_ExportExpenses: 'Экспорт затрат',
  Cargo_ExportFailed: 'Ошибка экспорта.',
  Cargo_ExportOrNot: 'Экспорт',
  Cargo_ExportRecordsSuccessfully: 'Экспорт записи успешно',
  Cargo_ExportRequired: 'Требуется экспорт',
  Cargo_ExportResult: 'Экспорт результатов',
  Cargo_ExportSuccessfully: 'Экспорт завершен, успешно',
  Cargo_ExportVatInvoice: 'Экспорт счета НДС',
  Cargo_ExportVatInvoiceXLS: 'Экспорт счета НДС.xls',
  Cargo_ExportVoucher: 'Экспортировать сертификат',
  Cargo_ExportWriteOffDetails: 'Экспорт деталей списания',
  Cargo_ExpressAddress: 'Адрес курьера',
  Cargo_ExpressInfo: 'Экспедиционная информация',
  Cargo_Extend: 'Задержка',
  Cargo_ExtendPeriod: 'Продление',
  Cargo_ExtensionAfterExpiration: 'Задержка после истечения срока',
  Cargo_ExtensionCycle: 'Цикл задержки',
  Cargo_External: 'Внешний',
  Cargo_Fax: 'Факс',
  Cargo_FCAEFAIIVWBIWBCCTV: 'Есть ли {0} счета - фактуры, которые экспортировали финансовую документацию, и если система аннулирования будет генерировать счет - фактуру красного цвета, подтвердит, что она недействительна?',
  Cargo_FCAOCAE: 'Расчет суммы в иностранной валюте',
  Cargo_FCASPSCT: 'Выберите валюту, которая должна учитываться',
  Cargo_FCL: 'Весь ящик',
  Cargo_SpecialSize: 'Особые размеры',
  Cargo_SpecialSizeTip: 'После галочки список информации о упаковке может дополнительно отображать поле « Размер спецификации (длина * ширина * высокая единица М) ».',
  Cargo_FclLclTypeSeaExport: 'Тип целой сборки (выход из моря)',
  Cargo_FclLclTypeSeaImport: 'Тип целой сборки (Seaving)',
  Cargo_EstimatedArrivalTimeSeaExport: 'Расчетное время отправления из порта (морской экспорт)',
  Cargo_EstimatedArrivalTimeSeaImport: 'Расчетное время прибытия в порт (морской импорт)',
  Cargo_EstimatedArrivalTimeAirExport: 'Расчетное время прибытия (авиаэкспорт)',
  Cargo_FDMOPPE0: 'Назначенная дата в месяц или период счета больше 0',
  Cargo_February: 'Февраль',
  Cargo_FeederOrNot: 'Является ли баржа',
  Cargo_FIAICTR: 'Следующий бланк заявки на выставление счета уже открыт и не может быть отозван!',
  Cargo_FIDSEC: 'Вы выбрали стоимость различных расчетных единиц и решили продолжить консолидацию счетов?',
  Cargo_FileApplication: 'Подача заявления',
  Cargo_FileDocumentation: 'Документация',
  Cargo_FileFormat: 'Формат файла',
  Cargo_FileHistory: 'История файлов',
  Cargo_FileLoadingFailed: 'Ошибка загрузки файла',
  Cargo_FileName: 'Название файла',
  Cargo_FileNo: 'Номер документа',
  Cargo_FileNotFoundInCloud: 'Облачное хранилище не может найти этот файл',
  Cargo_FileRetrievedSuccessfully: 'Файл был успешно возвращен.',
  Cargo_FileSize: 'Размер файла',
  Cargo_FileStatus: 'Статус файла',
  Cargo_FileType: 'Тип документа',
  Cargo_FileTypeDescription: 'Имя типа файла',
  Cargo_Filter: 'Фильтр',
  Cargo_FilterP: 'Фильтр:',
  Cargo_FinalDestination: 'Конечный пункт назначения',
  Cargo_FinancialApprovalDate: 'Дата финансового утверждения',
  Cargo_FinancialApproved: 'Финансовое утверждение',
  Cargo_FinancialAudit: 'Финансовый аудит',
  Cargo_FinancialAuditDetail: 'Финансовый аудит - подробнее',
  Cargo_FinancialChangeReview: 'Проверка распоряжений о внесении финансовых изменений',
  Cargo_FinancialCharges: 'Финансовые расходы',
  Cargo_FinancialCode: 'Финансовый код',
  Cargo_FinancialDate: 'Финансовые даты',
  Cargo_FinancialExpenseIs: 'Финансовые расходы включают:',
  Cargo_FinancialPeriod: 'Финансовый период',
  Cargo_FinancialReceived: 'Получено',
  Cargo_FinancialRemarks: 'Финансовые примечания',
  Cargo_FinancialSoftware: 'Финансовое программное обеспечение',
  Cargo_FinasialCheck: 'Финансовая экспертиза',
  Cargo_FindExistingCurrencies: 'Найдите уже существующие валюты.',
  Cargo_FirstAccruedProfit: 'Первая прибыль',
  Cargo_FirstAccruedTime: 'Время первого отсчета',
  Cargo_FirstContactDate: 'Дата первоначального контакта',
  Cargo_FiscalPeriod: 'Финансовый период',
  Cargo_Fit: 'рассеянный гость',
  Cargo_FixedAccountingCode: 'Фиксированный бухгалтерский код',
  Cargo_FixedDateMonthly: 'Назначенные ежемесячные даты',
  Cargo_FJTLCTW: 'Следующие рабочие листы заблокированы и не могут быть возвращены:',
  Cargo_FLCLType: 'Тип целой сборки',
  Cargo_FlightVoyage: 'Рейсы',
  Cargo_FollowingBillsInTheTextNotFound: 'Следующие счета в тексте не найдены:',
  Cargo_ForAirBusiness: 'Использование воздушного транспорта',
  Cargo_ForAirExportBusiness: 'Экспорт воздушным транспортом',
  Cargo_ForAirImportBusiness: 'Импорт воздушным транспортом',
  Cargo_ForRailwayBusiness: 'Использование железных дорог',
  Cargo_ForIntegratedJob: 'Комплексное логистическое использование',
  Cargo_ForFbaSeaBusiness: 'FBA Морские перевозки',
  Cargo_ForFbaAirBusiness: 'FBA Воздушный транспорт',
  Cargo_ForFbaRailwayBusiness: 'Использование железных дорог FBA',
  Cargo_ForceDelete: 'Обязательное удаление',
  Cargo_ForeignCurrency: 'Иностранная валюта',
  Cargo_ForeignCurrencyAccounting: 'Учет в иностранной валюте',
  Cargo_ForeignCurrencyAccountingExist: 'Учет в иностранной валюте.',
  Cargo_ForeignTrade: 'Внешняя торговля',
  Cargo_Format: 'Форматирование',
  Cargo_FormLayout: 'Форма',
  Cargo_FormVerification: 'Проверка формы',
  Cargo_ForOceanBusiness: 'Морские перевозки',
  Cargo_ForOtherBusiness: 'Прочее оперативное использование',
  Cargo_ForRailwayExportBusiness: 'Экспортное использование железных дорог',
  Cargo_ForSeaExportBusiness: 'Экспортные морские перевозки',
  Cargo_ForSeaImportBusiness: 'Морской импорт',
  Cargo_FreeDetension: 'Бесплатная аренда',
  Cargo_FreightForwardingFee: 'Оплата экспедиторских услуг',
  Cargo_FristApprovalDate: 'Время подачи заявки',
  Cargo_From: 'От',
  Cargo_Frozen: 'Заморожены',
  Cargo_FrozenSuccessfully: 'Замораживание успешно.',
  Cargo_FullPayment: 'Полный платеж',
  Cargo_FullScreenDisplay: 'Показать полный экран',
  Cargo_Fumigation: 'Фумигация',
  Cargo_FunctionOfSuccessfulAcquisition: 'Получение функции успеха',
  Cargo_FVOCPIOOPRECTBV: 'В настоящее время отчеты о получении и оплате экспортированы финансовые документы, которые не могут быть аннулированы',
  Cargo_FVOVNP: 'Сертификат 【{0}】 Следующие проверки не прошли:',
  Cargo_GeneralInvoice: 'Общий счет - фактура',
  Cargo_GeneralLedger: 'Главная бухгалтерская книга',
  Cargo_GeneralLedger2: 'Общая бухгалтерская книга2',
  Cargo_GeneralRate: 'Обычная цена',
  Cargo_GeneratedAccountStatement: 'Созданы ли счета',
  Cargo_GeneratedBillsOrNot: 'Созданы ли счета',
  Cargo_GetBack: 'Взять обратно',
  Cargo_GoldenTaxationExportPrint: 'Налог на экспорт',
  Cargo_GoOn: 'Продолжай.',
  Cargo_ARAP_Locked: 'В выбранных операциях заблокированы как дебиторская, так и кредиторская задолженности, невозможно добавить расходы.',
  Cargo_AR_Locked: 'В выбранных операциях заблокирована дебиторская задолженность, невозможно добавить дебиторские расходы.',
  Cargo_AP_Locked: 'В выбранных операциях заблокирована кредиторская задолженность, невозможно добавить кредиторские расходы.',
  Cargo_Only_AR: 'Текущий пользователь может добавлять только дебиторские расходы.',
  Cargo_Only_AP: 'Текущий пользователь может добавлять только кредиторские расходы.',
  Cargo_Cannot_Add_Charge: 'Текущий пользователь не может добавлять расходы.',
  Cargo_ChargeLockStatusChanged: 'Статус блокировки дебиторской/кредиторской задолженности обновлен, пожалуйста, выполните повторный запрос и повторите добавление расходов.',
  Cargo_GrandTotal: 'Всего',
  Cargo_GrandTotalP: 'Итого:',
  Cargo_GreaterThan: 'Больше чем',
  Cargo_GroupCompany: 'Группа компаний',
  Cargo_GroupExchangeRate: 'Обменный курс группы',
  Cargo_GroupingConditions: 'Условия группировки',
  Cargo_GroupingConditions1: 'Условия группирования 1',
  Cargo_GroupingConditions2: 'Условия группирования 2',
  Cargo_GroupingConditions3: 'Условия группирования 3',
  Cargo_GroupingConditions4: 'Условия группирования 4',
  Cargo_GroupingConditions5: 'Условия группирования 5',
  Cargo_GroupingConditions6: 'Условия группирования 6',
  Cargo_GroupingMethod: 'Метод группирования',
  Cargo_GroupingRulesOfJournalEntries: 'Правило группирования записей',
  Cargo_GroupingType: 'Тип группы',
  Cargo_GroupingTypesOfJournalEntries: 'Типы групп',
  Cargo_GroupingTypesOfJournalEntriesP: 'Типы групп для записи:',
  Cargo_HalfMonthly: 'Полумесяц',
  Cargo_Harbour: 'Морской порт',
  Cargo_HaulageCompany: 'Транспортная компания',
  Cargo_HaveHas: 'Есть.',
  Cargo_HaveOrNot: 'Есть ли',
  Cargo_HazmatContained: 'Содержит ли он опасные вещества',
  Cargo_HBLFreightTerm: 'Условия фрахта по накладной',
  Cargo_HBLMode: 'Формы коносамента HB / L',
  Cargo_MBLMode: 'MB / L Формы коносамента',
  Cargo_HBLTransitTerm: 'Условия перевозки',
  Cargo_HedgingInvoice: 'Счет хеджирования',
  Cargo_HideQuantity: 'Скрыть количество',
  Cargo_HoldCargoOrNot: 'Арест или нет',
  Cargo_HoldDoc: 'Штраф',
  Cargo_SpecialApprovalOrder: 'Специальные заказы',
  Cargo_HoldSubmission: 'Приостановление представления',
  Cargo_HqSWriteOffPendingConfirmation: 'Списания в Центральных учреждениях подлежат подтверждению',
  Cargo_HsCode: 'Номер HS',
  Cargo_IADBD: 'Дата подачи заявки',
  Cargo_IARS: 'Ходатайство об отзыве было удовлетворено.',
  Cargo_IBOCR: 'Недостаточный остаток по счетам поступлений:',
  Cargo_ICDOOAABBD: 'Инициализация сводных данных по морским и воздушным перевозкам по умолчанию',
  Cargo_IDVOCVDCCIATTC: 'Интерфейс для отображения версий интерфейса отображает соответствующий пользовательский интерфейс в зависимости от конфигурации',
  Cargo_Ignore: 'Игнорировать',
  Cargo_IgnoreP: 'Игнорировать',
  Cargo_IICS: 'Информация о счете - фактуре была успешной.',
  Cargo_IINMCTBE: 'Номера счетов - фактур не могут быть пустыми.',
  Cargo_Import: 'Импорт',
  Cargo_ImportBankSlip: 'Импорт воды',
  Cargo_ImportExcel: 'Импорт Excel',
  Cargo_INABNCTBBE: 'Номер счета - фактуры или номер операции не могут быть пустыми.',
  Cargo_INCBMDON: 'Можно ли изменить номер счета',
  Cargo_IncludedToBusinessNo: 'Номер операции',
  Cargo_IncludedToBusinessNoP: 'Включить операционный номер:',
  Cargo_InclusiveExpense: 'Содержит расходы',
  Cargo_InclusiveExpenseP: 'Содержит расходы:',
  Cargo_InclusiveOfAR: 'Включая дебиторскую задолженность',
  Cargo_Income: 'Получено',
  Cargo_IncorrectWriteOffRecord: 'Неправильная отчетность',
  Cargo_IncoTerm: 'Условия торговли',
  Cargo_IncreaseAdjustment: 'Дополнительные корректировки',
  Cargo_IncrementValueDuty: 'Налог на добавленную стоимость',
  Cargo_ProductNameEn: 'Название продукта (англ.)',
  Cargo_ContainerNumber: 'Номер контейнера',
  Cargo_TotalDataCount: 'Всего {0} записей данных',
  Cargo_PalletDetails: 'Детали паллет',
  Cargo_PalletDimensions: 'Размеры паллет',
  Cargo_ShippingCompanyWebsite: 'Веб-сайт судоходной компании',
  Cargo_OverseasWarehouseAddress: 'Адрес зарубежного склада',
  Cargo_Index: 'Индекс',
  Cargo_IndexCanTBeEmpty: 'Резюме не может быть пустым',
  Cargo_IndexName: 'Название резюме',
  Cargo_IndustrialTradingCompany: 'Промышленно - торговая интеграционная компания',
  Cargo_INEPREIN: 'Номер счета уже существует, пожалуйста, заполните его заново',
  Cargo_Infomation: 'Информация',
  Cargo_InformationSentDate: 'Дата представления информации',
  Cargo_InformationSentTime: 'Время распространения информации',
  Cargo_InitialBalance: 'Первоначальный остаток',
  Cargo_InitialBalanceImport: 'Импорт начального сальдо',
  Cargo_InitializePageSwitching: 'Переключить страницу инициализации',
  Cargo_InitializingPleaseWait: 'Сейчас инициализируется, пожалуйста, позже...',
  Cargo_InitialPeriod: 'Первоначальный период',
  Cargo_InitialPeriodCannotBeEmpty: 'Первоначальный период не может быть пустым.',
  Cargo_InitialPeriodCanTBeEmpty: 'Первоначальный период года не может быть пустым.',
  Cargo_InitialPeriodOrNot: 'Был ли начальный период',
  Cargo_InitialPeriodP: 'Первоначальный период:',
  Cargo_InitiateContainerPickupRequest: 'Запрос на доставку чемоданов',
  Cargo_INNECTCW: 'Номер счета - фактуры не был введен, подтвердить закрытие окна?',
  Cargo_INNECTP: 'Номер счета - фактуры не был введен, продолжается ли печать?',
  Cargo_INNECTS: 'Номер счета - фактуры не был введен, продолжается ли его хранение?',
  Cargo_InputBusinessNumber: 'Введите номер операции.',
  Cargo_InputTime: 'Время ввода',
  Cargo_InsertJournalEntry: 'Вставить запись',
  Cargo_InsidePacking: 'Упаковка мелких деталей',
  Cargo_InsideQuantity: 'Небольшое число',
  Cargo_InstantMessengerQqWechatEtc: 'Мгновенная связь (QQ WeChat и т.д.)',
  Cargo_InsufficientRecordBalance: 'Недостаточный зарегистрированный остаток средств:',
  Cargo_IntentionStage: 'Этап намерения',
  Cargo_InterfaceScheme: 'Схема интерфейса',
  Cargo_Internal: 'Внутренний',
  Cargo_InternalCode: 'Внутреннее кодирование',
  Cargo_InternalInvoice: 'Внутренние счета - фактуры',
  Cargo_International: 'За границей',
  Cargo_InternationalBill: 'Зарубежные счета',
  Cargo_IntLFreight: 'Международный агентский фрахт',
  Cargo_IntLFreightForwardingServiceFee: 'Плата за услуги международных экспедиторов',
  Cargo_IntLOceanFreight: 'Расходы на международные агентские морские перевозки',
  Cargo_InUseByBusinessCanTBeDeleted: 'Использовался бизнесом, не может быть удален',
  Cargo_Invalid: 'Отмена',
  Cargo_InvalidDate: 'Дата истечения срока действия',
  Cargo_InvalidNavigation: 'Навигация не работает',
  Cargo_InvalidOrNot: 'Отмена',
  Cargo_InvalidParameter: 'Неверный параметр',
  Cargo_InverseSelect: 'Противоп. избр.',
  Cargo_Invoice: 'Счета - фактуры',
  Cargo_Invoiceable: 'Счета могут быть выставлены',
  Cargo_InvoiceAcquisition: 'Получение счетов - фактур',
  Cargo_InvoiceAfterARAPOffset: 'Счета - фактуры к получению',
  Cargo_InvoiceAmount: 'Сумма счета - фактуры',
  Cargo_InvoiceAmountP: 'Сумма счета - фактуры:',
  Cargo_InvoiceConfirmation: 'Уведомление о фактуре',
  Cargo_InvoiceContent: 'Содержание счета - фактуры',
  Cargo_InvoiceCurrency: 'Валюта счета - фактуры',
  Cargo_InvoiceCurrencyP: 'Валюта счета - фактуры:',
  Cargo_Invoiced: 'Уже выставлены счета',
  Cargo_InvoiceDate: 'Дата выставления счета',
  Cargo_InvoiceDateP: 'Дата выставления:',
  Cargo_InvoicedBy: 'Счетчик',
  Cargo_InvoicedByP: 'Счетчик:',
  Cargo_InvoiceDeleted: 'Счет - фактура удален.',
  Cargo_InvoicedOrNot: 'Были ли выставлены счета - фактуры',
  Cargo_InvoiceHasBeenWrittenOff: 'Счета - фактуры аннулированы',
  Cargo_InvoiceHeader: 'Счет вверх',
  Cargo_InvoiceInformation: 'Информация о счете - фактуре',
  Cargo_InvoiceIssued: 'Счета выставлены',
  Cargo_InvoiceItemName: 'Название счета - фактуры',
  Cargo_InvoiceItemNameSetup: 'Название счета - фактуры',
  Cargo_InvoiceNo: 'Номер счета - фактуры',
  Cargo_InvoiceNoCanTBeEmpty: 'Номер счета не может быть пустым.',
  Cargo_InvoiceNoEntry: 'Номер счета - фактуры',
  Cargo_InvoiceNoExist: 'Номер счета.',
  Cargo_InvoiceNoExistedContinue: 'Номер счета - фактуры уже существует, продолжается ли?',
  Cargo_InvoiceNoExistedContinueToSave: 'Номер счета - фактуры уже существует, хранится ли он?',
  Cargo_InvoiceNoExistedRewrite: 'Номер счета - фактуры [{0}] уже существует, пожалуйста, заполните номер счета - фактуры заново.',
  Cargo_InvoiceNoIsEmpty: 'Номер счета - фактуры пуст.',
  Cargo_InvoiceNoIsEmptyContinue: 'Номер счета - фактуры пуст?',
  Cargo_InvoiceNoMandatory: 'Обязательно ли заполнять счет - фактуру',
  Cargo_InvoiceNoNotEntered: 'Номер счета не указан.',
  Cargo_InvoiceNoP: 'Номер счета - фактуры:',
  Cargo_InvoiceNoSegment: 'Номер счета',
  Cargo_InvoiceNoStatus: 'Номер счета - фактуры',
  Cargo_InvoicePrintedCanTBeDeleted: 'Счета - фактуры распечатаны и не могут быть удалены.',
  Cargo_InvoicePrinting: 'Печать счетов - фактур',
  Cargo_InvoiceRecord: 'Счета - фактуры',
  Cargo_InvoiceReIssued: 'Счета - фактуры были возобновлены',
  Cargo_InvoiceRemark: 'Примечания',
  Cargo_InvoiceSavedSuccessfully: 'Счет успешно сохранен',
  Cargo_InvoiceSaveFailed: 'Ошибка сохранения счета - фактуры',
  Cargo_InvoiceStatus: 'Статус счета - фактуры',
  Cargo_InvoiceTitle: 'Открыть счет',
  Cargo_ChargeInvoiceTitle: 'Рост расходов',
  Cargo_InvoiceTitleInvoiceNo: 'Номер счета - фактуры.',
  Cargo_InvoiceTitleNotMatched: 'Счета - фактуры представлены непоследовательно.',
  Cargo_InvoiceTitleP: 'Билеты вверх:',
  Cargo_InvoiceType: 'Тип счета - фактуры',
  Cargo_InvoiceTypeIncompatible: 'Виды счетов - фактур не являются единообразными.',
  Cargo_InvoiceTypeP: 'Тип счета - фактуры:',
  Cargo_InvoiceTypeSelection: 'Выбор типа счета - фактуры',
  Cargo_InvoiceUse: 'Использование счетов - фактур',
  Cargo_InvoiceVoided: 'Счета - фактуры аннулированы.',
  Cargo_InvoiceVoidedCanTBeDeleted: 'Счета - фактуры аннулированы и не могут быть удалены.',
  Cargo_InvoiceVoucherAfterARAPOffset: 'Счета - фактуры к получению',
  Cargo_InvoiceWrittenOffCanTBeDeleted: 'Счета - фактуры не могут быть удалены.',
  Cargo_InvoiceWrittenOffCanTBeVoided: 'Счета - фактуры аннулированы.',
  Cargo_Invoicing: 'Оформление счетов',
  Cargo_InvoicingAccordingToCurrency: 'Выдача денежных знаков',
  Cargo_InvoicingAddress: 'Адрес выставления счетов',
  Cargo_InvoicingAmount: 'Сумма выставленных счетов',
  Cargo_InvoicingApplicationDate: 'Дата подачи заявки',
  Cargo_InvoicingApplicationReview: 'Заявка на утверждение',
  Cargo_InvoicingCompleted: 'Оформление счетов завершено.',
  Cargo_InvoicingCurrency: 'Валюта выставления счетов',
  Cargo_InvoicingDateBusinessDate: 'Дата выставления счета',
  Cargo_InvoicingHeadCannotBeEmpty: 'Счет не может быть пустым.',
  Cargo_InvoicingInformation: 'Информация об открытии счета',
  Cargo_InvoicingListNo: 'Номер выписки',
  Cargo_InvoicingMachineNo: 'Номер счётчика',
  Cargo_InvoicingMethod: 'Порядок выставления счетов',
  Cargo_InvoicingMethodP: 'Способ выписки:',
  Cargo_InvoicingMode: 'Схема выставления счетов',
  Cargo_InvoicingPerBill: 'Выдача одного билета',
  Cargo_InvoicingPerMonth: 'Начисление месячных счетов',
  Cargo_InvoicingRequirements: 'Требования к выставлению счетов',
  Cargo_InvoicingSearch: 'Запись',
  Cargo_InvoicingStatus: 'Состояние выставления счетов',
  Cargo_InvoicingType: 'Тип выписки',
  Cargo_InvoicingVerification: 'Проверка выписки',
  Cargo_IOSPIM: 'Объект должен ввести информацию',
  Cargo_IPCTFATROJE: 'Неверный параметр не найден',
  Cargo_IsBroken: 'Для обозначения',
  Cargo_IsExtended: 'Превышение сроков',
  Cargo_IsItAR: 'Является ли дебиторской задолженностью',
  Cargo_IsItCollection: 'Является ли получение',
  Cargo_IsItDefaultExpense: 'Расходы по умолчанию',
  Cargo_IsCharterFlightCosts: 'Расходы на фрахт',
  Cargo_IsCharterVesselCosts: 'Стоимость упаковки',
  Cargo_IsCharterFlight: 'Является ли чартерным',
  Cargo_IsCharterVessel: 'Упаковка',
  Cargo_Number_Of_Charter_Containers: 'Количество чартерных контейнеров',
  Cargo_Charter_weight_Restrictions: 'Ограничение веса чартерных рейсов',
  Cargo_Charter_Volume_Restrictions: 'Ограничение объема чартерных рейсов',
  Cargo_Description_of_the_package_Information: 'Описание информации об упаковке',
  Cargo_Pallets_can_be_loaded_in_Weight: 'грузоподъемность упаковки',
  Cargo_Packing_Plates_Can_Be_Loaded_In_Volume: 'Упаковочный объем',
  Cargo_The_Total_Cost_Amount: 'Общая сумма расходов',
  Cargo_Unit_Load_Device: 'Комплектатор',
  Cargo_MountingInformation: 'Сведения о сборке',
  Cargo_Please_Load_The_Main_Ticket: 'Пожалуйста, выполните погрузку в основной билет.',
  Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation: 'Пожалуйста, сделайте чистку на главном билете.',
  Cargo_OtherBusinessUse: 'Прочее оперативное использование',
  Cargo_DefaultArSettlementObject: 'Фиксированный расчетный объект к получению по умолчанию',
  Cargo_DefaultArSettlementObjectNull: 'Пустой ли объект по умолчанию',
  Cargo_DefaultApSettlementObject: 'Фиксированный расчетный объект по умолчанию',
  Cargo_DefaultApSettlementObjectNull: 'Пустой ли объект по умолчанию',
  Cargo_IsItWriteOff: 'Является ли это хеджированием',
  Cargo_IsoCode: 'Код ISO',
  Cargo_IsShutOut: 'Вернуть ли',
  Cargo_IssuanceReceiptOfInvoice: 'Счет выставлен',
  Cargo_Issued: 'Опубликовано',
  Cargo_IssueHbl: 'Подписать HBL',
  Cargo_IssueInvoiceDirectly: 'Непосредственная подготовка счетов - фактур',
  Cargo_IssueInvoiceDirectlyOrNot: 'Наличие прямого счета',
  Cargo_IssueOfTheYear: '{0} Год {1}',
  Cargo_ISWBDC: 'Вы уверены, что хотите удалить эти {0} данные?',
  Cargo_Item: 'Проекты',
  Cargo_Item1: 'Пункт I',
  Cargo_Item2: 'Пункт II',
  Cargo_ItemNo: 'Номер проекта',
  Cargo_ItemNo2P: 'Номер проекта 2:',
  Cargo_ItemNoP: 'Номер проекта:',
  Cargo_ItemsAdded: 'Добавлена статья {0}',
  Cargo_ItemsNBR: 'Количество претензий',
  Cargo_ReturnContainerAddress: 'Адрес возврата контейнера',
  Cargo_LoadingAddress: 'Адрес погрузки',
  Cargo_ITIOCBNMPCBITIITBCPOTS: 'В настоящее время идентификатор терминала выписки билетов филиала не поддерживается, пожалуйста, настройте идентификатор терминала в базовой конфигурации',
  Cargo_ITPIEI: 'Тип счета - фактуры',
  Cargo_IYDTRIAACWTACYIYWTKTAABFFIACNCTCIA: 'Если вы уже определились с заявителем, подающим заявку на выставление счета, и решили отозвать заявку, нажмите"Да."Если заявка на выдачу билета сохранена в качестве основы для выдачи билета в будущем, нажмите"Нет"Подтвердите отмену заявки на выписку?',
  Cargo_January: 'Январь',
  Cargo_JEODTD: 'Запись типа данных ({0}) была удалена!',
  Cargo_JEOOSC: 'Зарубежные расчетные центры',
  Cargo_JFOCP: 'дискриминирующее поле',
  Cargo_JobListSearched: 'Список заданных заданий',
  Cargo_JobNo: 'Номер работы',
  Cargo_JobNoP: 'Номер работы:',
  Cargo_JobTypeImport: 'Импорт',
  Cargo_JournalEntryCategory: 'Тип записи',
  Cargo_JournalEntryRule: 'Правило разделения записи',
  Cargo_July: 'Июль',
  Cargo_June: 'Июнь',
  Cargo_KeyWord: 'Чувствительные слова',
  Cargo_KeyWordCanTBeEmpty: 'Чувствительные слова не могут быть пустыми',
  Cargo_KingdeeCloudApprove: 'Сертификат Cloud',
  Cargo_KingdeeCloudReview: 'Проверка облаков Золотой бабочки',
  Cargo_LastAccrualTime: 'Последнее время',
  Cargo_LastDate: 'Предыдущая дата',
  Cargo_LastInvoiceNo: 'Номер последнего счета.',
  Cargo_LastModificationTime: 'Время последнего изменения:',
  Cargo_LastReceiveDate: 'Дата получения',
  Cargo_LastReceivingDate: 'Дата последнего платежа',
  Cargo_LastTimeBalance: 'Предыдущий остаток',
  Cargo_LBNRYSTW: 'Связанные операции не были проверены, чтобы подтвердить возврат?',
  Cargo_LegalUnit: 'Юридическая единица',
  Cargo_Lender: 'Кредиторы',
  Cargo_LessThan: 'Меньше',
  Cargo_Letter: 'Слова',
  Cargo_Level: 'Уровень',
  Cargo_Level1AccountTitle: 'Предметы первого уровня',
  Cargo_Level2AccountTitle: 'Второй уровень',
  Cargo_Level3AccountTitle: 'Третичные предметы',
  Cargo_Level4AccountTitle: 'Четвертый уровень',
  Cargo_Level5AccountTitle: 'Пятый уровень',
  Cargo_Level6AccountTitle: 'Шестой уровень',
  Cargo_Limit: 'Номер',
  Cargo_LinkBills: 'Связаны ли счета',
  Cargo_LinkOffsetExpenseDifferentials: 'Связаны ли расходы на хеджирование разницы',
  Cargo_LinkPaymentRequests: 'Соответствующая заявка на платеж',
  Cargo_LinkToInvoice: 'Связано со счетами - фактурами',
  Cargo_Load: 'Загрузка',
  Cargo_LoadCache: 'Загрузить кэш',
  Cargo_Loaded: 'Загрузка завершена',
  Cargo_LoadedAndSave: 'Загрузка завершена, нажмите для сохранения.',
  Cargo_LoadingAtDoor: 'Упаковка дверей',
  Cargo_LoadingAtFactory: 'Пр-во и снар.',
  Cargo_LoadOrNot: 'Загрузить',
  Cargo_Loan: 'Займы',
  Cargo_LoanSwap: 'Кредитные свопы',
  Cargo_LocalAgent: 'Локальный агент',
  Cargo_LocalCharge: 'Местные расходы',
  Cargo_LocalChargeOrNot: 'Местные расходы',
  Cargo_LocalCurrency: 'Монеты',
  Cargo_LocalizedName: 'Локализованное имя',
  Cargo_Location: 'Местонахождение',
  Cargo_LocationOfCurrentVoucher: 'Расположение текущего сертификата',
  Cargo_LockCancellationDate: 'Отмена даты блокировки',
  Cargo_LockTheBill: 'Блокировка',
  Cargo_Log: 'Журнал',
  Cargo_LogisticsCompany: 'Логистические компании',
  Cargo_LogRecord: 'Журнал',
  Cargo_LOTFINMBGT3D: 'Номер первого счета должен быть больше трех цифр.',
  Cargo_LowerCase: 'В нижнем регистре',
  Cargo_MainLineTransport: 'Магистральный транспорт',
  Cargo_MaintenanceOfShippingTerms: 'Обслуживание условий перевозки',
  Cargo_ManagementOfWithdrawal: 'Управление возвратом средств',
  Cargo_ManageParameters: 'Параметры управленческого запроса',
  Cargo_MANMWCSAISCTD: 'Адрес доставки отличается от адреса клиента в данных обслуживания системы, вы уверены, что хотите отправить его?',
  Cargo_March: 'Март',
  Cargo_Mark: 'Маркировка',
  Cargo_MarkTime: 'Время маркировки',
  Cargo_Marker: 'Человек метки',
  Cargo_MarkStatus: 'Состояние метки',
  Cargo_MarkCancelledSuccessfully: 'Отменить метку успешно',
  Cargo_MarkDate: 'Дата',
  Cargo_Marked: 'Отметить успех',
  Cargo_MarkedBy: 'Поставщик',
  Cargo_MarkOfConfirmation: 'Подтвердить метку',
  Cargo_Marks: 'Маркировка',
  Cargo_MarkSymbols: 'Маркировка',
  Cargo_MasterBillNotSearched: 'Билеты не проверяются',
  Cargo_May: 'Май',
  Cargo_MBACM: 'Изменить порядок расчета суммы счета',
  Cargo_MBEIRPSUB: 'В записи есть помеченные счета, выберите немаркированные счета.',
  Cargo_MBLAudit: 'Проверка MBL',
  Cargo_MBLCargoDetention: 'MBL Изъятия',
  Cargo_MBLFreightTerm: 'Условия фрахта главной накладной',
  Cargo_MblNo: 'Основной номер',
  Cargo_MBLPayable: 'MBL Оплачиваемый',
  Cargo_MBLPaymentTime: 'Время оплаты MBL',
  Cargo_MBLReviewTime: 'Время проверки MBL',
  Cargo_MBLTimeOfCargoHolding: 'Время удержания MBL',
  Cargo_MBLTransitTerm: 'Основные условия перевозки',
  Cargo_MDEPSBP: 'Данные были изменены, пожалуйста, сохраните их после печати.',
  Cargo_MDEPSBPIN: 'Если данные были изменены, сохраните их и распечатайте [номер счета: {0}]',
  Cargo_Merge: 'Начать слияние',
  Cargo_MergeOrNot: 'Объединение',
  Cargo_MethodOfClaim: 'Режим признания',
  Cargo_MethodOfClaimP: 'Модель признания:',
  Cargo_Metrics: 'Измерения',
  Cargo_MfnTaxRate: 'Ставки НБН',
  Cargo_Mode: 'Модель',
  Cargo_ModelSpecification: 'Тип',
  Cargo_ModificationOfCollection: 'Изменение инкассо',
  Cargo_ModificationTime: 'Изменить время',
  Cargo_ModifiedDataNotSavedCancel: 'Измененные данные не сохранены, подтвердить отмену?',
  Cargo_Modifier: 'Изменитель',
  Cargo_Modify: 'Изменения',
  Cargo_ModifyAccountTitle: 'Изменить предмет',
  Cargo_ModifyAccountTitleName: 'Изменить название предмета',
  Cargo_ModifyAdjustBill: 'Счет - изменение корректировки',
  Cargo_ModifyBillingInformation: 'Изменение информации о счете',
  Cargo_ModifyCollectionInformation: 'Изменение информации о инкассо',
  Cargo_ModifyInvoice: 'Изменить счет - фактуру',
  Cargo_ModifyPort: 'Изменение порта',
  Cargo_ModifyRailwayStation: 'Пересмотр железнодорожного вокзала',
  Cargo_ModifyOverseaWarehouse: 'Редактирование зарубежного склада',
  Cargo_AddOverseaWarehouse: 'Добавить склад Amazon',
  Cargo_NewOverseaWarehouse: 'Новые зарубежные склады',
  Cargo_CannotDeleteWarehouse: '{0} Код склада используется и не может быть удален!',
  Cargo_ModifyRateWithTax: 'Изменение налоговых ставок',
  Cargo_ModifySelectedInvoiceStatus: 'Изменить выбранный статус счета - фактуры',
  Cargo_ModifyWriteOffRecord: 'Изменение учетных записей о списании',
  Cargo_MOMAOB: 'Обслуживание баланса на начало периода',
  Cargo_MonetaryEquivalent: 'Пер. сумма',
  Cargo_MonetaryEquivalentCNY: 'Суммы в пересчете на CNY',
  Cargo_Month: 'Месяц',
  Cargo_FinanceMonthUnitTip: 'Календарные месяцы: граница — на N месяцев раньше 1-го числа текущего месяца; блокируются только данные строго раньше границы (без самого дня границы). Пример: при 2 месяцах в сентябре блокируются данные до 1 июля (1 июля не включается)',
  Cargo_Monthly: 'Конец месяца',
  Cargo_MonthlyReconciliation: 'Выверка ежемесячных счетов',
  Cargo_Months: 'Месяц',
  Cargo_MoreConditions: 'Больше условий',
  Cargo_MoreSearch: 'Больше запросов',
  Cargo_Motorcade: 'Автоколонна',
  Cargo_MscServiceCode: 'Сервисный код',
  Cargo_MultipleChoiceBox: '【Параметры】',
  Cargo_MultipleCurrenciesExit: 'Существует несколько валют.',
  Cargo_MultipleSettlingPartiesExist: 'Существует несколько расчетных объектов.',
  Cargo_MUPIOOPFWO: 'Необходимо ли использовать фактическую оплату',
  Cargo_MustSelectTheSameClient: 'Необходимо выбрать одного и того же клиента.',
  Cargo_MVOACP: 'Обслуживание документов, подтверждающих получение аванса',
  Cargo_MVOARAPOI: 'Поддержание счетов - фактур к оплате',
  Cargo_Name: 'Имя',
  Cargo_NameCanTBeEmpty: 'Имя не может быть пустым.',
  Cargo_EnglishNameCheck: 'Английское название не может быть пустым.',
  Cargo_ExistDoorSite: 'Существует та же информация о двери.',
  Cargo_PleaseSelectCommissioningUnit: 'Выберите доверенное лицо в партнере',
  Cargo_PleaseInputOneDoorInfoAtLeast: 'Введите хотя бы одну точку входа.',
  Cargo_LandTransportationDetails: 'Редактор подробной информации о наземном транспорте',
  Cargo_NameP: 'Название:',
  Cargo_NAMISANOSNBCWBRS2DPTED: 'Примечание: Напоминание делается в виде « системного напоминания», и система вновь напоминает о запрете создания бизнес - конфигурации за 2 дня до истечения срока действия',
  Cargo_NatureOfSales: 'Свойства продаж',
  Cargo_NBCTBGTC: 'Отрицательная разница не может быть больше - 1 цента.',
  Cargo_NECDFTIC: 'Не более чем в {0} валютах, отличных от той, в которой выставлен счет',
  Cargo_BillPaymentCurrencyBeyond: 'Не может превышать {0} валют, отличающихся от валюты платежа!',
  Cargo_PayByBillingRate: 'Оплата по курсу счета',
  Cargo_NeedAccountingPeriod: 'Извините, вы используете версию программного обеспечения для пакета учетных записей"Финансовое программное обеспечение Water"Для редактирования предметов необходим учетный период.',
  Cargo_NeedAccrue: 'Иметь в виду',
  Cargo_NeedCustomsDeclare: 'Таможенная декларация',
  Cargo_NeedHqToWriteOffOrNot: 'Необходимость списания через Центральные учреждения',
  Cargo_NeedInvoiceOrNot: 'Требуется ли выписка',
  Cargo_NeedMandatoryAccrue: 'Обязательно ли',
  Cargo_NeedToBillCNYToCNY: 'Требуется взимание {0} {1}RMB',
  Cargo_NeedToConfiCNYankAccountOrNot: 'Нужно ли подтверждать банковский счет',
  Cargo_NeedToCreateBillOrNot: 'Нужно ли создавать счет?',
  Cargo_NeedToExportOrNot: 'Нужно ли экспортировать',
  Cargo_NeedToPayTo: 'Нужно платить {0} {1}RMB',
  Cargo_NEFEIDE: 'Непустая фильтрация при экспорте по умолчанию',
  Cargo_NegotiationStage: 'Коммерческий этап',
  Cargo_NEIAFPRPOCA: 'Заявка не оплачивается, пожалуйста, обновите веб - страницу или свяжитесь с системным администратором',
  Cargo_NEICTBD: 'Неэлектронные счета - фактуры не могут быть загружены.',
  Cargo_NetWork: 'Сеть',
  Cargo_NetworkName: 'Сетевое имя',
  Cargo_NetworkNameCanTBeEmpty: 'Имя сети не может быть пустым',
  Cargo_New: 'Новое строительство',
  Cargo_NewAccountStatement: 'Новые счета',
  Cargo_NewAccountTitle: 'Новые предметы',
  Cargo_NewFiscalPeriod: 'Новый учетный период',
  Cargo_NewInvoiceNo: 'Новый номер счета',
  Cargo_NewInvoiceNoP: 'Новый номер счета:',
  Cargo_NewPaymentRequest: 'Создание платежной заявки',
  Cargo_NewValue: 'Новое значение',
  Cargo_Next: 'Следующий шаг',
  Cargo_NextItem: 'Следующий',
  Cargo_NextStep: 'Следующее задание',
  Cargo_NextStepToSave: 'Следующий шаг Сохранить',
  Cargo_NFFICSPRE: 'Не найден файл облачного хранилища',
  Cargo_NFMKWPEAW: 'Примечание: Несколько важных слов, пожалуйста, вернитесь в машину и поменяйте строку',
  Cargo_NFPAFTS: 'Финансовый период, в течение которого эта учетная запись не используется.',
  Cargo_NFPSCATWBSACYCTS: 'Поскольку учетного периода не существует, текущий предметный год будет установлен в этом году, подтверждение будет продолжать сохраняться.',
  Cargo_NMT2MCTAIEAWO: 'Расходы не могут быть более чем в двух валютах, отличных от валют, в которых производятся продажи.',
  Cargo_NNTCVFCOPL: 'Нет необходимости в представлении документа о переносе прибыли и убытков',
  Cargo_NNTEIBOPLBFSOATBOTY: 'Пакет счетов, введенный в действие в начале года, не требует ввода начального остатка прибылей и убытков.',
  Cargo_No: 'Нет',
  Cargo_NOATGCAAIODMBETTGMO: 'Условия группирования предметов расположены в порядке, данные должны быть равны делению предметов минус один!',
  Cargo_NoBillToConfirm: 'Подтвержденных счетов нет.',
  Cargo_NoBillToCreateSoa: 'Счета не выставляются.',
  Cargo_NoBillToWriteOff: 'Нет счетов, которые нужно списать.',
  Cargo_NoBusinessNeedFinancialReview: 'Отсутствует финансовый аудит операций.',
  Cargo_NoBusinessTypeSelected: 'Тип операции не выбран',
  Cargo_NoCitySelectedToEdit: 'Не выбран город для редактирования',
  Cargo_NoConfirmedBillToCancel: 'Никаких счетов, которые можно отменить.',
  Cargo_NoData: 'Нет данных.',
  Cargo_NoDataModifiedNoNeedToSave: 'Данные не были изменены, и их не нужно было сохранять.',
  Cargo_NoDataSelected: 'Данные не выбраны.',
  Cargo_NoDataSelectedToDelete: 'Не выбраны данные для удаления',
  Cargo_NoDataToExport: 'Нет данных, которые можно было бы экспортировать.',
  Cargo_NoDataToModify: 'Нет модифицируемых данных',
  Cargo_NoDataToPreview: 'Предварительные данные отсутствуют.',
  Cargo_NoDataToTransfer: 'Нет данных, которые можно отправить.',
  Cargo_NoDoNotLink: 'Нет, я не связан.',
  Cargo_NOEGT1ICTSTNWBST1C: 'Количество расходов превышает 1, и если расходы на продолжение дробления будут установлены на уровне 1, будет ли оно продолжаться?',
  Cargo_NoElectronicInvoiceNoToCreate: 'Номер электронного счета не был создан.',
  Cargo_NoEligibleExpenseToPrint: 'Нет подходящих расценок для печати.',
  Cargo_NoEligibleRecord: 'Отсутствует соответствующая документация.',
  Cargo_NoEligibleRecordsFound: 'Записи, отвечающие требованиям, не найдены',
  Cargo_NoExpenseDifferentialsToProcess: 'Никаких расхождений не требуется.',
  Cargo_NoExpenseToBill: 'Никаких расходов для выставления счетов.',
  Cargo_NoExpenseToInvoice: 'Никаких расходов для выставления счетов.',
  Cargo_NoExpenseToReject: 'Никаких отклоняемых расходов.',
  Cargo_NoExpenseToReview: 'Отсутствуют подлежащие проверке расходы',
  Cargo_NoExpenseToWriteOff: 'Отсутствуют подлежащие списанию расходы.',
  Cargo_NoFileToRetrieve: 'Нет документов, которые можно вернуть.',
  Cargo_NoFileToRevoke: 'Нет документов, которые можно отменить',
  Cargo_NoForeignCurrencyAccounting: 'Без учета в иностранной валюте',
  Cargo_NoInvoiceNo: 'Нет номера счета.',
  Cargo_NoInvoiceNoForInvoiceAmounted: 'Счет - фактура на сумму {0} не имеет номера счета - фактуры!',
  Cargo_NoInvoiceNoToCheck: 'Нет номера счета, который нужно проверить.',
  Cargo_NoMaintainedBankForClient: 'Клиенты не обслуживают банк',
  Cargo_NoMatchedRecordFound: 'Никаких записей о соблюдении требований не найдено.',
  Cargo_NominatedAgent: 'Назначенный агент',
  Cargo_NonAccrual: 'Непредвиденные расходы',
  Cargo_None: 'Нет',
  Cargo_NoneAnyBillable: 'Плата за билеты отсутствует.',
  Cargo_NoNeedToRepeatConfirmation: 'Подтверждено, повторное подтверждение не требуется.',
  Cargo_NoNeedToSplitThisKeyWord: 'Это деликатное слово не нужно разделять.',
  Cargo_NonElectronicInvoice: 'Неэлектронные счета - фактуры',
  Cargo_NonSplitWriteOffExpense: 'Списанные расходы нельзя разделить.',
  Cargo_NoNumberBreak: 'Нет, нет.',
  Cargo_NoOfPages: 'Количество страниц',
  Cargo_NoParentAccountTitles: 'Без высшего образования',
  Cargo_NoPortSelected: 'Порт не выбран',
  Cargo_NoRecordChecked: 'Запись без галочки.',
  Cargo_NoRecordSelected: 'Запись не выбрана.',
  Cargo_NoRecordToSave: 'Нет никаких записей, которые можно было бы сохранить.',
  Cargo_NoRelease: 'Неотъемлемый лист',
  Cargo_NoReviewedExpenseToCancel: 'Нет платы за отмену аудита',
  Cargo_NoServiceTicketToDelete: 'Никаких подтверждений расходов, которые можно было бы удалить.',
  Cargo_NoSiteSelected: 'Сайт не выбран',
  Cargo_NoSobSetUpCurrently: 'В настоящее время никаких счетов не ведется.',
  Cargo_NotAcquired: 'Не получено',
  Cargo_NotAdjustedExpense: 'Расходы, не связанные с корректировкой',
  Cargo_NotAFinalAccountTitle: '【{0}}】 Это не последний предмет.',
  Cargo_NotCarriedOver: 'Не перенесено',
  Cargo_NotCollectAdvance: 'Неполученные авансы',
  Cargo_NotCollected: 'Не получено',
  Cargo_NotCollectedCNY: 'CNY Не получено',
  Cargo_NotCollectedEUR: 'EUR Не получено',
  Cargo_NotCollectedGBP: 'Не получено',
  Cargo_NotCollectedHKD: 'HKD Не получено',
  Cargo_NotCollectedInFull: 'Не получено',
  Cargo_NotCollectedJPY: 'JPY Не получено',
  Cargo_NotCollectedNGN: 'Не получено',
  Cargo_NotCollectedP: 'Не получены:',
  Cargo_NotCollectedUSD: 'США',
  Cargo_Collected: 'Получено',
  Cargo_NotContracted: 'Не подписано',
  Cargo_NotDisplayedIfMultipleItemsExist: 'Не показывается при наличии нескольких',
  Cargo_NOTDIST: 'Показать число шаблонов в подписи страницы запроса',
  Cargo_NotificationOfPaymentFreeze: 'Уведомление о замораживании платежей',
  Cargo_NotificationOfUnfrozenPayment: 'Уведомление о размораживании платежей',
  Cargo_NotifyHq: 'Уведомление Центральных учреждений',
  Cargo_NotifyId: 'Код уведомления',
  Cargo_NotifyInfo: 'Уведомление',
  Cargo_NotifyParty: 'Уведомление',
  Cargo_NotifyPartySName: 'Имя уведомляющего',
  Cargo_NotifyUser: 'Напоминание пользователю',
  Cargo_NotifyMethod: 'Форма уведомления',
  Cargo_NotInvoicedMoney: 'Сумма неоплаченных счетов',
  Cargo_NoTotal: 'лист {0}, всего {1} лист',
  Cargo_NotReviewed: 'Не проверено',
  Cargo_NotSent: 'Не отправлено',
  Cargo_NotSet: 'Не установлено',
  Cargo_NotSubmittedCanTWithdraw: 'Невыполнение требований',
  Cargo_NotTaxFree: 'Не облагается налогом',
  Cargo_NotWrittenBack: 'Красный удар',
  Cargo_NotWrittenOff: 'Списания не производились',
  Cargo_NotWrittenOff2: 'Несписанный эквивалент RMB',
  Cargo_NotWrittenOffCurrency: 'Не распроданы ({0})',
  Cargo_NotWrittenOffHKD: 'Не распроданы (HKD)',
  Cargo_NotWrittenOffUSD: 'Не распроданы (USD)',
  Cargo_NoUnInvoicedExpense: 'Нет неоплаченных счетов.',
  Cargo_November: 'Ноябрь',
  Cargo_NPDOSB: 'Предварительные данные о вспомогательном остатке отсутствуют.',
  Cargo_NRFTAL: 'Самодоставка',
  Cargo_NSEFPCA: 'Расходы на разделение не найдены, пожалуйста, свяжитесь с администратором!',
  Cargo_NTWBWRLION: 'Нужно ли выписывать красный счет?',
  Cargo_Number: 'Номер',
  Cargo_NumberS: 'А',
  Cargo_NumberOfAttachedDocuments: 'Количество сопроводительных документов',
  Cargo_NumberOfCopies: 'Количество экземпляров',
  Cargo_NumberOfCopiesCanTBe0: 'Количество экземпляров не может быть 0.',
  Cargo_NumberOfExpenseWriteOffs: 'Количество списанных расходов',
  Cargo_NumberOfNominatedAgents: 'Количество назначенных агентов',
  Cargo_OBCILC: 'Начальное сальдо (в консолидированных валютах)',
  Cargo_OBIMICMAWTCSCCPBR: 'Когда инкассация производится чеком банковским переводом простым векселем инкассационным платежом',
  Cargo_OceanExport: 'Морской экспорт',
  Cargo_OceanFreight: 'Морские перевозки',
  Cargo_OceanImport: 'Морской импорт',
  Cargo_OceanImportExport: 'Морские перевозки',
  Cargo_OCLWSPCBS: 'Можно выбирать только тех клиентов, которые связаны с продажей.',
  Cargo_October: 'Октябрь',
  Cargo_Oddment: 'Короткий счет',
  Cargo_ODWSSCBP: 'Можно распечатать только документы с тем же статусом.',
  Cargo_OEOSET: 'Общая сумма прав собственников или акционеров',
  Cargo_OEVCBWB: 'Только красные чеки были экспортированы.',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC: 'Операция не удалась, вся или часть расходов находится в процессе утверждения оплаты, пожалуйста, сделайте это после завершения процесса.',
  Cargo_OFCIIFPRNRN: 'Включая стоимость выставленного счета, пожалуйста, выберите номер платежной заявки \ n:',
  Cargo_OFCTCMT2: 'Операция не удалась, количество валют не может превышать 2.',
  Cargo_OffsetDataSource: 'Источник данных хеджирования',
  Cargo_OffsetEntity: 'Хеджирующие объекты',
  Cargo_OffsetOrNot: 'Есть ли хеджирование',
  Cargo_MustInvoiceNoAndTitle: 'Необходимо указать номер счета-фактуры и реквизиты плательщика.',
  Cargo_OFGTECOBUFEIIC: 'Операция не удалась, и « экспорт золотого налога» может действовать только на электронные счета - фактуры в валюте юаня.',
  Cargo_OFNBFSWWF: 'Невозможность выставления счета, нет стоимости выставления счета.',
  Cargo_OFTAPFSDNMTIR: 'Невыполнение требований в отношении выставления счетов',
  Cargo_OFTARFSDNMTIR: 'Статус дебиторской задолженности не соответствует требованиям к выставлению счетов',
  Cargo_OFTCBDNMTTINSIIITIEI: 'Операция не удалась, в настоящее время филиал не поддерживает идентификационный номер налогоплательщика, поэтому не может выставить электронный счет - фактуру.',
  Cargo_OFTFRCWNM: 'Операция не удалась и не отвечает условиям финансового аудита.',
  Cargo_OFTFRCWNMCSRT: 'Не может быть прямого финансового аудита, после изменения конфигурации попробуйте снова.',
  Cargo_OFTIISCBD: 'Счет выставлен, его невозможно удалить.',
  Cargo_OFTIRCBDTNIAF: 'Следующий бланк заявки уже открыт и не может быть удален!',
  Cargo_OFTIRCBETNIAF: 'Следующий бланк заявки уже открыт и не может быть отредактирован!',
  Cargo_OFTRFOTARFCBIITB: 'Счет включает в себя расходы на красный или красный кредит.',
  Cargo_OFTUFSCBS: 'Операция не удалась, еще не сохраненные расходы не могут быть разделены.',
  Cargo_OFTWOANTBETTSOREGALFE: 'Операция не удалась, и сумма списания должна быть равна сумме полученного платежа + курсовые прибыли и убытки + финансовые расходы + сумма нулевых счетов.',
  Cargo_OFWTIARTARMBGTTAP: 'Операция не удалась, когда тип поступлений и расходов является дебиторской задолженностью, общая сумма дебиторской задолженности должна превышать общую сумму кредиторской задолженности.',
  Cargo_OIRWPSCBCAC: 'Только заявки на выдачу билетов, статус которых еще не открыт, могут быть сгенерированы вместе с списком билетов!',
  Cargo_OIWWBCBP: 'Можно распечатать только счета - фактуры, не обработанные красным цветом.',
  Cargo_OnAccountHedge: '(Страхование)',
  Cargo_OneClickRenewal: 'Продление одним нажатием клавиши',
  Cargo_OnlyCheckedRecordsCanBeCancelled: 'Только те записи, которые были пересмотрены, могут быть аннулированы.',
  Cargo_OnlyReviewedVouchersCanBeDeleted: 'Можно только удалить непроверенные документы.',
  Cargo_OnlyUnCheckedRecordsCanBeChecked: 'Пересмотр может производиться только в отношении непроверенных записей.',
  Cargo_OOAPIICCTTTEPRCOEA: 'инкассо имеет только неоплаченные сборы, которые больше не могут быть переведены на сборы, пожалуйста, сделайте другую инкассо или заявку на сбор!',
  Cargo_OORCBSFASBI: 'При подсчете голосов можно выбрать только одну запись.',
  Cargo_OpeningAmountOfTheYear: 'На начало года',
  Cargo_OpeningBalance: 'Начальное сальдо',
  Cargo_OpeningBalanceCreditCNY: 'Кредиторы начального сальдо (в юанях)',
  Cargo_OpeningBalanceCreditUSD: 'Кредиты начального сальдо (в долл. США)',
  Cargo_OpeningBalanceDebitCNY: 'Дебетовое сальдо на начало периода (в юанях)',
  Cargo_OpeningBalanceDebitUSD: 'Дебетовое сальдо на начало периода (долл. США)',
  Cargo_OperateBy: 'Оператор',
  Cargo_OperatedSuccessfullyRefreshPage: 'Удачно обновить страницу',
  Cargo_OperatingCompany: 'Эксплуатационное подразделение',
  Cargo_Operation: 'Операция',
  Cargo_OperationCompany: 'Операторы',
  Cargo_OperationComplete: 'Операция прошла успешно',
  Cargo_OperationDate: 'Дата операции',
  Cargo_OperationDepartment: 'Операционный сектор',
  Cargo_OperationOffice: 'Эксплуатационное отделение',
  Cargo_OperationFailed: 'Ошибка операции',
  Cargo_OperationHistory: 'История операций',
  Cargo_OperationModeAir: 'Режим эксплуатации (воздушный транспорт)',
  Cargo_OperationModeAirExport: 'Режим работы (свободный)',
  Cargo_OperationModeAirImport: 'Режим работы (воздушный вход)',
  Cargo_OperationRequirementType: 'Тип операции',
  Cargo_OperationSuccessfully: 'Операция прошла успешно.',
  Cargo_HblTeleReleaseGuarantee: 'HBL Проверка печати',
  Cargo_TeleReleaseBillType: 'Виды электронных коносаментов',
  Cargo_OperationSymbol: 'символ операции',
  Cargo_OperationType: 'Тип операции',
  Cargo_OperationTypeCanTBeEmpty: 'Требования к типу операции не могут быть пустыми',
  Cargo_Operator: 'Оператор',
  Cargo_OperatorOfWithdrawal: 'Платежный оператор',
  Cargo_OppositeVoucherNo: 'Номер документа контрагента',
  Cargo_OppositeVoucherNoP: 'Номер сертификата:',
  Cargo_OPVWES: 'Это может быть сделано только в отношении документов, статус которых был пересмотрен.',
  Cargo_Order: 'Порядок',
  Cargo_OrdinaryTaxRate: 'Общая налоговая ставка',
  Cargo_ORDM: 'Эксплуатационные требования Описание',
  Cargo_Original: 'Первоначальный',
  Cargo_OriginalAmount: 'Первоначальная сумма',
  Cargo_OriginalAmountCNY: 'Первоначальная сумма CNY',
  Cargo_OriginalAmountInBill: 'Первоначальная сумма счета',
  Cargo_OriginalAmountUSD: 'Первоначальная сумма USD',
  Cargo_OriginalContent: 'Оригинальное содержание',
  Cargo_OriginalCurrency: 'Валюта',
  Cargo_OriginalCurrencyInBill: 'Первоначальная валюта счета',
  Cargo_OriginalCurrencyNotWrittenOff: 'Непогашенные валюты',
  Cargo_OriginalCurrencyP: 'Оригинальная валюта:',
  Cargo_OriginalExchangeRateInBill: 'Первоначальный курс счета',
  Cargo_OriginalExpense: 'Первоначальная стоимость',
  Cargo_OriginalExpenseAmount: 'Первоначальная сумма расходов',
  Cargo_OriginalExpenseP: 'Первоначальная стоимость:',
  Cargo_OriginalInvoiceNo: 'Первоначальный номер счета - фактуры',
  Cargo_OriginalInvoiceNoP: 'Первоначальный номер счета:',
  Cargo_OriginalInvoiceTitle: 'Первоначальный счет - фактура',
  Cargo_OriginalInvoiceTitleP: 'Первоначальный счет - фактура:',
  Cargo_OriginalValue: 'Первоначальная стоимость',
  Cargo_ChargeItemView: 'Посмотреть платные статьи',
  Cargo_ORORDCBO: 'Можно использовать только те документы, которые были возвращены или возвращены.',
  Cargo_ORVCBE: 'Можно экспортировать только проверенные документы.',
  Cargo_OSVBMP: 'Поиск только документов механизма',
  Cargo_Other: 'Прочее',
  Cargo_OtherChargeItem: 'Разные расходы по авианакладным',
  Cargo_OtherContact: 'Другие контракты',
  Cargo_OtherConversionAP: 'Прочая кредиторская задолженность',
  Cargo_OtherConversionAPCNY: 'Прочая кредиторская задолженность',
  Cargo_OtherConversionAPEUR: 'Другие переводы в евро',
  Cargo_OtherConversionAPGBP: 'Другие переводы в GBP',
  Cargo_OtherConversionAPHKD: 'Другие переводы HKD',
  Cargo_OtherConversionAPJPY: 'Другие переводы JPY',
  Cargo_OtherConversionAPNGN: 'Другие переводы в NGN',
  Cargo_OtherConversionAR: 'Прочая дебиторская задолженность',
  Cargo_OtherConversionARCNY: 'Прочая дебиторская задолженность',
  Cargo_OtherConversionAREUR: 'Прочая дебиторская задолженность в евро',
  Cargo_OtherConversionARGBP: 'Прочая дебиторская задолженность',
  Cargo_OtherConversionARHKD: 'Прочая дебиторская задолженность HKD',
  Cargo_OtherConversionARJPY: 'Прочая дебиторская задолженность JPY',
  Cargo_OtherConversionARNGN: 'Прочая дебиторская задолженность',
  Cargo_OtherCurrencies: 'Другие валюты',
  Cargo_OtherCurrencyExchangeRates: 'Обменные курсы других валют',
  Cargo_OtherExchangeRates: 'Другие обменные курсы',
  Cargo_OtherOutstandingConversionAP: 'Прочие невыплаченные суммы',
  Cargo_OtherOutstandingConversionAPCNY: 'Прочие переводы',
  Cargo_OtherOutstandingConversionAPEUR: 'Прочие переводы в евро',
  Cargo_OtherOutstandingConversionAPGBP: 'Прочие переводы',
  Cargo_OtherOutstandingConversionAPHKD: 'Прочие выплаты HKD',
  Cargo_OtherOutstandingConversionAPJPY: 'Прочие выплаты JPY',
  Cargo_OtherOutstandingConversionAPNGN: 'Прочие переводы',
  Cargo_OtherOutstandingConversionAR: 'Прочие причитающиеся суммы',
  Cargo_OtherOutstandingConversionARCNY: 'Прочие переводы к получению',
  Cargo_OtherOutstandingConversionAREUR: 'Прочие переводы в евро',
  Cargo_OtherOutstandingConversionARGBP: 'Прочие переводы',
  Cargo_OtherOutstandingConversionARHKD: 'Прочие переводы HKD',
  Cargo_OtherOutstandingConversionARJPY: 'Другие переводы JPY',
  Cargo_OtherOutstandingConversionARNGN: 'Прочие переводы',
  Cargo_OTNSOSICBD: 'Не отправленные и отправленные до удаления.',
  Cargo_OTWOOCCI: 'Отменить списание может только сам продавец.',
  Cargo_OTWOOCMI: 'Изменить расчет может только сам продавец.',
  Cargo_OurAccount: 'Наш счет',
  Cargo_OurBank: 'Наш банк',
  Cargo_OurBankIsEmptySaveBankReceipt: 'Наш банк пуст, хранит ли он водную накладную?',
  Cargo_Outcomes: 'Результаты',
  Cargo_OutstandingAP: 'Непогашенные обязательства',
  Cargo_OutstandingAPP: 'Непогашенные обязательства к выплате:',
  Cargo_OutstandingConversionAPInCNY: 'Эквивалент невыплаченных сумм CNY',
  Cargo_OutstandingConversionAPInCurrency: 'Эквивалент {0}',
  Cargo_OutstandingConversionPaidInCurrency: 'Эквивалент {0} Выплачен',
  Cargo_OutstandingPaymentParties: 'Непогашенные расчетные единицы',
  Cargo_OutstandingWrittenOffItemsExist: 'Наличие непогашенных счетов',
  Cargo_OVDCBUFPLAT: 'Категория прибылей и убытков, можно выбрать только виртуальный сектор.',
  Cargo_Virtual: 'Виртуальный',
  Cargo_Over90DaysShpt: 'Более 90 дней (билеты)',
  Cargo_OverdueExpenses: 'Перерасход средств',
  Cargo_Overseas: 'За границей',
  Cargo_OverseasAgencyContract: 'Контракты с зарубежными агентами',
  Cargo_OverseasAgent: 'Иностранные агенты',
  Cargo_OverseasAgentOrNot: 'Является ли иностранный агент',
  Cargo_OverseasCollection: 'Поступления из - за рубежа',
  Cargo_OverseasDirectClient: 'Прямые иностранные клиенты',
  Cargo_OverseasDirectClientOrNot: 'Прямые иностранные клиенты.',
  Cargo_OverseasDomestic: 'За рубежом',
  Cargo_OverseasOrNot: 'Является ли иностранная',
  Cargo_OverseasPayment: 'Платежи за рубежом',
  Cargo_OverseasWriteOff: 'Продажи за рубежом',
  Cargo_OverseasWriteOffOrNot: 'Продается ли за рубежом',
  Cargo_OverseasWriteOffSearch: 'Проверка зарубежных счетов',
  Cargo_OVICBETGTEI: 'Счета - фактуры НДС могут быть экспортированы в электронный счет - фактуру.',
  Cargo_OVWCSNCBE: 'Можно экспортировать только сертификаты с серийным номером.',
  Cargo_OVWUSCBE: 'Проверка может производиться только в том случае, если статус документов не пересматривается.',
  Cargo_OWCICGTSEEI: 'Валюта, в которой выставлен счет, - это {0}, прежде чем можно будет экспортировать электронный счет - фактуру.',
  Cargo_OwningDept: 'Подразделения',
  Cargo_Package: 'Упаковка',
  Cargo_PackageExistsOrSelectNull: 'Упаковка существует или не выбрана',
  Cargo_PackageMaintenance: 'Эксплуатация упаковки',
  Cargo_PackingInformationNotSelected: 'Информация об упаковке не выбрана.',
  Cargo_PADS: 'Отказ в оплате был удовлетворен.',
  Cargo_Page: 'Чжан',
  Cargo_Paid: 'Выплачено',
  Cargo_PaidInFull: 'Выплачено',
  Cargo_PaidInOutOfPocket: 'Фактические поступления',
  Cargo_ReceiptPaymentpVoucher: 'Документы, подтверждающие получение и оплату',
  Cargo_PANMWEAPCAOCA: 'Заявка на оплату не соответствует сумме сбора, пожалуйста, проверьте сумму или свяжитесь с администратором!',
  Cargo_ParentAccountTitle: 'Высшие учебные заведения',
  Cargo_PARGMSA: 'Требуется ли разрешение генерального директора',
  Cargo_Parter: 'Партнеры',
  Cargo_CreditAccountingPeriod: 'Кредитный период',
  Cargo_CreditLine: 'Кредитная линия',
  Cargo_ExceededAmount: 'Превышение, {0} юаней',
  Cargo_Exceeded: 'Превышение',
  Cargo_PartialConfirmation: 'Частично подтверждено',
  Cargo_PartialExpense: 'Часть расходов',
  Cargo_PartialPayment: 'Частичный платеж',
  Cargo_PartialReversalCompleted: 'Частично возвращение прошло успешно.',
  Cargo_PartialWriteOff: 'Частичное списание',
  Cargo_Participant: 'Участники',
  Cargo_PartnerCanTBeEmpty: 'Партнеры не могут быть пустыми',
  Cargo_PartnerSCreditLimitExceeded: 'Счета партнеров превысили',
  Cargo_Password: 'Пароль',
  Cargo_PasswordField: 'Зона шифрования',
  Cargo_PAWOCTBD: 'Платежные требования аннулированы и не могут быть удалены',
  Cargo_Pay: 'А',
  Cargo_Payable: 'Подлежащие оплате',
  Cargo_PayableNeedPay: 'Подлежащие оплате (к оплате)',
  Cargo_PayableOrNot: 'Подлежит оплате',
  Cargo_PayablesWriteOfStatus: 'Статус, подлежащий списанию',
  Cargo_Payee: 'Получатель',
  Cargo_PayeeP: 'Получатель:',
  Cargo_Payment: 'Платежи',
  Cargo_PaymentAccount: 'Номер счета платежей',
  Cargo_PaymentAgainstMonthlySoa: 'Месячный / кассовый остаток',
  Cargo_PaymentAmount: 'Сумма платежа',
  Cargo_PaymentApplicationDirectlySent: 'Запрос на оплату прямой',
  Cargo_PaymentApplicationInformation: 'Информация о заявке на оплату',
  Cargo_PaymentApplicationNo: 'Номер заявки на оплату',
  Cargo_PaymentAppliedSuccessfully: 'Заявки на оплату были удовлетворены.',
  Cargo_PaymentApprovalSlipDetails: 'Подробная информация об утверждении платежа',
  Cargo_PaymentApprovalSlipNo: 'Номер платежного поручения',
  Cargo_PaymentCompany: 'Входящие подразделения',
  Cargo_PaymentCompanyName: 'Название компании',
  Cargo_PaymentCycle: 'Периодичность счетов',
  Cargo_PaymentDate: 'Дата платежа',
  Cargo_PaymentDateCanTBeEmpty: 'Дата платежа не может быть пустой.',
  Cargo_PaymentMethod: 'Способы оплаты',
  Cargo_PaymentNotApplied: 'Необязательные платежи',
  Cargo_PaymentNotificationNo: 'Номер платежного извещения',
  Cargo_PaymentPeriod: 'Срок платежа',
  Cargo_PaymentPeriodExceeded: 'Превышение сроков',
  Cargo_PaymentPeriodRange: 'Сфера охвата счетов',
  Cargo_PaymentReceiveMethod: 'Способ получения и оплаты',
  Cargo_PaymentReceiveMethodP: 'Способ получения и оплаты:',
  Cargo_PaymentReceiveType: 'Вид оплаты',
  Cargo_PaymentReceiveTypeP: 'Тип оплаты:',
  Cargo_PaymentRequest: 'Заявки на оплату',
  Cargo_PaymentRequestBusiness: 'Заявки на оплату - операции',
  Cargo_PaymentRequestDetail: 'Заявки на оплату - подробнее',
  Cargo_PaymentRequested: 'Запрошенные платежи',
  Cargo_PaymentRequestedNotRequested: 'Запрошенные платежи / не запрошенные платежи',
  Cargo_PaymentRequestsCreatedOrNot: 'Число выданных платежных поручений',
  Cargo_PaymentTime: 'Время платежа',
  Cargo_PaymentToBeChecked: 'Подлежащие проверке суммы',
  Cargo_CarryForwardList: 'Список переходящих остатков',
  Cargo_PaymentType: 'Тип платежа',
  Cargo_PaymentVerification: 'Проверка платежей',
  Cargo_PayReceive: 'Получение и оплата',
  Cargo_PayReceiveDate: 'Дата получения',
  Cargo_PayUnit: 'Платежная единица',
  Cargo_PCAOCO: 'Пожалуйста, подтвердите, что эта сумма {0} составляет:',
  Cargo_PCHIUV: 'Проверка клиентов в открытом море',
  Cargo_PCITIHBI: 'Проверьте, выставлен ли счет.',
  Cargo_INVOICE_NO_FILE: 'По этому счету - фактуре не было найдено соответствующего электронного счета - фактуры.',
  Cargo_Pcs: 'А',
  Cargo_PCSALOA: 'Пожалуйста, выберите более одной заявки.',
  Cargo_PCSALOI: 'Пожалуйста, выберите более одного счета.',
  Cargo_Pcst: 'Статья',
  Cargo_PCTAOTCPI: 'Пожалуйста, подтвердите: \ \ n Фактическая сумма платежа составляет:',
  Cargo_PCTOOPAIWOADSA: 'Пожалуйста, подтвердите: \ \ n Реальная сумма платежа: {0}, \ n сумма списания: {1}, \ n разница: {2} как нулевой короткий счет!',
  Cargo_PDDPAF: 'Показывает только часть данных, пожалуйста, добавьте фильтр условий поиска.',
  Cargo_PeakSeason: 'Высокий сезон',
  Cargo_PEALTVJE: 'Введите хотя бы две записи.',
  Cargo_PEATGR: 'Введите правила группирования предметов.',
  Cargo_PECCI: 'Пожалуйста, введите полную информацию о доставке.',
  Cargo_PECINSWACONIO: 'Введите правильный номер счета - фактуры, и система автоматически введет другие номера в свою очередь!',
  Cargo_PEERAVC: 'Были подготовлены авизо на конец периода:',
  Cargo_PEFEA: 'Перевод средств на конец периода',
  Cargo_PEFEA2: 'Переводы на конец периода2',
  Cargo_PEFEAS: 'Конечный перевод успешно',
  Cargo_PendingBusinessApplication: 'Ожидаемые операции',
  Cargo_PendingPrice: 'Подлежит рассмотрению',
  Cargo_People: 'Человек',
  Cargo_PerformLetterFiltering: 'Фильтрация символов',
  Cargo_PERFROIRF: 'Пожалуйста, укажите причину повторного открытия в примечании.',
  Cargo_Period: 'Период',
  Cargo_PeriodEndAmount: 'Конечное число',
  Cargo_PeriodEndBalance: 'Остаток на конец периода',
  Cargo_PeriodEndBalanceCreditCNY: 'Кредитор конечного сальдо (в юанях)',
  Cargo_PeriodEndBalanceCreditUSD: 'Кредиты конечного сальдо (в долл. США)',
  Cargo_PeriodEndBalanceDebitCNY: 'Дебетовое сальдо на конец периода (в юанях)',
  Cargo_PeriodEndBalanceDebitUSD: 'Дебетовое сальдо на конец периода (долл. США)',
  Cargo_PeriodEndExchangeRateAdjustment: 'Перевод средств на конец периода',
  Cargo_PeriodRange: 'Период',
  Cargo_Periods: 'Период',
  Cargo_PermissionCheck: 'Проверка прав доступа',
  Cargo_PermissionControl: 'Управление правами',
  Cargo_PermissionToSubmitExpense: 'Полномочия на представление информации о расходах',
  Cargo_PESAI: 'Введите информацию о вспомогательном учете 【{0}】 {1}.',
  Cargo_PESAIN: 'Введите номер проекта вспомогательного учета [bracket0]',
  Cargo_PESCSBA: 'Введите номер банковского счета сбытовой организации.',
  Cargo_PETSAINO: 'Введите номер проекта вспомогательного учета [bracket0].',
  Cargo_PETSFIIB: 'Пожалуйста, введите ниже информацию о расходах',
  Cargo_PEWOIPETS: 'Пожалуйста, введите информацию о продажах и вернитесь к запросу.',
  Cargo_PFAEFTS: 'Платежи по воздуху в Шанхае',
  Cargo_PICNENCTSFS: 'Введите китайское имя, английское имя, код, сокращенно нечеткий запрос',
  Cargo_PlaceOfDelivery: 'Место поставки',
  Cargo_PlaceOfMblPayment: 'Место платежа по основному счету',
  Cargo_PlaceOfReceipt: 'Место получения',
  Cargo_PlanDescription: 'Описание программы',
  Cargo_PlatformCode: 'Код платформы',
  Cargo_PlatformCustomerService: 'Платформа для клиентов',
  Cargo_CustomerServiceOverSea: 'Зарубежные клиенты',
  Cargo_PLCOS: 'Перенесенные прибыли и убытки успешно',
  Cargo_PleaseAddAtLeastOneContactPerson: 'По крайней мере, один контакт клиента.',
  Cargo_PleaseAddContactPerson: 'Заполните контакты',
  Cargo_PleaseAddExpense: 'Пожалуйста, добавьте стоимость.',
  Cargo_PleaseAddNominationCargoAgent: 'Пожалуйста, заполните указанный агент.',
  Cargo_PleaseAddNominationCargoAgentP: 'Пожалуйста, заполните указанный агент:',
  Cargo_PleaseAddTelNumbers: 'Пожалуйста, заполните телефон.',
  Cargo_PleaseBatchSelectInvoiceNo: 'Пожалуйста, выберите номер счета. {0}',
  Cargo_PleaseCheckClient: 'Пожалуйста, выберите клиента.',
  Cargo_PleaseCheckInvoice: 'Пожалуйста, отметьте счет - фактуру.',
  Cargo_PleaseChooseData: 'Выберите данные.',
  Cargo_PleaseChooseFeeName: 'Выберите название расходов.',
  Cargo_PleaseChooseSettlementEntity: 'Выберите расчетную единицу.',
  Cargo_PleaseClickSelectAnInvoice: 'Пожалуйста, выберите счет.',
  Cargo_PleaseClickSelectARecord: 'Пожалуйста, выберите запись.',
  Cargo_PleaseConfirmPaymentMade: 'Пожалуйста, подтвердите, что оплата была произведена {0} {1} {2}!',
  Cargo_PleaseConfirmReviewDate: 'Подтвердите дату проверки:',
  Cargo_PleaseConfirmTheDueAmount: 'Пожалуйста, подтвердите: \ \ n Сумма должна быть {0}:',
  Cargo_PleaseConfirmThePaidInAmountIs: 'Просьба подтвердить, что полученная сумма составляет:',
  Cargo_PleaseConfirmThisTime: 'Пожалуйста, подтвердите, что эта сумма {0} составляет:',
  Cargo_PleaseDeleteAfterVoid: 'Пожалуйста, отмените, а затем удалите.',
  Cargo_PleaseEnterAccountTitle: 'Введите название предмета.',
  Cargo_PleaseEnterAmount: 'Введите сумму',
  Cargo_PleaseEnterClientName: 'Введите имя клиента.',
  Cargo_PleaseEnterCode: 'Пожалуйста, введите код.',
  Cargo_PleaseEnterCorrectAmount: 'Пожалуйста, введите правильную сумму.',
  Cargo_PleaseEnterCorrectBillingParty: 'Введите правильный расчетный объект.',
  Cargo_PleaseEnterCorrectExchangeRate: 'Пожалуйста, введите правильный обменный курс.',
  Cargo_PleaseEnterCorrectNumber: 'Пожалуйста, введите правильные цифры.',
  Cargo_PleaseEnterCurrencyExchangeRate: 'Пожалуйста, введите обменный курс валюты 【{0}】.',
  Cargo_PleaseEnterDate: 'Введите дату',
  Cargo_PleaseEnterDateOfReceipt: 'Пожалуйста, введите дату получения.',
  Cargo_PleaseEnterDifferential: 'Пожалуйста, введите разницу.',
  Cargo_PleaseEnterExpenseDescription: 'Пожалуйста, введите название расходов.',
  Cargo_PleaseEnterExpenseDetails: 'Пожалуйста, введите разбивку расходов.',
  Cargo_PleaseEnterFinancialCode: 'Пожалуйста, введите финансовый код.',
  Cargo_ApAndArCodeIsEmpty: 'В настоящее время 【Код дебиторской задолженности】 / 【Код кредитора】 пусты, попробуйте снова после уточнения данных.',
  Cargo_PleaseEnterFinancialDate: 'Пожалуйста, введите финансовую дату.',
  Cargo_PleaseEnterHsCode: 'Введите HSCode',
  Cargo_PleaseEnterInformationOf: 'Введите информацию о вспомогательном учете [bracket0] {1}.',
  Cargo_PleaseEnterInvoiceInformation: 'Пожалуйста, введите данные счета.',
  Cargo_PleaseEnterInvoiceNo: 'Пожалуйста, введите номер счета.',
  Cargo_PleaseEnterInvoiceNoP: 'Введите номер счета:',
  Cargo_PleaseEnterMailingAddress: 'Пожалуйста, введите адрес доставки.',
  Cargo_PleaseEnterName: 'Введите имя.',
  Cargo_PleaseEnterNewInvoiceNo: 'Пожалуйста, введите новый номер счета.',
  Cargo_PleaseEnterNewInvoiceTitle: 'Пожалуйста, введите новый счет - фактуру вверх.',
  Cargo_PleaseEnterOperationCode: 'Введите оператор.',
  Cargo_PleaseEnterOurBankAccountNo: 'Пожалуйста, введите номер нашего банковского счета.',
  Cargo_PleaseEnterPaidInAmount: 'Пожалуйста, введите полученную сумму.',
  Cargo_PleaseEnterPaidInDate: 'Пожалуйста, введите дату получения.',
  Cargo_PleaseEnterPaymentParty: 'Введите платежную единицу.',
  Cargo_PleaseEnterPaymentTerm: 'Пожалуйста, введите срок оплаты.',
  Cargo_PleaseEnterPlanName: 'Введите имя программы',
  Cargo_PleaseEnterGuarantrrName: 'Введите имя гарантии',
  Cargo_PleaseEnterRecipientSName: 'Введите имя получателя.',
  Cargo_PleaseEnterReturnedCourierNo: 'Пожалуйста, введите номер возврата.',
  Cargo_PleaseEnterSalesCompanySBank: 'Введите, пожалуйста, торговую единицу для открытия счета.',
  Cargo_PleaseEnterScarletLetterNumber: 'Пожалуйста, введите красный номер уведомления.',
  Cargo_PleaseEnterSearchInformation: 'Пожалуйста, введите информацию о запросе.',
  Cargo_PleaseEnterSettlingParty: 'Введите расчетный объект',
  Cargo_PleaseEnterSobCode: 'Пожалуйста, введите код счета.',
  Cargo_PleaseEnterSobName: 'Введите имя счёта.',
  Cargo_PleaseEnterSplitAmount: 'Пожалуйста, введите сумму разделения.',
  Cargo_PleaseEnterTableName: 'Введите имя таблицы',
  Cargo_PleaseEnterTelNo: 'Пожалуйста, введите контактный телефон.',
  Cargo_PleaseEnterUserName: 'Введите пользователя',
  Cargo_PleaseEnterValueOfCondition: 'Введите условное значение.',
  Cargo_PleaseEnterVoucherLetter: 'Введите слово сертификата.',
  Cargo_PleaseEnterVoucherNo: 'Введите номер сертификата.',
  Cargo_PleaseEnterVoucherType: 'Введите тип сертификата.',
  Cargo_PleaseInputJobNo: 'Введите рабочий номер.',
  Cargo_PleaseReselectTheVoucherToExport: 'Выберите сертификат для экспорта.',
  Cargo_PleaseSelect: 'Выберите',
  Cargo_PleaseSelectP: '- Пожалуйста, выберите...',
  Cargo_PleaseSelect2OrMoreApplications: 'Пожалуйста, выберите более двух заявок.',
  Cargo_PleaseSelectAccountTitle: 'Пожалуйста, выберите предмет.',
  Cargo_PleaseSelectAnAdvanceReceipt: 'Пожалуйста, выберите аванс.',
  Cargo_PleaseSelectAnExpenseItem: 'Пожалуйста, выберите стоимость.',
  Cargo_PleaseSelectAnInvoice: 'Пожалуйста, выберите счет.',
  Cargo_PleaseSelectAPAndARExpense: 'Пожалуйста, выберите стоимость и дебиторскую задолженность.',
  Cargo_PleaseSelectApplication: 'Пожалуйста, выберите форму заявки.',
  Cargo_PleaseSelectARecord: 'Пожалуйста, выберите запись.',
  Cargo_PleaseSelectBill: 'Пожалуйста, выберите счет.',
  Cargo_PleaseSelectBillToMark: 'Пожалуйста, выберите счет, который нужно отметить.',
  Cargo_PleaseSelectBillToPrint: 'Пожалуйста, выберите счет для печати.',
  Cargo_PleaseSelectBillToRemove: 'Выберите счет для удаления.',
  noRowsToShow: 'Нет результатов запроса',
  Cargo_PleaseSelectBranch: 'Пожалуйста, выберите филиал.',
  Cargo_SelectBranch: 'Выбрать филиал',
  Cargo_ApplicationBranch: 'Филиал прикладных операций',
  Cargo_ApplicationDepartment: 'Отдел прикладных операций',
  Cargo_MoreBusinessConditions: 'Дополнительные условия работы',
  Cargo_MoreConditionsOptions: 'Дополнительные параметры условий',
  Cargo_BusinessConditionsOptions: 'Варианты условий работы',
  Cargo_PleaseSelectBusiness: 'Пожалуйста, выберите бизнес.',
  Cargo_PleaseSelectBusinessDate: 'Пожалуйста, выберите дату операции.',
  Cargo_PleaseSelectBusinessOrderRecord: 'Пожалуйста, выберите запись бизнес - листа.',
  Cargo_PleaseSelectBusinessType: 'Выберите тип бизнеса',
  Cargo_PleaseSelectGuaranteeType: 'Выберите тип гарантии',
  Cargo_PleaseSelectClosureTime: 'Пожалуйста, выберите время окончания.',
  Cargo_PleaseSelectContentToModify: 'Пожалуйста, выберите то, что необходимо изменить.',
  Cargo_PleaseSelectCurrency: 'Пожалуйста, выберите валюту.',
  Cargo_PleaseSelectData: 'Пожалуйста, отметьте данные.',
  Cargo_PleaseSelectContainerGroup: 'Пожалуйста, выберите группу контейнеров для выполнения операции добавления.',
  Cargo_AutomaticReleaseTips: 'Наличие коносамента в состоянии накладной не требует специального выпуска.',
  Cargo_PleaseSelectDataToDelete: 'Выберите данные для удаления.',
  Cargo_PleaseSelectDataToRevoke: 'Выберите данные, которые будут аннулированы.',
  Cargo_SuredRevokeJob: 'Решили отменить выбранный бизнес?',
  Cargo_PleaseSelectDataToExport: 'Выберите данные, которые необходимо экспортировать.',
  Cargo_PleaseSelectDataType: 'Выберите тип данных.',
  Cargo_PleaseSelectDataTypeToCreate: 'Выберите тип данных, которые будут генерироваться.',
  Cargo_PleaseSelectDate: 'Выберите дату',
  Cargo_PleaseSelectExpense: 'Пожалуйста, выберите стоимость.',
  Cargo_PleaseSelectExpenseToConfirm: 'Выберите стоимость подтверждения.',
  Cargo_PleaseSelectExpenseToSplit: 'Пожалуйста, выберите стоимость разделения.',
  Cargo_PleaseSelectExpenseToWriteOff: 'Пожалуйста, выберите стоимость, которую нужно списать.',
  Cargo_PleaseSelectFile: 'Выберите файл',
  Cargo_OwnFileDelete: 'Недостаточные права доступа: невозможно удалить файлы, загруженные другими пользователями',
  Cargo_PleaseSelectFileType: 'Выберите тип файла',
  Cargo_PleaseSelectGroupingCondition: 'Выберите условия группирования',
  Cargo_PleaseSelectGroupingCondition2: 'Выберите Групповое условие 1.',
  Cargo_PleaseSelectIncludedBizNo: 'Пожалуйста, выберите бизнес - номер.',
  Cargo_PleaseSelectInvoice: 'Пожалуйста, выберите счет - фактуру.',
  Cargo_PleaseSelectInvoiceNo: 'Пожалуйста, выберите номер счета.',
  Cargo_PleaseSelectOurBank: 'Пожалуйста, выберите наш банк.',
  Cargo_PleaseSelectPaymentApplication: 'Пожалуйста, выберите заявку на оплату.',
  Cargo_PleaseSelectTheRecord: 'Выберите запись, которую необходимо изменить',
  Cargo_batchChangePaymentSuccess: 'Успешно изменена заявка на оплату',
  Cargo_batchChangePaymentFailed: 'Ошибка подачи заявки на внесение исправлений',
  Cargo_NotEmptyChangePaymentTime: 'Время подачи заявки не может быть пустым',
  Cargo_ApprovedSuccess: 'Утверждение прошло успешно.',
  Cargo_ApprovedFaild: 'Ошибка утверждения.',
  Cargo_ReturnedSuccess: 'Возвращение успешно.',
  Cargo_ReturnedFaild: 'Ошибка возврата.',
  Cargo_NoBusinessApproval: 'Данные, требующие утверждения операций, отсутствуют.',
  Cargo_NoDeptApproval: 'Данные, требующие одобрения департаментов, отсутствуют.',
  Cargo_NoFinanceApprovalData: 'Нет данных, требующих финансового одобрения',
  Cargo_NoSupervisorApprovalData: 'Нет данных, требующих одобрения руководителя',
  Cargo_PleaseSelectPeriodRange: 'Выберите интервал',
  Cargo_PleaseSelectRecord: 'Пожалуйста, выберите запись.',
  Cargo_PleaseSelectRecordToInvoice: 'Пожалуйста, выберите запись для выставления счета.',
  Cargo_PleaseSelectRecordToReview: 'Выберите запись для проверки.',
  Cargo_PleaseSelectRecordToCancelReview: 'Выберите запись для отмены проверки.',
  Cargo_PleaseSelectRecordToWriteOff: 'Пожалуйста, выберите запись для продажи.',
  Cargo_PleaseSelectReviewDate: 'Пожалуйста, выберите дату проверки.',
  Cargo_PleaseSelectSameInvoiceType: 'Пожалуйста, выберите тот же тип счета.',
  Cargo_PleaseSelectServiceTicket: 'Пожалуйста, выберите форму подтверждения расходов.',
  Cargo_PleaseSelectSettlingParty: 'Пожалуйста, выберите объект расчетов.',
  Cargo_AddTag: 'Дополнительная маркировка',
  Cargo_NotFoundNeedSaveCharges: 'В списке нет дополнительных расходов.',
  Cargo_SureSaveBilling: 'Вы уверены, что сохраняете и создаете счет?',
  Cargo_SureSaveChargeOnly: 'Вы уверены, что только расходы на сохранение?',
  Cargo_SureCancelEdit: 'Вы уверены, что отменить редактирование?',
  Cargo_JobBillingChargeNotEqual: 'Бизнес [{0}] [{1} [{2}}] Несоответствие со счетом, пожалуйста, удалите непоследовательную плату, прежде чем ее можно изменить!',
  Cargo_SaveGenerateBills: 'Сохранение и создание счетов',
  Cargo_GenerateExpensesOnly: 'Создание только расходов',
  Cargo_PleaseSelectSoa: 'Пожалуйста, выберите выписку.',
  Cargo_PleaseSelectSob: 'Пожалуйста, выберите счет.',
  Cargo_PleaseSelectStartTime: 'Пожалуйста, выберите время начала.',
  Cargo_PleaseSelectThePurchaser: 'Пожалуйста, выберите покупателя.',
  Cargo_PleaseSelectTypeOfJournalEntries: 'Выберите тип записи.',
  Cargo_PleaseSelectVatInvoice: 'Пожалуйста, выберите счет НДС.',
  Cargo_PleaseSelectVatEiInvoice: 'Пожалуйста, выберите тариф НДС.',
  Cargo_PleaseSelectVoucher: 'Пожалуйста, выберите сертификат.',
  Cargo_PleaseSelectVoucherGroupingRule: 'Выберите правило группирования сертификатов',
  Cargo_PleaseSelectVoucherToCancel: 'Выберите документ, который необходимо отменить.',
  Cargo_PleaseSelectVoucherToReview: 'Пожалуйста, выберите документы для проверки.',
  Cargo_PleaseSelectWriteOffDetails: 'Пожалуйста, выберите деталь продажи.',
  Cargo_PleaseSelectWriteOffRecord: 'Пожалуйста, выберите учетную запись.',
  Cargo_PleaseSpecifyPaymentPeriodRange: 'Укажите объем счета',
  Cargo_PleaseUseComponent: 'Пожалуйста, используйте компоненты',
  Cargo_PlsInput: 'Введите',
  Cargo_PLVDCTBE: 'Дата документа о прибылях и убытках не может быть пустой',
  Cargo_PLVDNITP: 'В течение периода, не охватываемого документом о прибылях и убытках',
  Cargo_PLVFCTBE: 'Документы о прибылях и убытках не могут быть пустыми',
  Cargo_PLVNAPATCTBE: 'Счет нераспределенной прибыли не может быть пустым',
  Cargo_PoaCustomsDeclaration: 'ДТД',
  Cargo_PODcode: 'Код порта',
  Cargo_FileFromQuotation: 'Файлы, импортированные из управления ценами, не могут быть удалены',
  Cargo_FileFromInquiry: 'Файлы, импортированные из управления запросами, не могут быть удалены',
  Cargo_PodSea: 'Порт разгрузки (морской порт)',
  Cargo_Unloading: 'Разгрузка',
  Cargo_ArrivalNotice: 'Уведомление о прибытии',
  Cargo_PickUp: 'Получение товаров',
  Cargo_AircraftGISPositioning: 'Позиция самолета GIS',
  Cargo_PointOfPermission: 'Точка доступа',
  Cargo_PointsToNote: 'Есть ли особенности',
  Cargo_Pol: 'Порт погрузки',
  Cargo_PolAgent: 'Агент порта отправления',
  Cargo_POLCannotBeNull: 'Порт отправления не должен быть пустым.',
  Cargo_PolSea: 'Порт отправления (морской порт)',
  Cargo_Port: 'Порт',
  Cargo_PortCodeCanTBeEmpty: 'Код порта не может быть пустым.',
  Cargo_PortGroup: 'Портовая группа',
  Cargo_PortGroupCanTBeEmpty: 'Порт не может быть пустым.',
  Cargo_PortOfDestinationCode: 'Код порта назначения',
  Cargo_PortOfDischarge: 'Порт разгрузки',
  Cargo_PortOfDischargeCannotBeNull: 'Порт разгрузки не должен быть пустым.',
  Cargo_PortOfLoading: 'Порт отправления',
  Cargo_PortOfLoadingSea: 'Порт отправления (морские перевозки)',
  Cargo_PortOfLoadingAir: 'Порт отправления (воздушный транспорт)',
  Cargo_PortPrompt: 'Введите порт.',
  Cargo_PortRequirement: 'Требования к портам',
  Cargo_PositiveOperation: 'Работает.',
  Cargo_Post: 'Должность',
  Cargo_PotentialStage: 'Потенциальный этап',
  Cargo_PPNCASA: 'В качестве нулевых коротких счетов авансы не генерируются.',
  Cargo_PRCTBCFWOE: 'Списанные расходы / операции не могут создать платежные требования.',
  Cargo_PreCollection: 'Авансы',
  Cargo_PreferredAgentAtDestination: 'Предпочтительный агент порта назначения',
  Cargo_PreferredAirline: 'Предпочтения авиакомпании',
  Cargo_PreferredAirport: 'Предпочтение аэропортам',
  Cargo_PreferredAirportAir: 'Предпочтение Порт (аэропорт)',
  Cargo_PreferredCustomsBroker: 'Предпочтительные таможенные услуги',
  Cargo_PreferredOceanCarrier: 'Предпочтение судоходным компаниям',
  Cargo_PreferredPort: 'Предпочтение морским портам',
  Cargo_PreferredPortSea: 'Предпочтение Порты (морские порты)',
  Cargo_PreferredShippingMethod: 'Предпочтение типу перевозки',
  Cargo_PreferredShippingRoute: 'Предпочтительный маршрут',
  Cargo_PreferredShippingTerms: 'Предпочтительные условия перевозки',
  Cargo_PreferredTrucker: 'Предпочтение трейлерам.',
  Cargo_PreferredTruckingService: 'Предпочтение услуги трейлера',
  Cargo_PrepaidOrNot: 'Предоплата',
  Cargo_PreparedBy: 'Индивидуальные',
  Cargo_PreparedByP: 'Индивидуальные:',
  Cargo_PrepareServiceTicket: 'Удостоверение расходов на производство',
  Cargo_PrePayment: 'Наличие аванса',
  Cargo_PrepaymentRecordedSuccessfully: 'Зарегистрирован аванс успешно.',
  Cargo_PreReviewStatus: 'Статус предварительного производства',
  Cargo_PreReviewAllStatus: 'Статус предварительного производства (пересмотр)',
  Cargo_PreSubmission: 'Предварительное представление',
  Cargo_PreviewEmailContent: 'Предварительный просмотр содержимого почты',
  Cargo_Previous: 'Предыдущий',
  Cargo_PrimeCost: 'Стоимость',
  Cargo_Print: 'Печать',
  Cargo_PrintAll: 'Все распечатки',
  Cargo_PrintBill: 'Печать счетов',
  Cargo_PrintedSuccessfully: 'Печать прошла успешно.',
  Cargo_PrintInvoice: 'Распечатка счетов',
  Cargo_PrintList: 'Печать списка',
  Cargo_PrintOrNot: 'Печать',
  Cargo_LACKINVOICE: 'Отсутствует счет-фактура?',
  Cargo_Printout: 'Результаты печати',
  Cargo_PrintPaymentList: 'Печать платежных ведомостей',
  Cargo_PrintSoa: 'Печать счетов',
  Cargo_PrintStatusSaved: 'Сохранить состояние печати успешно.',
  Cargo_PrintTheProfit: 'Печать прибыли',
  Cargo_PrintVerification: 'Проверка печати',
  Cargo_PrintWithdrawalList: 'Печать (список возвратов)',
  Cargo_ProcessedAsShortAccount: 'Обработка коротких нулевых счетов',
  Cargo_ProcessedBy: 'Обработчик',
  Cargo_ProcessingChangeRemarks: 'Обработка корректирующих примечаний',
  Cargo_ProcessingPleaseWait: 'Подождите, пожалуйста, обрабатываю...',
  Cargo_ProcessingRemarks: 'Обработка заметок',
  Cargo_ProcessingTime: 'Время обработки',
  Cargo_ProductName: 'Назв.прогр.',
  Cargo_Profit: 'Прибыль',
  Cargo_ProfitLossAccount: 'Категория прибылей и убытков',
  Cargo_ProfitLoss: 'Отчет о прибылях',
  Cargo_ProfitLoss2: 'Ведомость прибыли2',
  Cargo_ProfitLossVoucherNoCanTBeEmpty: 'Номер документа о прибылях и убытках не может быть пустым',
  Cargo_ProfitLossVoucherNotInThePeriod: 'В отсутствие документов о прибылях и убытках',
  Cargo_Prompt: 'Напоминание',
  Cargo_Proof: 'Свидетельство',
  Cargo_ProofDate: 'Дата документа',
  Cargo_ProofDateP: 'Дата документа:',
  Cargo_ProofOrNot: 'Создается ли сертификат',
  Cargo_Property: 'Свойства',
  Cargo_Province: 'Провинция',
  Cargo_PRSCSCRICP: 'Записи о инкассо судоходной компании, пожалуйста, подпишите на страницу инкассо, чтобы отменить.',
  Cargo_PSALOAPAARE: 'Пожалуйста, выберите хотя бы одну из сумм, причитающихся и подлежащих оплате.',
  Cargo_PSALOER: 'Пожалуйста, выберите хотя бы одну запись расходов.',
  Cargo_PSALOGODC: 'Пожалуйста, выберите хотя бы один набор условий даты.',
  Cargo_PSALOGODC2: 'Выберите хотя бы одно условие фильтрации.',
  Cargo_SelectLockOrderCondition: 'Выберите условия блокировки',
  Cargo_PSBOTSSP: 'Пожалуйста, выберите ту же расчетную единицу.',
  Cargo_PSCI: 'Пожалуйста, выберите информацию о получении',
  Cargo_PSDTOVG: 'Выберите тип данных кластера сертификатов.',
  Cargo_PSEDTRWO: 'Пожалуйста, выберите разбивку расходов, которые необходимо отменить.',
  Cargo_PSFDD: 'Поиск страниц для ввода таможенной документации',
  Cargo_PSFPOTSY: 'Бухгалтерский период Выберите тот же год.',
  Cargo_PleaseSelectVoucherRange: 'Выберите интервал сертификата',
  Cargo_PSGROJE: 'Выберите правило группирования записей',
  Cargo_PSOR: 'Выберите требования к операции',
  Cargo_PSPAF: 'Пожалуйста, выберите платежную заявку.',
  Cargo_PSPATD: 'Пожалуйста, выберите запрос на оплату для удаления.',
  Cargo_PSPATW: 'Пожалуйста, выберите заявку на оплату, которая будет отозвана.',
  Cargo_PSPATR: 'Пожалуйста, выберите заявку на возврат платежа.',
  Cargo_PSPATS: 'Пожалуйста, выберите заявку на оплату, которую нужно подать.',
  Cargo_PSROACP: 'Пожалуйста, выберите фактическую платежную запись.',
  Cargo_PSRTCPA: 'Пожалуйста, выберите запись заявки на оплату.',
  Cargo_PSRTCV: 'Выберите запись для создания сертификата.',
  Cargo_PSSDOCD: 'Выберите дату начала или окончания.',
  Cargo_PSUSPAF: 'Пожалуйста, выберите неоплаченные заявки.',
  Cargo_PSSPAF: 'Отзыв только нерассмотренных заявок на оплату',
  Cargo_PSVOFS: 'Пожалуйста, выберите версию финансового программного обеспечения.',
  Cargo_CurrencyMismatch: '{0} Валюта не соответствует номеру банковского счета, пожалуйста, измените счет',
  Cargo_PublicClientHub: 'Клиенты открытого моря',
  Cargo_Publish: 'Опубликовано',
  Cargo_PublishStatus: 'Статус публикации',
  Cargo_PurchasedBy: 'Покупатель',
  Cargo_PurchaseRecord: 'Учет покупок',
  Cargo_PurchaseRegisteredSuccessfully: 'Покупка зарегистрирована успешно.',
  Cargo_PurchaseRegistration: 'Регистрация покупок',
  Cargo_PurchasingParty: 'Покупатель',
  Cargo_PurchasingUnit: 'Закупающая организация',
  Cargo_PUSBAANMRIDSS: 'Должны ли храниться банковские счета, в которых открыт счет и номер счета закупающей организации не {0}?',
  Cargo_PutARItemsOnTop: 'Причитается сверху.',
  Cargo_PYPALAA: 'Корректировка прибылей и убытков за предыдущие годы',
  Cargo_PYPALAAP: 'Корректировка прибылей и убытков за предыдущие годы:',
  Cargo_Query: 'Запрос',
  Cargo_QueryFailed: 'Ошибка запроса.',
  Cargo_QueryInvoice: 'Проверка счетов - фактур',
  Cargo_QuickSearch: 'Простой запрос',
  Cargo_QuotaCurrency: 'Валюта',
  Cargo_QuotaRange: 'Номерный интервал',
  Cargo_RAIAV: 'Выверка сумм в абсолютном выражении',
  Cargo_Railway: 'Железнодорожный транспорт',
  Cargo_RailwayExport: 'Желдор. экс.',
  Cargo_RailwayImport: 'Желдор. имп.',
  Cargo_RailwayBusiness: 'Железнодорожный транспорт',
  Cargo_IntegratedJob: 'Компл. лог.',
  Cargo_FbaOrder: 'Оформление FBA',
  Cargo_FbaSea: 'FBA Морские перевозки',
  Cargo_FbaAir: 'FBA Воздушный транспорт',
  Cargo_FbaRailway: 'Железнодорожный ФБА',
  Cargo_RailwayRoute: 'Железнодорожный маршрут',
  Cargo_RCAFTPOY: 'Коррективы {0} Год {1}',
  Cargo_RCBDIDL: 'Обновить текущие данные филиала',
  Cargo_RealPaid: 'Выплачено',
  Cargo_RealPaidP: 'Выплачено:',
  Cargo_ReasonNotEntered: 'Причины не заполнены',
  Cargo_ReasonOfCargoDetention: 'Причины вычета',
  Cargo_ReasonOfCargoDetentionP: 'Причины вычета:',
  Cargo_ReCalculateBillingAmount: 'Пересчет суммы счета',
  Cargo_Receipt: 'Поступления',
  Cargo_ReceiptAmount: 'Сумма поступлений',
  Cargo_Receivable: 'ДЗ',
  Cargo_ReceivableToCNY: 'Дебиторская задолженность CNY:',
  Cargo_ReceivableB: '(Дебиторская задолженность)',
  Cargo_ReceivedCNY: 'CNY Получено',
  Cargo_PayPaidCNY: 'CNY Выплачено',
  Cargo_ReceivedUSD: 'USD Получено',
  Cargo_ReceivedEUR: 'EUR Получено',
  Cargo_ReceivedGBP: 'GBP Получено',
  Cargo_ReceivedHKD: 'HKD Получено',
  Cargo_ReceivedJPY: 'Джей Пи получил',
  Cargo_ReceivedNGN: 'NGN Получено',
  Cargo_PayPaidUSD: 'USD Выплачено',
  Cargo_PayPaidEUR: 'EUR Выплачено',
  Cargo_PayPaidGBP: 'GBP Выплачено',
  Cargo_PayPaidHKD: 'HKD Выплачено',
  Cargo_PayPaidJPY: 'JPY Выплачено',
  Cargo_PayPaidNGN: 'NGN Выплачено',
  Cargo_OtherConversionReceivedUSD: 'Другие переводы в USD получены',
  Cargo_OtherConversionReceivedEUR: 'Прочие переводы в евро',
  Cargo_OtherConversionReceivedGBP: 'Другие переводы GBP получены',
  Cargo_OtherConversionReceivedHKD: 'Другие переводы HKD получены',
  Cargo_OtherConversionReceivedJPY: 'Прочие выплаты JPY',
  Cargo_OtherConversionReceivedNGN: 'Другие переводы NGN получены',
  Cargo_OtherConversionPayPaidUSD: 'Прочие выплаты в долл. США',
  Cargo_OtherConversionPayPaidEUR: 'Прочие выплаты в евро',
  Cargo_OtherConversionPayPaidGBP: 'Прочие выплаты',
  Cargo_OtherConversionPayPaidHKD: 'Прочие выплаты HKD',
  Cargo_OtherConversionPayPaidJPY: 'Прочие выплаты JPY',
  Cargo_OtherConversionPayPaidNGN: 'Прочие выплаты',
  Cargo_OtherConversionReceivedCNY: 'Другие переводы CNY получены',
  Cargo_OtherConversionPayPaidCNY: 'Прочие выплаты',
  Cargo_ReceivableCNY: 'Дебиторская задолженность',
  Cargo_ReceivableEUR: 'Дебиторская задолженность EUR',
  Cargo_ReceivableGBP: 'Дебиторская задолженность',
  Cargo_ReceivableHKD: 'Дебиторская задолженность HKD',
  Cargo_ReceivableJPY: 'Дебиторская задолженность JPY',
  Cargo_ReceivableNGN: 'Дебиторская задолженность NGN',
  Cargo_ReceivableP: 'Дебиторская задолженность:',
  Cargo_ReceivablesInvoicingDate: 'Дата выставления счетов к получению',
  Cargo_ReceivablesInvoicingStatus: 'Статус выставления счетов к получению',
  Cargo_ReceivablesWriteOfStatus: 'Списание дебиторской задолженности',
  Cargo_ReceivableUSD: 'Дебиторская задолженность',
  Cargo_Receive: 'Прием',
  Cargo_RevocationOfReceipt: 'Отменить получение',
  Cargo_Received: 'Принято',
  Cargo_ReceivedDate: 'Дата получения',
  Cargo_ReceiveMethod: 'Формы получения',
  Cargo_Receiver: 'Вернуть людей',
  Cargo_Receiver2: 'Получатель',
  Cargo_ReceiverCompanyName: 'Получающая единица',
  Cargo_ReceivingBank: 'Банк - получатель',
  Cargo_ReceivingBankAccount: 'Номер счета',
  Cargo_ReceivingDate: 'Дата возвращения',
  Cargo_Recheck: 'Пересмотр',
  Cargo_RecheckDate: 'Дата пересмотра',
  Cargo_ReCheckedSuccessfully: 'Обзор был успешным.',
  Cargo_ReCheckedFailed: 'Ошибка пересмотра.',
  Cargo_CancelReCheckedSuccessfully: 'Отмена пересмотра прошла успешно.',
  Cargo_RecheckOrNot: 'Пересмотр',
  Cargo_RecheckP: 'Пересмотр:',
  Cargo_ReCheckPermission: 'Полномочия по пересмотру',
  Cargo_RecipientOfWithdrawal: 'Получатель возврата',
  Cargo_RecipientSCompanyOfWithdrawal: 'Получающая сторона',
  Cargo_ReconcileOrNot: 'Выверка счетов',
  Cargo_Reconciliation: 'Выверка счетов',
  Cargo_ReconciliationAmount: 'Сумма выверки',
  Cargo_ReconciliationConfirmation: 'Подтверждение выверки',
  Cargo_ReconciliationDate: 'Дата выверки',
  Cargo_ReconciliationOfAR: 'Выверка дебиторской задолженности',
  Cargo_ReconciliationStatus: 'Статус выверки',
  Cargo_ReconciliationStatusControl: 'Контроль за состоянием выверки',
  Cargo_ReconciliationType: 'Тип выверки',
  Cargo_SendEmailByReconciliationDiff: 'Синхронизировать ли уведомление о расходах при сохранении',
  Cargo_ReconciliationDiffConfirm: 'Ликвидация расхождений',
  Cargo_ReconciliationDiffReason: 'Причины разницы',
  Cargo_ReconciliationDiffConfirmTip: 'Отправлено ли уведомление по электронной почте при сохранении',
  Cargo_Record: 'Регистрация',
  Cargo_RecordCount: 'Число записей',
  Cargo_Recorder: 'Регистратор',
  Cargo_RecordLabel: 'Метка записи',
  Cargo_RecordNoOfPaidIn: 'Полученные регистрационные номера',
  Cargo_RecordOrNot: 'Регистрация',
  Cargo_RecordOutOfPocket: 'Регистрация платежей',
  Cargo_RecordPrepayment: 'Зарегистрированный аванс',
  Cargo_RecordsFound: 'Запросить запись {0}',
  Cargo_RecordsWithEmptyInvoiceTypeExist: 'Имеются пустые записи о типах счетов - фактур',
  Cargo_RecordTime: 'Время записи',
  Cargo_RedChargesOrNot: 'Есть ли у Red Chong зарубежные расходы Нет действительного номера счета',
  Cargo_ReDeliveryOrNot: 'Выдается ли второй раз?',
  Cargo_ReferralFromExistingClient: 'Знакомство с гостями',
  Cargo_Reflush: 'Обновление',
  Cargo_RefNbr: 'Номер квитанции',
  Cargo_Refresh: 'Обновить',
  Cargo_RefreshCompleteStatus: 'Обновление завершено.',
  Cargo_RefreshSearch: 'Обновить запрос',
  Cargo_RefundAdvanceReceipt: 'Возврат авансов',
  Cargo_RefundOfLclBusiness: 'Возврат платы за упаковку?',
  Cargo_Refuse: 'Отказ',
  Cargo_Region: 'Регион',
  Cargo_RegisteredCapital: 'Регистрационный взнос компании',
  Cargo_RegisteredCapitalIn10Thousand: 'Регистрационный взнос компании / 10 000',
  Cargo_RegistrationNumber: 'Идентификатор налогоплательщика',
  Cargo_RegistrationNumberP: 'Идентификатор налогоплательщика:',
  Cargo_ReIssuedInvoiceNo: 'Новый номер счета - фактуры.',
  Cargo_ReIssuedInvoiceNoP: 'Новый номер счета - фактуры:',
  Cargo_ReIssueInvoice: 'Возобновление счетов',
  Cargo_ReIssueVoidedInvoice: 'Возобновление счетов после аннулирования',
  Cargo_RelatedBLNo: 'Номер сопроводительного коносамента',
  Cargo_Release: 'Освобождение',
  Cargo_ReleaseHbl: 'Индивидуальный лист',
  Cargo_Releasing: 'Расписание',
  Cargo_ReleasingStatus: 'Уникальное состояние',
  Cargo_RemainingAmount: 'Остаток средств',
  Cargo_RemainingPledgedAmount: 'Оставшаяся сумма требований',
  Cargo_Remarks: 'Примечания',
  Cargo_SupervisorComments: 'Область комментариев руководителя',
  Cargo_RemarksCannotBeEmptyWhenWipeOut: 'Примечания при игнорировании нуля не могут быть пустыми.',
  Cargo_RemarksOnAROrAPItems: 'Примечания к расходам',
  Cargo_RemarksOnPayment: 'Примечания к платежам',
  Cargo_RemarksP: 'Примечания:',
  Cargo_ArOriginalCurrency: 'Дебиторская задолженность (в первоначальной валюте)',
  Cargo_ApOriginalCurrency: 'Кредиторская задолженность (в первоначальной валюте)',
  Cargo_RemarkTheLengthCannotExceedP: 'Длина заметок не должна превышать',
  Cargo_RemarkTheLengthCannotExceedP256: 'Длина заметок не должна превышать 256.',
  Cargo_RemittanceFee: 'Перевод',
  Cargo_Remove: 'Удалить',
  Cargo_RemoveConfig: 'Удалить конфигурацию',
  Cargo_AddConfig: 'Добавить конфигурацию',
  Cargo_RemoveBillCharge: 'Расходы на удаление',
  Cargo_RemoveDetails: 'Удалить детали',
  Cargo_RemoveExpenseRemoveAll: 'Сборы за удаление / Удалить все',
  Cargo_RemoveParameterFunction: 'Удаление параметров',
  Cargo_RemovePartial: 'Удалить часть',
  Cargo_OrderType: 'Тип заказа',
  Cargo_TruckTrailer: 'Прицеп для сбора карт',
  Cargo_WholeVehicleAndLessThanCarload: 'Автомобиль / брутто',
  Cargo_RemovePermissionToSubmitExpense: 'Отмена права на представление гонораров',
  Cargo_RemoveSelectedData: 'Удалить выделенные данные',
  Cargo_RemoveSelectedExpense: 'Удалить выбранные расходы',
  Cargo_RenderStyle: 'Стиль рендеринга',
  Cargo_Renew: 'Продление',
  Cargo_RenewContract: 'Продление контракта',
  Cargo_ReOpen: 'Переоткрыть',
  Cargo_ReOpenedSuccessfully: 'Повторное открытие успешно.',
  Cargo_RepeatedMaintenance: 'Повторное обслуживание',
  Cargo_ReplaceBill: 'Замена счетов',
  Cargo_ReportTo: 'Субъекты отчетности',
  Cargo_Reset: 'Сбросить',
  Cargo_ResetFilter: 'Условия сброса',
  Cargo_Restore: 'Восстановление',
  Cargo_RestoreSelectedClient: 'Подтвердить выбранного клиента',
  Cargo_RetreatASingle: 'Список возвратов',
  Cargo_RetrievalFailureReturnFunction: 'Ошибка восстановления функции',
  Cargo_RetrievalFunction: 'Функция поиска',
  Cargo_RetrievalType: 'Тип поиска',
  Cargo_RetrievalTypeP: 'Тип поиска:',
  Cargo_Retrieved: 'Отобрано',
  Cargo_RetrievedButNotReturned: 'Получено (не возвращено)',
  Cargo_RetrieveMark: 'Сбор меток',
  Cargo_Return: 'Вернуть назад',
  Cargo_ReturnDate: 'Дата возвращения',
  Cargo_Returned: 'Возмещено',
  Cargo_ReturnedSuccessfully: 'Возвращение успешно.',
  Cargo_ReturnExpressNumber: 'Вернуть номер курьера',
  Cargo_ReturnOrderExpressNumber: 'Номер возврата.',
  Cargo_ReturnQuery: 'Вернуться к запросу',
  Cargo_ReturnToSearch: 'Вернуть запрос',
  Cargo_Revenue: 'Поступления',
  Cargo_RevenueAndExpenditureType: 'Вид поступлений и расходов',
  Cargo_RevenueOrExpenditure: 'Поступления и расходы',
  Cargo_Reverse: 'Подтвердите красный удар.',
  Cargo_ReversedCloseAccountSuccessfully: 'Контрсчет успешно',
  Cargo_CloseAccountSuccessfully: 'Счет успешно',
  Cargo_ReverseReview: 'Контраудит',
  Cargo_ReverseReviewedSuccessfully: 'Контраудит удался',
  Cargo_ReviewCancelledSuccessfully: 'Отмена проверки прошла успешно.',
  Cargo_ReviewedOrNot: 'Проверено ли',
  Cargo_ReviewOverallSearch: 'Проверка глобальных запросов',
  Cargo_ReviewTime: 'Время проверки',
  Cargo_ReviewVoucher: 'Аудиторская документация',
  Cargo_Revoke: 'Отмена',
  Cargo_RevokeClaim: 'Отзыв заявления',
  Cargo_RevokedSuccessfully: 'Отмена прошла успешно.',
  Cargo_RevokeInvoicingApplication: 'Отзыв заявления',
  Cargo_RevokeOrNot: 'Отмена',
  Cargo_PushFailByCBMS: 'Ошибка push, свяжитесь с сотрудником, чтобы проверить',
  Cargo_PushSuccessByCBMS: 'Успешное продвижение бизнеса',
  Cargo_RevokeReview: 'Отмена проверки',
  Cargo_RevokeSelection: 'Отменить выделение',
  Cargo_RevokeWithdrawal: 'Аннулирование требований',
  Cargo_RevokeWithdrawalList: 'Списки аннулированных требований',
  Cargo_RevokingRetrievalFailed: 'Отмена не удалась.',
  Cargo_RFPNMIS: 'Счета не ведутся в течение соответствующего финансового периода.',
  Cargo_RITSS: 'Запись успешно импортирована в систему.',
  Cargo_RTGTEOMCACC: 'Существует ли уверенность в том, что повторный налоговый экспорт может привести к дополнительным расходам?',
  Cargo_RTIAFRODI: 'Если вы не выберете « одновременное удаление подтверждения расходов», вы вернете счет - фактуру на рассмотрение заявки на выставление счета или удалите счет - фактуру и подтверждение расходов',
  Cargo_RTPIRS: 'Переведено на рассмотрение заявки.',
  Cargo_Rule: 'Правило',
  Cargo_SABID: 'Пропустить ли заполнение основной информации',
  Cargo_SADNSUICAT: 'По текущим предметам вспомогательных счетов не предусмотрено.',
  Cargo_SailingDate: 'Дата отправления',
  Cargo_SailingDay: 'Дата отправления',
  Cargo_ETD: 'ETD',
  Cargo_ETA: 'ETA',
  Cargo_ATD: 'ATD',
  Cargo_ATA: 'ATA',
  Cargo_LookDetail: 'Смотрите подробнее',
  Cargo_Sales: 'Продажа',
  Cargo_SalesP: 'Продажа:',
  Cargo_SalesBranchCompany: 'Отдел продаж',
  Cargo_SalesCommission: 'Проценты от продаж',
  Cargo_SalesCompany: 'Компании по сбыту',
  Cargo_SalesDepartment: 'Отдел сбыта',
  Cargo_SalesFreeHand: 'Продается самостоятельно',
  Cargo_Salesman: 'Оператор',
  Cargo_SalesmanP: 'Оператор:',
  Cargo_SalesParty: 'Продавец',
  Cargo_SalesPerson: 'Продавец',
  Cargo_SALOGROEI: 'По крайней мере, необходимо выбрать условие группировки или ввести имя резюме.',
  Cargo_SameYear: 'В том же году',
  Cargo_SAPPMBI: 'Выбранная расчетная единица фактического получения / платежа должна быть одинаковой.',
  Cargo_Save: 'Сохранить',
  Cargo_SaveAll: 'Сохранить все',
  Cargo_SaveAndAdd: 'Сохранить и добавить',
  Cargo_SaveAndCalculateTotalAmount: 'Сохранить и рассчитать общую сумму',
  Cargo_SaveBill: 'Счет сохранен',
  Cargo_SaveCurrentSelection: 'Сохранить текущий выделенный элемент',
  Cargo_CurrentSelection: 'Текущий выделенный элемент',
  Cargo_Saved: 'Сохранение завершено.',
  Cargo_SaveEditing: 'Сохранить редактор',
  Cargo_SaveEntity: 'Депозитарий',
  Cargo_SaveExchangeRateToCache: 'Сохранить обменный курс в кэш',
  Cargo_SaveFailed: 'Ошибка сохранения.',
  Cargo_SaveGroupInfo: 'Сохранить сведения о группах',
  Cargo_SaveInvoice: 'Сохранить счет - фактуру',
  Cargo_SaveInvoiceNo: 'Сохранить номер счета',
  Cargo_SaveOrNot: 'Сохраняются ли большие',
  Cargo_SaveQueryP: 'Сохранить параметры запроса',
  Cargo_SaveReconciliation: 'Сохранить выверку',
  Cargo_SaveSucceed: 'Сохранить успешно.',
  Cargo_Saving: 'Сохраняется',
  Cargo_SBRASPATFRD: 'Заявки на оплату не требуют бизнес - аудита и направляются непосредственно на финансовый аудит',
  Cargo_SBSPISB: 'Те же филиалы объединяются по объектам расчетов',
  Cargo_ScaleOfCompany: 'Размер компании',
  Cargo_ScaleOfCompanyEmployees: 'Размер компании / человек',
  Cargo_SCNEIPMSL: 'Партнерские модули уже существуют, необходимо ли ассоциировать предприятия с аналогичными именами',
  Cargo_SCOCCSC: 'Процент от продаж, процент от операций, процент от обслуживания клиентов.',
  Cargo_SDNCCNTFL: 'Если данные выписки не загружены, нажмите следующий шаг для загрузки.',
  Cargo_SDNMBR: 'Счет не соответствует требованиям',
  Cargo_SDNMWOR: 'Статус счета не соответствует требованиям',
  Cargo_SeaportOfDischarge: 'Порт разгрузки (морской порт)',
  Cargo_Search: 'Поиск',
  Cargo_SearchAlreadyExisted: 'Запрос уже существует',
  Cargo_SearchAPWriteOffs: 'Проверка счетов кредиторской задолженности',
  Cargo_SearchARWriteOff: 'Проверка дебиторской задолженности',
  Cargo_SearchCompleted: 'Запрос удался.',
  Cargo_SearchConditions: 'Условия запроса',
  Cargo_SearchCreated: 'Создан запрос',
  Cargo_SearchDisplayColumn: 'Показать столбец запроса',
  Cargo_SearchError: 'Ошибка запроса.',
  Cargo_SearchForBill: 'Проверить счет',
  Cargo_SearchForBusinessDeptApproved: 'Проверка утверждения операций и утверждения департаментом',
  Cargo_SearchForBusinessOfSameGroup: 'Поиск операций с одной и той же группой',
  Cargo_SearchForData: 'Данные поиска',
  Cargo_SearchForDataAsPerPermission: 'Доступ к данным по разрешениям',
  Cargo_SearchForExpenses: 'Расходы на запросы',
  Cargo_SearchForMore: 'Дополнительные запросы',
  Cargo_SearchForOverseasExpense: 'Проверить зарубежные расходы',
  Cargo_SearchForParameterTemplateList: 'Список шаблонов параметров запроса',
  Cargo_SearchInformation: 'Информация о запросе',
  Cargo_SearchMark: 'Метка запроса',
  Cargo_SearchOperation: 'Операция запроса',
  Cargo_SecondNotifyParty: 'Второй уведомитель',
  Cargo_SecondVoyage: 'Количество судов',
  Cargo_SecureBusiness: 'Блокирование операций',
  Cargo_SEFInput: 'Ввод таможенной документации',
  Cargo_Select: 'Выбор',
  Cargo_SelectAddPlatfoCNYLMethod: 'Выбор формы коносамента',
  Cargo_SelectAddPlatformContainerType: 'Выбор типа платформы Добавить',
  Cargo_SelectAddPlatformCurrency: 'Выбор валюты платформы Добавить',
  Cargo_ShippingAddress: 'Адрес доставки',
  Cargo_AddModel: 'Техническое обслуживание самолетов',
  Cargo_maintenance: 'Техническое обслуживание контейнеров',
  cargo_container_type: 'Тип сборщика',
  cargo_container_code: 'Код сборщика',
  cargo_container_number: 'Номер сборщика',
  cargo_pallet: 'Упаковка',
  cargo_container_max_weight: 'грузоподъемность контейнера',
  cargo_container_max_capacity: 'вместимость контейнера',
  cargo_loading_rate: 'Коэффициент загрузки',
  Cargo_Container_Type_Not_Configured: 'Вы не обслуживаете сборщик и можете обратиться к 【Базовые данные - сборщик】 для поддержания соответствующих данных',
  cargo_please_enter_the_container: 'Пожалуйста, введите сборку.',
  cargo_please_enter_the_container_code: 'Введите код сборщика.',
  cargo_Please_select_a_container: 'Выберите сборщик',
  cargo_Charter_package_board_statistics: 'Статистика чартерных перевозок',
  cargo_please_enter_the_cost: 'Введите стоимость',
  Cargo_please_enter_flight_costs: 'Чартерные / чартерные рейсы, пожалуйста, введите стоимость рейса.',
  Cargo_Please_enter_charter_details_or_flight_costs: 'Упакованные рейсы, пожалуйста, введите информацию об упаковке или стоимости рейса.',
  cargo_can_only_be_dragged_under_a_container: 'Его можно перетащить под контейнер.',
  cargo_requires_dragging_across_containers: 'Требуется перетаскивание через коллектор',
  cargo_not_allowed_reconfiguration: 'Перераспределение операций вне операционного режима не допускается',
  Cargo_cross_flight_tips: 'Трансрейсовые рейсы будут связаны с новым сборщиком и удалят всю информацию о сборщике, связанную с первоначальным бизнесом, пожалуйста, убедитесь, что это продолжается?',
  Cargo_CheckUldWeightOrCubage: 'Код сборщика: {0} Товар {1} превышает груз {2}, пожалуйста, убедитесь, что он сохранен?',
  Cargo_master_reconfiguration_tips: 'После перепрофилирования все небольшие билеты под основным билетом были связаны под этим контейнером, продолжается ли?',
  cargo_no_flight_information: 'Текущий бизнес не имеет рейсов, а целевое местоположение не имеет информации о рейсах, не требует обработки',
  cargo_unloaded_container_business: 'Эксплуатация неснаряженных накопителей',
  Cargo_SelectAddPlatformPackages: 'Выбор упаковки платформы Добавить',
  Cargo_SelectAddPlatformShippingTerms: 'Условия перевозки Платформа Выбрать Добавить',
  Cargo_SelectAddPlatformTradeMethod: 'Платформа Выбор способа торговли Добавить',
  Cargo_SelectAddPlatformTradeTerms: 'Торговые условия Платформы Добавить',
  Cargo_SelectAll: 'Полная выборка',
  Cargo_SelectBusinessDateRange: 'Выберите диапазон бизнес - дат',
  Cargo_SelectCopyContent: 'Выберите содержимое для копирования',
  Cargo_SelectCurrency: 'Выберите валюту',
  Cargo_Selected: 'Выбранные',
  Cargo_SelectedByDefault: 'Выбор по умолчанию',
  Cargo_SelectedData: 'Выбранные данные',
  Cargo_SelectedEntity: 'Выбранные объекты',
  Cargo_SelectedExpenseConfirmedExpense: 'Подтвержденные расходы',
  Cargo_SelectedInvoice: 'Выбранные счета - фактуры',
  Cargo_SelectedItems: 'Выбрано: {0}',
  Cargo_SelectedP: 'Выбраны:',
  Cargo_SelectedVoucher: 'Избранные сертификаты',
  Cargo_SelectedVoucherCantOver100: 'Избранные ваучеры {0} не могут превышать 100.',
  Cargo_SelectEventStatus: 'Выберите состояние события',
  Cargo_SelectEventToApprove: 'Пожалуйста, выберите вопрос утверждения',
  Cargo_SelectFilesToDownload: 'Выберите файл, который нужно скачать',
  Cargo_SelectInvoiceNo: 'Выберите номер счета',
  Cargo_SelectNewInvoiceNo: 'Выберите новый номер счета',
  Cargo_SelectOrAddInvoiceNo: 'Выберите или заполните номер счета',
  Cargo_SelectPaperInvoiceByDefault: 'Выберите бумажный счет - фактуру по умолчанию',
  CargoMsg_Information_Supplement: 'Дополнение информации',
  Cargo_SelectRecordsToExport: 'Выберите запись для экспорта',
  Cargo_SelectSalesPerson: 'Выберите Продажа',
  Cargo_SelectSalesPersonDep: 'Пожалуйста, выберите отдел продаж.',
  Cargo_SelectCsr: 'Пожалуйста, выберите обслуживание.',
  Cargo_SelectCsrDep: 'Пожалуйста, выберите отдел обслуживания клиентов.',
  Cargo_SelectDoc: 'Выберите документ',
  Cargo_SelectDocDep: 'Пожалуйста, выберите отдел документации',
  Cargo_SelectOverseaOp: 'Пожалуйста, выберите зарубежное обслуживание.',
  Cargo_SelectOverseaOpDep: 'Пожалуйста, выберите зарубежную службу.',
  Cargo_SelectCargoSales: 'Пожалуйста, выберите продажу.',
  Cargo_SelectPlanner: 'Пожалуйста, выберите руководителя маршрута.',
  Cargo_SelectPlannerDep: 'Пожалуйста, выберите ответственного за маршрут.',
  Cargo_invalidBatchModifyBusiness: 'Не найден тот же бизнес, что и операционный филиал и филиал по продажам, пожалуйста, выберите еще раз и попробуйте',
  Cargo_SelectSob: 'Выберите счет',
  Cargo_SelectSubject: 'Выберите тему',
  Cargo_SelectToCopyInFutureDoNotAsk: 'Копировать после этого выбора больше не нужно.',
  Cargo_SelectVoucherDate: 'Выбор даты документа',
  Cargo_SelfDeclaration: 'СамоТД',
  Cargo_SelfDeclareToCustoms: 'Подать декларацию самостоятельно',
  Cargo_SelfDelivery: 'СД',
  Cargo_SpecialApprovalIssuance: 'Особое утверждение на выдачу',
  Cargo_CurrentAvailableQuantity: 'Текущее количество в наличии',
  Cargo_OccupiedBusinessNumber: 'Занятый номер бизнеса',
  Cargo_RemainingAvailableQuantity: 'Оставшееся количество в наличии',
  Cargo_SpecialApprovalCreateBusiness: 'Если объект расчета превышает кредитный контроль и настроено [не сохранять], при создании бизнеса можно использовать специальное утверждение для создания бизнеса в процессе выдачи.',
  Cargo_CopyResult: 'Успешно скопировано {0} элементов, не удалось скопировать {1} элементов',
  Cargo_SellingPrice: 'Продажа',
  Cargo_SellTitle: 'Товарная единица',
  Cargo_Send2: 'Отправка',
  Cargo_SendAll: 'Отправить все',
  Cargo_SendAllP: 'Отправить все',
  Cargo_SendBack: 'Возврат средств',
  Cargo_SendConfirmationStatus: 'Статус подтверждения отправки',
  Cargo_SendFailed: 'Ошибка отправки.',
  Cargo_SendingDate: 'Дата отправки',
  Cargo_SendMessage: 'Отправить сообщение',
  Cargo_SendPartial: 'Частичная передача',
  Cargo_SendToBranchCompany: 'Отправить филиал',
  Cargo_Sent: 'Отправлено',
  Cargo_SentDate: 'Дата отправки',
  Cargo_SeparateNumber: 'Товарный номер',
  Cargo_September: 'Сентябрь',
  Cargo_SequenceNumber: 'Серийный номер',
  Cargo_UNNumber: 'Номер ООН',
  Cargo_ChargeUnit: 'Расчетная единица / единица',
  Cargo_DangerousGoods: 'Опасные грузы',
  Cargo_IndicatesRequired: '* Номер должен быть заполнен',
  Cargo_NewTo: 'Дополнительные',
  Cargo_EditTo: 'Редактирование',
  Cargo_AccountingPeriodRange: 'Укажите объем счета.',
  Cargo_SerialNoOfBankReceipt: 'Водяной номер',
  Cargo_AutoUpdateNote: 'Должны ли примечания обновляться автоматически?',
  Cargo_ConfirmBeforeEnable: 'Пожалуйста, подтвердите с технической командой перед включением. Не включайте его без необходимости.',
  Cargo_MultiHeaderBankMode: 'Режим многозаголовочного банка',
  Cargo_ServiceCodeCannotBeNull: 'Сервисный код не может быть пустым',
  Cargo_ServiceItems: 'Статьи обслуживания',
  Cargo_ServiceName: 'Название службы',
  Cargo_AutoGenerateFeeName: 'Автоматически создавать название сбора',
  Cargo_AutoGenerateTaxRate: 'Автоматически создавать налоговую ставку',
  Cargo_TaxNameRateConsistency: 'Название налога/сбора и налоговая ставка должны быть либо указаны вместе, либо оставлены пустыми.',
  Cargo_AutoGenerateOrDefaultTaxExclusive: 'Автогенерация налоговой ставки и налоговая ставка по умолчанию не могут быть активны одновременно; может быть включена только одна опция.',
  Cargo_ServiceNameCanTBeEmpty: 'Название службы не может быть пустым',
  Cargo_ServiceRequestAddressForEInvoice: 'Адрес запроса на услуги электронного счета - фактуры',
  Cargo_ServiceTicket: 'Удостоверение расходов',
  Cargo_ServiceTicketState: 'Подтверждение состояния',
  Cargo_ServiceTicketCreatedOrNot: 'Наличие подтверждения расходов',
  Cargo_ServiceTicketIssued: 'Открыто подтверждение',
  Cargo_SetAging: 'Установить возраст',
  Cargo_SetDefault: 'Настройка по умолчанию',
  Cargo_SetDefaultItemDescription: 'Установить имя проекта по умолчанию',
  Cargo_SetDefaultItemName: 'Имя проекта по умолчанию',
  Cargo_SetFocusToFileNoTextTable: 'Установить фокус в текстовом поле номера файла',
  Cargo_SetName: 'Имя настройки',
  Cargo_SetsOfBooks: 'Счета',
  Cargo_SetsOfBooksP: 'Комплект счетов:',
  Cargo_SetText: 'Настройка текста',
  Cargo_SettleAccountsTo: 'Объект расчетов',
  Cargo_SettleByMonthly: 'Ежемесячные расчеты',
  Cargo_SettleByWeekly: 'Еженедельные расчеты',
  Cargo_SettlementAgent: 'Расчетный агент',
  Cargo_SettlementAgentError: 'Расчетный агент Ошибка, пожалуйста, выберите заново!',
  Cargo_SettlementByBill: 'Касса',
  Cargo_SettlementCompany: 'Расчетная единица',
  Cargo_SettlementMethod: 'Порядок расчетов',
  Cargo_SettlementMethodP: 'Порядок расчетов',
  Cargo_SettlementNotByBill: 'Некупонный узел',
  Cargo_SettlementNotice: 'Уведомление о переносе средств',
  Cargo_SettlementPartyDoesNotExist: 'Объект расчетов не существует.',
  Cargo_SettlementStatus: 'Состояние платежей',
  Cargo_SettlementType: 'Тип расчетов',
  Cargo_DoNotSpecify: 'Не указано',
  Cargo_DomesticAndForeign: 'Внутренний / внешний',
  Cargo_CurrencyRequirements: 'Валютные требования',
  Cargo_NotSpecified: 'Не указано',
  Cargo_Appoint: 'Назначение',
  Cargo_PaymentInOriginalCurrency: 'Платежи в первоначальной валюте',
  Cargo_SettlingAgentInconsistent: 'Расчетные агенты не совпадают.',
  Cargo_SettlingCompanyMustBeIdentical: 'Расчетные единицы должны быть одинаковыми.',
  Cargo_SettlingCompanySAbbreviation: 'Расчетная единица (сокращенно)',
  Cargo_SettlingCompanySCode: 'Расчетная единица (код)',
  Cargo_SettlingPartyCanTBeEmpty: 'Объект расчетов не может быть пустым.',
  Cargo_SettlingPartyIncompatible: 'Объекты расчетов не являются единообразными.',
  Cargo_SettlingPartyInconsistent: 'Объекты расчетов не совпадают.',
  Cargo_SettlingPartyOrSettlementAgentInconsistent: 'Расчетный объект или расчетный агент не совпадают',
  Cargo_SettlingPartyIsMandatory: 'Объект расчетов должен быть введён.',
  Cargo_SettlingPartyMustBeConsistent: 'Объекты расчетов должны быть согласованы.',
  Cargo_ProjectNumberNotNull: 'Номер бизнес - листа не может быть пустым',
  Cargo_SettlingPartyOfPayables: 'Платежная расчетная единица',
  Cargo_SetToCurrentSob: 'Установить текущий счет',
  Cargo_SetUpDefaultsInBatch: 'Настройка пакетов по умолчанию',
  Cargo_SetUpServiceTypesInBatch: 'Тип службы пакетной настройки',
  Cargo_SFEDOCSP: 'Разбивка текущих расчетов',
  Cargo_CollectFeeType: 'Тип платы',
  Cargo_Shipper: 'Отправитель',
  Cargo_ShipperId: 'Код отправителя',
  Cargo_ShipperInfo: 'Информация о отправителе',
  Cargo_ShipperSName: 'Наименование отправителя',
  Cargo_ShippingCompanyContractNo: 'Судоходная компания',
  Cargo_ShippingCompanySAbbreviation: 'Судоходная компания (сокращенно)',
  Cargo_ShippingCompanySCode: 'Судоходная компания (код)',
  Cargo_ShippingInformation: 'Информация об отгрузке',
  Cargo_ShippingRouteArea: 'Маршруты / районы',
  Cargo_ShortAccountIs: 'Короткий нулевой счет:',
  Cargo_ShowDetailedTitles: 'Показать раздел',
  Cargo_ShowAdjustRateEntry: 'Включая корректировки на конец периода',
  Cargo_ShowDetails: 'Показать подробности',
  Cargo_ShowedByVessel: 'Показать по названию судна',
  Cargo_ShowFromTo2: 'А',
  Cargo_ShowInvoiceDetails: 'Показать подробные счета',
  Cargo_ShowOpeningBalance: 'Показать начальное сальдо',
  Cargo_ShowRows: 'Показать число полос',
  Cargo_ShowStatementInformation: 'Показать информацию о выписке счетов',
  Cargo_ShutOut: 'Таможенная очистка возвращена',
  Cargo_SIATEPIISOTT: 'Начальный сегмент шаблона',
  Cargo_SignContract: 'Подпись',
  Cargo_SingleBillPrinting: 'Печать одного билета',
  Cargo_SITCINCOSDHBFLBS: 'Всего: {0} Счета - фактуры, в настоящее время №: {1} (при сохранении убедитесь, что другие данные Счета - фактуры загружены)',
  Cargo_SiteVisit: 'Поездки на места',
  Cargo_Size: 'Размер',
  Cargo_SkipPreviousStep: 'Проходит ли предыдущий шаг',
  Cargo_SLNECTS: 'Номер уведомления с красным шрифтом не был введен, продолжается ли его сохранение?',
  Cargo_SoaConfirmed: '[{0}] Счет подтвержден.',
  Cargo_SoaCreated: 'Счет составлен.',
  Cargo_SoaCreatedM: '[{0} Счет выставлен',
  Cargo_SoaCreatedAlready: 'Счет был выписан.',
  Cargo_SoaNoAlreadyCreated: 'Уже создан номер выверки.',
  Cargo_SobCode: 'Код пакета',
  Cargo_SobCodeAlreadyExists: 'Код счета уже существует.',
  Cargo_SobDataLoadingFailed: 'Ошибка загрузки данных.',
  Cargo_SobList: 'Списки счетов',
  Cargo_SobName: 'Название счета',
  Cargo_SobNameP: 'Название счета:',
  Cargo_SobSetup: 'Параметры счетов',
  Cargo_Soc: 'Контейнер владельца',
  Cargo_IsSoc: 'Является ли контейнер',
  Cargo_SoftwareVersion: 'Версия программного обеспечения',
  Cargo_SolicitationType: 'Тип груза',
  Cargo_SOSINTU: 'Обновить выбранный номер счета',
  Cargo_SOSINTUIU: 'Обновить выбранный номер счета как используемый',
  Cargo_SourceOfClient: 'Источник клиента',
  Cargo_SOWLC: 'Внутренний склад',
  Cargo_Sp1: 'Счета - фактуры',
  Cargo_Sp17: 'Развертывание деталей',
  Cargo_Sp18: 'Сведенные данные',
  Cargo_Sp24: 'Финансовые примечания',
  Cargo_Sp27: 'Корпоративная подпись',
  Cargo_Sp31: 'Разделение расходов',
  Cargo_SPABNCTBBE: 'Объекты расчетов и номера операций не могут быть пустыми.',
  Cargo_Space2: 'Дата счета - фактуры',
  Cargo_SPBNMNAL1SCR: 'Расчетный объект, номер бизнеса, номер основного листа, условия запроса даты должны быть заполнены.',
  Cargo_SpecialApproval: 'Специальные партии',
  Cargo_SpecialApprovalValidUntil: 'Срок действия специальной партии до',
  Cargo_BusinessExpirationDate: 'Срок действия',
  Cargo_SpecialApprovalTip: 'Примечание: Специальная партия имеет долгосрочный срок действия, если срок действия пуст.',
  Cargo_SpecialGoods: 'Есть ли у продукции особенности',
  Cargo_SpecialInvoice: 'Специальные счета - фактуры',
  Cargo_SpecialInvoiceGeneralInvoice: 'Специальные счета - фактуры / общие счета - фактуры',
  Cargo_SpecialInvoiceInternalInvoice: 'Специальные счета - фактуры / внутренние счета - фактуры',
  Cargo_SpecialPrice: 'Специальная цена',
  Cargo_SpecialPriceInstructions: 'Описание специальных цен',
  Cargo_SpecifyCollectionPayment: 'Различие между получением и оплатой',
  Cargo_SPIANA: 'Объекты расчетов непоследовательны и не имеют отношения к объединению.',
  Cargo_SPIANA_DiffSettlementAgent: 'Расчетные объекты не совпадают и не имеют отношения к объединению, а расчетные агенты не совпадают.',
  Cargo_Split: 'Разделить',
  Cargo_SplitBillingFees: 'Расходы на дробление счетов',
  Cargo_SplitBL: 'Распоряжение',
  Cargo_SplitExpense: 'Расходы на разделение',
  Cargo_SplitExpenseP: 'РНР:',
  Cargo_SplitHBL: 'Скачать HBL',
  Cargo_SplitMBL: 'Распаковка MBL',
  Cargo_SplitOldDataToNew: 'Разделение (старые данные становятся новыми)',
  Cargo_SplitSuccessfully: 'Разделить успешно',
  Cargo_SPNETRSC: 'Расчетный объект не существует, попробуйте сбросить кэш.',
  Cargo_SPWPWO: 'Объекты расчетов по счетам, подлежащим списанию',
  Cargo_SSNMIR: 'Счета - фактуры не соответствуют требованиям к выставлению счетов',
  Cargo_SSNMWOR: 'Счета - фактуры не соответствуют требованиям',
  Cargo_SSSFPR: 'Успешно ли сдано в предварительное производство',
  Cargo_STAEONRS: 'Условия перевозки уже существуют или не выбраны',
  Cargo_Staff: 'Служащие',
  Cargo_StaffP: 'Персонал:',
  Cargo_StampOfSalesUnit: 'Единица продажи: (глава)',
  Cargo_StartDateOfContainerReturn: 'Дата начала возврата',
  Cargo_StartDateOfFinancialPeriod: 'Дата начала финансового периода',
  Cargo_StartingAccountTitle: 'Начальные предметы',
  Cargo_StartNo: 'Начальный номер',
  Cargo_StartReconciliation: 'Проверка вручную',
  Cargo_StatementOfBalance: 'Ведомость текущих сальдо',
  Cargo_StatementOfBalance2: 'Ведомость 2',
  Cargo_Statistics: 'Статистика',
  Cargo_StatisticsWithoutMblExpenses: 'Стоимость основного билета не учитывается',
  Cargo_Status: 'Статус',
  Cargo_StatusChanged: 'Изменение состояния',
  Cargo_StatusOfAdvanceReceipt: 'Статус аванса',
  Cargo_STCCOTB: 'Вы уверены, что хотите отменить подтверждение этого счета?',
  Cargo_STDTATM: 'Удалить отображение предмета?',
  Cargo_STDTATNRAD: 'Вы уверены, что хотите удалить этот предмет? Невозможно восстановить после удаления!',
  Cargo_STDTPA: 'Подтвердить удаление этих платежных заявок?',
  Cargo_STWTPA: 'Подтвердите отзыв этих заявок на оплату?',
  Cargo_STDTSPT: 'Удалить шаблон параметров запроса',
  Cargo_STDTSRRAVWBDT: 'Вы уверены, что хотите удалить аккаунт? Правила и документы, связанные с записью, также будут удалены.',
  Cargo_STDTSVRJEWBDT: 'Удалить выбранный сертификат? Связанные с ним записи документов также будут удалены.',
  Cargo_STDTSVRJEWBDTM: 'Удалить выбранный сертификат {0}? Связанные с ним записи документов также будут удалены.',
  Cargo_STDTVGR: 'Убедитесь, что хотите удалить это правило группирования сертификатов?',
  Cargo_STOAOWO: 'Показать общую сумму неизрасходованных средств',
  Cargo_Storage: 'Хранение',
  Cargo_SendToEachRecipientSeparately: 'Отправить отдельно каждому получателю',
  Cargo_SyncSendCCAddress: 'Адрес синхронизации отправки копий',
  Cargo_SearchForTheDataYouWantToInsert: 'Поиск данных, которые вы хотите вставить',
  Cargo_StorageRequired: 'Хранить ли на складе',
  Cargo_STRAEAAWORWBRC: 'Вы уверены, что хотите отменить? Все корректировки расходов и списания будут заменены.',
  Cargo_StreetAddress: 'Подробный адрес улицы',
  Cargo_StreetAddressCanTBeEmpty: 'Адрес улицы не может быть пустым.',
  Cargo_STRTWOREAIIWBR: 'Вы уверены, что хотите отменить этот расчет? Информация о соответствующих расходах и счетах - фактурах будет заменена.',
  Cargo_Stuff: 'Заполнение',
  Cargo_STWBTSV: 'Убедитесь, что этот {0} сертификат выбран красным?',
  Cargo_SubCategoryOfAccountTitle: 'Подкласс предмета',
  Cargo_Submit: 'Представлено',
  Cargo_SubmitExpenseForReviewDirectly: 'Представление расходов на аудит непосредственно',
  Cargo_SubmitPaymentNotice: 'Представление платежных извещений',
  Cargo_SubmitStatusSelection: 'Статус представления',
  Cargo_Submitted: 'Представлено',
  Cargo_SubmittedForPreReviewStatus: 'Ход предварительного производства',
  Cargo_SubmittedSuccessfully: 'Представлено успешно.',
  Cargo_SpecialFeeLimitReleaseApply: 'Заявка на снятие ограничения спецрасходов',
  Cargo_SpecialFeeLimitReleaseApplyContent: 'Заявка на снятие ограничения спецрасходов для {0}',
  Cargo_SpecialFeeLimitReleaseApplyContentPlain: 'Заявка на снятие ограничения спецрасходов',
  Cargo_ReleaseDocumentNumberApplication: 'Заявка на выпуск документа/номера',
  Cargo_ReleaseNumberDocument: 'Выпуск номера/документа',
  Cargo_IsPaymentReceived: 'Получен ли платеж',
  Cargo_PaymentTime2: 'Время получения платежа',
  Cargo_ReleaseNumberQuantity: 'Количество выпущенных номеров',
  Cargo_RelatedAttachments: 'Связанные вложения',
  Cargo_ReleaseNumber: 'Выпуск номера',
  Cargo_ReleaseDocument: 'Выпуск документа',
  Cargo_RemainingTemporaryReleaseQuantity: 'Оставшееся количество временных выпусков',
  Cargo_TemporaryDocumentReleaseApplication: 'Заявка на временный выпуск документа',
  Cargo_TemporaryNumberReleaseApplication: 'Заявка на временный выпуск номера',
  Cargo_SubscribePOL: 'Место отправления',
  Cargo_SubsidiaryAccounting: 'Вспомогательный учет',
  Cargo_SubsidiaryAccountingClient: 'Вспомогательный учет клиентов',
  Cargo_SubsidiaryAccountingCondition1: 'Дополнительные условия учета',
  Cargo_SubsidiaryAccountingCondition2: 'Дополнительные условия учета II',
  Cargo_SubsidiaryAccountingCondition3: 'Условия дополнительного учета III',
  Cargo_SubsidiaryAccountingCondition4: 'Условия дополнительного учета IV',
  Cargo_SubsidiaryAccountingCondition5: 'Дополнительные условия учета 5',
  Cargo_SubsidiaryAccountingCondition6: 'Дополнительные условия учета 6',
  Cargo_SubsidiaryAccountingItems: 'Вспомогательные счета',
  Cargo_SubsidiaryAccountingStaff: 'Сотрудник по вспомогательному учету',
  Cargo_SubsidiaryLedger: 'Подробная отчетность',
  Cargo_SubsidiaryLedger2: 'Подробная отчетность 2',
  Cargo_SubtitlesOfAccount: 'Поддисциплины',
  Cargo_SubTotal: 'Итого',
  Cargo_SubTotalOfOpeningBalance: 'Итого, начальное сальдо',
  Cargo_Success: 'Успех',
  Cargo_SummarizeDistributionExpense: 'Статистика совместного несения расходов',
  Cargo_SummarizeMblExpense: 'Статистика стоимости билетов',
  Cargo_SupervisionMethod: 'Методы регулирования',
  Cargo_SupplierContract: 'Контракты с поставщиками',
  Cargo_Surcharge: 'Дополнительные расходы',
  Cargo_Controlled: 'Контролируемый элемент',
  Cargo_NeedInvoice: 'Требуется счет',
  Cargo_SurchargeOrNot: 'Дополнительные сборы',
  Cargo_SureToAddToBlackList: 'Вы уверены, что хотите попасть в черный список?',
  Cargo_SureToBatchConfirmTheBill: 'Вы уверены, что хотите подтвердить этот {0} счет?',
  Cargo_SureToBatchReviewTheExpense: 'Вы уверены, что хотите проверить эту {0} статью расходов?',
  Cargo_SureToCancel: 'Вы уверены, что хотите отменить?',
  Cargo_SureToCancelConfirmation: 'Вы уверены, что хотите отменить подтверждение?',
  Cargo_SureToCancelConfirmationYes: 'Вы уверены, что хотите отменить подтверждение?',
  Cargo_SureToCancelReviewOfTheExpense: 'Вы уверены, что хотите отменить аудит этой {0} статьи расходов?',
  Cargo_SureToCancelReviewOfTheVoucher: 'Подтвердите отмену проверки этого документа?',
  Cargo_SureToCancelReviewOfTheExpenseCheck: 'Выбранные расходы существуют {0} <br/>',
  Cargo_Billinged: 'Созданные счета',
  Cargo_WriteOffed: 'Списано',
  Cargo_SureToCancelVerification: 'Вы уверены, что отменяете аудит?',
  Cargo_SureToCarryOver: 'Вы подтверждаете переход?',
  Cargo_SureToConfirmWriteOffRecord: 'Вы уверены, что хотите подтвердить списание?',
  Cargo_SureToCreateInvoice: 'Вы уверены, что генерируете счет?',
  Cargo_SureToCreateListOfCombinedBills: 'Вы уверены, что сгенерировали список билетов?',
  Cargo_SureToDelete: 'Вы уверены, что хотите удалить?',
  Cargo_SureToDeleteWarehouse: 'После удаления будет удалена вся входная информация, будет ли продолжена?',
  Cargo_SureToDeleteInvoice: 'Удалить счет - фактуру?',
  Cargo_SureToDeleteSelectedRecord: 'Удалить выбранную запись?',
  Cargo_SureToDeleteTheAbstractRule: 'Удалить это краткое правило?',
  Cargo_SureToDeleteTheAdvanceReceipt: 'Удалить этот аванс?',
  Cargo_SureToDeleteTheBill: 'Удалить этот {0} счет?',
  Cargo_SureToDeleteTheExchangeRate: 'Подтвердить удаление этого обменного курса?',
  Cargo_SureToDeleteTheInvoice: 'Вы уверены, что хотите удалить этот {0} счет?',
  Cargo_SureToDeleteTheMapping: 'Удалить это отображение?',
  Cargo_SureToDeleteTheRecord: 'Удалить запись?',
  Cargo_SureToDeleteTheRule: 'Удалить это правило?',
  Cargo_SureToDeleteThisSoaItem: 'Удалить этот {0} счет?',
  Cargo_SureToDeliverToBranch: 'Подтвердите отправку в филиал?',
  Cargo_SureToDeny: 'Уверены, что хотите отказаться?',
  Cargo_SureToFreezeApplication: 'Вы уверены, что хотите заморозить заявку?',
  Cargo_SureToHoldSubmission: 'Уверены, что не подадут?',
  Cargo_SureToIssueCombinedInvoice: 'Вы уверены в слиянии счетов?',
  Cargo_SureToModifyBillingDate: 'Вы уверены, что хотите изменить дату счета?',
  Cargo_SureToPrint: 'Вы уверены, что хотите распечатать?',
  Cargo_SureToPrintDetailList: 'Вы уверены, что распечатали список?',
  Cargo_SureToReIssueInvoice: 'Вы уверены, что хотите снова открыть счет?',
  Cargo_SureToRejectIt: 'Уверены в отказе?',
  Cargo_SureToRejectTheExpenseItem: 'Вы уверены, что хотите отклонить эту {0} статью расходов?',
  Cargo_SureToRemoveTheBill: 'Убедитесь, что хотите удалить этот {0} счет?',
  Cargo_SureToRemoveTheExpenseItem: 'Убедитесь, что хотите удалить эту статью {0}?',
  Cargo_SureToReturnApplication: 'Вы уверены, что хотите вернуть заявление?',
  Cargo_SureToReviewTheBills: 'Вы уверены, что проверили эти списки?',
  Cargo_SureToReviewTheVoucher: 'Убедитесь, что хотите проверить этот {0} документ?',
  Cargo_SureToRevokeContractWith: 'Подтверждение факта расторжения контракта с компанией * * * * * * * *',
  Cargo_SureToRevokeRetrieval: 'Уверены в отзыве?',
  Cargo_SureToRevokeWithdrawal: 'Уверены в отзыве чека?',
  Cargo_SureToVoid: 'Уверены, что его отменят?',
  Cargo_SureToVoidInvoice: 'Вы уверены, что хотите отменить счет?',
  Cargo_SureToVoidTheInvoice: 'Вы уверены, что хотите отменить этот счет?',
  Cargo_SureToVoidTheInvoiceM: 'Вы уверены, что хотите отменить этот {0} счет?',
  Cargo_SUSBODNMWBACTS: 'Счет продавца не совпадает с банковским счетом, убедитесь, что его нужно сохранить?',
  Cargo_SUSBODNMWRISCTS: 'Номер банковского счета сбытовой организации не совпадает с обслуживанием в системе, убедитесь, что он должен быть сохранен?',
  Cargo_SUTCPALVIBC: 'Сведения о перенесенных прибылях и убытках указываются до закрытия счетов',
  Cargo_SVSFPHBC: 'Финансовый период, к которому относится выбранная в настоящее время дата подтверждения, был закрыт.',
  Cargo_SVSMHBC: 'Выбранные в настоящее время ваучеры были закрыты в течение месяца, к которому они относятся.',
  Cargo_SWDE: 'Совместное несение расходов',
  Cargo_Switch: 'Переключить',
  Cargo_SwitchBasisToAcquireDocument: 'Переключиться на получение документа',
  Cargo_SwitchCurrency: 'Переключить валюту',
  Cargo_SwitchFile: 'Переключить файл',
  Cargo_SwitchInvoice: 'Переключить счет',
  Cargo_SwitchMethodOfClaim: 'Переключить режим доступа',
  Cargo_SwitchSob: 'Переключить чехол',
  Cargo_Symbol: 'Символы',
  Cargo_SynchronousCodingPartners: 'Синхронное кодирование клиентов',
  Cargo_SystemAlertForPayment: 'Системное напоминание',
  Cargo_SystemBusy: 'Система занята.',
  Cargo_SystemBusyPRL: 'Система занята, попробуйте позже.',
  Cargo_TableFilter: 'Фильтрация таблиц',
  Cargo_TakeByCustomsBroker: 'Таможенная декларация сама себя',
  Cargo_TAOPLFESAMBETCWOA: 'Сумма + совокупная прибыль / убытки + финансовые расходы + нулевая сумма должна быть равна сумме списания.',
  Cargo_TAOPLFESAMBETCWOANoFinance: 'Сумма + совокупная прибыль / убытки + нулевая сумма должна быть равна сумме списания.',
  Cargo_TAOPLFESAMBETCWOAPC: 'Сумма + агрегированные прибыли и убытки + финансовые расходы + мелкие счета должны быть равны сумме списания, пожалуйста, проверьте.',
  Cargo_TAPBACTBLTARAWIETIAP: 'В случае кредиторской задолженности общая сумма кредиторской задолженности не может быть меньше общей суммы дебиторской задолженности.',
  Cargo_Tax: 'Налоги',
  Cargo_TaxAmount: 'Налоги',
  Cargo_TaxAmountP: 'Сумма налога:',
  Cargo_TaxationNbr: 'Номер налоговой регистрации',
  Cargo_TaxExcludedPrice: 'Без учета налогов',
  Cargo_TaxExcludedPriceP: 'Без учета налогов:',
  Cargo_TaxFreeAmount: 'Сумма без учета налогов',
  Cargo_TaxIncludedPrice: 'Налоговая стоимость',
  Cargo_TaxIncludedPriceP: 'Налоговые цены:',
  Cargo_TaxpayerAuthorizationCode: 'Код разрешения налогоплательщика',
  Cargo_TaxRate: 'Налоговые ставки',
  Cargo_TaxRateNotNull: 'Пожалуйста, заполните тариф.',
  Cargo_TaxRateP: 'Налоговые ставки:',
  Cargo_TaxRatePct: 'Налоговая ставка (%)',
  Cargo_TBTRS: 'Выверка счетов прошла успешно.',
  Cargo_TDCBODNBTTCBOTULBC: 'Действующие данные находятся в филиале, который не принадлежит текущему филиалу или филиалу более высокого уровня. Вы уверены, что хотите продолжить?',
  Cargo_TeamLeader: 'Руководитель группы',
  Cargo_TeamLeaderAssignment: 'Назначение руководителя группы',
  Cargo_Tel: 'Телефон',
  Cargo_TelexReleaseApplicant: 'Электронный заявитель',
  Cargo_TelexReleaseApplicationDate: 'Время подачи заявки на электроэнергию',
  Cargo_TelexReleaseFee: 'Плата за электроэнергию',
  Cargo_TelexReleaseMaterial: 'Электрические данные',
  Cargo_TelexReleaseNo: 'Электрический номер',
  Cargo_ExpenseBoxNo: 'Номер ячейки',
  Cargo_TemplateDownload: 'Загрузка шаблонов',
  Cargo_TemplateDownloadFailed: 'Ошибка загрузки модуля.',
  Cargo_TenDigitCode: 'Десятизначный код',
  Cargo_TenThousandYuan: 'Тысячи долларов.',
  Cargo_TEYAPHBMBSEC: 'Стоимость вашей операции была изменена другими, хотите ли вы продолжить операцию?',
  Cargo_TFCFDTECNIPSDOACS: 'Клиенты, у которых уже есть следующие номера в партнере, не смогли подписать документ, а остальные клиенты успешно подписали его',
  Cargo_TFOTPCTBCWOP: 'Сроки периода не могут пересекаться с другими периодами.',
  Cargo_TFSIIUDNA: 'Следующие сайты используются бизнесом и не допускаются к удалению',
  Cargo_The1StInvoiceNoCanTBeEmpty: 'Номер первого счета не может быть пустым.',
  Cargo_TheAmountOfWrittenOff: 'Списанная сумма',
  Cargo_TheExpenseNotBoundToInvoice: 'Эти расходы не связаны со счетами - фактурами.',
  Cargo_TheLast: 'Последняя.',
  Cargo_TheLastPage: 'Предыдущая',
  Cargo_TheNextPage: 'Следующий',
  Cargo_TheOppositeSideAccount: 'Номер счета другой стороны',
  Cargo_TheOppositeSideBank: 'Банк другой стороны',
  Cargo_TheOppositeSideCompany: 'Единицы контрагента',
  Cargo_TheOppositeSideInvoiceNo: 'Номер счета контрагента',
  Cargo_ThisFeeHasBeenInvoiced: 'Стоимость уже выставлена и не может быть разделена!',
  Cargo_ThisFeeHasBeenWrittenOff: 'Эти расходы были списаны и не могут быть разделены!',
  Cargo_ThisTimeBalance: 'Текущий остаток',
  Cargo_ThisTimeWriteOff: 'Нынешнее списание',
  Cargo_ThisTimeWriteOffEq: 'Списание = полученная сумма + совокупные прибыли и убытки + финансовые расходы + мелкие счета',
  Cargo_ThisWriteOffNoIs: 'Номер этого счета:',
  Cargo_TIBYEIB: 'Начальный баланс, который вы ввели',
  Cargo_TIBYEIUPDCTBSAIS: 'Первоначальный баланс, который вы ввели, не сбалансирован, пожалуйста, тщательно проверьте балансовый отчет и отчет о прибыли',
  Cargo_Time: 'Время',
  Cargo_TimeFrame: 'Сроки',
  Cargo_TimeOfCargoHolding: 'Время удержания',
  Cargo_TimeOfDocHolding: 'Время вычета',
  Cargo_TimeOfPurchase: 'Время покупки',
  Cargo_TimeOfPurchaseCanTBeEmpty: 'Время покупки не может быть пустым.',
  Cargo_TimeOfUse: 'Время использования',
  Cargo_TimeOfUseCanTBeEmpty: 'Время использования не может быть пустым.',
  Cargo_Tips: 'Подсказка',
  Cargo_PleaseSelectTheSailingScheduleBelow: 'Пожалуйста, выберите следующий срок.',
  Cargo_ChooseShippingSchedulesTips1: '1. Пожалуйста, выберите соответствующую информацию о продолжительности судна. Если вы не сделаете выбор, вы не сможете получить запланированное время выхода из причала, время остановки, фактическое время выхода из причала',
  Cargo_ChooseShippingSchedulesTips2: '2. Если вы еще не можете подтвердить срок, вы можете нажать кнопку [временно не выбрать] и нажать кнопку [выбрать срок] после подтверждения, чтобы выбрать срок',
  Cargo_MoreShippingSchedulesTips: 'Возврат порта к нескольким причалам может повлиять на отображение информации о сроках и push, выберите информацию о сроках, которую вы хотите',
  Cargo_ChooseShippingSchedules: 'Выбор продолжительности судна',
  Cargo_NoSelectYet: 'Пока нет.',
  Cargo_ChangePayment: 'Пересмотр платежных требований',
  Cargo_PaymentTimeLimit: 'Ср. пл.',
  Cargo_Title: 'Заголовок',
  Cargo_TitleOfAccount: 'Счета',
  Cargo_TLOOSE: 'Общая сумма пассивов и прав собственников или акционеров',
  Cargo_TMAEONRS: 'Существующие или не выбранные формы торговли',
  Cargo_To: 'Б',
  Cargo_FROM: 'От',
  Cargo_ToDetermineIfEditableWhenViewing: 'Чтобы определить, можно ли редактировать при просмотре',
  Cargo_TOEIAADFIA: 'Сумма статей расходов отличается от суммы счета - фактуры.',
  Cargo_ChargeAmountCannotExceedInvoiceAmount: 'Сумма статьи расходов не может превышать сумму счета-фактуры.',
  Cargo_ChargeAlreadyAssociatedInvoice: 'Расход {0} уже связан со счетом-фактурой.',
  Cargo_TORFRS: 'Всего найдено {0} записей, выбрано {1} записей',
  Cargo_Total0: 'Итого: {0}',
  Cargo_TotalAmount: 'Общая сумма',
  Cargo_TotalAmountNotWrittenOff: 'Общая сумма неизрасходованных средств',
  Cargo_TotalAmountOfCurrentPeriod: 'Итого, текущий период',
  Cargo_TotalAmountPJ: 'Общая сумма -',
  Cargo_TotalAmountP: 'Итого, сумма:',
  Cargo_TotalAmountToWriteOff: 'Общая сумма',
  Cargo_TotalAPAmount: 'Итого, кредиторская задолженность',
  Cargo_TotalARAmount: 'Общая сумма дебиторской задолженности',
  Cargo_TotalBalance: 'Общий остаток',
  Cargo_TotalCommissionAmount: 'Общая сумма отчислений',
  Cargo_TotalCommissionAmountP: 'Общая сумма отчислений:',
  Cargo_TotalCost: 'Общая стоимость',
  Cargo_TotalCurrency: 'Итого, монеты',
  Cargo_TotalCurrentLiabilities: 'Общая сумма текущих обязательств',
  Cargo_TotalIncome: 'Общий объем поступлений',
  Cargo_TotalLiabilities: 'Общая сумма обязательств',
  Cargo_TotalNonCurrentAssets: 'Итого, неликвидные активы',
  Cargo_TotalNonCurrentLiabilities: 'Итого, нетекущие обязательства',
  Cargo_TotalOfVouchersEntered: 'Всего регистрационных документов {0}',
  Cargo_TotalOutstandingAmountByCurrency: 'Итого, непогашенные монеты',
  Cargo_TotalPriceWithTaxInWords: 'Общая сумма налога с цены (с заглавной буквы)',
  Cargo_TotalProfit: 'Общая сумма прибыли',
  Cargo_TotalRevenue: 'Всего поступлений',
  Cargo_TotalWriteOffAmount: 'Общая сумма списаний',
  Cargo_Choose: 'Выбор',
  Cargo_TotalWriteOffs: 'Итого, списание',
  Cargo_TotalWriteOffsP: 'Всего списаний Credit:',
  Cargo_TPOPNOINOE: 'Общая сумма прибыли',
  Cargo_TPTODIDDYCTMAGV: 'Должны ли различные виды платежей или способы получения объединяться для создания сертификатов?',
  Cargo_TradeTerm: 'Форма торговли',
  Cargo_TradeTerms: 'Условия сделки',
  Cargo_TradeTermsMaintenance: 'Защита торговых условий',
  Cargo_TradeType: 'Тип торговли',
  Cargo_TradingCompany: 'Торговые компании',
  Cargo_Transfer: 'Б',
  Cargo_TransferAllToReconciliation: 'Все на выверку.',
  Cargo_TransferBackAmount: 'Сумма возврата',
  Cargo_TransferBackGrandTotal: 'Общая сумма возвращенных сумм',
  Cargo_TransferBackToReconciliation: 'Перевод средств на выверку счетов',
  Cargo_TransferCash: 'Денежные переводы',
  Cargo_TransferExpense: 'Трансферные расходы',
  Cargo_TransferIntoCollection: 'Перевод на инкассо',
  Cargo_TransferOutToCollection: 'Перевод инкассо',
  Cargo_TransferPort: 'Порт транзита',
  Cargo_TransferToCNY: 'Перейти CNY',
  Cargo_TransitPortSea: 'Порт транзита (морской порт)',
  Cargo_TransitTerm: 'Условия перевозки',
  Cargo_Transportation: 'Транспорт',
  Cargo_TRAYEINR: 'Сумма, которую вы ввели, не является разумной!',
  Cargo_TRFRBLFDAF: 'Плата за электроэнергию',
  Cargo_TrialBalance: 'Экспериментальное равновесие',
  Cargo_TrialBalanceCheck: 'Проверка балансировки',
  Cargo_TRNAPUCWOFISI: 'Невозможно отменить все, используйте функцию отмены списания в интерфейсе запроса.',
  Cargo_TruckCompany: 'Грузовые компании',
  Cargo_TSASOBMBTS: 'Расчетный агент должен быть таким же!',
  Cargo_TSBADNCTCC: 'Номер выбранного банковского счета не включает эту валюту, продолжайте.',
  Cargo_TTAEONRS: 'Существующие или не выбранные торговые условия',
  Cargo_TTOAFNTCCPM: 'Предметы учитываются только: {0}, не учитываются текущие категории валют: {1}, пожалуйста, измените',
  Cargo_TUPAOTPALVCBE: 'Счет нераспределенной прибыли не может быть пустым',
  Cargo_TWORHBRCC: 'Эта запись о списании была Red Chong и не может быть отозвана.',
  Cargo_Type: 'Тип',
  Cargo_MaximumTakeOffWeight: 'Максимальный взлетный вес',
  Cargo_Charter_Flights_Tips: 'Если для чартерных / упаковочных рейсов « Если для чартерных чартерных чартерных рейсов, вы можете поддерживать стоимость рейса здесь',
  Cargo_Charter_package_board: 'Чартерные рейсы / пакеты',
  Cargo_Board_Tips: 'Пакетный бизнес для последующего анализа пропускной способности и прибыли',
  Cargo_Flight_costs: 'Стоимость рейса',
  Cargo_NumberOfCartridges: 'Количество контейнеров',
  Cargo_Please_Select_The_Model_You_Want_To_Edit: 'Выберите модель для редактирования',
  Cargo_Please_Select_The_Model_To_Be_Deleted: 'Выберите модель, которую нужно удалить.',
  Cargo_Please_Select_The_Uld_You_Want_To_Edit: 'Выберите сборку для редактирования',
  Cargo_Please_Select_The_Uld_To_Be_Deleted: 'Выберите сборку, которую нужно удалить',
  Cargo_WeightRestrictions: 'Ограничение веса',
  Cargo_VolumeLimit: 'Ограничение объема',
  Cargo_LoadableCapacity: 'Грузоподъемность',
  Cargo_LoadableWeight: 'Грузоподъемный вес',
  Cargo_DeadWeight: 'Самооценка',
  Cargo_LSize: 'Размер (длина)',
  Cargo_WSize: 'Размер (ширина)',
  Cargo_HSize: 'Размер (высокий)',
  Cargo_ApplicableModels: 'Тип самолета',
  Cargo_ApplicableContainerType: 'Тип сборщика',
  Cargo_ApplicableContainerCode: 'Код сборщика',
  Cargo_ApplicableContainerNumber: 'Номер сборщика',
  Cargo_CharterPack: 'Чартерные рейсы / пакеты',
  Cargo_TypeOfBill: 'Тип документа',
  Cargo_TypeOfGoods: 'Вид груза',
  Cargo_TypeOfPort: 'Тип порта',
  Cargo_UBEIRPSMB: 'В записи есть немаркированные счета, выберите помеченные счета',
  Cargo_UCOVEIIDPCTD: 'Текущие импортированные данные существуют для клиентов или поставщиков, которые не поддерживаются в системе, нажмите для загрузки.',
  Cargo_Unbilled: 'Неоплаченные счета',
  Cargo_Uncommitted: 'Не представлено',
  Cargo_Unconfirmed: 'Не подтверждено',
  Cargo_UnderConfirmation: 'Подтверждаю.',
  Cargo_UnfrozenSuccessfully: 'Оттепель прошла успешно.',
  Cargo_UnInvoiced: 'Неоплаченные счета - фактуры',
  Cargo_Unissued: 'Не опубликовано',
  Cargo_UnissuedServiceTicket: 'Неоткрытые подтверждения',
  Cargo_Unit: 'Единицы измерения',
  Cargo_UnitOfMeasurement: 'Единицы измерения',
  Cargo_UnitOfPaymentPeriod: 'Единицы учета',
  Cargo_UnitPrice: 'Стоимость единицы',
  Cargo_UnitPriceP: 'Стоимость единицы:',
  Cargo_Unknown: 'Неизвестно',
  Cargo_UnKnownStatus: 'Статус неизвестен',
  Cargo_Unlimited: 'Без ограничений',
  Cargo_Unpaid: 'Невыплаченные взносы',
  Cargo_UnpaidClear: 'Непогашенные обязательства',
  Cargo_UnpaidCNY: 'Не выплачено',
  Cargo_UnpaidEUR: 'Не выплачено',
  Cargo_UnpaidGBP: 'Невыплачено',
  Cargo_UnpaidHKD: 'КПЧ невыплачен',
  Cargo_UnpaidJPY: 'Не выплачено',
  Cargo_UnpaidNGN: 'Не выплачено',
  Cargo_UnpaidP: 'Не выплачено:',
  Cargo_SimpleUnpaidP: 'Не выплачено',
  Cargo_UnpaidUSD: 'США)',
  Cargo_ReceivedP: 'Получено',
  Cargo_PaidP: 'Выплачено',
  Cargo_EmptyValue: 'Пустой',
  Cargo_UnsavedNewExpenseCanTBeSplit: 'Невозможно разделить дополнительные, не сохраненные расходы!',
  Cargo_UpdateBar: 'Обновление',
  Cargo_UpdateBusinessDate: 'Изменить дату операции',
  Cargo_UpdatedSuccessfully: 'Обновление прошло успешно.',
  Cargo_UpdateFailed: 'Ошибка обновления.',
  Cargo_UpdatePageDisplay: 'Обновить страницу',
  Cargo_UpdatePrintButtonStatus: 'Обновить состояние кнопки печати',
  Cargo_Upload: 'Загрузить',
  Cargo_UploadAttachment: 'Загрузить вложение',
  Cargo_DeleteAttachment: 'Удалить вложение',
  Cargo_UploadContract: 'Загрузка контракта',
  Cargo_UploadContractAttachments: 'Загрузить приложение к контракту',
  Cargo_UploadData: 'Загрузка данных',
  Cargo_URVUTSWBRIKC: 'Необработанные учетные записи будут проверены через Cloud Gold Batter, и вы уверены, что хотите продолжить?',
  Cargo_USD: 'Доллары',
  Cargo_USDAmount: 'долл. США',
  Cargo_USDExchangeRate: 'Обменный курс доллара США',
  Cargo_USDInvoiceNo: 'Номер счета - фактуры в долларах США',
  Cargo_USDP: 'В долл. США:',
  Cargo_Use: 'Использование',
  Cargo_Used: 'Используется',
  Cargo_UseGroupExchangeRate: 'Использование группового обменного курса',
  Cargo_UseOriginalTemporarily: 'Временный вариант',
  Cargo_User: 'Пользователи',
  Cargo_UserCanTBeEmpty: 'Пользователь не может быть пустым.',
  Cargo_UseShouldBeTemporarily: 'Временно здесь должно быть',
  Cargo_ValidityOfInvoice: 'Действителен ли счет - фактура',
  Cargo_Value: 'Значение',
  Cargo_VatGeneralInvoice: 'Налог на добавленную стоимость',
  Cargo_VatInvoice: 'Счета - фактуры по НДС',
  Cargo_VatInvoiceIssuingMachineNo: 'Номер счета - фактуры НДС',
  Cargo_VatSpecialInvoice: 'Специальные счета - фактуры по НДС',
  Cargo_Vendor: 'Поставщики',
  Cargo_VendorCantBeEmpty: 'Поставщики не могут быть пустыми',
  Cargo_VendorClient: 'Поставщики',
  Cargo_VendorModification: 'Изменения поставщика',
  Cargo_VendorP: 'Поставщики:',
  Cargo_VendorSInvoiceNo: 'Номер счета поставщика',
  Cargo_VerificationCancelled: 'Проверка отменена.',
  Cargo_VerificationPassed: 'Проходит ли аудит',
  Cargo_VerificationRejected: 'Проверка отклонена',
  Cargo_VerifiedSuccessfullyClickToSave: 'Проверка прошла успешно, нажмите для сохранения.',
  Cargo_VerifiedSuccessfullyClickToExport: 'Проверка прошла успешно, нажмите на экспорт.',
  Cargo_Verify: 'Проверка',
  Cargo_VerifyARAPExpense: 'Проверка кредиторской задолженности',
  Cargo_VerifyInvoiceNo: 'Удостоверение номера счета - фактуры',
  Cargo_VerifyJournalEntry: 'Проверить запись',
  Cargo_VesselAndVoyage: 'Название судна / рейс',
  Cargo_VesselVoyageFlight: 'Название рейса',
  Cargo_VGIVSI: 'Налог на добавленную стоимость',
  Cargo_VHBCFSACCTBC: 'Вспомогательный учет 【Клиенты】 был генерирован сертификат, который не может быть отменен.',
  Cargo_VHBCFSADCTBC: 'Вспомогательный учет 【Сектор】 был генерирован сертификат, который не может быть отменен.',
  Cargo_VHBCFSAICTBC: 'Вспомогательный учет 【Проекты】 был генерирован сертификат, который не может быть отменен.',
  Cargo_VHBCFSASCTBC: 'Вспомогательный учет 【Служащие】 был генерирован сертификат, который не может быть отменен.',
  Cargo_VHBCFSAVCTBC: 'Вспомогательный учет 【Поставщики】 был генерирован сертификат, который не может быть отменен.',
  Cargo_ASCCCTBC: 'Отправленная компания подтверждает, что отменить нельзя.',
  Cargo_VHBEFCWOWBRWBCITWORSTWB: 'Эта учетная запись о списании уже экспортировала финансовые документы, и если система списания будет отозвана, будет ли она генерировать учетную запись о красном ударе, подтверждающую красный удар?',
  Cargo_View: 'Посмотреть',
  Cargo_ViewAllBusiness: 'Посмотреть все операции',
  Cargo_ViewAllExpenses: 'Посмотреть все расходы',
  Cargo_ViewBill: 'Посмотреть счет',
  Cargo_ViewBusinessOfSameGroup: 'Просмотреть ту же группу операций',
  Cargo_ViewDetail: 'Посмотреть подробнее',
  Cargo_ViewDetails: 'Смотрите подробнее',
  Cargo_ViewDetailsOfRemovals: 'Посмотреть Удаление деталей',
  Cargo_ViewedByFee: 'Посмотреть по стоимости',
  Cargo_ViewedByJob: 'Посмотреть по делу',
  Cargo_ViewExpensesOfSameGroup: 'Посмотреть стоимость группы',
  Cargo_ViewFile: 'Просмотр документов',
  Cargo_ViewInvoice: 'Посмотреть счет',
  Cargo_ViewSelfBusiness: 'Проверьте свой бизнес',
  Cargo_ViewSoa: 'Посмотреть Счет',
  Cargo_ViewUploadedDeclarationDocInfo: 'Просмотреть загруженные файлы таможенной декларации',
  Cargo_ViewVoucher: 'Посмотреть документы',
  Cargo_ViolationOfUniquenessConstraint: 'Нарушение ограничений уникальности',
  Cargo_VOCMEICSR: 'Текущая выбранная запись содержит документы за месяц, в течение которого были закрыты счета.',
  Cargo_VoidCompleted: 'Завершение аннулирование.',
  Cargo_Voided: 'Отменено',
  Cargo_VoidedBy: 'Лишение прав',
  Cargo_VoidedInvoice: 'Аннулированные счета - фактуры',
  Cargo_VoidedInvoiceNo: 'Номер аннулированного счета - фактуры',
  Cargo_VoidedInvoiceNoP: 'Номер аннулированного счета - фактуры:',
  Cargo_VoidedSuccessfully: 'Отмена успешно.',
  Cargo_VoidStatus: 'Статус недействительности',
  Cargo_VoidTime: 'Время истечения срока действия',
  Cargo_AssociatedExpenseID: 'Идентификатор сопутствующих расходов',
  Cargo_ChargeID: 'Идентификатор расходов',
  Cargo_VOPLCOCTBD: 'Акт о перенесенных прибылях и убытках не может быть удален.',
  Cargo_StateDeleteError: 'Успешно импортирована система сертификатов, не может быть удалена',
  Cargo_VoucherAbstract: 'Резюме документов',
  Cargo_VoucherCannotBeEmpty: 'Документы не могут быть пустыми!',
  Cargo_VoucherCreatedOrNot: 'Были ли созданы документы',
  Cargo_VoucherCreatedSuccessfully: 'Успешное создание {0} сертификатов',
  Cargo_VoucherDateCanTBeEmpty: 'Дата документа не может быть пустой',
  Cargo_VoucherEntryCanTBeEmpty: 'Регистрация документов не может быть пустой.',
  Cargo_VoucherGroupingRule: 'Правила группирования документов',
  Cargo_VoucherGroupingType: 'Тип группы сертификатов',
  Cargo_VoucherGroupingTypeP: 'Тип группы сертификатов:',
  Cargo_VoucherLetter: 'Свидетельство',
  Cargo_VoucherLetterCanTBeEmpty: 'Сертификат не может быть пустым',
  Cargo_VoucherLetterNo: 'Номер документа',
  Cargo_VoucherLetterP: 'Свидетельство:',
  Cargo_VoucherList: 'Список документов',
  Cargo_VoucherMonth: 'Сертификат месяца',
  Cargo_VoucherNo: 'Номер документа',
  Cargo_VoucherNoCanTBeEmpty: 'Номер документа не может быть пустым.',
  Cargo_VoucherNoP: 'Номер документа:',
  Cargo_VoucherNotCreatedCreateItNow: 'Не был создан сертификат, был ли создан сертификат?',
  Cargo_VoucherOfAdvance: 'Авансовые авизо',
  Cargo_VoucherPeriod: 'Срок действия документа',
  Cargo_VoucherPeriodCanTBeEmpty: 'Срок действия документа не может быть пустым.',
  Cargo_VoucherRule: 'Правила доказывания',
  Cargo_VoucherSearch: 'Проверка документов',
  Cargo_VoucherStatus: 'Статус документа',
  Cargo_VoucherType: 'Тип документа',
  Cargo_VoyageFlight: 'Рейсы / рейсы',
  Cargo_VoyageNo: 'Рейс',
  Cargo_VRDBR: 'Просмотреть удаление деталей по согласованию',
  Cargo_VSRAOGTEPAEIADPERAPIT: 'Налог на золото экспортирует бумажные счета - фактуры, проверки электронных счетов - фактур и запросы на обслуживание по разным адресам, пожалуйста, экспортируйте их отдельно в соответствии с видом счета - фактуры.',
  Cargo_Warehouse: 'Склад',
  Cargo_WarehouseDoor: 'Склад / пункт входа',
  Cargo_WarehouseLoading: 'Внутри склада',
  Cargo_WarehouseLoadingStorage: 'Внутренняя упаковка / хранение',
  Cargo_WarehouseNo: 'Номер склада',
  Cargo_WBOWBVCTBD: 'Красный или красный сертификат не может быть удален.',
  Cargo_WBOWBVCTBWB: 'Сертификат красного удара или сертификат красного удара не может быть красным.',
  Cargo_REVERSE: 'Красный сертификат удался.',
  Cargo_WCDCOVCWBDBOSRCCWBIDDRWNOPC: 'После галочки запрос будет отображать подробный список различных валют в соответствии с найденными результатами, игнорируя пользовательские настройки. Результаты динамического отображения не будут перекрывать исходную конфигурацию.',
  Cargo_WDPCCS: 'Данные ошибочны, пожалуйста, свяжитесь с гостевой службой.',
  Cargo_Wechat: 'Микросхема',
  Cargo_Week: 'Чжоу',
  Cargo_Weight: 'Вес',
  Cargo_WHCode: 'Номер входа',
  Cargo_WhetherOrNotBroken: 'Не поврежден',
  Cargo_WipeOut: 'Игнорировать ноль',
  Cargo_WithdrawalAddress: 'Адрес возврата',
  Cargo_WithdrawalListOfLinkedConsignors: 'Списки возвратов ассоциированных доверительных организаций',
  Cargo_WithdrawExpense: 'Сборы',
  Cargo_WONCPPC: 'Номер счета подтверждает, что процесс оплаты завершен.',
  Cargo_WORIPCPARO: 'Неправильная запись о списании, пожалуйста, закройте страницу и откройте ее снова',
  Cargo_WorkSetAfterSearch: 'Рабочая группа после запроса',
  Cargo_WriteBack: 'Красный удар',
  Cargo_WriteBackVoucher: 'Красный сертификат',
  Cargo_WriteOff: 'Списание счетов',
  Cargo_WriteOffAll: 'Все списания',
  Cargo_WriteOffAllP: 'Все ли списаны',
  Cargo_WriteOffAmount: 'Сумма списания',
  Cargo_WriteOffAmountCNY: 'Сумма списания CNY',
  Cargo_WriteOffAmountIs: 'Сумма списания составляет:',
  Cargo_WriteOffAmountUSD: 'Сумма списания USD',
  Cargo_WriteOffAR: 'Дебиторская задолженность',
  Cargo_WriteOffBalance: 'Сальдо списания',
  Cargo_WriteOffBalanceIs: 'Остаток списанных средств составляет:',
  Cargo_WriteOffCurrency: 'Валюта списания',
  Cargo_WriteOffDate: 'Дата списания',
  Cargo_WriteOffDetails: 'Подробная информация о списании',
  Cargo_WriteOffEntry: 'Вывод счетов',
  Cargo_WriteOffFailed: 'Ошибка списания',
  Cargo_WriteOffInputError: 'Отобранные подлежащие списанию расходы включают расходы на включение в платежные требования, которые должны быть списаны после завершения процесса рассмотрения платежных требований.',
  Cargo_WriteOffList: 'Подробная информация о списании',
  Cargo_WriteOffListPDF: 'Подробная информация о продаже.pdf',
  Cargo_WriteOffListXLS: 'Подробная информация о продажах.xls',
  Cargo_WriteOffNo: 'Номер списания',
  Cargo_WriteOffOfAdvance: 'Списание авансовых платежей',
  Cargo_WriteOffOrNot: 'Списаны ли счета',
  Cargo_WriteOffP: 'Списание -',
  Cargo_WriteOffPerson: 'Счетчик',
  Cargo_WriteOffRate: 'Курс списания',
  Cargo_WriteOffRecordsNotSelected: 'Записи о списании не выбраны.',
  Cargo_WriteOffRemarks: 'Примечания к списанию',
  Cargo_WriteOffReverseWriteOff: 'Списание / встречное списание',
  Cargo_WriteOffRevokedSuccessfully: 'Отмена счетов прошла успешно.',
  Cargo_WriteOffSerialNumber: 'Номер дебита',
  Cargo_WriteOffStartingPeriod: 'Списание на начало периода',
  Cargo_WriteOffStartingPeriodP: 'На начало периода списания:',
  Cargo_WriteOffStatus: 'Статус списания',
  Cargo_WriteOffType: 'Б',
  Cargo_WriteOffTypeP: 'Тип списания:',
  Cargo_WrittenOff: 'Списанные счета',
  Cargo_WrittenOff2: 'Списанный эквивалент RMB',
  Cargo_WrittenOffItemsCanTBeModified: 'Они были списаны и не могут быть изменены.',
  Cargo_WrittenOffItemsExist: 'Есть списанные счета',
  Cargo_WrittenOffNotWrittenOff: 'Списанные счета',
  Cargo_WrittenOffSuccessfully: 'Счет успешно',
  Cargo_WrongInvoicingMachineNoEntered: 'Ошибка при вводе номера счетчика.',
  Cargo_WroteOff: 'Списание',
  Cargo_WroteOffOrNot: 'Списаны ли',
  Cargo_X10: 'Десять.',
  Cargo_X100: 'Сто',
  Cargo_X1000: 'Тысячи',
  Cargo_X10000: 'Вань',
  Cargo_YadongKingdee: 'Ядонская бабочка',
  Cargo_Year: 'Год',
  Cargo_Years: 'Год',
  Cargo_Yes: 'Да.',
  Cargo_YesControlled: 'Под контролем',
  Cargo_NotControlled: 'Без контроля',
  Cargo_YesLink: 'Это я.',
  Cargo_YesNo: 'Нет',
  Cargo_Yuan: 'Юань',
  Cargo_ContentIsEmpty: 'Содержание пустое.',
  Cargo_PleaseSelectExpenseToProcess: 'Пожалуйста, выберите стоимость обработки.',
  Cargo_EditSoa: 'Редактирование счетов',
  Cargo_InvalidParameterCFR: 'Неверный параметр, не найдено правило записи предмета.',
  Cargo_SuccessItemsFailedItems: 'Статья успеха {0}, статья {1} неудача.',
  Cargo_BADNMOPRTB: 'Расчетный агент по счету {0} не соответствует объекту расчета по счету, пожалуйста, удалите счет и сохраните его.',
  Cargo_IVCNBVPDTORTI: 'Есть {0} счета - фактуры генерированные ваучеры, которые не могут быть аннулированы, пожалуйста, удалите ваучер или Red Chong.',
  Cargo_Temp: '- Пустой -',
  Cargo_OperationCommission: 'Операционные отчисления',
  Cargo_CSCommission: 'Проценты от обслуживания клиентов',
  Cargo_ViewPaymentRequest: 'Просмотреть заявку на оплату',
  Cargo_WantToAddThemToTheBill: 'Выбранные расходы включают списанные расходы, и будут ли они по - прежнему включаться в счета - фактуры?',
  Cargo_AddAllToTheBill: 'Все счета',
  Cargo_OnlyTheUnwrittenOffExpenses: 'Включить только неучтенные расходы',
  Cargo_ImportAndQueryOfBillNumber: 'Импорт номера счета',
  Cargo_DebitAmountCN: 'Заимствованная сумма',
  Cargo_CreditAmountCN: 'Сумма кредита',
  Cargo_PushMiddleTable: 'Переместить таблицу',
  Cargo_IfError: 'Ошибка',
  Cargo_ErrorInfo: 'Неправильное сообщение',

  Cargo_AIOCER: 'Валютный курс',
  Cargo_BalanceInRmb: 'Остаток в юанях',
  Cargo_BalanceInUsd: 'Остаток в долл. США',
  Cargo_CanTDeleteInvoicedItems: 'Невозможно удалить счет.',
  Cargo_CanTDeleteIssuedInvoice: 'Счет не может быть удален!',
  Cargo_CardAccessControl: 'Управление правами доступа к картам',
  Cargo_CCTBEVCTBE: 'Клиент не может быть пустым, поставщик не может быть пустым',
  Cargo_ConfirmAPP: 'Подтверждение причитающихся сумм',
  Cargo_ConfirmBill: 'Подтверждение счетов',
  Cargo_CreditSideRmb: 'Кредитор (в юанях)',
  Cargo_CreditSideUsd: 'Кредиторы (в долл. США)',
  Cargo_CurrencyIncompatible: 'Несоответствие валют',
  Cargo_CustomizedField: 'Настройка поля',
  Cargo_IssuedUnissued: 'Опубликовано Не опубликовано',
  Cargo_NoExpensesToBeInvoiced: 'Невозможность выставления счета',
  Cargo_OVICBETGTEI_2: 'Счета - фактуры НДС могут быть аннулированы',
  Cargo_OWCICGTSEEI_2: 'Валюта, в которой выставлен счет, - это RMB.',
  Cargo_PleaseSelectAnBillPayment: 'Пожалуйста, выберите платежную заявку.',
  Cargo_PleaseSelectPurchaser: 'Пожалуйста, выберите покупателя.',
  Cargo_SelectAddPlatformBLMethod: 'Выбор формы коносамента',
  Cargo_SettlingPartyMustBeIdentical: 'Объект расчетов должен быть одинаковым.',
  Cargo_Space5: 'Полумесяц',
  Cargo_TARBACTBLTAPAWIETIAR: 'Общая сумма дебиторской задолженности не может быть меньше общей суммы кредиторской задолженности',
  Cargo_CanNotRemovedAllCharge: 'Невозможно снять все расходы!',
  Cargo_BillNotAllowEditEtowerOne: 'Счет EtowerOne не позволяет оперировать!',
  Cargo_NoSubmit_SR: 'Не представлено',
  Cargo_AwaitApproval_SR: 'В процессе утверждения',
  Cargo_Approved_SR: 'Утверждение завершено',
  Cargo_ModifyFilter: 'Условия увеличения или уменьшения',
  Cargo_SaveChanges: 'Сохранить изменения',
  Cargo_SaveAsScheme: 'Сохранить как программу',
  Cargo_QueryScheme: 'Программа поиска',
  Cargo_QuerySchemeManagement: 'Управление программой запросов',
  Cargo_SelectQueryCriteria: 'Выбор условий запроса',
  Cargo_ApplicationForm: 'Заявка',
  Cargo_ApprovalHistory: 'История утверждения',
  Cargo_AllQueryCriteria: 'Все условия запроса',
  Cargo_MyQueryCriteria: 'Мои условия запроса.',
  Cargo_DisplayName: 'Показать имя',
  Cargo_ConditionalExpression: 'Условное выражение',
  Cargo_ProcessingDifference: 'Обработка расхождений',
  Cargo_NotFoundTemplate: 'Не найден соответствующий шаблон печати!',
  Cargo_NoPaymentMethodPermissionOfReconciliation: 'Недостаточные права, пожалуйста, свяжитесь с администратором, чтобы настроить права доступа к странице сверки!',
  Cargo_NoFeeTypePermissionOfReconciliation: 'Недостаточные права доступа, пожалуйста, свяжитесь с администратором, чтобы настроить права типа оплаты на странице сверки!',
  Cargo_SearchDataForReconciliation: 'Пожалуйста, сначала проверьте данные, прежде чем начать сверку!',
  Cargo_ChargeUpdateFailed: 'Есть {0} расходы, которые были изменены другими людьми, не были обновлены успешно!',
  Cargo_SaveReconciliationSuccess: 'Сохранить выверку успешно!',
  Cargo_RemoveAll: 'Удалить все',
  Cargo_ViewDeleteChargeDetail: 'Просмотр / удаление деталей',
  Cargo_DeleteAdjustment: 'Удалить настройку',
  Cargo_PleaseSelectedCancelConfirmCharge: 'Выберите стоимость отмены подтверждения',
  Cargo_PleaseSelectedConfirmCharge: 'Выберите стоимость подтверждения',
  Cargo_PleaseSelectedBillingDate: 'Пожалуйста, выберите дату счета!',
  PleaseSelectSplitCharge: 'Выберите стоимость, которую нужно разделить!',
  OnlySelectOneChargeToSplit: 'Выбрать можно только одну стоимость!',
  ChargeHasInvoicedOrWriteOff: 'Стоимость выставлена или распродана, пожалуйста, выберите заново!',
  NoChargeForSplit: 'Нет фактической разделенной стоимости, пожалуйста, выберите заново!',
  Cargo_exportExcelAll: 'Экспортировать все',
  Cargo_PleaseInputKeyWordsForQuery: 'Введите ключевое слово для запроса',
  Cargo_AccountNumber: 'Номер счета',
  Cargo_OwnerBankOfDeposit: 'Наш банк',
  Cargo_JoinBill: 'Добавить счет',
  Cargo_SelectedUnConfirmedCharge: 'Выберите стоимость отмены подтверждения!',
  Cargo_NoChargeForSplit: 'Нет фактической разделительной стоимости, пожалуйста, выберите заново!',
  Cargo_InputTaxAmount: 'Пожалуйста, введите налоговую цену!',
  Cargo_ReconciliationTypeP: 'Тип выверки:',
  Cargo_ByFee: 'По стоимости',
  Cargo_SelectBill: 'Выберите счет',
  Cargo_BillOfType: 'Тип счета:',
  Cargo_BillDateP: 'Дата счета:',
  Cargo_StatementDateP: 'Дата выставления счета:',
  Cargo_RegistrationAddress: 'Адрес налогоплательщика',
  Cargo_OriginalCurrency2: 'Первоначальная валюта',
  Cargo_ExchangeRate2: 'Обменный курс',
  Cargo_BillRateEmpty: 'Обменный курс первоначальной валюты счета не может быть пустым!',
  Cargo_BillCurrencyMore: 'Стоимость счета не может превышать трех валют.',
  Cargo_BillCurrencyEmpty: 'Валюта счета не может быть пустой!',
  Cargo_SettlementAgentEmpty: 'Расчетный агент не может быть пустым!',
  Cargo_IncludingTaxAmountZero: 'Налоговая цена не может быть нулевой!',
  RequiredAccrueDate: 'Введите дату',
  RequiredCancelDate: 'Введите дату отмены',
  Cargo_NoChargeForBillPayment: 'Нет платы за создание заявки на оплату!',
  Cargo_CancelSpecialApproval: 'Отмена специальных разрешений',
  Cargo_LockTheBillTime: 'Время блокировки',
  Cargo_CreditControlObject: 'Контролируемый объект',
  Cargo_SpecialApprovalTime: 'Сроки предоставления специальных партий',
  Cargo_SpecialApprovalUser: 'Специальная группа',
  Cargo_AmountExceeded: 'Превышение',
  Cargo_DateExceeded: 'Превышение сроков',
  Cargo_CreditControlInfo: 'Информация о доверии',
  Cargo_OperateTime: 'Время работы',
  Cargo_DownloadLog: 'Загрузить журнал',
  Cargo_Times: 'А',
  Cargo_LockTheBillDate: 'Дата блокировки',
  Cargo_SpecialApprovalDate: 'Дата утверждения',
  Cargo_OperateDate: 'Дата операции',
  Cargo_LockTheBillUser: 'Запертый человек',
  Cargo_sono: 'SoNo',
  Cargo_pono: 'PO.No.',
  Cargo_PolAir: 'Порт отправления (аэропорт)',
  Cargo_keyWordsTip: 'Введите ключевые слова',
  Cargo_sopDoubleClickTip: 'Двойной щелчок на текстовом поле для выбора запроса состояния узла.',
  Cargo_SchemeName: 'Название программы',
  Cargo_NewQueryScheme: 'Дополнительные программы запросов',
  Cargo_TheQueryItemSelected: 'Запрос [bracket0] был выбран',
  Cargo_SchemeSaveSuccess: 'Успешное сохранение программы',
  Cargo_BillLogManagement: 'Управление журналом коносаментов',
  Cargo_ModifyContent: 'Изменить содержание',
  Cargo_CheckPermission: 'У вас нет прав на просмотр бизнеса!',
  Cargo_CheckBusinessType: 'Пожалуйста, выберите тот же тип бизнеса!',
  Cargo_MasterChargeWhetherShareOrNot: 'Распределение расходов по основным векселям',
  Cargo_DepartmentPrefixNotSelected: 'Не выбран расчетный отдел.',
  Cargo_SalesIsEmpty: 'Текущие продажи клиентов пусты, нельзя подписывать!',
  Cargo_Distribution: 'Распределение',
  Cargo_SalesNotSelected: 'Не выбрана продажа!',
  Cargo_ReviewedByLeader: 'Назначен, этот клиент ожидает аудита бывшего руководителя группы:',
  Cargo_AllocationSucceeded: 'Распределение успешно!',
  Cargo_FormerGroupLeader: 'Бывший руководитель группы',
  Cargo_ChineseNameIsEmpty: 'Китайские имена клиентов пусты!',
  Cargo_OriginalTeamLeaderIsEmpty: 'Оригинальное название - Пустой!',
  Cargo_DoNotOperate: 'Запретите операции с текущими клиентами, пожалуйста, свяжитесь с менеджером по продажам, чтобы решить!',
  Cargo_RestoreCurrentCustomer: 'Подтвердить восстановление текущего клиента?',
  Cargo_CustomerInformationIsEmpty: 'Информация о клиенте пуста!',
  Cargo_CannotBeDeleted: 'Клиент был использован бизнесом и не может быть удален!',
  Cargo_DeleteSuccessfully: 'Удаление было успешным, и клиент был переведен в пункт сбора клиентов!',
  Cargo_AreYouSureDelete: 'Вы уверены, что хотите удалить?',
  Cargo_PleaseSelectForDelete: 'Выберите клиента, которого вы хотите удалить!',
  Cargo_ChineseNameAlreadyExists: 'Китайское название уже существует.',
  Cargo_EnglishNameAlreadyExists: 'Английское название уже существует.',
  Cargo_ChineseOrEnglishAlreadyExists: 'Английское или китайское название уже существует.',
  Cargo_ContactPersonToFillInA: 'По крайней мере, один контакт клиента!',
  Cargo_PleaseInvoicingRequirementsTab: 'Пожалуйста, заполните требования к валюте, подписанные на листе запроса!',
  Cargo_SignOrNot: 'Подписать ли',
  Cargo_DangerousChemicals: 'Опасны ли химические вещества',
  Cargo_DaysNotFollowedUp: 'Количество дней без последующих действий',
  Cargo_CustomerNotSelected: 'Клиенты не выбирают!',
  Cargo_AssignedClientsSuccessfully2: 'Выделено {0} клиентов',
  Cargo_examine: 'Клиентов ждет проверка от бывшего руководителя.',
  Cargo_DistributionSales: 'Успешное распределение продаж среди клиентов',
  Cargo_MoreThan1Year: 'Более 1 года',
  Cargo_list: 'Список',
  Cargo_MyClients: 'Мой клиент.',
  Cargo_CustomersInThisGroup: 'Данная группа клиентов',
  Cargo_CustomerRecycleBin: 'Станция сбора информации о клиентах',
  Cargo_PleaseSelectTheCustomerToExport: 'Выберите клиента, который должен быть экспортирован!',
  Cargo_city: 'Муниципалитет',
  Cargo_email: 'Почтовый ящик',
  Cargo_add: 'Добавить',
  Cargo_Append: 'Добавить',
  Cargo_PSCF: 'Сначала выберите контакт!',
  Cargo_NCS: 'Контакты не выбраны!',
  Cargo_CNATCBE: 'Имя и телефон контакта не могут быть пустыми!',
  Cargo_ERF: 'Ошибка удаления файла!',
  Cargo_FDS: 'Файл удалён успешно!',
  Cargo_AYSDF: 'Удалить файл?',
  Cargo_PSAEF: 'Выберите событие',
  Cargo_theme: 'Тема',
  Cargo_FTMFT: 'Ошибка изменения типа файла',
  Cargo_EventStatus: 'Состояние события',
  Cargo_TaskTime: 'Время выполнения задания',
  Cargo_CustomerChineseName: 'Китайские имена клиентов',
  Cargo_CustomerEnglishName: 'Английское имя клиента',
  Cargo_NextTask: 'Следующее задание',
  Cargo_RWSR: 'Успешный отказ {0} записи',
  Cargo_isActive: 'Эффективность',
  Cargo_OverdueLimit: 'Превышение сроков',
  Cargo_OverdueDays: 'Превышение сроков',
  Cargo_Enable: 'Включить',
  Cargo_Disable: 'Запретить',
  Cargo_EnableStatus: 'Включить состояние',
  Cargo_Enabled: 'Включено',
  Cargo_Disabled: 'Запрещено',
  Cargo_amount: 'Количество статей',
  Cargo_HasChosen: 'Выбран',
  Cargo_RemoveToBlackList: 'Выйти из черного списка',
  Cargo_SureToRemoveToBlackList: 'Вы уверены, что хотите выйти из черного списка?',
  Cargo_Flight: 'Рейсы',
  Cargo_OutstandingAmount: 'Неизрасходованная сумма (расходы)',
  Cargo_WriteOffAmountCharge: 'Списанные суммы (расходы)',
  Cargo_ReceivableExcludingTax: 'Дебиторская задолженность без учета налогов (счет - фактура)',
  Cargo_TaxIncludedReceivable: 'Дебиторская задолженность, включая налоги (счета - фактуры)',
  Cargo_PayableExcludingTax: 'Причитается без учета налогов (счет - фактура)',
  Cargo_TaxPayable: 'Причитается с учетом налогов (счета - фактуры)',
  Cargo_TotalExcludingTax: 'Общая сумма без учета налогов (счет - фактура)',
  Cargo_TotalTaxIncluded: 'Итого, включая налоги (счета - фактуры)',
  Cargo_PleaseEnterBoxTypeOrBoxType: 'Введите тип ящика или тип ящика!',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate: 'Дата вступления в силу должна быть меньше даты истечения срока действия',
  Cargo_MaintenanceOfExpenseDetails: 'Детальное техническое обслуживание',
  Cargo_CustomerQuickSearch: 'Быстрый поиск: имя клиента на китайском / английском языке',
  Cargo_WechatAccount: 'Микросигнал',
  Cargo_Download: 'Скачать',
  Cargo_ChineseNamed: 'Китайские названия',
  Cargo_EnglishNamed: 'Английское название',
  Cargo_SignContractTip: 'Партнерские модули уже существуют для предприятий с аналогичными именами, необходимо ли их ассоциировать?',
  Cargo_SignContractTipYes: 'Да, я хочу связать',
  Cargo_SignContractTipNo: 'Нет, я не связан',
  Cargo_CooperationStage: 'Этап сотрудничества',
  Cargo_Financial_Year: 'Финансовый год',
  Cargo_ConfirmCloseWindow: 'Подтвердить закрытие окна?',
  Cargo_NoteUpdatedSuccessfully: 'Обновление успешно',
  Cargo_PleaseSelectAPieceOfData: 'Выберите данные.',
  Cargo_SelectDataIsNotAuditState: 'Поддерживайте только приостановление предварительного статуса для операций, подлежащих проверке, пожалуйста, повторно отметьте.',
  Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState: 'Поддерживать только те операции, которые находятся в предварительном состоянии и которые были приостановлены или отклонены, пожалуйста, отметьте заново.',
  Cargo_SelectAtLeastOneRecord: 'Пожалуйста, выберите хотя бы одну запись.',
  Cargo_FieldDisplay: 'Отображение поля',
  Cargo_ControlSelection: 'Выбор элемента управления',
  Cargo_EnumValue: 'Перечислимое значение',
  Cargo_StatusIsNotPending: 'Статус не подлежит проверке.',
  Cargo_NotSubmittedAndRejectedStatusTips: 'Можно выбрать только временно не представленный и отклоненный статус.',
  Cargo_subimitPreStatusTips: 'Определен ли статус предварительного производства?',
  Cargo_TransitCannotBeNull: 'Порт транзита не может быть пустым.',
  Cargo_TheClientDoesNotBelongToYourCustomerTips: 'Эта доверительная организация не принадлежит вашему клиенту, пожалуйста, выберите из нового варианта',
  Cargo_ThereAreBargesTips: 'Введите дату закрытия баржи.',
  Cargo_ClosingDateCannotBeGreaterThanTheSailingDate: 'Дата закрытия не должна превышать даты отправления.',
  Cargo_ClosingDateOfBargeTips: 'Дата перехвата баржи не должна превышать',
  Cargo_CurrentAccount: 'Переменные предметы',
  Cargo_BusinessNoAndChargeName: 'Номер операции / наименование расходов',
  Cargo_BusinessNum: 'Количество операций',
  Cargo_VoucherLineNumberSetting: 'Параметры числа строк сертификата',
  Cargo_VoucherLine: 'Количество строк',
  Cargo_UseRmbEntrytypeByInvoice: 'Является ли запись счета - фактуры [сумма в первоначальной валюте] прямой [сумма в местной валюте], обменный курс 1',
  Cargo_UseRmbEntrytypeByInvoiceTip: '(Разделено "," 1 = дебиторская задолженность 3 = кредиторская задолженность 5 = операционный доход 7 = операционные расходы)',
  Cargo_UseRmbEntrytypeByFact: 'Получает ли квитанция о получении и оплате [сумму в первоначальной валюте] непосредственно [сумму в местной валюте], обменный курс 1',
  Cargo_UseRmbEntrytypeByFactTip: '(Разделены ",": 1 = Дебиторская задолженность 3 = Кредиторская задолженность 73 = Кредиторская задолженность (индивидуальная) 40 = Дебиторская задолженность (консолидация) 41 = Кредиторская задолженность (консолидация) 42 = Операционный доход (консолидация) 43 = Операционные расходы (консолидация))',
  Cargo_UseRmbEntrytypeByPre: 'Является ли запись авансового платежа прямой [сумма в первоначальной валюте] [сумма в местной валюте], обменный курс 1',
  Cargo_UseRmbEntrytypeByPreTip: '(Разделено "," 1 = дебиторская задолженность 3 = кредиторская задолженность 26 = дебиторская задолженность 44 = предоплата)',
  Cargo_UploadTime: 'Время загрузки',
  Cargo_Finished: 'Завершено',
  Cargo_OperationRequirement: 'Требования к эксплуатации',
  Cargo_measurements: 'Размер CM (длина * ширина * высота * Количество мест)',
  Cargo_Note: 'Примечания',
  Cargo_ChooseEdiTemplate: 'Выберите шаблон EDI',
  Cargo_OperatedFailed: 'Ошибка операции',
  Cargo_SelectPurchaseRecord: 'Выберите запись покупки.',
  Cargo_SelectAcquiredRecord: 'Выберите запись.',
  Cargo_CheckInvoiceInvalidState: 'Текущий вариант содержит номера счетов, которые были аннулированы или использованы.',
  Cargo_CheckInvoiceUsedState: 'Не выбран счет - фактура или не выбран статус полученного платежа.',
  Cargo_InvoiceRestoreSuccessfully: 'Счета - фактуры были восстановлены.',
  Cargo_CheckInvoiceRestoreState: 'Текущий вариант содержит номера счетов - фактур, которые не являются недействительными.',
  Cargo_ConfirmRestoreInvoice: 'Вы уверены, что хотите восстановить аннулированные счета?',
  Cargo_InvoiceInvalidSuccessfully: 'Счета - фактуры аннулированы.',
  Cargo_CheckInvoiceType: 'Виды счетов - фактур не совпадают.',
  Cargo_CheckInvoiceRecipientState: 'Текущий выбор содержит полученные записи.',
  Cargo_LocalAmount: 'Монеты',
  Cargo_SourceAmount: 'Валюта',
  Cargo_DebitAmountOccurredLocal: 'Дебетовые платежи (в местной валюте)',
  Cargo_DebitAmountOccurredSource: 'Дебетовые платежи (в первоначальной валюте)',
  Cargo_CreditAmountOccurredLocal: 'Возникновение кредита (в местной валюте)',
  Cargo_CreditAmountOccurredSource: 'Возникновение кредита (в первоначальной валюте)',
  Cargo_dispPop: 'Нажмите, чтобы развернуть статистику',
  Cargo_hidePop: 'Нажмите, чтобы убрать статистику',
  Cargo_SchemeUserTips: 'Примечание: Поддерживаются тарифные схемы для пользователей, применимые только к пользователям, включенным в следующий список',
  Cargo_NoDataCanBeModified: 'Нет данных, которые можно изменить.',
  Cargo_BalanceLocal: 'Сальдо (в местной валюте)',
  Cargo_BalanceSource: 'Сальдо (в первоначальной валюте)',
  Cargo_DebitAmountLocal: 'Дебетовая сумма (в местной валюте)',
  Cargo_DebitAmountSource: 'Дебетовая сумма (в первоначальной валюте)',
  Cargo_DebitSideLocal: 'Заимствование (в местной валюте)',
  Cargo_DebitSideSource: 'Заимствование (в оригинальной валюте)',
  Cargo_CreditAmountLocal: 'Кредитор (в местной валюте)',
  Cargo_CreditAmountSource: 'Кредиторы (в первоначальной валюте)',
  Cargo_BatchUpload: 'Массовая загрузка',
  Cargo_PleaseSelectBusinessData: 'Выберите имя файла для соответствия бизнес - данным',
  Cargo_DocumentsBack: 'Возвращение документов',
  Cargo_CanNotWriteOffForDifferentExpenseTypes: 'Внутренние и внешние расходы не могут быть списаны одновременно!',
  Cargo_VehicleRequestForm: 'Заявка на транспорт',
  Cargo_VehicleOrder: 'Заказ на транспорт',
  Cargo_BatchGenerateVehicleOrder: 'Массовое создание заказов',
  Cargo_VehicleRequestFormNo: 'Номер заявки',
  Cargo_PickUpDelivery: 'Забор/доставка',
  Cargo_EstimatedPickUpDate: 'Предполагаемая дата забора',
  Cargo_Port2: 'Порт',
  Cargo_VehicleOrderNo: 'Номер заказа',
  Cargo_VehicleTime: 'Время отправки',
  Cargo_CancelVehicleOrder: 'Отменить заказ',
  Cargo_VehicleDispatched: 'Транспорт отправлен',
  Cargo_CancelVehicleStatus: 'Отменить статус отправки',
  Cargo_CancelCompletedStatus: 'Отменить статус завершения',
  Cargo_StatusUpdateRecord: 'История изменений статуса',
  Cargo_UpdateVehicleOrderStatus: 'Обновить статус заказа',
  Cargo_CancelCondition: 'Можно отменить только при статусе "Не отправлен"',
  Cargo_ConfirmCancelVehicleOrder: 'Подтвердить отмену отправки?',
  Cargo_SelectNotDispatched: 'Выберите заказы со статусом "Не отправлен".',
  Cargo_SelectDispatched: 'Выберите заказы со статусом "Отправлен".',
  Cargo_SelectStatusConsistent: 'Статус выбранных заказов должен совпадать.',
  Cargo_VehicleOrderCompleted: 'Заказ завершен.',
  Cargo_SelectCompleted: 'Выберите заказы со статусом "Завершен".',
  Cargo_CompletionTimeNotEarlierThanDispatchTime: 'Время завершения не может быть раньше времени отправки.',
  Cargo_ActualPickupDate: 'Фактическая дата забора',
  Cargo_DispatchTaskLinkedToVehicle: 'Задание связано с заказом, удаление невозможно. Сначала отвяжите.',
  Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod: 'Задание связано с заказом, нельзя изменить "Способ доставки". Сначала отвяжите.',
  Cargo_DispatchTaskLinkedToVehicle_DestinationPort: 'Задание связано с заказом, нельзя отменить "Доставку в порт". Сначала отвяжите.',
  Cargo_Port_Airport: 'Порт (аэропорт)',
  Cargo_VehicleRequestDifferentPorts: 'Заявки относятся к разным портам. Объединить?',
  Cargo_VehicleOrderGeneratedSuccess: 'Заказ создан успешно',
  Cargo_VehicleOrderSerialNumber: 'Серийный номер заказа',
  Cargo_BusinessCreationTime: 'Время создания заявки',
  Cargo_CurrencyMustBeTheSame: 'Валюта должна быть одинаковой!',
  Cargo_AccountContacts: 'Контакты расчетных подразделений',
  Cargo_AccountAddr: 'Адрес расчетной единицы',
  Cargo_AccountContactsTel: 'Контактный телефон',
  Cargo_CustomsDeclarationInformationOujian: 'Таможенная информация (в настоящее время не поддерживается режим таможенного оформления в специальных регулируемых зонах)',
  Cargo_ChargeSubmit: 'Представлены ли расходы',
  Cargo_ContractRatePropertySE: 'Характер договорной цены (выход из моря)',
  Cargo_ContractRatePropertySI: 'Характер договорной цены (морское движение)',
  Cargo_TaxRevenueShortName: 'Код',
  Cargo_TaxRevenueName: 'Имя налогового кода',
  Cargo_TaxRevenueToolTip: 'Примечание: Код обозначен как единый национальный налоговый код, пример: 304080020102000000; Налоговый код называется кодом налоговой классификации, сокращенно, пример: брокерские агентские услуги',
  Cargo_CargoSourceTip: 'Переключить тип груза на [0]?',
  Cargo_AccountingMonthMaintain: 'Ежемесячное финансовое обслуживание',
  Cargo_FclApproximatePrice: 'Полная цена.',
  Cargo_LclApproximatePrice: 'Номер упаковки цена',
  Cargo_AddContractNo: 'Добавить условный номер',
  Cargo_Income20: '20\'Корректировка',
  Cargo_Income40: '40\'Корректировка',
  Cargo_Income40HC: '40HC\'Корректировка',
  Cargo_Income45: '45\'Корректировка',
  Cargo_WeightPriceAdjust: 'Корректировка по весу',
  Cargo_CubagePriceAdjust: 'Корректировка объемной цены',
  Cargo_MinimumPriceAdjust: 'Корректировка минимальной цены',
  Cargo_GrossMargin: 'Валовая процентная ставка',
  Cargo_IncorrectExpenseStatus: 'Статус расходов неправильный!',
  Cargo_ExpenseStatusModifiedSuccessfully: 'Статус расходов изменен успешно!',
  Cargo_DestinationSelection: 'Выбор места назначения',
  Cargo_AciPortCode: 'Код порта ACI',
  Cargo_InlandLocation: 'Внутреннее расположение',
  Cargo_SubLocationCode: 'Подпозиционный код',
  Cargo_DeleteBillTips: 'Удалить только неопубликованные счета, статус которых не подтвержден!',
  Cargo_ForceDeleteBillTips: 'Можно только удалить состояние счета как неподтвержденный, подтвержденный, распечатанный, аннулированный счет!',
  Cargo_ConfirmDeleteCategoryAndType: 'Удалить выбранные категории и типы?',
  Cargo_RangeAndGE: 'Нижний предел величины (включая)',
  Cargo_RangeAndLT: 'Величина верхнего предела (исключая)',
  Cargo_FinancialDateCheckNull: 'Финансовые даты не могут быть пустыми!',
  Cargo_CurrencyCheckNull: 'Валюта не должна быть пустой!',
  Cargo_FinancialDateCheckBefore: 'Выбрать дату не позднее текущей даты',
  Cargo_OperatingCompanyCannotBeEmpty: 'Оператор не может быть пустым.',
  Cargo_DeliveryCannotBeNull: 'Место поставки не должно быть пустым',
  Cargo_DesignatedCannotBeNull: 'Назначенный агент не может быть пустым!',
  Cargo_SalesCannotBeEmpty: 'Продажа не может быть пустой',
  Cargo_ItemNumberCannotBeEmpty: 'Номер проекта не может быть пустым!',
  Cargo_PleaseSelectLoadingPort: 'Пожалуйста, выберите порт погрузки!',
  Cargo_PleaseChooseTheDestinationPort: 'Пожалуйста, выберите порт назначения!',

  Cargo_UserManagement: 'Управление пользователями',
  Cargo_Search2: 'Поиск',
  Cargo_RecordAmount: 'Число записей',
  Cargo_RoleUserSettings: 'Настройка пользователя роли',
  Cargo_SystemAdministrator: 'Системный администратор',
  Cargo_UserCode: 'Пользовательский код',
  Cargo_UserDepartment: 'Подразделения пользователей',
  Cargo_UserCompany: 'Компании, принадлежащие пользователям',
  Cargo_IncludingElectricitySupplierAccount: 'Включает электронные счета',
  Cargo_ValidOrNot: 'Эффективность',
  Cargo_Valid: 'Эффективно',
  Cargo_Invalid2: 'Отказ',
  Cargo_LoginName: 'Имя пользователя',
  Cargo_MobilePhoneNo: 'Мобильные телефоны',
  Cargo_PasswordExpirationDate: 'Дата истечения срока действия пароля',
  Cargo_NetworkManagementCode: 'Сетевой код',
  Cargo_Superior: 'Старший руководитель',
  Cargo_OfficeAndDep: 'Подразделение / подразделение',
  Cargo_ConfirmBatchModifyUser: 'Соответствие данных галочки пакетной замены [bracket0]',
  Cargo_BatchModifyUserSucceed: 'Успешное изменение {0} данных 【{1}】 для 【{2}】',
  Cargo_Activation: 'Активация',
  Cargo_ElectricitySupplierAccountOrNot: 'Является ли электронный счет',
  Cargo_SystemAdministratorOrNot: 'Является ли системный администратор',
  Cargo_BatchModify: 'Пакетное изменение',
  Cargo_TheCompanyToWhichTheAccountBelongs: 'Компании, которым принадлежит счет',
  Cargo_EditPermission: 'Права редактирования',
  Cargo_AddUser: 'Добавить пользователя',
  Cargo_DeleteUser: 'Удалить пользователя',
  Cargo_RemoveUser: 'Удалить пользователя',
  Cargo_Filter2: 'Условия фильтрации',
  Cargo_Import2: 'Массовый импорт',
  GOODS_INFO_IMPORT: 'Импорт информации о грузе',
  Cargo_ContinueToCreate: 'Этот партнер поддерживается под {0} и продолжает ли он создаваться?',
  Cargo_AssignRolesToUsers: 'Пользователи ролей, подлежащих распределению',
  Cargo_SelectARangeOfUsers: 'Выбор диапазона пользователей',
  Cargo_NotSubmittedOrRejectedTips: 'Разрешается удалять только отложенные или отклоненные операции, пожалуйста, выберите заново',
  Cargo_SelectedMoreThenNPieces: 'Выбранные вами данные превысили лимит {0}, выберите заново',
  Cargo_SmallTicketCannotBeRemoved: 'Небольшие билеты содержат совместное несение расходов и не могут быть удалены.',
  Cargo_invoiceNotInconsistent: 'Тип счета - фактуры, тип счета - фактуры не совпадает, продолжается ли операция?',
  Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted: 'Только счета с номером счета.',
  Cargo_SureDoThis: 'Вы уверены, что выполняете эту операцию?',
  Cargo_BillHasBeenSubmitted: 'Счет был подан [0]',
  Cargo_BillWasNotSubmitted: 'Счет [0] не представлен статус',
  Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff: 'Только счета с номером счета.',
  Cargo_BillsHasBeenPaidInFull: 'Счет {0} оплачен полностью и не может быть списан снова.',
  Cargo_NotAllowWriteOffFee: 'Из расходов, подлежащих списанию, есть неоплаченные требования к оплате или процесс подачи заявок на оплату не завершен, и списание не допускается.',
  Cargo_BillsAlreadyWriteOffFee: 'Счет {0} уже оплачен и не может быть возвращен',
  Cargo_RevokeAll: 'Все отзывы',
  Cargo_ConfirmAndNotityHQ: 'Уведомляете штаб?',
  Cargo_AllBillingHasBeenSentToBranches: 'Все выбранные расчетные объекты отправлены в компанию',
  Cargo_Sender: 'Отправитель',
  Cargo_SendDate: 'Время EDI',
  Cargo_VersionNo: 'Номер версии',
  Cargo_BookingLog: 'Журнал бронирования',
  Cargo_BookingSubscribe: 'Подписаться',
  Cargo_BookingSubscribeSync: 'Синхронизация данных',
  Cargo_BookingSubscriptionStatus: 'Детали подписки',
  Cargo_SubscribeDataType: 'Тип данных',
  Cargo_SubscribeStatus: 'Статус подписки',
  Cargo_BatchUpdateExchangeRate: 'Обновление валютного курса',
  Cargo_UpdateExchangeRate: 'Обновление обменных курсов',
  Cargo_SelectAccountAndCurrency: 'Пожалуйста, выберите объект расчетов и валюту для изменения обменного курса:',
  Cargo_InputRate: 'Ввод обменного курса:',
  Cargo_ConfirmUpdateExchangeRate: 'Подтверждается ли обновление обменного курса?',
  Cargo_PleaseInputRate: 'Пожалуйста, введите обменный курс, который необходимо изменить!',
  Cargo_PleaseSelectAccountAndCurrency: 'Пожалуйста, выберите расчетный объект / валюту, для которых необходимо изменить обменный курс!',
  Cargo_ValidateUpdateRateTips: 'Операция не удалась, расчетная единица / валюта, которая обновляет обменный курс, не входит в эту операцию!',
  Cargo_UpdateRateConfirmTipsHead: 'Пакетное обновление обменного курса включает генерацию',
  Cargo_UpdateRateConfirmTipsTail: 'Расходы, на этот раз только обновить первоначальный курс расходов, пересмотренные данные не могут быть восстановлены, продолжается ли?',
  Cargo_BillVoidTipForState: 'Счет может быть аннулирован только в "неподтвержденном" состоянии!',
  Cargo_BillVoidTipForReview: 'Счет может быть аннулирован только в "непроверенном" состоянии!',
  Cargo_DuplicatedCode: 'Этот код повторяется, пожалуйста, введите его снова.',
  Cargo_PlatformCertifiedPartner: 'Выберите партнера по сертификации платформы',
  Cargo_Examine: 'Проверено ли',
  Cargo_NameOfApplicant: 'Наименование предприятия',
  Cargo_CreateSource: 'Источник',
  Cargo_Tenant: 'Арендаторы',
  Cargo_Platform: 'Платформа',
  Cargo_AdvertisingManagement: 'Управление рекламой',
  Cargo_AdvertisingNo: 'Рекламный номер',
  Cargo_AdvertisingContent: 'Содержание рекламы',
  Cargo_System: 'Принадлежность к системе',
  Cargo_Module: 'Принадлежность модуля',
  Cargo_PageIndex: 'Домашняя страница',
  Cargo_AdvertisingSpace: 'Рекламное место',
  Cargo_AdvertisingSubject: 'Субъект рекламы',
  Cargo_PromotionCycle: 'Цикл распространения',
  Cargo_DataTime: 'Дата данных',
  Cargo_AdvertisingSpaceNo: 'Номер объявления',
  Cargo_billPaymentNo: 'Номер платежного поручения',
  Cargo_RangeSmaller: 'Рекомендуется использовать небольшой диапазон',
  Cargo_SyncFinanceCode: 'Будет ли это продолжать записывать код партнера в код клиента?',
  Cargo_SyncFinanceCodeSuccess: 'Успешная синхронизация кода клиента',
  Carge_ConfirmDate: 'Время подтверждения',
  Carge_ConfirmUser: 'Подтверждение',
  Carge_BillingConfirmDate: 'Время подтверждения счета',
  Carge_BillingConfirmUser: 'Удостоверяющий счет',
  Carge_BillingGroupConfirmDate: 'Время подтверждения выписки',
  Carge_BillingGroupConfirmUser: 'Подтверждение счетов',
  Carge_ChinessNameExist: 'Китайские названия уже существуют, пожалуйста, измените',
  Carge_EnglishNameExist: 'Английское название уже существует, пожалуйста, измените',
  Cargo_Dep: 'Входящие подразделения',
  Cargo_contactInformationCopy: 'Контактная информация - однозначная копия',
  Cargo_contactInformationCode: 'Контактная информация - поиск кода',
  Cargo_auditResult: 'Результаты проверки',
  Cargo_number: 'Номер',
  Cargo_PlatformCode2: 'Код платформы',
  Cargo_InterchaneeCode: 'Код коммутации',
  Cargo_abbreviation: 'Сокращения',
  Cargo_TemplateDescribe: 'Описание шаблона',
  Cargo_Describe: 'Описание',
  Cargo_BillingHeaderName: 'Введите имя',
  Cargo_EnglishNameOfBank: 'Название банка на английском языке',
  Cargo_ContactName: 'Имя контакта',
  Cargo_TenantID: 'Идентификатор арендатора',
  Cargo_AppendQuery: 'Дополнительный запрос',
  Cargo_CollapseList: 'Закрыть список',
  Cargo_SetAsDefault: 'Установить по умолчанию',
  Cargo_MultipleWorkNoEnter: 'Пожалуйста, используйте обратную машину для ввода нескольких рабочих номеров.',
  Cargo_DeleteConfirm: 'После удаления данные не будут восстановлены, продолжается ли?',
  Cargo_EachPage: 'Каждая страница',
  Cargo_DataBar: 'Ст. Данных',
  Cargo_ClientNumberMaintenance: 'Номер налогового контроля',
  Cargo_BillingPointCode: 'Код выставления счетов',
  Cargo_UseDepartment: 'Сектор использования',
  Cargo_CanNotEmpty: 'Нельзя быть пустым!',
  Cargo_CanNotRepeat: 'Повторить нельзя!',
  Cargo_BeforeCurrentDisplay: 'Пред. т.п.',
  Cargo_ReceivableChargeInput: 'Учет дебиторской задолженности',
  Cargo_CostChargeInput: 'Начислены ли подлежащие оплате расходы',
  Cargo_ConvertToCnyAr: 'Дебиторская задолженность: в пересчете на RMB',
  Cargo_ConvertToCnyAp: 'К оплате: в пересчете на RMB',
  Cargo_FeeModifier: 'Изменение расходов',
  Cargo_FeeModifyDate: 'Сроки пересмотра расходов',
  Cargo_SoNoChangeTips: 'Изменилось ли количество таможенных листов, обновились ли первоначальные расходы по номеру таможенного листа?',
  Cargo_EditSaleInfo: 'Корректировка информации о продажах',
  Cargo_PleaseSelectChargeApplyData: 'Пожалуйста, выберите данные проверки расходов.',
  Cargo_PleaseSelectExportChargeDetailData: 'Запишите заявку и попробуйте снова.',
  Cargo_BeyondMaxExportChargeDetailData: 'Экспорт записей заявок не может превышать 5000, пожалуйста, выберите заново',
  Cargo_ExportChargeDetailDataSucceed: 'Экспорт успешно',
  Cargo_NotSameEtd: 'Сроки открытия бизнеса не совпадают по месяцам!',
  Cargo_BatchModifyJobNoMore: 'Одноразовое изменение бизнес - номера не может превышать 100.',
  Cargo_BatchModifyJobNoSuccess: 'Пакетное изменение успешно: {0}',
  Cargo_VolumeIsChanged: 'Изменился ли фактический объем и были ли обновлены первоначальные расходы в единицах стоимости объема?',
  Cargo_DealingsCustomer: 'Остаток средств по операциям на основе номера операции',
  Cargo_AllowsExceptionProofExport: 'Разрешить пропускать экспорт сертификатов',
  Cargo_ChargeChanger: 'Изменение расходов',
  Cargo_ChargeCreadBy: 'Создатель расходов',
  Cargo_DeleteData: 'Данные удалены, свяжитесь с администратором',
  Cargo_MasterTicketShareCharge: 'Расходы по основному векселю были распределены, и новые мелкие голоса должны быть перераспределены.',
  Cargo_CreateBillNo: 'Создается ли номер счета',
  Cargo_CalcShareAmount: 'Расчет начисленных взносов',
  Cargo_CalcShareAmountTip: 'Нажмите кнопку для расчета начисленных взносов для подтверждения перерасчета.',
  Cargo_CancelOrder: 'Удалось отменить {0} заказ, не удалось отменить {1} заказ. Поддерживается только отмена заказов в рабочем состоянии.',
  Cargo_CancelOrderTip1: 'Следующий заказ не может быть отменен, продолжается ли?',
  Cargo_CancelOrderTip2: 'Этот заказ уже отправлен из порта и имеет номер магистрального бизнеса, который не может быть отменен',
  Cargo_CancelOrderTip3: 'Этот заказ уже отправлен и не может быть отменен.',
  Cargo_CancelOrderTip4: 'Этот заказ уже имеет номер магистрального бизнеса и не может быть отменен',
  Cargo_CancelOrderTip5: 'Нужно ли отменить этот {0} заказ?',
  Cargo_CancelOrderTip6: 'Отменить заказ',
  Cargo_CancelOrderTip7: 'На этот раз для подачи {0} заказов. Следующий заказ не может быть отменен, хотите продолжить?',
  Cargo_CancelOrderTip8: 'Статус заказа {0}, не может быть отменен',
  Cargo_Reason: 'Причины',
  Cargo_PushResultLog: 'Запись результатов Push Data',
  Cargo_SendContent: 'Отправить содержимое',
  Cargo_ResultSuccess: 'Отправить состояние',
  Cargo_ResultMessage: 'Причины неудачи',
  Cargo_DesignatedCargoWarehouseNo: 'При назначении товара номер склада равен операционному справочному номеру',
  Cargo_SelfCargoWarehouseNo: 'При самоинкассировании номер склада равен бизнес - справочному номеру',
  Cargo_BusinessMark: 'Бизнес - маркер',
  Cargo_ModifyBusiness: 'Изменить заново созданную операцию',
  Cargo_SelectJobNo: 'Выберите номер операции',
  Cargo_ClosingRecord: 'Отчет о закрытии счетов',
  Cargo_ClosingAudit: 'Проверка закрытия счетов',
  Cargo_AccountKeeper: 'Счетчик',
  Cargo_ClosingMonth: 'Месяц закрытия счетов',
  Cargo_ClosingBranch: 'Оформление счетов',
  Cargo_AccountClosingType: 'Тип закрытия счетов',
  Cargo_ClosingDate: 'Дата закрытия счетов',
  Cargo_FinancialClosing: 'Финансовое закрытие',
  Cargo_BusinessClosing: 'Закрытие счетов',
  Cargo_SelectClosingDate: 'Выберите дату закрытия счета',
  Cargo_SelectDeleteTip: 'Выберите шаблон для удаления',
  Cargo_SelectDeleteTip2: '{0} Использовано, не может быть удалено',
  Cargo_SelectDeleteTip3: 'Удалить выбранную конфигурацию? После удаления интерфейс вызова больше не будет возвращать данные',
  Cargo_SameCurrencyForMultipleRecord: 'Пожалуйста, выберите платежные записи в той же валюте для продажи!',
  Cargo_SamePayReceiveDateForMultipleRecord: 'Пожалуйста, выберите ту же самую дату получения и оплаты для продажи!',
  Cargo_DefaultTaxRete: 'Стандарт по умолчанию',
  Cargo_TaxRateRange: 'Диапазон применяемых ставок',
  Cargo_TaxRateRangeLimit: '{0} Текущая ставка налога недоступна, пожалуйста, проверьте и, при необходимости, свяжитесь с руководителем для поддержания этой ставки 【Доступные тарифы】',
  Cargo_BargeETD: 'Баржа ETD',
  Cargo_DataModifyDate: 'Время изменения данных',
  Cargo_sendOcOrder: 'Информация о повторных заказах',
  Cargo_sendOcTracking: 'Повторить информацию о траектории',
  Cargo_sendOcFile: 'Переиздать информацию о файле',
  Cargo_sendOcBilling: 'Сведения о повторном выставлении счетов',
  Cargo_chargeUpdater: 'Обновление расходов',
  Cargo_WriteOffForMultipleRemainTipAr: 'Недостаточная сумма платежа в этом выборе, рекомендуется изменить сумму списания!',
  Cargo_SharedChargeRecord: 'Отчет о совместном несении расходов',
  Cargo_ExcludingTaxAmount: 'Сумма, не облагаемая налогом',
  Cargo_IncludedTaxAmount: 'Сумма налога',
  Cargo_ShareScheme: 'Порядок начисления взносов',
  Cargo_ChargeSyncStatus: 'Состояние синхронизации расходов',
  Cargo_ChargeSyncConfirmStatus: 'Синхронизация состояния подтверждения',
  Cargo_WriteOffForMultipleRemainTipAp: 'Этот выбор недостаточно уплаченной суммы, рекомендуется изменить сумму этого списания!',
  Cargo_ConsolidatedProfitLossIs2: 'Курсовые прибыли и убытки включают:',
  Cargo_GroupScene: 'Групповая сцена',
  Cargo_GroupName: 'Название группы',
  Cargo_GroupType: 'Тип группы',
  Cargo_CcPerson: 'Копии',
  Cargo_UpdatePerson: 'Обновить человека',
  Cargo_Common: 'Публичные',
  Cargo_Personal: 'Частные лица',
  Cargo_ReleasePerson: 'Отправить одного',
  Cargo_MailGroupType: 'Пожалуйста, выберите хотя бы один тип.',
  Cargo_MailGroupName: 'Введите название группы.',
  Cargo_MailGroupEmail: 'Введите хотя бы один почтовый адрес.',
  Cargo_MailGroupCheckEmail: 'Проверьте формат входной почты.',
  Cargo_MailGroupDelete: 'Операция удаления не может быть восстановлена, убедитесь, что данные удалены?',
  Cargo_ChargeRate: 'Обменный курс',
  Cargo_BillingRate: 'Курс счета',
  Cargo_GroupChargeRate: 'Обменный курс групповых расходов',
  Cargo_BranchRate: 'Обменный курс филиала',
  Cargo_EnabledChildOffice: 'Текущий обменный курс для дочерних компаний',
  Cargo_ShowParentRateOffice: 'Применение: {0} Обменный курс',
  Cargo_SetEnabledChild: 'Вступление в силу дочерней компании',
  Cargo_SetEnabledChildDialog: 'Вступление в силу для дочерних компаний',
  Cargo_SetEnabledChildCheckbox: 'Вступление в силу для дочерних компаний',
  Cargo_CopyOfficeRate: 'Копирование обменного курса филиала',
  Cargo_CopyHqRate: 'Копирование группового обменного курса',
  Cargo_ConfirmCopyBillingRateTip: 'Охватывают ли имеющиеся данные?',
  Cargo_Cover: 'Покрытие',
  Cargo_NotCover: 'Не перезаписывать',
  Cargo_PleaseSelectExportData: 'Выберите данные, которые вы хотите экспортировать!',
  Cargo_UploadRateTip: 'Загрузить файлы можно только в формате xls и xlsx!',
  Cargo_UploadDataSizeMore: 'Размер файла не должен превышать 2 МБ!',
  Cargo_UploadDataFailed: 'Ошибка импорта, свяжитесь с администратором!',
  Cargo_UploadFailedCheckExcel: 'Ошибка импорта, проверьте содержимое шаблона!',
  Cargo_ValidateUploadRateTip1: 'Исходное значение валюты {0}, а базовое значение валюты {1} повторяется с другими данными в Excel!',
  Cargo_ValidateUploadRateTip2: 'Первоначальное значение валюты {0}, базовое значение валюты {1} повторяется с существующими данными в таблице!',
  Cargo_ValidateUploadRateTip3: 'Данные повторяются с уже имеющимися данными в таблице!',
  Cargo_DefaultReceivableMode: 'Режим дебиторской задолженности по умолчанию',
  Cargo_DefaultReceivableRate: 'Ставки по умолчанию к получению',
  Cargo_SecondReceivableRate: 'Вторая ставка к получению',
  Cargo_ChargeableAmountInterval: 'Диапазон взимаемых сборов',
  Cargo_ReceivableIntervalType: 'Тип интервала дебиторской задолженности',
  Cargo_DefaultUnitPrice: 'Цена единицы по умолчанию',
  Cargo_DefaultRate: 'Ставка по умолчанию',
  Cargo_Suit: 'Применение',
  Cargo_DefaultPayableMode: 'Режим обработки по умолчанию',
  Cargo_DefaultPayableRate: 'Ставки, подлежащие выплате по умолчанию',
  Cargo_SecondRatePayable: 'К выплате по второй ставке',
  Cargo_PayableAmountInterval: 'Диапазон кредиторской задолженности',
  Cargo_PayableIntervalType: 'Тип интервала',
  Cargo_EDIFileType: 'Тип файла EDI при отправке(UploadFileSuffix)',
  Cargo_MarkOrCargoEnglishNameChangeTip: 'Подписка основной страницы {0} была изменена, обновить ли данные подписи на странице коносамента?',
  Cargo_ShareChargeCheckCurrency: 'Валюта совместного несения расходов и направление поступлений и расходов должны быть одинаковыми.',
  Cargo_ShareChargeCheck: 'Совокупная сумма небольших голосов не равна первоначальной стоимости!',
  Cargo_PleaseSelectedSalesForCustomer: 'Поддерживайте клиентов для продажи!',
  Cargo_PleaseSelectedLevelForCustomer: 'Поддерживайте уровень клиента!',
  AutomaticReconciliation: 'Автоматическая выверка счетов',
  AutomaticReconciliationHistory: 'Автоматическая сверка истории',
  CheckHistory: 'История выверки',
  ReconciliationResult: 'Результаты выверки',
  ImportReconciliationExcel: 'Импорт таблицы сверки Excel',
  Cargo_BatchUpdateChargeConfirmSerialNumber: 'Изменить партию',
  Cargo_BatchUpdateChargeConfirmSerialNumberTip: 'Выбранные расходы будут изменены на следующие номера партий',
  Cargo_InputChargeConfirmSerialNumber: 'Введите номер партии.',
  Cargo_ChargeConfirmSerialNumber: 'Номер партии',
  Cargo_ChargeConfirmSerialNumberLengthMore: 'Номер партии не должен превышать 20 цифр!',
  Cargo_PleaseSelectSolicitationType: 'Пожалуйста, выберите тип товара!',
  Cargo_WriteoffSeqNo: 'Номер списанной партии',
  Cargo_CustomerContactChannel: 'Каналы связи с клиентами',
  Cargo_AgentBilling: 'Агент делится на счет',
  Cargo_AgentBillingCanNotEdit: 'Агент, разделенный на счет, не может быть отредактирован!',
  Cargo_RecheckBillingCanNotEdit: 'Проверенные счета не могут быть отредактированы!',
  Cargo_ContainsAgentBilling: 'Содержит прокси - раздел счета, пожалуйста, выберите другой счет для операции!',
  Cargo_HasAgentBilling: 'Содержит прокси разделенные счета, пожалуйста, выберите другие счета для операции!',
  Cargo_ForeignBillStatusError: 'Статус иностранного счёта не соответствует требованиям печати.',
  Cargo_ExportBillVoucherStatus: 'Экспорт статуса платёжной ведомости',
  Cargo_BillGeneratedNoCancel: 'Номер счёта сгенерирован, отмена проверки невозможна',
  Cargo_OverseasBillReverseRule1: 'Зарубежные счета должны иметь номер для сторнирования',
  Cargo_WriteOffStatusReverseRule: 'Статус "Погашено" не может быть сторнирован',
  Cargo_VoidStatusReverseRule: 'Счета со статусом "Аннулировано" нельзя сторнировать',
  Cargo_AlreadyReversedRule: 'Уже сторнированные счета нельзя сторнировать повторно',
  Cargo_NoBillToReverse: 'Нет счетов для сторнирования',
  Cargo_ConfirmReverseBills: 'Вы уверены, что хотите сторнировать эти {0} счетов?',
  Cargo_ReversedBillNoInvoice: 'Сторнированные счета не могут быть выставлены повторно',
  Cargo_BillInvoicedNoReverse: 'Счет выставлен и не может быть сторнирован',
  Cargo_BillPaymentAppliedNoReverse: 'Счет использован для заявки на оплату и не может быть сторнирован',
  Cargo_BillStatementMadeNoReverse: 'Счет использован для сверки и не может быть сторнирован',
  Cargo_BillWrittenOffNoReverse: 'Счет погашен и не может быть сторнирован',
  Cargo_Config: 'Настройка',
  Cargo_OrderTemplateName: 'Имя шаблона заказа',
  Cargo_TemplateTips: 'Советы:',
  Cargo_Blue: 'Синий',
  Cargo_MusetSelectd: 'Обязательное заполнение не может быть удалено, необходимо настроить имя заголовка шаблона, если шаблон не имеет значения, настройте значение по умолчанию для заказа',
  Cargo_StartLine: 'Импорт в начальную строку (включая заголовок)',
  Cargo_TemplateDefault: 'Если в шаблоне нет обязательного поля, здесь можно сохранить значение по умолчанию для импорта генерируемого заказа',
  Cargo_TemplateDefaultValue: 'Значение шаблона',
  CargoFieldDescription: 'Описание поля',
  Cargo_FieldDropdownValue: 'Значение выпадающего поля',
  Cargo_ActualFieldName: 'Имя фактического рабочего поля',
  Cargo_TemplateHeaderName: 'Название заголовка шаблона',
  Cargo_TemplateImportValue: 'Импорт шаблонов',
  Cargo_OrderDefaultValue: 'Значение по умолчанию для заказа',
  Cargo_OrderOperation: 'Операция',
  Cargo_OrderDelete: 'Удалить',
  Cargo_CloseAccountTips1: 'Текущая дата корректировки закрыта, пожалуйста, выберите заново.',
  Cargo_CloseAccountTips2: 'Текущая финансовая дата закрыта, пожалуйста, выберите ее заново.',
  Cargo_PayableOrderCreationDate: 'Дата создания кредиторской задолженности',
  Cargo_InvoiceHistoryEmail: 'Историческая почта счета - фактуры',
  Cargo_SendCc: 'Адрес синхронизации отправки копий',
  Cargo_DoInvoiceTip: 'Только {0} Права, не может управлять получением билетов',
  Cargo_DoInvoiceTip2: 'Только {0} Права, неоперабельные смешанные счета к получению',
  Cargo_CallBackTip: '【Представлено, издано】 Записи о страховании не могут вернуться к предыдущему шагу',
  Cargo_CabinSpaceSerialNo: 'Номер люка',
  Cargo_CabinSpaceStatus: 'Класс проезда',
  Cargo_CabinSpaceNote: 'Примечания',
  Cargo_AllocationStatus: 'Состояние распределения',
  Cargo_QuantityInconsistency: 'Количество S / O или MBL не соответствует количеству мест',
  Cargo_VesselCallSign: 'Позывной судна',
  Cargo_SORecognitionNewAdd: 'СО идентифицирует новые',
  Cargo_ShutOut2: 'Сбор таможенных пошлин',
  Cargo_CabinSpaceBackFill: 'Заполнение мест',
  Cargo_RevokeAllocation: 'Отмена распределения',
  Cargo_CancelCabinReservation: 'Выход.',
  Cargo_AllocateCabinSpace: 'Распределение мест',
  Cargo_Allocate1: 'Распределение - - ассоциированные операции',
  Cargo_Allocate2: 'Распределение - создание бизнеса',
  Cargo_SelectBusinessTip: 'Выберите операцию копирования',
  Cargo_GuidedSellingPrice: 'Руководство продажной ценой',
  Cargo_CabinCancellationNote: 'Замечания по выходу',
  Cargo_CutOffDate: 'Дата закрытия',
  Cargo_DeclarationCutOffDate: 'Дата уведомления',
  Cargo_CutOffDate2: 'Дата закрытия клиента',
  Cargo_ReturnDateForCustoms: 'Дата возврата клиента',
  Cargo_CutOffTime: 'Заказчик останавливает время',
  Cargo_FreeStorageDays: 'Количество дней без реактора',
  Cargo_TotalPiecesMismatchContinue: 'Общее количество мест не совпадает. Продолжить?',
  Cargo_BasicData: 'Базовые данные',
  Cargo_CustomerVendorRating: 'Оценка клиента/поставщика',
  Cargo_DeliveryOperator: 'Оператор поставки',
  Cargo_DeliveryOperationTime: 'Время операции поставки',
  Cargo_DeliveryOperationMethod: 'Метод операции поставки',
  Cargo_PartnerApprovalRequired: 'Выбранному партнёру требуется согласование; он станет доступен только после одобрения и недоступен во время проверки. Начать процесс согласования сейчас?',
  Cargo_ContractApprovalRequired: 'Для вступления договора в силу требуется процедура согласования; во время рассмотрения запрещены редактирование, пролонгация и управление документами. Начать согласование сейчас?',
  Cargo_ViewPartnerDetails: 'Просмотр сведений о партнёре',
  Cargo_PartnerApplicationForm: 'Заявление на партнёрство',
  Cargo_ContractApplicationForm: 'Заявление на заключение договора',
  Cargo_PartnerApplicationApprovalProcess: 'Процесс подачи и согласования заявки партнёра',
  Cargo_ContractApplicationApprovalProcess: 'Процесс подачи и согласования заявки на договор',
  Cargo_UnderReview: 'На рассмотрении',
  Cargo_CanSubmitOnlyUnreviewedPartner: 'Можно отправить только партнёра со статусом «Не рассмотрено». Повторите выбор.',
  Cargo_DataUnderReviewCheckRetry: 'Есть данные на рассмотрении; проверьте и повторите попытку',
  Cargo_ViewContractDetails: 'Просмотр сведений о договоре',
  Cargo_WeightOutOperator: 'Оператор выгрузки по весу',
  Cargo_WeightOutOperationTime: 'Время операции выгрузки',
  Cargo_WeightOutOperationMethod: 'Метод операции выгрузки',
  Cargo_ConfirmBatchOperation: 'Подтвердить массовую операцию?',
  Cargo_AutomationConfig: 'Конфигурация автоматизации',
  Cargo_TaskScenario: 'Сценарий задачи',
  Cargo_TimingMethod: 'Метод тайминга',
  Cargo_LastExecutionTime: 'Время последнего выполнения',
  Cargo_ExecutionFrequency: 'Частота выполнения',
  Cargo_PerHour: 'Каждый час',
  Cargo_Daily: 'Ежедневно',
  Cargo_Weekly: 'Еженедельно',
  Cargo_Monthly2: 'Ежемесячно',
  Cargo_VesselEnglishName: 'Английское название судна',
  Cargo_ActualSailingTime: 'Фактическое время отправления',
  Cargo_EstimatedSailingTime: 'Расчетное время отправления',
  Cargo_ShippingCompanyName2: 'Название судоходной компании',
  Cargo_ActualAmount: 'Фактическая сумма (окончательная сумма расходов)',
  Cargo_FeeCreationTime: 'Время создания расхода',
  Cargo_StartExecutionTime: 'Время начала выполнения',
  Cargo_Every: 'Каждые',
  Cargo_Hour: 'Час(ов)',
  Cargo_EffectiveTime: 'Время вступления в силу',
  Cargo_TaskResult: 'Результат задачи',
  Cargo_TaskResultReminder: 'Уведомление о результате задачи (email + Excel)',
  Cargo_ScenarioName: 'Название сценария',
  Cargo_AutomationTask: 'Автоматизированная задача',
  Cargo_SpecifiedWeekday: 'Указанный день недели',
  Cargo_SpecifiedDay: 'Указанный день',
  Cargo_LastDayOfMonth: 'Последний день месяца',
  Cargo_Day29to31Fallback: 'При выборе 29, 30 или 31 и отсутствии такого дня в месяце задача выполнится в последний день месяца.',
  Cargo_ExecuteCommand: 'Выполнить команду',
  Cargo_AutoInvoicing: 'Автоматическое выставление счетов',
  Cargo_TaskName: 'Название задачи',
  Cargo_MultiLegVoyageManagement: 'Управление многорейсовым плаванием',
  Cargo_ScheduleSelection: 'Выбор рейса',
  Cargo_Leg1: 'Сегмент 1',
  Cargo_Leg2: 'Сегмент 2',
  Cargo_Leg3: 'Сегмент 3',
  Cargo_Leg4: 'Сегмент 4',
  Cargo_Leg5: 'Сегмент 5',
  Cargo_OnlyOneVoucherForCopy: 'Можно выбрать только один документ для копирования!',
  Cargo_VoyageInfoCannotBeEmpty: '{0} в информации о рейсе не может быть пустым',
  Cargo_AutoExecute: 'Автоматическое выполнение',
  Cargo_TaskNameCannotBeEmpty: 'Название задачи не может быть пустым!',
  Cargo_TaskNameAlreadyExists: 'Название задачи «{0}» уже существует, повтор невозможен!',
  Cargo_TaskScenarioAutoExecuteCannotDelete: 'Этот сценарий задачи настроен на автоматическое выполнение и не может быть удалён!',
  Cargo_EnabledStatusCannotDelete: '{0} Статус «включено»; перед удалением отключите.',
  Cargo_ConfirmDeleteTaskScenario: 'Вы уверены, что хотите удалить этот сценарий задачи?',
  Cargo_ScenarioSettings: 'Настройки сценария',
  Cargo_TransmissionRule: 'Transmission Rule',
  Cargo_Script: 'Script',
  Cargo_AccountPassword: 'Account & Password',
  Cargo_GetTokenUrl: 'Token Acquisition URL',
  Cargo_InterfaceUrl: 'Interface URL',
  Cargo_TransmissionSample: 'Transmission Format Sample',
  Cargo_RuleSettings: 'Настройки правил',
  Cargo_CommandSettings: 'Настройки команд',
  Cargo_DataScript: 'Скрипт данных',
  Cargo_DataDisplay: 'Отображение данных',
  Cargo_DeleteFromLastLeg: 'Удалите, начиная с последнего сегмента',
  Cargo_PreviewData: 'Предпросмотр данных',
  Cargo_NotificationPersonnel: 'Уведомляемый персонал',
  Cargo_DebugExecute: 'Отладка выполнения',
  Cargo_ConditionName: 'Имя условия',
  Cargo_SendToExchangeTime: 'Время отправки в судоходную биржу',
  Cargo_EnterYourRequirement: 'Введите ваше требование',
  Cargo_ConfigExecuteCommands: 'Настройка команд выполнения (выполнять по порядку номеров)',
  Cargo_CommandName: 'Название команды',
  Cargo_SelectCommand: 'Выбор команды',
  Cargo_ConfirmRuleSettings: 'Подтвердите настройки правил',
  Cargo_ScenarioDescription: 'Описание сценария',
  Cargo_Command: 'Команда',
  Cargo_ExecutionTime: 'Время выполнения',
  Cargo_HistoryDetails: 'Детали истории',
  Cargo_ExecutionScenario: 'Сценарий выполнения',
  Cargo_DataID: 'ID данных',
  Cargo_ExecuteCommandName: 'Имя команды выполнения',
  Cargo_ManualRun: 'Ручной запуск',
  Cargo_AsyncExecutingCheckLogLater: 'Выполняется асинхронно, пожалуйста, проверьте журнал выполнения позже',
  Cargo_ExecutionLog: 'Журнал выполнения',
  Cargo_Execute: 'Выполнить',
  Cargo_NoOutboundCommandConfirmPickList: '{0},Команда на отгрузку не выдана. Подтвердить создание листа отбора?',
  Cargo_CabinSpaceAllocationDate: 'Дата распределения мест',
  Cargo_AssociatedBusinessNo: 'Номер ассоциированной операции',
  Cargo_AssociatedBusinessStatus: 'Статус ассоциированных операций',
  Cargo_FirstTimeSalesAllocation: 'Первое распределение продаж',
  Cargo_FirstTimeAllocationEntrustingUnit: 'Первое распределение доверенности',
  Cargo_CabinCancellationExplanation: 'Описание выхода',
  Cargo_CabinSpaceRecord: 'Учет класса проезда',
  Cargo_VoyageInformation: 'Информация о рейсе',
  Cargo_AssociatedBusinessStatus2: 'Статус ассоциированных операций',
  Cargo_UploadFileOver50: 'Поскольку объем данных слишком большой, скорость загрузки может быть медленнее, пожалуйста, посмотрите позже.',
  Cargo_UserSecurityPolicy: 'Политика безопасности пользователя',
  Cargo_RoleGroupManagement: 'Управление группами ролей',
  Cargo_RoleGroupName: 'Название группы ролей',
  Cargo_UnmaintainedRoleGroupPermissions: 'Соответствующие права групп ролей не поддерживаются',
  Cargo_RoleGroup: 'Группа ролей',
  Cargo_RoleGroupCountLessThanTwo: 'Количество групп ролей < 2',
  Cargo_PolicySettings: 'Настройки политики:',
  Cargo_EnableUserSecurityPolicy: 'Включить политику безопасности пользователя',
  Cargo_PasswordLengthRange: 'Диапазон длины пароля:',
  Cargo_MaxLengthRange8to20: 'Максимум 8-20 символов',
  Cargo_CompositionRule: 'Правило составления:',
  Cargo_RequireNumUpperLower: 'Должен содержать цифры, прописные и строчные буквы',
  Cargo_MustIncludeSpecialChars: 'Обязательные спецсимволы: !,$,%,&,_,|,-,@,#,*,=',
  Cargo_PasswordHistoryCheck: 'Проверка истории паролей:',
  Cargo_HistoryLength0to10: 'Диапазон 0-10; 0 — не проверять, 3 — нет повторов в последних 3',
  Cargo_PasswordErrorLock: 'Блокировка по ошибкам пароля:',
  Cargo_LockLength0to10: 'Диапазон 0-10; 0 — не блокировать, иначе отключение аккаунта',
  Cargo_AdminApplication: 'Применение к админам:',
  Cargo_AdminPwdFollowPolicy: 'Пароли администраторов подчиняются той же политике',
  Cargo_NoRepeatLastNPasswords: 'Не должен совпадать с последними {0} паролями',
  Cargo_PasswordRulePrompt: 'Соблюдайте правила: длина {0}-{1}, должны быть цифры, прописные и строчные буквы',
  Cargo_Allocated: 'Выделено',
  Cargo_NotAllocated: 'Не распределено',
  Cargo_PriceAuditEventFclTitle: 'Уведомление об обновлении тарифа',
  Cargo_FillSO: 'Заполнить S / O',
  Cargo_FillMBL: 'Заполнить MBL',
  Cargo_FillALL: 'Заполнение MBL и S / O одновременно',
  Cargo_CustomsReturnAndRecovery: 'Взыскание класса проезда из операций по таможенной очистке',
  Cargo_CheckDTip: 'MBL NO. или SO NO. Уже существует и подтверждает, что нужно продолжать создавать?',
  Cargo_BatchUpdateTitle1: 'Массовое изменение - заполнение мест',
  Cargo_WindowTip1: '* Обновление серийных номеров коносаментов.',
  Cargo_WindowTip2: '* * В случае расхождений в количестве ящиков в заказах, отобранных партиями, заполните отдельный отсек для обратного заполнения.',
  Cargo_CheckDTip2: 'Операция не может быть выполнена в состоянии "снятого" или "выделенного"',
  Cargo_CheckDTip3: 'Пожалуйста, выберите каюту с одинаковым количеством модулей.',
  Cargo_NoItems_NoAudit: 'Нет {0}, не требуется аудит',
  Cargo_Audited_NoNeedAudit: 'Проверено, повторный аудит не требуется',
  Cargo_AvailableCabinSpace: 'Нын.отс',
  Cargo_QueryTip: 'Быстрый поиск: номер люка',
  Cargo_PriceUpdateUser: 'Пересмотр тарифов',
  Cargo_BookingPreAudit: 'Предварительное бронирование',
  Cargo_UniversalIntelligentRecognition: 'Универсальное интеллектуальное распознавание',
  Cargo_PromptWords: 'Подсказка',
  Cargo_PleaseUploadFile: 'Пожалуйста, загрузите файл.',
  Cargo_BatchImportAr1: 'Массовый импорт дебиторской задолженности',
  Cargo_BatchImportAp1: 'Оплата оптом',
  Cargo_BatchImportAr2: 'Загрузить шаблон импорта поступлений',
  Cargo_BatchImportAp2: 'Загрузить шаблон оплаты',
  Cargo_ImportingDataSuccess1: 'Это упражнение как асинхронная операция, где вы можете',
  Cargo_ImportingDataSuccess2: 'Хранение файлов - > Загрузка журнала',
  Cargo_ImportingDataSuccess3: 'Просмотреть результаты импорта',
  Cargo_RecordsWrittenOff: 'Списано {0} записей.',
  Cargo_lockLabel1: 'Заблокировать покупную цену',
  Cargo_lockLabel2: 'Заблокировать цену продажи',
  Cargo_lockLabel3: 'Разблокировать цены',
  Cargo_lockLabel4: 'Разблокировать цены',
  Cargo_UnLockLabel: 'Разблокировать',
  Cargo_LockLabel: 'Блокировка',
  Cargo_LockSuccess: '{0} {1} Успех',
  Cargo_DisplayByBillOfLading: 'Показать по коносаменту',
  Cargo_DisplayByDateAndVoyageNo: 'Показать по датам',
  Cargo_ShowSeaExportJob: 'Объед.брон.данных',
  Cargo_OperatingSpaceOnly: 'Только рабочие места, неоплачиваемые заказы',
  Cargo_IsCabinSpace: 'Использовать текущий отсек',
  Cargo_CheckBoxTip: 'Количество ящиков не соответствует классу, проверьте',
  Cargo_CheckBoxTip2: 'Название судна, рейс, судоходная компания, ETD и класс заказа не совпадают, пожалуйста, подтвердите, продолжается ли?',
  Cargo_CheckBoxTip3: 'Связанный бизнес уже имеет MBL NO, или SO NO, не может быть связан',
  Cargo_AllocationSuccess: 'Распределение успешно!',
  Cargo_AllocationCancel: 'Подтвердить отмену распределения?',
  Cargo_CabinReturn: 'Одновременный выход.',
  Cargo_CabinReturnTip: 'Заполните инструкцию по выходу.',
  Cargo_CancelCabinTip1: 'Отмена завершена',
  Cargo_CancelCabinTip2: 'Выход завершен.',
  Cargo_CancelCabinTip3: 'Дела, связанные с классом, сначала отмените связь',
  Cargo_CancelCabinTip4: 'Услуги, связанные с проездом, все еще находятся на предварительном этапе бронирования, и в случае отмены распределения просьба отклонить их на предварительном этапе бронирования',
  Cargo_CancelCabinTip5: 'Услуги, связанные с проездом, еще не возмещены, прежде чем они будут возвращены',
  Cargo_CancelCabinTip6: 'Наличие нераспределенных мест, пожалуйста, проверьте',
  Cargo_BusinessProcessStage: 'Этап оперативной деятельности',
  Cargo_PleaseSelectDataAndUpload: 'Пожалуйста, отметьте данные после загрузки файла в пакете.',
  Cargo_PleaseSelectDataAndUpload2: 'Пожалуйста, выберите тот же тип бизнеса после загрузки файла в пакете.',
  Cargo_BatchUploadFile: 'Массовая загрузка файлов',
  Cargo_BatchUploadFile2: 'Ошибка загрузки не поддерживает этот формат',
  Cargo_Allocate3: 'Распределение - создание бизнеса',
  Cargo_CabinCreate1: 'Создано для предварительного заказа.',
  Cargo_CabinCreate2: 'Создано для морского бронирования.',
  Cargo_CabinCreate3: 'Создан номер бизнес - листа:',
  Cargo_CloseAndCopyNumber: 'Закрыть и скопировать номер',
  Cargo_AllocateCheck1: 'Наличие выделенных данных, проверьте',
  Cargo_AllocateCheck2: 'Наличие данных, не выпущенных из модуля, проверьте, пожалуйста.',
  Cargo_OnlyReturnTheCabin: 'Можно удалить только данные о состоянии отсека.',
  Cargo_CabinManagement: 'Регулирование класса проезда',
  Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement: 'Поля красного шрифта, которые будут покрывать морской экспорт значениями, управляемыми классом',
  Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten: 'Синее поле шрифта, которое сохранит первоначальную стоимость морского экспорта, не будет покрыто',
  Cargo_ImportedMultipleBusiness: 'Импортированы операции с несколькими билетами',
  Cargo_UploadedRepeatedly: 'Повторить загрузку',
  Cargo_BoxType2: 'Соответствующая ячеистая порода',
  Cargo_BoxTypeAndCategory: 'Ячечный вид',
  Cargo_CheckBoxSize: 'Заполните форму ящика.',
  Cargo_UsedQuota: 'Использованная сумма (хеджирование)',
  Cargo_PleaseSelectTheConsignee: 'Пожалуйста, выберите грузополучателя.',
  Cargo_ViewingMessage: 'Просмотреть оригинальное сообщение',
  Cargo_ChangeSettlement: 'Изменить объект расчетов',
  Cargo_CanNotEditTips: 'Включая неотредактированные расходы, пожалуйста, проверьте!',
  Cargo_PleaseSelectExpenseToModify: 'Пожалуйста, выберите расход для изменения.',
  Cargo_ArChargeSettlementCannotModify: 'Объект расчетов дебиторской задолженности изменить нельзя.',
  Cargo_ChargeSettledCannotModify: 'Расход уже выставлен/выставлен счет/заявка на оплату/списан и не может быть изменен.',
  Cargo_ArChargeSettlementCannotModifyDetail: 'Расход {0} является дебиторским, объект расчетов изменить нельзя.',
  Cargo_ChargeSettledCannotModifyDetail: 'Расход {0} уже выставлен/выставлен счет/заявка на оплату/списан и не может быть изменен.',
  Cargo_CanNotEditChargeDetail: 'Расход {0} не имеет прав на редактирование и не может быть изменен.',
  Cargo_CheckChargeDetailBranchDetail: 'Расход {0} относится к филиалу, с которым нельзя работать.',
  Cargo_BeforeAdjustment: 'До корректировки',
  Cargo_AfterAdjustment: 'После корректировки',
  Cargo_EstimateListQuery: 'Запрос предварительной сметы',
  Cargo_MappingConfiguration: 'Настройка отображения',
  Cargo_CreateEstimate: 'Создание предварительной сметы',
  Cargo_SendSharingCenter: 'Отправить общий центр',
  Cargo_GenerateExpenseAmount: 'Сумма понесенных расходов',
  Cargo_GenerateExpenseMode: 'Модель генерирующих расходов',
  Cargo_GenerateInReceivables: 'Создание в дебиторской задолженности',
  Cargo_GenerateInPay: 'Генерировать в процессе обработки',
  Cargo_GenerateAll: 'Создано отдельно в дебиторской задолженности',
  Cargo_ChargeAmount: 'Пожалуйста, заполните сумму расходов',
  Cargo_PushDate: 'Дата отправки',
  Cargo_GetSendResult: 'Получение результатов отправки',
  Cargo_ALittleSend: 'Как спорадический клиент',
  Cargo_MappingEditor: 'Изменить отображение',
  Cargo_NewMapping: 'Новое отображение',
  Cargo_Recipient: 'Отправить объект',
  Cargo_DataRepetition: 'Наличие дублирующих данных',
  Cargo_checkTip2: '{0} или {1}',
  Cargo_ErrorExcel: 'Ошибка шаблона',
  Cargo_ImportException: 'Импорт аномалий',
  Cargo_SelectiveFinanceMonth: 'Выбор финансового месяца',
  Cargo_FinancialMonth: 'Финансовый месяц',
  Cargo_PushLog: 'Запись push',
  Cargo_ConfirmImport: 'Импортировать',
  Cargo_SETitle: 'Планируемое время выхода / ожидаемое время прибытия',
  Cargo_AETitle: 'Предполагаемое время вылета / предполагаемое время прибытия',
  Cargo_CurentSETitle: 'Текущее запланированное время выхода (Current ETD) / Текущее запланированное время прибытия (Current ETA)',
  Cargo_OriginalSETitle: 'Оригинальное запланированное время выхода (Original ETD) / Original ETA',
  Cargo_SEAtdAtaTitle: 'Фактическое время выхода (ATD) / Фактическое время прибытия (ATA)',
  Cargo_AEAtdAtaTitle: 'Фактическое время взлета (ATD) / фактическое время прибытия (ATA)',
  Cargo_UpdateAtdAtaDateTip: 'Введите фактическое время вылета и фактическое время прибытия',
  Cargo_UpdateAtdAtaDateTip2: 'Введите фактическое время вылета и фактическое время прибытия',
  Cargo_UpdateDateTip: 'Введите время вылета, ожидаемое время прибытия',
  Cargo_UpdateDateTip2: 'Введите предполагаемое время вылета и предполагаемое время прибытия',
  Cargo_BusinessNotPositiveOperation: '{0} Не в рабочем состоянии, время не может быть изменено',
  Cargo_SuccessTip: 'Успех {0}, неудача 0',
  Cargo_SuccessTip1: 'Статья успеха {0}, статья неудачи {1}, < br / > Описание неудачи: < br / > {2} не является положительным операционным состоянием, время не может быть изменено',
  Cargo_SuccessTip2: 'Успешно: {0}, Ошибок: {1}.<br/>Причины ошибок: <br/> {2} не в операционном статусе, невозможно изменить <br/> {3} выбрана только домовая накладная без информации о главной накладной, невозможно изменить',
  Cargo_ErrorCause: 'Необычные причины',
  Cargo_PushMessage: 'Печать сообщений',
  Cargo_PushMessageRsp: 'Получить сообщение',
  Cargo_ViewMessage: 'Просмотреть сообщение',
  Cargo_Message: 'Сообщение',
  Cargo_BusinessApplicationContext: 'Сценарий прикладного бизнеса',
  Cargo_ConfigureEmailTemplate: 'Настроить шаблон почты',
  Cargo_SendingPosition: 'Отправить пост',
  Cargo_DeleteEmailTip: 'Подтвердить удаление выбранного шаблона почты?',
  Cargo_UpdateEmailTip: 'Имя шаблона почты не может быть пустым!',
  Cargo_UpdateEmailTip2: 'push - звено: {0}, Отправить объект: {1}, уже есть соответствующие настройки, не повторяйте!',
  Cargo_UpdateEmailTip3: 'Имя шаблона [bracket0] уже существует, имя шаблона почты не может быть повторено!',
  Cargo_EmailTemplate: 'Шаблон почты',
  Cargo_OrganizeClearing: 'Расчетная организация',
  Cargo_DocumentCode: 'Номер документа',
  Cargo_BillDate2: 'Дата документа',
  Cargo_EndDate2: 'Дата истечения',
  Cargo_doTip: 'В фоновом режиме выполняется асинхронная обработка, пожалуйста, повторите запрос позже!',
  Cargo_TypeOfExchange: 'Тип операции',
  Cargo_CurrentAccountCode: 'Коды операций',
  Cargo_PE: 'Предварительная / предварительная оценка',
  Cargo_ENo: 'Оценочный номер',
  Cargo_OrderChannel: 'Применение каналов заказа',
  Cargo_MonthlyFinancial: 'Финансовый месяц',
  Cargo_DocumentId: 'Идентификатор документа операционной системы',
  Cargo_SourceSystemCoding: 'Код исходной системы',
  Cargo_businessShipAgency: 'Тип операции (судовой агент)',
  Cargo_CoinsReceivable: 'Дебиторская задолженность',
  Cargo_ArApAmount: 'Дебиторская / кредиторская задолженность',
  Cargo_CostItem: 'Статья расходов Код',
  Cargo_TaxNumber: 'Номер налога',
  Cargo_IsDefaultTitle: 'Является ли это стандартным наименованием',
  Cargo_SingleTitleMode: 'Режим одиночного наименования',
  Cargo_MultipleTitleMode: 'Режим множественных наименований',
  Cargo_UnitPrice2: 'Налоговая цена',
  Cargo_TaxRateCode: 'Налоговые ставки. Код',
  Cargo_Discount: 'Способ скидки',
  Cargo_CanNotChargeTips: 'Уже есть неотредактированные расходы, пожалуйста, обработайте их вовремя!',
  Cargo_RefreshChargeTips: 'Уже есть расходы, обновляются ли затраты?',
  Cargo_ArAmount: 'Сумма к получению',
  Cargo_MonthCode: 'Код месяца',
  Cargo_BeforeChange1: 'Прогнозируемая прибыль до внесения изменений',
  Cargo_BeforeChange2: 'Прогнозируемая прибыль после изменения',
  Cargo_TaxPolicyCoding: 'Код налоговой политики',
  Cargo_SendingSharingCenter: 'Отправить общий центр',
  Cargo_SendingResult: 'Push Успешно: {0} Статьи, Ошибка: {1} Статьи',
  Cargo_System2: 'Системы',
  Cargo_FileDelete: 'Файл Удалить: Удалить',
  Cargo_BillsPayable: 'Кредиторская задолженность',
  Cargo_PaymentSlipDataNo: 'Номер платежного поручения',
  Cargo_Payer: 'Субъект платежа',
  Cargo_Prepaid: 'Авансировано',
  Cargo_TypeOfInvoice: 'Вид счета - фактуры',
  Cargo_UploadInvoiceCloudStatus: 'Загрузить облачный статус счета - фактуры',
  Cargo_AccountToBeCredited: 'Счета поступлений',
  Cargo_BankConnectionNo: 'Банковский номер / SWIFT CODE',
  Cargo_BankConnectionNo2: 'Серийный номер / SWIFT',
  Cargo_OriginalPaymentSlipNo: 'Первоначальный номер платежного поручения',
  Cargo_ProcessNumber: 'Номер процесса',
  Cargo_FinancialPayStatus: 'Статус финансовой кредиторской задолженности',
  Cargo_PaymentRequisitionStatus: 'Статус платежного поручения',
  Cargo_DefaultDetailItems: 'Элементы по умолчанию',
  Cargo_GeneratePay: 'Формирование кредиторской задолженности',
  Cargo_MergeGeneratePay: 'Совокупное формирование кредиторской задолженности',
  Cargo_PrintChannel: 'Канал печати',
  Cargo_BookingConfirmed: 'Бронированные каюты',
  Cargo_OrderRecorded: 'Запись',
  Cargo_CreateBillsPayable: 'Создание кредиторской задолженности',
  Cargo_FinancialPayAreSent: 'Направление финансовых счетов - фактур',
  Cargo_PaymentRequestSent: 'Направление платежных поручений',
  Cargo_DetailEntryID: 'Идентификатор записи',
  Cargo_PayableSingleAttribute: 'Свойства кредиторской задолженности',
  Cargo_SelectAp2: 'Пожалуйста, выберите запрос на оплату, который должен быть выставлен',
  Cargo_SelectAp: 'Пожалуйста, выберите список',
  Cargo_LookAp: 'Посмотреть Кредиторскую задолженность',
  Cargo_IdentifyTheCustomsTips: 'Существуют файлы, которые анализируются или уже обработаны.',
  Cargo_IdentifyTheCustomsDeclaration: 'Идентификационная таможенная декларация',
  Cargo_RefreshCustomsDeclaration: 'Обновить таможенную декларацию',
  Cargo_ContactMultiple: 'Контракт содержит несколько договорных соглашений.',
  Cargo_CustomsActivatedTip: 'Не включена функция идентификации',
  Cargo_CustomsActivatedTip2: 'Недостаточный остаток, пожалуйста, свяжитесь с клиентской службой пополнения',
  Cargo_CustomsDeclarationNo: 'Номер таможенной декларации',
  Cargo_AnalysisStatus: 'Аналитическое состояние',
  Cargo_SystemFee: 'Системные расходы',
  Cargo_InsurancePremium: 'Расходы на обеспечение безопасности',
  Cargo_ProcessingFee: 'Расходы на обработку',
  Cargo_FOBValue: 'Стоимость FOB',
  Cargo_ExportCustomsDeclaration: 'Экспорт таможенной декларации',
  Cargo_Nonstop: 'Смотреть только прямые рейсы',
  Cargo_InternationalRoute: 'Смотреть только международные маршруты.',
  Cargo_SelectNoDeleteAp: '【Кредиторская задолженность】 Вышла, не может быть удалена',
  Cargo_SelectInvoiceAR: 'Выберите счет - фактуру',
  Cargo_SelectInvoiceAR2: 'Выберите данные, которые были отправлены для получения статуса.',
  Cargo_SelectNoPushData: 'Выберите неоткрытые данные',
  Cargo_SelectNoDelete: '【Предварительная смета】 Вышла, не может быть удалена',
  Cargo_SendSharedCenter: 'Отправить состояние общего центра',
  Cargo_SelectInvoiceType: 'Выберите тип счета',
  Cargo_EditAp: 'Редактирование кредиторской задолженности',
  Cargo_NotPushAP: 'Статус инкассо, без необходимости push [bracket0]',
  Cargo_NotPushAP2: 'Серийный номер / SWIFT пуст и не может быть отправлен',
  Cargo_AttachmentName: 'Название приложения',
  Cargo_AccessoriesAddress: 'Адрес вложения',
  Cargo_canNotEdit: 'Уже push, не может редактировать',
  Cargo_GetTheWriteOffResult: 'Получение результатов списания',
  Cargo_RemarkTip1: 'Общее количество слов в счете - фактуре превышает 230 символов',
  Cargo_RemarkTip2: 'Сцена открытия билета, когда « нечетко - детальная подача билета», необходимо поднять голову выставления билета, заполнить название пункта выдачи билета',
  Cargo_PortOfTransferCheck: 'Пожалуйста, выберите "транзитный порт"',
  Cargo_BatchServiceLocking: 'Блокировка пакетных операций',
  Cargo_UnlockServicesInBatches: 'Операции по массовому разблокированию',
  Cargo_SetAMarginAlert2: 'Настройка напоминаний',
  Cargo_SetAMarginAlert: 'Настройка напоминаний',
  Cargo_ApplicableBranch: 'Подходящие филиалы',
  Cargo_AdditionalRemark: 'Примечания',
  Cargo_FixedLastNumber: 'Номер стоп 00',
  Cargo_GenerativeRule: 'Правила генерации',
  Cargo_StartNumber: 'Начальный номер',
  Cargo_EndNumber: 'Конечный номер',
  Cargo_MarginTip1: 'Недостаточное напоминание компании.',
  Cargo_MarginTip2: 'Недостаточное напоминание работодателям',
  Cargo_MarginTip3: 'Если требуется напоминание, введите недостающее количество номеров в соответствующей колонке.',
  Cargo_useTip: 'Номер должен быть еще не использован.',
  Cargo_useTip2: 'Отмененные номера не могут быть распределены',
  Cargo_DeleteTip: 'Можно удалить только аннулированные номера.',
  Cargo_PrefixTip: 'Неправильный префикс главного номера',
  Cargo_StarTip: 'Начальный номер, конечный номер не соответствует правилам',
  Cargo_StarNoTip: 'Стартовая единичная аномалия',
  Cargo_MarginTip4: 'Заполните, пожалуйста, получателя.',
  Cargo_NumberErrTip: ':: Недостаточно однозначных цифр',
  Cargo_NumberErrTip2: 'Единичный номер не соответствует правилам генерации',
  Cargo_AlreadyExistTip: 'Ошибка импорта, импортированный номер единицы уже существует. < br/>{0}',
  Cargo_ImportStarTip: 'Ошибка импорта, неверно импортирован префикс одного номера. < br/>{0}',
  Cargo_ImportNoTip: 'Ошибка импорта, импортированная единичная аномалия. < br/>{0}',
  Cargo_EmptyNoTip: 'Импорт файла Excel без номера MBL',
  Cargo_CarrierCheck: 'Пожалуйста, войдите в судоходную компанию.',
  Cargo_NumberMarginUse: 'Текущий запас номера пользователя ниже {0}',
  Cargo_NumberMarginCompany: 'Текущий баланс компании ниже {0}',
  Cargo_receiveTip: 'Введённый вами номер уже получен, пожалуйста, убедитесь, что он продолжается?',
  Cargo_receiveTip2: 'Основной номер не согласуется с данными, поддерживаемыми "Главным номером управления", и вы уверены, что хотите продолжать использовать этот номер?',
  Cargo_Recognition: 'Идентификация',
  Cargo_WoodenPackagingType: 'Тип деревянной упаковки',
  Cargo_ClearSave: 'Очистить и сохранить',
  Cargo_OrderModificationTimes: 'Количество измененных ордеров',
  Cargo_ServiceStatisticalArea: 'Регион оперативной статистики',
  Cargo_DangerousGoodPackage: 'Упаковка опасных грузов',
  Cargo_DangerousGoodPackageCode: 'Код упаковки опасных грузов',
  Cargo_OOGTEU: 'Объем OOG TEU',
  Cargo_SeaRailTransport: 'Железнодорожные перевозки',
  Cargo_BoxOneWay: 'Ящик (в одну сторону / цикл)',
  Cargo_OOGTEUTip: 'Пожалуйста, заполните OOG TEU',
  Cargo_OneWay: 'В одну сторону',
  Cargo_Circulation: 'Цикл',
  Cargo_Grade: 'Пользовательский бизнес - тип уровня II',
  Cargo_Grade2: 'Пользовательский тип бизнеса',
  Cargo_LotteryDraw: 'Билеты.',
  Cargo_SchoolMonth: 'Луна открылась',
  Cargo_WithdrawTheEntrustment: 'Отзыв доверенности',
  Cargo_checkData1: 'Не найдено данных о заказе или проверено',
  Cargo_ContractTip: 'Если необходимо внести изменения в контрактное соглашение, договор должен быть расторгнут.',
  Cargo_DetailMakeInvoice: 'Описание',
  Cargo_SplitMakeInvoice: 'Расчёт валюты',
  Cargo_RemarkAddContent: 'Описание дополнительных элементов',
  Cargo_CustomerAssociatedFactory: 'Завод, связанный с клиентом',
  Cargo_FactoryName: 'Название завода',
  Cargo_AddAssociatedFactory: 'Добавить связанный завод',
  Cargo_BatchOperationSameEntrustedUnit: 'Эта пакетная операция поддерживается только для одинаковых операций с одним и тем же доверительным агентством. Пожалуйста, выберите заново.',
  Cargo_ImportFailMessage: 'Неудача импорта: Стоимость пакетного импорта не удовлетворяет ограничению объекта расчета = доверительная организация или связанная фабрика. Пожалуйста, отрегулируйте и попробуйте снова',
  Cargo_RemarkAddContent3: 'Информация об обменном курсе',
  Cargo_SaveAndConfirm: 'Сохранить и подтвердить',
  Cargo_ExportUndoHistory: 'Экспорт истории отмены',
  Cargo_RevocationBy: 'Отзыв',
  Cargo_RevocationByDate: 'Время отмены',
  Cargo_billingTip: 'Запросить счет по счету',
  Cargo_remarkAddContent2: 'Дополнительные примечания',
  Cargo_detailMakeInvoice2: 'Подробно ли выставлен счет',
  Cargo_splitMakeInvoice2: 'Разделить валюту',
  Cargo_rmbGoodsName: 'Счет CNY',
  Cargo_usdGoodsName: 'Счет USD',
  Cargo_CarrierCode: 'Код EDI корабля',
  Cargo_identifyTheResult: 'Результаты идентификации',
  Cargo_identifyTheResult2: 'Идентификационная информация коносамента',
  Cargo_SystemResult: 'Информация о системном коносаменте',
  Cargo_ContrastingSystem: 'Система сравнения',
  Cargo_SaveBillData: 'Сохранение информации о системном коносаменте',
  Cargo_SaveBill2: 'Идентификационная информация Покрытие и сохранение коносамента',
  Cargo_InAnalysis: 'В анализе, пожалуйста, подождите',
  Cargo_UnopenedService: 'Сервис не открыт, не может быть использован',
  Cargo_F17Verify: 'Для отправки F17 необходимо, чтобы номер мастер-накладной и номер домашней накладной совпадали',
  Cargo_Will: 'А',
  Cargo_DFI: 'Перетащите сюда для идентификации, или',
  Cargo_seaFile: 'Оформление документов из моря.',
  Cargo_siFile: 'Морской коносамент',
  Cargo_seBillFile: 'Офшорный коносамент',
  Cargo_GenerateSiBusiness: 'Создание морских импортных операций',
  Cargo_MaritimeIdentification: 'Морская идентификация',
  Cargo_ApplicationIdentificationType: 'Тип распознавания приложений',
  Cargo_IdentificationType: 'Тип идентификации',
  Cargo_IdentificationChannel: 'Каналы идентификации',
  Cargo_OriginalMessage: 'Первоначальное сообщение',
  Cargo_DataSource: 'Источник данных',
  Cargo_InvoiceExport: 'Экспорт счетов',
  Cargo_InvoiceNoImport: 'Импорт номера счета - фактуры',
  Cargo_profitMargin: 'Норма прибыли',
  Cargo_Payment1: 'Плательщик',
  Cargo_PaymentCode: 'Код плательщика',
  Cargo_PaymentName1: 'Наименование контакта плательщика',
  Cargo_PaymentName: 'Наименование плательщика',
  Cargo_SelectPayment: 'Выбор плательщика',
  Cargo_ShowTab: 'Показать подпись дополнительной страницы',
  Cargo_MscBookingInfo: 'Дополнительная информация о бронировании MSC',
  Cargo_PaymentInfo: 'Информация о плательщике',
  Cargo_PaymentInfo1: 'Форматирование плательщика',
  Cargo_PaymentEnterpriseCode: 'Корпоративный код плательщика',
  Cargo_Payment2: 'Наименование предприятия плательщика',
  Cargo_Payment3: 'Подробный адрес плательщика',
  Cargo_Payment4: 'Номер телефона плательщика',
  Cargo_Payment5: 'Адрес электронной почты плательщика',
  Cargo_Payment6: 'Телефонный номер плательщика',
  Cargo_Province1: 'Провинция / штат',
  Cargo_GeneralFormat: 'Общий формат',
  Cargo_DetailFormat: 'Подробный формат',
  Cargo_BringInData: 'Введите данные',
  Cargo_DefaultInvoiceIssuer: 'Значение по умолчанию для выставления счетов',
  Cargo_checkCabinTip: 'Наличие данных о потоках и потоках, не связанных с классом, которые не могут использоваться одновременно',
  Cargo_checkCabinTip2: 'Заказы, которые вы выбрали, выполнят процесс отзыва места',
  Cargo_RecoverText: 'Подтверждается ли рекуперация мест и непосредственная регистрация выхода из кабины?',
  Cargo_RecoverRemark: 'Описание выхода',
  Cargo_RecoverTips: 'Сб. и выв.',
  Cargo_LinesArAp: 'Дебиторская / кредиторская задолженность',
  Cargo_RInPay: 'Дебиторская задолженность включает кредиторскую задолженность',
  Cargo_market: 'Продажа',
  Cargo_GPExplain: 'Описание GP',
  Cargo_ServiceLockSetting1: 'Параметры автоматической блокировки операций',
  Cargo_ServiceLockSettings: 'Параметры блокировки операций',
  Cargo_LockTheNumberOfDeferredDays: 'Задержка блокировки составляет от 3 до 120 дней.',
  Cargo_checkBillingGroup: '[bracket0] Состояние счета не"{1}"',
  Cargo_AutoLock: 'Автоблокировка',
  Cargo_BusinessDate1: 'После даты операции',
  Cargo_Days1: '(День)',
  Cargo_SendBookingFail: 'Ошибка отправки заказа',
  Cargo_OrderTemplateSaveSuccess: 'Настройка шаблона заказа успешно сохранена',
  Cargo_ContinueSave: 'Имя заголовка шаблона не настроено будет использовать фактическое имя бизнес - поля, продолжается ли?',
  Cargo_OrderTemplateSaveFail: 'Ошибка сохранения шаблона заказа',
  Cargo_DownImportTemplate: 'Загрузить шаблон импорта',
  Cargo_DownImportTemplate_Simple: 'Загрузить отдельный шаблон импорта',
  Cargo_DownImport_Simport: 'Индивидуальный импорт',
  Cargo_ImportingData: 'Импорт данных...',
  Cargo_ImportingDataSuccess: 'Это упражнение как асинхронная операция, вы можете просмотреть результаты импорта в журнале хранения файлов - > Загрузка',
  Cargo_WriteOffHeader: 'Заголовок списания',
  Cargo_PackageNo: 'Номер упаковки:',
  Cargo_DeletePackage: 'Удалить упаковку',
  Cargo_WareHoused: 'Упаковки уже на складе.',
  Cargo_NotWareHoused: 'Упаковки не складированы.',
  Cargo_CheckPackage: 'Удалить соответствующую упаковку? В этом случае данные о фактическом поступлении также будут удалены.',
  Cargo_SureDeletePackageIn: 'Эти упаковки были поставлены на склад, и было ли решено удалить соответствующую упаковку? В этом случае данные о фактическом поступлении также будут удалены.',
  Cargo_SelectPackage: 'Выберите данные упаковки, которые необходимо удалить',
  Cargo_SureDeleteAbovePackage: 'Подтверждается ли удаление этих упаковок?',
  Cargo_BalanceSheetQuarter: 'Ежеквартальные балансовые отчеты',
  Cargo_ProfitLossQuarter: 'Отчет о прибылях',
  Cargo_BalanceSheetYear: 'Ведомость активов и пассивов',
  Cargo_ProfitLossYear: 'Отчет о прибылях',
  Cargo_ReasonForJudgment: 'Причины осуждения',
  Cargo_CheckSavePoInfoItem: 'Товар уже связан с упаковкой, сначала снимите связь!',
  Cargo_HasBillingGroup: 'Этот лист сгенерирован для выставления счетов и не может быть отредактирован!',
  Cargo_HasInvoice: 'Этот список уже открыт, его нельзя редактировать!',
  Cargo_HasWriteOff: 'Этот список был аннулирован и не может быть отредактирован!',
  Cargo_HasConfirm: 'Этот список подтвержден и не может быть отредактирован!',
  Cargo_ContinueOperation: 'Продолжить работу',
  Cargo_CancelOperation: 'Отмена операции',
  Cargo_BackTopPreviousVersion: 'Вернуться к старой версии',
  Cargo_Combine: 'Объединение',
  Cargo_DataEnableSuccess: 'Данные включены успешно!',
  Cargo_DataDisEnableSuccess: 'Данные отключены успешно!',
  Cargo_CombineChargeItem: 'Объединение сборов',
  Cargo_ConsolidatedChargeItem: 'Объединение сборов:',
  Cargo_ChargeItemHasUsedForCombine: '{0} Запрещено, пожалуйста, выберите другие платные пункты для объединения!',
  Cargo_CombineChargeItemTips: 'После объединения будут обновлены все расходы, связанные с {1}, как {0} и установлены как отключенные состояния, продолжается ли?',
  Cargo_CombineChargeItemTipsOne: 'Идет слияние, пожалуйста, подождите.',
  Cargo_CombineChargeItemTipsTwo: 'Вы можете выйти из этого интерфейса и, как ожидается, завершить слияние в течение 10 минут, посмотрите позже.',
  Cargo_CombineChargeItemTipsThree: 'Пожалуйста, выберите различные тарифы для объединения!',
  Cargo_PayService: 'Платные статьи:',
  InvoiceTitleCannotBeBlank: 'Счет не может быть пустым.',
  InvoiceTitleCannotBeDuplicate: 'Счет не может быть повторен.',
  TaxControlPanelCannotBeDuplicate: 'Диск налогового контроля (BRACKET0) не допускает множественных выписок.',
  CheckTaxControlPanelNo: '【{0}】 Поддерживает несколько номеров дисков налогового контроля, продолжается ли?',
  TaxControlPanelNoHasInvoiceTitle: 'Информация налогового контроля была связана с выставлением счета вверх, не может быть удалена, сначала отмените связь!',
  ChinaAdditionalTaxRateIsEmpty: '【Дополнительные тарифы в Китае】 Поле пусто и подтверждает, что оно сохраняется?',
  SpecialCharactersExcept: 'Существуют другие специальные символы, кроме английского, цифры и пунктуации',
  Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness: 'Этот билет был отправлен по предварительной накладной. Ошибка импорта.',
  EstimatedDeliveryDate: 'Предполагаемая дата доставки',
  ActualDeliveryDate: 'Фактическая дата доставки',
  LatestDeliveryDate: 'Самая последняя дата доставки',
  DischargingWay: 'Способ разгрузки',
  Cargo_DownloadSource: 'Загрузка данных',
  Cargo_canOnlyBeUppercaseCharactersAndNumbers: 'Только прописные символы и цифры.',
  Cargo_numbersNotLetters: 'Цифры, не могут содержать буквы',
  Cargo_pleaseSelectShippingTerms: 'Пожалуйста, выберите условия фрахта',
  Cargo_pleaseSelectTheTypeOfGoods: 'Выберите тип груза',
  Cargo_pleaseSelectTheBillOfLadingMethod: 'Пожалуйста, выберите форму коносамента.',
  Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters: 'Введите полное английское название порта.',
  Cargo_PortOfDischargeTipText: 'Заполнить транзитный порт, добраться до порта назначения',
  Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers: 'Могут быть только буквы, цифры, "," - "," пробелы "',
  Cargo_PortPreRateCode: 'Номер тарифной ставки порта',
  Cargo_SideLineType: 'Тип боковой линии',
  Cargo_EndRouteRateCode: 'Номер тарифной ставки конечного маршрута',
  Cargo_DeliveryAddressType: 'Тип адреса доставки',
  Cargo_DirectHaul: 'Прямой транспорт',
  Cargo_SideLine: 'Боковая линия',
  Cargo_HuzhouSeaRail: 'Худжоу морской и железнодорожный транспорт',
  Cargo_HaiNingBranch: 'Линия Хайнин',
  Cargo_ZhapuSideLine: 'Боковая линия Чжапу',
  Cargo_OriginPortInfo: 'Информация о портовом отправлении',
  Cargo_ChargeByContainerType: 'Тариф по типу контейнера',
  Cargo_ChargeNotByContainerType: 'Тариф не по типу контейнера',
  Cargo_SpecialRemark: 'Особое замечание',
  Cargo_AddEntry: 'Добавить запись',
  Cargo_FreeUseContainer: 'Контейнер без использования',
  Cargo_FreeStorage: 'Бесплатное хранение',
  Cargo_ThirdPartyAddress: 'Адрес третьей стороны',
  Cargo_AmazonWarehouse: 'Склад Amazon',
  Cargo_WalmartWarehouse: 'Склад Walmart',
  Cargo_YiCang: 'Склад YiCang',
  Cargo_DestinationPortInfo: 'Информация о порту назначения',
  Cargo_Shelving: 'Размещение на полке',
  Cargo_PleaseSelectNonNormalRateForShelving: 'Пожалуйста, выберите не "нормальный" тариф для размещения на полке.',
  Cargo_PleaseSelectValidRateForShelving: 'Пожалуйста, выберите тариф с действительным сроком действия для размещения на полке.',
  Cargo_PleaseSelectNormalRateForUnShelving: 'Пожалуйста, выберите "нормальный" тариф для снятия с полки.',
  Cargo_SeaFreightFullContainer: 'Морская перевозка полным контейнером',
  Cargo_SeaFreightLessThanContainer: 'Морская перевозка неполным контейнером',
  Cargo_EnquiryNumber: 'Номер запроса',
  Cargo_EnquirySource: 'Источник запроса',
  Cargo_Enquirer: 'Запрашивающий',
  Cargo_EnquiryStatus: 'Статус запроса',
  Cargo_FirstLegQuoteStatus: 'Статус предварительной оценки порта',
  Cargo_MainlineQuoteStatus: 'Статус предложения по магистральному маршруту',
  Cargo_LastLegQuoteStatus: 'Статус предложения по последнему этапу',
  Cargo_PalletType: 'Тип паллеты',
  Cargo_DirectOrTransshipment: 'Прямой/Транзит',
  Cargo_Range: 'Интервал',
  Cargo_Dimensions: 'Длина, Ширина, Высота',
  Cargo_Terms: 'Условия обслуживания',
  Cargo_DeliveryAddress: 'Адрес доставки',
  Cargo_NameHSCode: 'Наименование товара (HS код)',
  Cargo_MainlineRate: 'Тариф основной линии',
  Cargo_PrePortRate: 'Тариф перед портом',
  Cargo_EndRouteRate: 'Тариф завершающего маршрута',
  Cargo_RateCode: 'Код тарифа',
  Cargo_MatchQuote: 'Согласованная ставка',
  Cargo_Select_Inquiry_Responsible: 'Выберите ответственного за запрос',
  Cargo_Multiple_Route_Leaders: 'Найдено несколько руководителей маршрутов. Пожалуйста, выберите того, кому нужно инициировать запрос:',
  Cargo_Pre_Port_Rate_Leader: 'Ответственный за тариф перед портом',
  Cargo_Mainline_Rate_Leader: 'Ответственный за основной тариф',
  Cargo_End_Route_Rate_Leader: 'Ответственный за тариф завершения маршрута',
  Cargo_NoMatchFound: 'Не найдено совпадений [{0}]',
  Cargo_CombinationPlanQuery: 'Запрос на комбинацию планов',
  Cargo_FillQueryConditions: 'Заполните условия запроса',
  Cargo_SelectMatchingRate: 'Выберите соответствующий тариф',
  Cargo_GenerateCombinationPlan: 'Сгенерировать комбинацию планов',
  Cargo_ReturnToPreviousStep: 'Вернуться на предыдущий шаг',
  Cargo_PrePortPrice: 'Цена до порта',
  Cargo_MainlinePrice: 'Цена по магистральному маршруту',
  Cargo_LastMilePrice: 'Цена последней мили',
  Cargo_AssociatedPrePortQuoteNumber: 'Номер связанного предварительного предложения по порту',
  Cargo_AssociatedLastMileQuoteNumber: 'Номер связанного предложения по последней миле',
  Cargo_20GPQuantity: 'Количество 20GP',
  Cargo_40GPQuantity: 'Количество 40GP',
  Cargo_40HCQuantity: 'Количество 40HC',
  Cargo_45HCQuantity: 'Количество 45HC',
  Cargo_20NORQuantity: 'Количество 20NOR',
  Cargo_40NORQuantity: 'Количество 40NOR',
  Cargo_20FootNORQuantity: 'Количество 20\' NOR',
  Cargo_40FootNORQuantity: 'Количество 40\' NOR',
  Cargo_SubmitQuotation: 'Отправить предложение',
  Cargo_WithdrawQuotation: 'Отозвать предложение',
  Cargo_RejectQuotation: 'Отклонить предложение',
  Cargo_InquiryManagement: 'Управление запросами груза',
  Cargo_PrePort: 'Предпортовая',
  Cargo_FinalMile: 'Последняя миля',
  Cargo_OriginAreaSelection: 'Выбор области отправления',
  Cargo_ShippingAddressSelection: 'Выбор адреса доставки',
  Cargo_AddArea: '+Добавить область',
  Cargo_AddAddress: '+Добавить адрес',
  Cargo_AddressDisabledTip: 'Можно добавить несколько областей. При выборе двух или более улиц/поселков подробный адрес будет отключен.',
  Cargo_PleaseMaintainAtLeastOne: 'Пожалуйста, поддержите хотя бы одну.',
  Cargo_CannotMatchPleaseFill: '{0} не может быть сопоставлен, пожалуйста, заполните [{1}].',
  Cargo_Match: 'Сопоставление',
  Cargo_QuoteStatusNotAllowedSave: 'Сохранение невозможно в статусе предложенной цены',
  Cargo_SaveDraft: 'Сохранить черновик',
  Cargo_PublishDirectly: 'Опубликовать сразу',
  Cargo_SelectPendingQuoteSubmittedCancel: 'Пожалуйста, выберите ожидающий报价 и отправленный запрос для отмены',
  Cargo_LastMileDeliveryAddress: 'Адрес последней мили доставки',
  Cargo_PackingDoorPoint: 'Точка упаковки двери',
  Cargo_BoxTypeNotAllowedDuplicate: 'Тип коробки не может быть повторным',
  Cargo_PrePortBusinessLeader: 'Руководитель бизнес-операций до порта',
  Cargo_MainlineBusinessLeader: 'Руководитель бизнес-операций магистральной линии',
  Cargo_LastMileBusinessLeader: 'Руководитель бизнес-операций последней мили',
  Cargo_OverseaTracker: 'Ответственный за отслеживание за рубежом',
  Cargo_EndCommerceSynced: 'Синхронизировано',
  Cargo_EndCommerceAudited: 'Проверено',
  Cargo_EndCommerceNotSynced: 'Не синхронизировано',
  Cargo_EndCommercePleaseSelectAtLeastOne: 'Пожалуйста, выберите хотя бы одну запись',
  Cargo_EndCommerceOnlySelectOne: 'Для этой операции можно выбрать только одну запись',
  Cargo_EndCommerceRecordNotAllowEdit: 'Данная запись не может быть отредактирована',
  CargoMsg_CurrentIdentityNotice: 'Текущая роль будет связана с последующими правами. Если вы хотите подать запрос с другой ролью, сначала переключите филиал и отдел в правом верхнем углу интерфейса.',

  Cargo_enterTheVoyageThereCanBeNoV: 'Не может быть V.',
  Cargo_ResubscribeBookingReceipt: 'Повторная подписка на квитанцию бронирования',
  Cargo_BookingReceiptSubscriptionFailed: 'Не удалось подписаться на квитанцию бронирования',
  Cargo_inputVoyage: 'Введите рейс.',
  Cargo_pleaseSelectAShippingGeneration: 'Пожалуйста, выберите корабль.',
  Cargo_pleaseSelectAShippingCompany: 'Пожалуйста, выберите судоходную компанию.',
  Cargo_pleaseEnterAnAddressWithin140Characters: 'Введите адрес в пределах 140 символов.',
  Cargo_pleaseEnterTheEnterpriseCode: 'Введите корпоративный код, который должен содержать « + » и не может содержать пробелов до и после номера +',
  Cargo_pleaseEnterAPhoneNumber: 'Введите номер телефона.',
  Cargo_pleaseEnterANameWithin140Characters: 'Введите имя, в пределах 140 символов',
  Cargo_pleaseEnterANameWithin140Characters2: 'Введите имя в пределах 70 символов',
  Cargo_pleaseSelectACountryCode: 'Пожалуйста, выберите код страны',
  Cargo_pleaseEnterTheActualContactName: 'Введите имя фактического контакта',
  Cargo_ViewShipGenerations: 'Посмотреть Корабль',
  Cargo_ReferenceShipGenerations: 'Реферат',
  Cargo_CopyShipInformation: 'Копирование информации о судне',
  Cargo_PleaseInquireWithTheBookingHatchOrCustomerService: 'Пожалуйста, проконсультируйтесь по бронированию или обслуживанию.',
  UnverifiedAmountForCharge: 'Неизрасходованная сумма (расходы)',
  VerifiedAmountForCharge: 'Списанная сумма (расходы)',
  ReceivableForCharge: 'Дебиторская задолженность (расходы)',
  PayableForCharge: 'Причитается (расходы)',
  Cargo_PrePlanBookingCheckSoNo: 'В отправленных / исправленных накладных имелись номера таможенных деклараций, которые не обслуживались в рамках операций с простыми векселями. Продолжение?',
  Cargo_SwitchToTheOldVersion: 'Переключиться на старую версию',
  Cargo_MaintainChargeItem: 'Пожалуйста, сначала сохраните статью расходов!',
  Cargo_UsePeriodRate: 'Использование подробных обменных курсов',
  Cargo_initRatePeriod: 'Дата вступления в силу исторического обменного курса',
  Cargo_MonthRate: 'Месячный курс',
  Cargo_PartialImport: 'Частичный импорт',
  Cargo_CopyCustomerShippingInformation: 'Запись и передача',
  Cargo_NoPermissionForModule: 'У вас нет прав на открытие модуля!',
  Cargo_OcPayment: 'Поиск информации о получении оффлайн',
  Cargo_BatchProcess: 'Массовая обработка',
  Cargo_BatchCancelProcess: 'Массовая отмена обработки',
  Cargo_OcPaymentTime: 'Дата платежа',
  Cargo_ErialNumber: 'Трехсторонний платежный номер',
  Cargo_OcErialNumber: 'OC Заплатить номер',
  Cargo_BillingAccountId: 'Оплата счетов имя клиента',
  Cargo_BillingSettlementAgentId: 'Расчетное имя агента счета',
  Cargo_Processed: 'Обработка',
  Cargo_Project: 'Название проекта',
  Cargo_PaymentStatus: 'Состояние платежей',
  Cargo_UnlockPaymentTimeQuery: 'Если выбранная дата платежа превышает 2 года, повлияет ли это на скорость загрузки данных и определит, какие данные будут запрашиваться за два года?',
  Cargo_OnlyUnProcessedRecordsCanBeProcessed: 'Обрабатываются только необработанные записи [bracket0].',
  Cargo_ConfirmAndProcessSelectedRecord: 'Подтверждается ли обработка выбранной записи [bracket0]?',
  Cargo_OnlyProcessedRecordsCanBeCancelled: 'Можно отменить только обработанные записи [bracket0].',
  Cargo_CancelProcessOfSelectedRecord: 'Подтверждается ли отмена записи выбора обработки [bracket0]?',
  Cargo_ProcessedSuccessfully: 'Отметить как обработанный',
  Cargo_CancelProcessSuccessfully: 'Отметить как необработанный',
  Cargo_LockedOrNot: 'Блокировка',
  Cargo_DeleteOCBillTips: 'Удалить только незаблокированные счета!',
  Cargo_DeleteRecheckedBillTips: 'Удалить только непроверенные счета!',
  Cargo_OCCanWriteOff: 'Списание только заблокированных счетов 【Перевод оффлайн】!',
  Cargo_Adjustment: 'Корректировка',
  Cargo_InChangeExpenseReview: 'При пересмотре расходов',
  Cargo_Verification: 'Списание',
  Cargo_BeWriteBack: 'Красный удар.',
  Cargo_InquiryAndQuotation: 'Запрос и Котировка',
  Cargo_AlertTodoCategoryList: 'Список категорий оповещений и задач',
  Cargo_ItemDescription: 'Описание пункта',
  Cargo_Alert: 'Оповещение',
  Cargo_Todo: 'Задача',
  Cargo_TodoAlert: 'Задачи/Оповещения',
  Cargo_ChangeFeeApplicationProgress: 'Изменение графика рассмотрения заявок',
  Cargo_userDefinedRole1: 'Пользовательский пост 1',
  Cargo_userDefinedRole2: 'Пользовательский пост 2',
  Cargo_userDefinedRole3: 'Пользовательский пост 3',
  Cargo_userDefinedRole4: 'Пользовательский пост 4',
  Cargo_userDefinedRole5: 'Пользовательский пост 5',
  Cargo_userDefinedRole6: 'Пользовательский пост 6',
  Cargo_userDefinedRole7: 'Пользовательский пост 7',
  Cargo_userDefinedRole8: 'Пользовательский пост 8',
  Cargo_DisplaysTheRequestChangeFee: 'Показать стоимость заявки на изменение',
  Cargo_UpdateVesselVoyageMsg: 'Вы изменили название судна, {0} существующее значение, нужно ли очистить?',
  Cargo_UpdateMblMsg: 'Вы настроили номер основного листа, который был получен с помощью службы отслеживания экспорта по воздуху, и хотите ли вы очистить соответствующее поле?',
  Cargo_CheckUnitRate: 'Сохраняются ли сборы за единицу с нулевой ценой, которые будут автоматически очищены от стоимости единицы с нулевой ценой?',
  Cargo_ZeroUnitPrice: 'Есть плата с единичной ценой 0, продолжить сохранение или удалить плату с единичной ценой 0?',
  Cargo_ClearZeroFee: 'Удалить расходы с нулевой стоимостью',
  Cargo_NoFeesCanBeAdded: 'Нет расходов для добавления',
  Cargo_ZeroUnitPriceEntry: 'Цена за единицу введена как 0, подтвердите, нужно ли продолжить сохранение',
  Cargo_ZeroAmountWarning: 'Единичная цена или сумма введены как 0. Пожалуйста, подтвердите, хотите ли продолжить сохранение.',
  Cargo_Readjust: 'Перенастроить',
  Cargo_Validate_Insure: 'Использование функции страхования не разрешается в головном офисе, пожалуйста, переключитесь на филиал.',
  Cargo_ReceivingOperator: 'Оператор приема',
  Cargo_ReceivingOperationTime: 'Время приема',
  Cargo_ClaimOperator: 'Запросить оператора',
  Cargo_ClaimOperationTime: 'Время работы',
  Cargo_OrderChangeOperator: 'Оператор по переводу заказов',
  Cargo_ChangeOrderOperationTime: 'Время выполнения заказа',
  Cargo_ContinueToReleaseDocuments: 'Подтверждаете ли вы продолжение выпуска?',
  Cargo_ExpectedReturnDate: 'Предполагаемая дата возвращения',
  Cargo_OcPrePayment: 'Маркировка предварительного получения',
  Cargo_OcCancelPrePayment: 'Отменить отметку предварительного получения',
  Cargo_GetKingdeId: 'Получение идентификатора Золотой бабочки',
  Cargo_RefreshData: 'Операция не удалась, повторите попытку после обновления!',
  Cargo_ContinueExportTip: 'Выбранная запись экспортирована, точно ли она будет экспортирована снова?',
  Cargo_WarnRuleConfiguration: 'Список конфигураций правил раннего предупреждения',
  Cargo_BPMApprovalProcess: 'Процесс утверждения BPM',
  Cargo_DataServiceReminder: 'Предупреждение службы данных',
  Cargo_ValueAddedServiceReminder: 'Напоминание о дополнительной услуге',
  Cargo_DataServiceItems: 'Услуги по обработке данных',
  Cargo_SopTemplate: 'Шаблоны: SOP',
  Cargo_SopNode: 'Узлы SOP',
  Cargo_TriggerTypeSelection: 'Выбор типа запуска',
  Cargo_TriggerType: 'Тип запуска',
  Cargo_WarningConditions: 'Условия раннего предупреждения',
  Cargo_NodeUpdate: 'Обновление узлов',
  Cargo_EarlyWarning: 'Тип раннего предупреждения',
  Cargo_WarningContent: 'Содержание раннего предупреждения',
  Cargo_DataServiceConfig: 'Имя конфигурации сервиса данных',
  Cargo_ConfigureNameNotEmpty: 'Имя конфигурации не может быть пустым',
  Cargo_ConfigureNameRepeat: '{0} уже существует; имя конфигурации должно быть уникальным',
  Cargo_NotifierRoleRepeat: 'Должность {0} уже присутствует в конфигурации {1}; пожалуйста, не настраивайте повторно',
  Cargo_NotifierIdRepeat: 'Пользователь {0} уже присутствует в конфигурации {1}; пожалуйста, не настраивайте повторно',
  Cargo_RemarksInfo: 'Примечания',
  Cargo_DesignatedPost: 'Назначенные должности (отправка уведомлений в соответствии с операциями, продажами, обслуживанием клиентов и другими позициями, установленными в каждом билетном бизнесе)',
  Cargo_SendSettings: 'Параметры отправки',
  Cargo_SetTheNotificationRecipients: 'Установить объект уведомления (внутренний персонал)',
  Cargo_ReminderMethod: 'Режим напоминания',
  Cargo_DesignatedPersonnel: 'Назначенные лица',
  Cargo_AutoIgnoreMode: 'Автоматическое игнорирование',
  Cargo_WarningLevel: 'Уровень раннего предупреждения',
  Cargo_ShipPlanReminderMethod: 'Способ напоминания о плане судна',
  Cargo_ShipNameAndVoyage: 'Напоминание по названию судна и рейсу',
  Cargo_Job: 'Напоминание по операции',
  Cargo_AlertOnStatus: 'Состояние открытия системы раннего предупреждения',
  Cargo_EarlyWarningMode: 'Модели раннего предупреждения',
  Cargo_WarningSwitch: 'Переключатель системы раннего предупреждения',
  Cargo_StartAlert: 'Включить предупреждение.',
  Cargo_CloseAlert: 'Закрыть предупреждение',
  Cargo_EnablePersonalSettings: 'Включить персональные настройки',
  Cargo_ClosePersonalSettings: 'Отключить персональные настройки',
  Cargo_DataServiceReminderWarning1: '1.【Отправка согласно "Базовой конфигурации"】выполняется через узлы, заданные в 【Базовой конфигурации】',
  Cargo_DataServiceReminderWarning2: '2. После 【Включить оповещение】-【Сохранить】 узлы получения определяются персональными настройками',
  Cargo_ConfigurationAlert: 'Отправка согласно "Базовой конфигурации"',
  Cargo_PushNodeSettings: 'Персональные настройки узла отправки',
  Cargo_NodPushSettings: 'Настройки отправки узлов',
  Cargo_VesselReminderMethodDifferent: 'Действующий 【Способ напоминания о расписании судна】 {По названию судна и рейсу} будет полностью заменён на новый {По бизнесу}',
  Cargo_VesselReminderMethodDifferent2: 'Действующий 【Способ напоминания о расписании судна】 {По бизнесу} будет полностью заменён на новый {По названию судна и рейсу}',
  Cargo_UserConfigOpenDifferent: 'Действующие 【Настройки отправки узлов】 {Персональные настройки отключены} будут полностью заменены на новые {Персональные настройки включены}',
  Cargo_UserConfigOpenDifferent2: 'Действующие 【Настройки отправки узлов】 {Персональные настройки включены} будут полностью заменены на новые {Персональные настройки отключены}',
  Cargo_BringForward: 'Досрочно',
  Cargo_Postpone: 'Отсрочка',
  Cargo_EarlyWarningReminder: 'Раздел, предупреждение',
  Cargo_EarlyTimedIgnore: 'Время игнорировать',
  Cargo_TurnOffAutoIgnore: 'Закрыть автоматическое игнорирование',
  Cargo_SetSOPNodeOfAlert: 'Узлы SOP раннего предупреждения',
  Cargo_SOPNodeOfAlert: 'Предупреждение узлов SOP',
  Cargo_ApplicationScope: 'Сфера применения',
  Cargo_DocumentNotification: 'Уведомление о документах',
  Cargo_ApplyToAllTemplates: 'Применить к шаблону бизнес - типа',
  Cargo_UseOnlyTheCurrentTemplate: 'Использовать только текущий шаблон',
  Cargo_SetAlertNotificationObject: 'Установить объект оповещения',
  Cargo_ReminderModes: 'Режим напоминания',
  Cargo_IgnoreTime: 'Игнорировать время',
  Cargo_AutomaticallyIgnoreAfterHours: 'Автоматическое игнорирование через час',
  Cargo_EditNodeAlertRules: 'Изменить правила оповещения узлов',
  Cargo_CloudPlatformFeeStatus: 'Состояние расходов облачной платформы',
  Cargo_CloudPlatformSyncStatus: 'Состояние синхронизации облачной платформы',
  Cargo_CloudPlatformDocumentNumber: 'Номер документа облачной платформы',
  Cargo_SynchronousCloudPlatform: 'Синхронизация облачной платформы',
  Cargo_SendThirdParty: 'Отправить третьей стороне',
  Cargo_SupplementaryInformation: 'Дополнительная информация',
  Cargo_InvoiceTypeOfTheOppositePlatform: 'Тип счета - фактуры другой платформы',
  Cargo_PaymentBranch: 'Платежное отделение',
  Cargo_SyncInvoiceAttachment: 'Синхронизировать вложения счета',
  Cargo_Send: 'Отправить',
  Cargo_SendSuccess: 'Отправить успешно',
  Cargo_SendFail: 'Ошибка отправки',
  Cargo_Remarks2: 'Примечания',
  Cargo_PaymentInstructions: 'Инструкции по оплате',
  Cargo_PaymentReason: 'Причина платежа',
  Cargo_OurHeader: 'Наша шапка',
  Cargo_DeleteBookingNote: 'Вы уверены, что хотите удалить эту {0} книгу?',
  Cargo_ApplicationDetails: 'Подробная заявка',
  Cargo_SubscribeToDataAlerts: 'Напоминание о подписке',
  Cargo_EnableDataServiceReminder: 'Включить напоминание службы данных',
  Cargo_ClickToLearnMore: 'Нажмите, чтобы узнать больше',
  Cargo_DataServiceReminderWarningOne: '1. push - оповещение об аномалии является логическим суждением, только для справочных целей, и конкретные данные основаны на официальной информации.',
  Cargo_DataServiceReminderWarning: '2. Если вы получаете слишком много напоминаний о контейнере каждый день, вы можете отключить это напоминание, и вышеупомянутое напоминание должно включать модуль службы добавленной стоимости.',
  Cargo_AskDataServiceReminder: 'После открытия службы передачи данных, эффективные и точные автоматические push - напоминания для внутреннего персонала, чтобы узнать больше:',
  Cargo_AskSopDataService: 'После открытия службы передачи данных можно автоматически отправлять эффективные и точные push - уведомления внутренним сотрудникам и клиентам (без поддержки ручного потока), а также настроить службу оповещения о данных в конфигурации правил раннего предупреждения и немедленно связаться с администратором вашей компании, чтобы узнать больше:',
  Cargo_ContactDataServiceReminder: 'Или связаться с WallTech Online для обслуживания клиентов или работы 021 - 65143931',
  Cargo_DataServiceRemind: 'Служба напоминания данных',
  Cargo_WhetherToTurnOffAlerts: 'Закрыть предупреждение',
  Cargo_DayWarning: 'Раннее предупреждение сегодня',
  Cargo_OnlyDataNodesAreDisplayed: 'Показывать только узлы с предупреждением',
  Cargo_ViewProcessedAlerts: 'Просмотреть обработанные предупреждения',
  Cargo_ViewIgnoredAlerts: 'Посмотреть Забытые предупреждения',
  Cargo_SelectTheSopTemplateToApplyToTheBusiness: 'Выберите шаблон SOP для этого бизнеса',
  Cargo_MakeSureToApplyTheSopTemplate: 'Подтвердите применение шаблона SOP [bracket0]',
  Cargo_PleaseSelectAnSOPTemplate: 'Выберите шаблон SOP',
  Cargo_PleaseSelectSOPTemplateForChange: 'Выберите шаблон SOP для замены',
  Cargo_PleaseSelectOtherSOPTemplate: 'Выбранный вами бизнес уже является шаблоном SOP, который вам нужен, пожалуйста, выберите заново',
  Cargo_ReplaceTheSOPTemplate: 'Замена шаблона SOP',
  Cargo_Apply: 'Применение',
  Cargo_MoreFilters: 'Больше скрининга',
  Cargo_Handled: 'Обработано',
  Cargo_ProcessSelectedData: 'Все выбранные сообщения раннего предупреждения будут помечены как обработанные, и операция только обновляет статус сообщений раннего предупреждения.',
  Cargo_IgnoreSelectedData: 'Все варианты раннего предупреждения будут проигнорированы?',
  Cargo_Personnel: 'Персонал',
  Cargo_NewSopTemplate: 'Создать шаблон SOP',
  Cargo_EditSopTemplate: 'Изменить шаблон SOP',
  Cargo_CopySopTemplate: 'Копировать текущий шаблон SOP',
  Cargo_SopTemplateName: 'Имя шаблона SOP',
  Cargo_LookNode: 'Посмотреть узел',
  Cargo_NewNode: 'Новый узел',
  Cargo_EditNode: 'Изменить узел',
  Cargo_NewNodeStatus: 'Состояние нового узла',
  Cargo_NodeSettings: 'Настройка узла',
  Cargo_NodeStatusSettings: 'Настройка состояния узла',
  Cargo_NoticeOfEachBill: 'Уведомление по каждому билету (включая мелкие билеты)',
  Cargo_NoNoticeOfTickets: 'Небольшой билет без уведомления',
  Cargo_AlertSettings: 'Настройки раннего предупреждения',
  Cargo_ConfigureSopMessagePush: 'Настройка push - сообщений SOP',
  Cargo_NodeType: 'Тип узла',
  Cargo_WhetherToDisclose: 'Открыто ли',
  Cargo_EditTheAlertConfiguration: 'Изменить конфигурацию оповещения',
  Cargo_AddedAlertConfiguration: 'Дополнительная конфигурация системы раннего предупреждения',
  Cargo_EditTheStatusDetails: 'Изменить состояние',
  Cargo_NewStatusDetails: 'Дополнительные сведения о состоянии',
  Cargo_StatusDetails: 'Детали состояния',
  Cargo_SetUpSopTemplateApplicationBusinessScenarios: 'Настройка шаблонов SOP для бизнес - сценариев',
  Cargo_QuicklySelectBusinessNodes: 'Быстрый выбор бизнес - узлов',
  Cargo_QuicklyConfigureDataServices: 'Услуги быстрой настройки данных',
  Cargo_QuicklyConfigureStatusNotifications: 'Уведомление о состоянии быстрого развертывания (внутренний персонал)',
  Cargo_ShipPlanningAtThePortOfDeparture: 'План порта отправления',
  Cargo_ContainerTracking: 'Отслеживание контейнеров',
  Cargo_ShipDynamicsAtThePortOfDestination: 'Движение судов в порту назначения',
  Cargo_CarryEmpty: 'Пустить пустоту',
  Cargo_TheActualDischarging: 'Фактическая разгрузка',
  Cargo_ReturnBox: 'Пустой.',
  Cargo_TheHomePageIsDisplayed: 'Главная страница Показать',
  Cargo_QuicklyConfigureSettings: 'Быстрая настройка',
  Cargo_QuickConfigurationIsCheckedByDefault: 'Быстрая настройка по умолчанию',
  Cargo_PleaseEnterAThemeTemplate: 'Введите шаблон темы',
  Cargo_PleaseEnterTheBodyTemplateContent: 'Введите текст шаблона',
  Cargo_PleaseEnterTheTemplateContent: 'Введите содержимое шаблона',
  Cargo_PleaseEnterAnExampleTemplate: 'Введите пример шаблона',
  Cargo_SOPPushObjectChannelRepeats: 'Повторение канала SOP push - объектов',
  Cargo_DataService: 'УПОД',
  Cargo_WarningRuleTips: 'После обновления состояния узла SOP соответствующая информация раннего предупреждения будет помечена как обработанная',
  Cargo_SopTemplateChangeTips: 'Соответствует новому шаблону SOP 【{0}】, Сохраняется ли оригинальный шаблон SOP?',
  Cargo_ApplyTheSopTemplateAs: 'Применить шаблон SOP для:',
  Cargo_TheNodeIsShutDown: 'Узлы закрыты.',
  Cargo_CanNotUploadFileOfNewContract: 'Новые несохраненные номера контрактов не могут быть загружены!',
  Cargo_OrderReceiving: 'Приемный ордер',
  Cargo_PrintTemplate: 'Печать шаблонов',
  Cargo_ControlObject: 'Объект управления',
  Cargo_ControlMode: 'Режим управления',
  SetDefaultType: 'Установить тип по умолчанию',
  DefaultFileType: 'Тип файла по умолчанию',
  DefaultType: 'Тип по умолчанию',
  Cargo_ActualPaymentAmount: 'Сумма платежа',
  Cargo_ReceivedAmount: 'Сумма поступления',
  Cargo_OcServiceCharge: 'Расходы OC',
  Cargo_ChannelServiceCharge: 'Платежи по каналам',
  Cargo_Abnormal: 'Необычно ли',
  Cargo_AbnormalState: 'Аномальное описание',
  Cargo_AbnormalRemark: 'Примечания',
  Cargo_ProcessedDate: 'Время обработки',
  Cargo_UpdateReceivedAmount: 'Изменить сумму счета',
  Cargo_AbnormalComment: 'Необычные примечания',
  Cargo_MarkAbnormal: 'Аномальная маркировка',
  Cargo_ValueAddedServices: 'Усл.доп.стоим.',
  Cargo_CustomsMode: 'Таможенная декларация',
  Cargo_ServiceType: 'Тип услуги',
  Cargo_PODServices: 'Услуги порта назначения',
  Cargo_POD: 'Порт назначения',
  Cargo_POL: 'Порт отправления',
  Cargo_InitData: 'Инициализация данных',
  Cargo_NotInitData: 'Существующие данные не могут быть инициализированы',
  Cargo_GeneratedVoucherInvoice: 'Номер счета - фактуры, содержащий генерированные документы:',
  Cargo_DownLoad_Summary: 'агр. шаблон агр.',
  Cargo_DownLoad_Detail: 'Загр. шаблоны',
  Cargo_Import_OnOrder: 'Импортировать заказ',
  Cargo_Not_Submit: 'Подтвердить отсрочку?',
  Cargo_Not_Approved: 'Только заказы могут быть отложены в пакете [bracket0]!',
  Cargo_Not_Submit_Please: 'Пожалуйста, выберите бизнес [bracket0]!',
  Cargo_Not_Submit_Batch_Success: 'Обновление состояния приостановлено',
  Cargo_Submit_Batch: 'Пожалуйста, выберите бизнес [bracket0]',
  Cargo_Submit_Pre_Qualification: 'Подтверждаете ли вы предварительный статус?',
  Cargo_Submit_Job: 'Операции, которые могут быть представлены только оптом 【Приостановление представления】',
  Cargo_Submit_Success: 'Заказы представлены',
  Cargo_OnlySelectedOneVoucher: 'Для экспорта можно выбрать только одну цифру.',
  Cargo_BatchSetCategory: 'Категория пакетной настройки',
  Cargo_ExportExcelTemplate: 'Экспорт шаблонов Excel?',
  Cargo_Run: 'Запуск',
  Cargo_ExcelTemplateExport: 'Экспорт отчетов Excel',
  CARGO_OFFICE_EMAIL_ISEMPTY: 'В настоящее время почтовый ящик филиала не обслуживается, пожалуйста, проверьте.',
  Cargo_ChangeChargeChanged: '{0} Первоначальная стоимость изменена (выставление счетов / счетов - фактур / заявок на оплату / списание и т.д.), пожалуйста, проверьте!',
  Cargo_SecondPolCode: '2 Порт отправления (код)',
  Cargo_SecondPol: 'Вторичный порт отправления',
  Cargo_SecondPodCode: 'Второй порт назначения (код)',
  Cargo_SecondPod: 'Второй порт назначения',
  Cargo_WaybillDestination: 'Пункт назначения накладной',
  Cargo_PolCountry: 'Страна / регион отправления',
  Cargo_IC: 'Международная авиакомпания',
  Cargo_IC_Master: 'Международные авиабилеты.',
  Cargo_IC_Basic: 'Международная подпись',
  Cargo_Settlement: 'Расчёт',
  Cargo_ReconciliationTab: 'Вкладка сверки',
  Cargo_BillTab: 'Вкладка счета',
  Cargo_CancelApprovalCheck: 'Выбранные данные включают операции, для которых уже отправлен BO. Отмена утверждения не допускается, пожалуйста, проверьте!',
  Cargo_BusinessPushStatus: 'Статус отправки бизнес-операций',
  Cargo_CostPushStatus: 'Статус отправки расходов',
  Cargo_AutoGenerateEnabled: 'Автоматически создавать?',
  Cargo_BusinessQuotationAmount: 'Сумма коммерческого предложения',
  Cargo_BusinessQuotationConfirmed: 'Коммерческое предложение подтверждено',
  Cargo_BusinessQuotationConfirmedCancel: 'Отмена подтверждения предложения',
  Cargo_OperationAllowedOnlyForUnconfirmedQuotation: 'Эта операция разрешена только для расходов с подтвержденным предложением "Нет"!',
  Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation: 'Эта операция разрешена только для расходов с коммерческим предложением не равным 0 и подтверждением предложения "Да"!',
  Cargo_VehicleModel: 'Модель автомобиля',
  Cargo_TypeKh: 'Каркас',
  Cargo_waybillInvoice: 'Информация о накладной',
  Cargo_customsMethodPol: 'Таможенная декларация',
  Cargo_transferAgent: 'Транспортный агент',
  Cargo_destinationAgent: 'Агент назначения',
  Cargo_dispatchingPlace: 'Место отправления',
  Cargo_dispatchingPlace2: 'Место получения / отправления',
  Cargo_dischargingPortCode: 'Место разгрузки (POD)',
  Cargo_transferPortCode: 'Место транзита',
  Cargo_loadingPortCode: 'Место отправления (POL)',
  Cargo_actAta: 'Фактическая дата прибытия (ATA)',
  Cargo_estEta: 'Предполагаемая дата прибытия (ETA)',
  Cargo_actAtd: 'Фактическая дата отгрузки (ATD)',
  Cargo_estEtd: 'Предполагаемая дата отгрузки (ETD)',
  Cargo_OrderCar: 'Бронирование',
  Cargo_DestinationDelivery: 'Доставка в пункт назначения',
  Cargo_trailerNumber: 'Регистрация',
  Cargo_polInfo: 'Информация о порту отправления',
  Cargo_estLandingTime: 'Ожидаемое время прибытия',
  Cargo_actLandingTime: 'Фактическое время прибытия',
  Cargo_estEntryTime: 'Прогнозируемое время прибытия.',
  Cargo_actEntryTime: 'Фактическое время прибытия',
  Cargo_estExitTime: 'Прогнозируемое время выезда.',
  Cargo_actExitTime: 'Фактическое время выезда',
  Cargo_estReplacementTime: 'Ожидаемое время перегрузки',
  Cargo_actReplacementTime: 'Фактическое время перегрузки',
  Cargo_declareTime: 'Время таможенной очистки',
  Cargo_transferInfo: 'транзитная информация',
  Cargo_declareCompletedTime: 'Время завершения транзита',
  Cargo_estShippingTime: 'Ожидаемое время отгрузки',
  Cargo_actShippingTime: 'Фактическое время отгрузки',
  Cargo_estArrivePodTime: 'Ожидаемое время прибытия на границу',
  Cargo_actArrivePodTime: 'Время фактического прибытия к границе пункта назначения',
  Cargo_estEnterPodTime: 'Предполагаемое время прибытия',
  Cargo_actEnterPodTime: 'Фактическое время прибытия',
  Cargo_estArriveClearTime: 'Ожидаемое время прибытия',
  Cargo_actArriveClearTime: 'Фактическое время прибытия',
  Cargo_estDischargeTime: 'Ожидаемое время разгрузки',
  Cargo_actDischargeTime: 'Фактическое время разгрузки',
  Cargo_estArriveTime: 'Ожидаемое время прибытия трейлера',
  Cargo_actArriveTime: 'Фактическое время прибытия прицепа',
  Cargo_estTakeTime: 'Ожидаемое время доставки трейлера',
  Cargo_actTakeTime: 'Фактическое время доставки',
  Cargo_estUnloadTime: 'Ожидаемое время разгрузки трейлера',
  Cargo_actUnloadTime: 'Фактическое время разгрузки прицепа',
  Cargo_podInfo: 'Отправка информации из порта назначения',
  Cargo_estWarehouseDeliveryTime: 'Ожидаемое время доставки на склад',
  Cargo_actWarehouseDeliveryTime: 'Фактическое время доставки на склад',
  Cargo_estGoodsDeliveryTime: 'Ожидаемое время доставки',
  Cargo_actGoodsDeliveryTime: 'Фактическое время доставки',
  Cargo_estReturnTime: 'Ожидаемое время',
  Cargo_actReturnTime: 'Фактическое время',
  Cargo_polPortInfo: 'Информация о порту отправления',
  Cargo_khLandingTime: 'Прибытие на берег',
  Cargo_khEntryTime: 'Въезд авиакомпании',
  Cargo_khExitTime: 'Экипаж',
  Cargo_khReplacementTime: 'Перегрузка в кэш',
  Cargo_khDeclare: 'таможенная декларация',
  Cargo_transferTransitInfo: 'транзитная информация',
  Cargo_transferDeclareCompleted: 'Транспортная декларация завершена',
  Cargo_transferShipping: 'Транзитные перевозки',
  Cargo_arriveDestinationBorder: 'Прибытие на границу назначения',
  Cargo_podClearInfo: 'Информация о таможенной очистке пункта назначения',
  Cargo_arrivePod: 'Прибытие в пункт назначения',
  Cargo_arriveClear: 'Прибытие в пункт таможенной очистки',
  Cargo_khUnloading: 'Каркасная разгрузка',
  Cargo_polExchangeInfo: 'Информация о разгрузке груза в месте отправления',
  Cargo_trailerLoad: 'Получение груза в трейлере',
  Cargo_trailerArrive: 'Приём трейлера',
  Cargo_trailerUnload: 'выгрузка прицепа',
  Cargo_podDeliveryInfo: 'Распространение информации',
  Cargo_warehouseDelivery: 'Поставка на склад',
  Cargo_goodsDelivery: 'Доставка',
  Cargo_podReturn: 'Пустой.',
  Cargo_estTime: 'Предполагаемое время',
  Cargo_actTime: 'Фактическое время',
  Cargo_secondPlateNumber: 'Номер второго номера.',
  Cargo_secondTrailerNumber: 'Двойной прицеп',
  Cargo_secondVehicleType: 'Двухходовой автомобиль',
  Cargo_secondEtd: 'Дата отгрузки',
  Cargo_secondPol: 'Место отправления',
  Cargo_secondPod: 'Пункт назначения',
  Cargo_secondLoadingTime: 'Время погрузки',
  Cargo_secondShippingTime: 'Время отправления',
  Cargo_secondArriveTime: 'Время прибытия',
  Cargo_secondDischargeTime: 'Время разгрузки',
  Cargo_secondTransportType: 'Способ перевозки',
  Cargo_bargeInfo: 'Информация о барже',
  Cargo_bargeEtd: 'Дата отгрузки баржи',
  Cargo_bargeAtd: 'Дата прибытия баржи',
  Cargo_bargePlateNumber: 'Номер баржи',
  Cargo_bargeTrailerNumber: 'прицеп - баржа',
  Cargo_bargePol: 'Место отправления баржи (POL)',
  Cargo_bargePod: 'Пункт назначения баржи (POD)',
  Cargo_ActualEntryTime: 'Фактическое время захода',
  Cargo_ActualLoadingTime: 'Фактическое время загрузки',
  Cargo_EstimatedDepartureTime: 'Ожидаемое время взлета',
  Cargo_ActualDepartureTime: 'Фактическое время взлета',
  Cargo_EstimatedArrivalTime: 'Предполагаемое время прибытия',
  Cargo_ActualArrivalTime: 'Фактическое время прибытия',
  Cargo_ActualBillingTime: 'Фактическое время получения',
  Cargo_ActualUnloadingTime: 'Фактическое время разгрузки',
  Cargo_ActualArrivalNotificationTime: 'Время фактического уведомления о прибытии',
  Cargo_ActualPickupTime: 'Фактическое время доставки',
  Cargo_EstimatedTransitArrivalTime: 'Ожидаемое время прибытия',
  Cargo_TransitArrivalTime: 'Время прибытия',
  Cargo_EstimatedTransitDepartureTime: 'Ожидаемое время взлета',
  Cargo_TransitDepartureTime: 'транзитное время взлёта',
  Cargo_bargeLine: 'Маршрутный код',
  Cargo_bargeCarrierId: 'Баржевая транспортная компания',
  Cargo_khPlateNumber: 'Номер бортового номера',
  Cargo_khPlateNum: 'Номерный знак',
  Cargo_PlateNums: 'Внутренний номерной знак',
  Cargo_khTrailerNumber: 'КАТ - прицеп',
  Cargo_TypeTc: 'Прицеп',
  Cargo_SyncTargetDocumentNo: 'Синхронизация номеров сертификатов',
  Cargo_PleaseChooseTargetDocumentNo: 'Пожалуйста, выберите запись с номером удостоверения.',
  Cargo_WriteOffInputFail: 'Из подлежащих списанию расходов есть подлежащие оплате расходы, которые не были обработаны или процесс подачи заявок на оплату не был завершен, списание не допускается!',
  Cargo_WriteOffInputFail2: 'Из подлежащих списанию расходов процесс подачи заявок на оплату кредиторской задолженности не завершен, списание не допускается!',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment: 'Операция не удалась, заявка на оплату находится в процессе утверждения оплаты, пожалуйста, сделайте это после завершения процесса.',
  Cargo_estimation: 'Предварительная оценка',
  Cargo_estimationAmount: 'Предварительная оценка',
  Cargo_CooperateBranchId: 'Кооперативный филиал',
  Cargo_EntrustBranchId: 'Делегирование',
  Cargo_CooperateBusinessType: 'Типы совместных операций',
  Cargo_BillingWeightActual: 'Расчетный вес (фактически)',
  Cargo_BillingWeightContract: 'Расчетный вес (комиссия)',
  Cargo_NumberOfItemsActual: 'Количество претензий (фактически)',
  Cargo_NumberOfItemsContract: 'Число претензий (Комиссия)',
  Cargo_VolumeActual: 'Объем (реальный)',
  Cargo_VolumeContract: 'Объем (КВ)',
  Cargo_GrossWeightContract: 'Вес брутто (КМ)',
  Cargo_GrossWeightActual: 'Вес брутто (реальный)',
  Cargo_CooperateStatus: 'Состояние сотрудничества',
  Cargo_BusinessStatusRemark: 'Примечания к рабочему статусу',
  Cargo_ChargeStatusRemark: 'Статус расходов',
  Cargo_CooperateStatusLog: 'Журнал изменений состояния сотрудничества',
  Cargo_BusinessStatusLog: 'Журнал изменений бизнес - статуса',
  Cargo_ChargeStatusLog: 'Журнал изменений состояния расходов',
  Cargo_AssociatedWithMasterTicket: 'Связаны ли основные векселя',
  Cargo_SelectCooperateBranch: 'Выбор кооперативного филиала',
  Cargo_CooperateBranchCannotBeEmpty: 'Кооперативный филиал не может быть пустым.',
  Cargo_CooperateBusinessTypeCannotBeEmpty: 'Тип совместной работы не может быть пустым.',
  Cargo_Cooperation: 'Сотрудничество',
  Cargo_CooperationReturn: 'Вернуть назад',
  Cargo_CooperateStatusApprovedCanTBeDeleted: 'Состояние совместной задачи проверено и не может быть удалено.',
  Cargo_AreYouSureUpdateState: 'Вы уверены, что хотите изменить статус?',
  Cargo_CooperateSucceed: 'Успешное сотрудничество',
  Cargo_CooperateLogOperation: 'Содержание операции',
  Cargo_CooperateLogState: 'Режим после операции',
  Cargo_CooperateLogContent: 'Подробности',
  Cargo_AreYouSureReturn: 'Вы уверены, что хотите вернуться?',
  Cargo_CooperateCreatedDate: 'Время создания совместной задачи',
  Cargo_CooperateReviewSeparately: 'В записи выбора есть совместный бизнес, пожалуйста, проверьте отдельно',
  Cargo_CooperateNoPretrialReview: 'Совместные операции не пересматриваются',
  Cargo_ShowCooperateAll: 'Больше информации о сотрудничестве',
  Cargo_SettleBranchId: 'Расчетная компания',
  Cargo_ShowInternalCharges: 'Показать внутренний узел',
  Cargo_InternalCharges: 'Внутренний узел',
  Cargo_IsCooperate: 'Это совместный бизнес, который может осуществляться только филиалом по приему заказов',
  Cargo_BranchCooperate: 'Компания помогает бизнесу',
  Cargo_DownLoad_Template: 'Загрузить шаблон',
  Cargo_EstimatedWarehousingTime: 'Предполагаемое время хранения',
  Cargo_ActualWarehousingTime: 'Фактическое время складирования',
  Cargo_EstimatedDeliveryTime: 'Ожидаемое время выхода',
  Cargo_ActualDeliveryTime: 'Фактическое время выхода',
  Cargo_SyncWarehouseData: 'Синхронизация данных складирования',
  Cargo_PleaseEnterActualWarehousingTime: 'Введите фактическое время хранения',
  Cargo_LockOrderTip: 'Все соответствующие операции будут обновлены до 【Проверено】, продолжается ли?',
  Cargo_RefreshTcloudToken: 'Обновить openToken',
  Cargo_SeaBooking: 'Морской заказ',
  Cargo_RailwayOperate: 'Железнодорожные операции',
  Cargo_IntegratedOperate: 'Комплексные логистические операции',
  Cargo_Timezone: 'Часовой пояс',
  Cargo_HiddenPlatform: 'Скрыть готовые шаблоны платформы',
  Cargo_TemplateName: 'Название шаблона',
  Cargo_PleaseEnterPlanRemark: 'Введите описание программы',
  Cargo_StartLine2: 'Начальная строка (включая заголовок)',
  Cargo_PleaseEnterStartLine: 'Введите начальную строку',
  Cargo_ImportTableSet: 'Импорт таблиц',
  Cargo_PleaseQuery: 'Поиск',
  Cargo_EnableFilterRowRule: 'Включить правила фильтрации строк',
  Cargo_ImportColumnsFilterOut: 'При импорте таблицы каждая строка данных в действительном столбце таблицы, соответствующая установленным здесь параметрам, будет отфильтрована.',
  Cargo_SpaceGreaterThan: 'Количество пробелов больше',
  Cargo_PleaseEnterHeaderName: 'Имя ячейки Excel: Введите имя заголовка таблицы, которое необходимо импортировать в таблицу Excel.',
  Cargo_PleaseEnterHeaderGridNum: 'Номер столбца блока Excel: Введите номер столбца, который необходимо импортировать в таблицу Excel, например: A、B、AA。',
  Cargo_AddNewTemplate: 'Создать шаблон импорта',
  Cargo_SerialNo: 'Серийный номер',
  Cargo_InternalTableName: 'Название внутренней таблицы',
  Cargo_ExcelCellName: 'Имя ячейки Excel',
  Cargo_DocumentEntry: 'Ввод таможенной документации',
  Cargo_QueryTags: 'Метка запроса',
  Cargo_ChargebackManage: 'Управление возвратом средств',
  Cargo_ReconciliationRule: 'Правила выверки',
  Cargo_ReconciliationRuleName: 'Название правила выверки',
  Cargo_MatchFieldSettings: 'Параметры поля совпадения',
  Cargo_PleaseSelectField: 'Выберите поле для сравнения',
  Cargo_Relationship: 'Отношения',
  Cargo_And: 'А',
  Cargo_Or: 'Или',
  Cargo_MatchingOrder: 'Порядок согласования',
  Cargo_MatchFieldName: 'Название поля',
  Cargo_CompareFieldOperations: 'Параметры поля сравнения',
  Cargo_SelectFieldToCompare: 'Выберите имя поля для сравнения',
  Cargo_CompareOrder: 'Порядок сравнения',
  Cargo_CompareField: 'Контрастное поле',
  Cargo_ComparisonOperation: 'Сравнительные операции',
  Cargo_MultiRowSumMethod: 'Многострочный метод агрегирования',
  Cargo_ComparisonSingleLine: 'Однострочный контраст',
  Cargo_AttachFilePlaneOrNot: 'Прилагается ли случайный файл',
  Cargo_FlightDate: 'Дата рейса',
  Cargo_OtherWarehousingInstructions: 'Прочие вводные примечания',
  Cargo_PhotoShootingAwait: 'Заходите на склад и фотографируйте список.',
  Cargo_PhotoShootingAwaitPallets: 'Установить доску для фотографирования',
  Cargo_DeleteSelected: 'Удалить выделение',
  Cargo_StartUploading: 'Начать загрузку',
  Cargo_Register: 'Регистрация',
  Cargo_Void: 'Отмена',
  Cargo_Unbind: 'Освободите.',
  Cargo_OrderPassingAgent: 'Агент по переуступке',
  Cargo_BusinessBookiingAgent: 'Агент бизнес - бронирования',
  Cargo_RegisteredDate: 'Дата получения',
  Cargo_EstimatedBackDate: 'Предполагаемая дата возвращения',
  Cargo_ActualBackDate: 'Фактическая дата возвращения',
  Cargo_FreightRateM: 'Тариф М',
  Cargo_FreightRateN: 'Тариф N',
  Cargo_FreightRate45: 'Тариф 45',
  Cargo_FreightRate100: 'Тариф 100',
  Cargo_FreightRate300: 'Тариф 300',
  Cargo_FreightRate500: 'Тариф 500',
  Cargo_FreightRate1000: 'Тариф 1000',
  Cargo_NewIATAFreightRate: 'Новые тарифы IATA',
  Cargo_EditIATAFreightRate: 'Изменить тарифы IATA',
  Cargo_DeliveryStation: 'Станция доставки',
  Cargo_FlightSchedule: 'Расписание рейсов',
  Cargo_Schedule: 'Продолжительность смены',
  Cargo_ArrivaledTime: 'Время прибытия',
  Cargo_Voyage: 'Период плавания',
  Cargo_MustBEntered: 'Необходимо ввести',
  Cargo_NewFlight: 'Новые рейсы',
  Cargo_EditFlight: 'Редактирование рейсов',
  Cargo_OneWayPort: 'Один порт',
  Cargo_SecondPort: 'Второй порт',
  Cargo_ThirdPort: 'Трехсторонний порт',
  Cargo_TransshipmentPort: 'Порт транзита',
  Cargo_NewLine: 'Новые линии',
  Cargo_EditLine: 'Изменить линию',
  Cargo_NewAirTransportationArea: 'Новые воздушные перевозки',
  Cargo_EditAirTransportationArea: 'Редактирование воздушного пространства',
  Cargo_RegionalPorts: 'Региональные порты',
  Cargo_OriginRegionCode: 'код зоны отправления',
  Cargo_TargetRegionCode: 'Код зоны назначения',
  Cargo_NewRoute: 'Новые маршруты',
  Cargo_ResponsibilityList: 'Список обязанностей',
  Cargo_ResponsibilityInformation: 'Информация об обязанностях',
  Cargo_ResponsibilityStep1: 'Шаг 1: Введение базовой информации об обязанностях',
  Cargo_ResponsibilityStep2: 'Шаг 2: Выбор маршрута',
  Cargo_ResponsibilityStep3: 'Шаг 3: Выбор авиакомпании',
  Cargo_ResponsibilityStep4: 'Шаг 4: Выбор характера бронирования',
  Cargo_ResponsibilityStep5: 'Шаг 5: Выбор аэропорта',
  Cargo_ResponsibilityStep6: 'Шаг 6: Выбор продаж',
  Cargo_ResponsibilityStep7: 'Шаг 7: Определение информации об обязанностях',
  Cargo_ResponsibilityNew: 'Новые оперативные обязанности',
  Cargo_ResponsibilityEdit: 'Функции редактирования',
  Cargo_QueryType: 'Тип запроса',
  Cargo_NotClearedToday: 'Накануне не сообщалось.',
  Cargo_ToBeClearedToday: 'В тот же день рейс',
  Cargo_DeclarationTheSameDay: 'Таможенная декларация в тот же день',
  Cargo_InculdeHistoricalData: 'Включает исторические данные',
  Cargo_DeclarationTracking: 'Отслеживание таможенной декларации',
  Cargo_FlightTracking: 'Отслеживание рейсов',
  Cargo_ModifyDeclarationBatches: 'Массовое изменение таможенного статуса',
  Cargo_PrintedTag: 'Метки',
  Cargo_PrintTag: 'Печать тегов',
  Cargo_CheckData: 'Проверка данных',
  Cargo_AWBQuantity: 'Количество единиц',
  Cargo_AWBWeight: 'Валовой вес',
  Cargo_AWBVolume: 'Удельный объем',
  Cargo_GoodsSize: 'Размер груза',
  Cargo_ActualFlight: 'Фактический рейс',
  Cargo_OnwardInformation: 'Информация о продолжении',
  Cargo_AttachmentDescription: 'Примечания',
  Cargo_CustomsDeclarationStatus: 'Статус таможенной декларации',
  Cargo_NumberDeclaration: 'Количество таможенных деклараций',
  Cargo_DeclarationGrossWeight: 'Таможенный вес брутто',
  Cargo_CustomsDeclarationRemarks: 'Примечания к таможенной декларации',
  Cargo_DeleteAccountingEntry: 'Удалить запись',
  Cargo_Assets: 'Активы',
  Cargo_LineNo: 'Строка',
  Cargo_LiabilitiesOwner: 'Обязательства и права собственников (или акционеров)',
  Cargo_LineNo2: 'Строка',
  Cargo_OpeningAmountOfTheYear2: 'На начало года',
  Cargo_PeriodEndAmount2: 'Конечное число',
  Cargo_AmountOfMonth: 'Сумма в этом месяце',
  Cargo_AmountOfYear: 'Совокупная сумма за текущий год',
  Cargo_TrackingTipOne: 'Этот значок используется в системе B2B!',
  Cargo_TrackingTipTwo: 'Примечание: Для загрузки рекомендуется использовать белый формат png с пиктограммами размером не более 500 КБ.',
  Cargo_WarehouseMapTip: 'Примечание: Рекомендуется загрузить карту склада в формате PNG / JPG.',
  Cargo_UploadDataSizeMore500KB: 'Размер файла не должен превышать 500 КБ!',
  Cargo_RuleNotesTip: 'Примечания могут быть заполнены, чтобы пользователи могли просматривать соответствующие советы по примечаниям при использовании.',
  Cargo_MainOrderRegistr: 'Регистрация основного листа',
  Cargo_MainOrderStart: 'Основной исходный номер',
  Cargo_TotalCopies: 'Всего',
  Cargo_LastUpdateTime: 'Время последнего обновления',
  Cargo_AddBranch: 'Добавить филиал',
  Cargo_CopyBranch: 'Подразделение копирования',
  Cargo_EORIDetail: 'EORI Подробнее',
  Cargo_DeleteEORITip: 'Невозможно восстановить после удаления EORI, подтвердить удаление?',
  Cargo_EORINotNull: 'ЭОРИ не может быть пустым',
  Cargo_EORINotDuplicate: 'ЭОРИ не может повториться',
  Cargo_AddDept: 'Добавить раздел',
  Cargo_BranchCnName: 'Китайское название филиала',
  Cargo_ChineseAddress: 'Китайский адрес',
  Cargo_BranchEnName: 'Английское название филиала',
  Cargo_BranchCode: 'Код филиала',
  Cargo_PostalCode: 'Почтовый индекс',
  Cargo_Email: 'Электронная почта',
  Cargo_LocalCurrency2: 'Местная валюта',
  Cargo_DefaultAirport: 'Аэропорт по умолчанию',
  Cargo_DefaultHarbor: 'Порт по умолчанию',
  Cargo_DefaultTimeZone: 'Часовой пояс по умолчанию',
  Cargo_RMBAccount: 'Платежный счет в юанях',
  Cargo_USDAccount: 'Платежный счет в долларах США',
  Cargo_ReceiveRMBAccount: 'Счет для поступлений в юанях',
  Cargo_ReceiveUSDAccount: 'Счет для поступлений в долларах США',
  Cargo_DefaultPaymentAccount: 'По умолчанию (оплата)',
  Cargo_DefaultReceiveAccount: 'По умолчанию (поступления)',
  Cargo_OverseasBillingAddress: 'Зарубежный адрес счета',
  Cargo_DomesticBillingAddress: 'Внутренний адрес счета',
  Cargo_OverseasEDICode: 'Зарубежный код EDI',
  Cargo_ValueAddedTaxRate: 'Ставка наценки',
  Cargo_InvoicingTaxRate: 'Налоговая ставка',
  Cargo_SettleEmail: 'Расчетный почтовый ящик',
  Cargo_TaxationSystemAPIAddress: 'Адрес интерфейса налоговой системы',
  Cargo_TaxControlMachineNo: 'Номер налогового контроля',
  Cargo_ElectronicInvoicePlatformCode: 'Электрический код платформы',
  Cargo_ElectronicInvoice: 'Электрический код.',
  Cargo_ElectronicInvoiceTaxpayer: 'Идентификационный номер налогоплательщика',
  Cargo_ElectronicInvoiceAuthCode: 'Электрический код разрешения налогоплательщика',
  Cargo_ElectronicInvoiceRequestAddress: 'Адрес запроса на обслуживание билетов',
  Cargo_InvoiceCancellationRequestAddress: 'Адрес запроса об аннулировании счета - фактуры',
  Cargo_EFreighAMSAccount: 'E - Freigh (счет AMS)',
  Cargo_EFreighACIAccount: 'E - Freigh (счет ACI)',
  Cargo_Preview: 'Предварительный просмотр',
  Cargo_NewBranchInformation: 'Новая информация о филиале',
  Cargo_AssociatePartners: 'Ассоциированные партнеры',
  Cargo_AddRole: 'Добавить роль',
  Cargo_DepartmentCode: 'Секторальный код',
  Cargo_JobNumberCodeField: 'Поле кодирования рабочего номера',
  Cargo_SettlementCompanyIsOrNot: 'Является ли расчетная компания',
  Cargo_Introduction: 'Введение',
  Cargo_EnableOpen: 'Открыть',
  Cargo_DisableOpen: 'Закрыть',
  Cargo_GeneralSettings: 'Настройки компании Application General',
  Cargo_ControlMode2: 'Режим управления:',
  Cargo_ReminderMode: 'Режим напоминания',
  Cargo_LockMode: 'Режим блокировки',
  Cargo_Notification: 'Уведомление напоминает:',
  Cargo_LockingControl: 'Управление блокировкой:',
  Cargo_Event: 'События',
  Cargo_NotificationMethod: 'Форма уведомления',
  Cargo_NotificationObject: 'Объект уведомления',
  Cargo_BLRelease: 'коносамент',
  Cargo_NoLock: 'Никаких накладных.',
  Cargo_NewOrCopyJob: 'Новые / размноженные официальные операции',
  Cargo_LockAfterSaving: 'Сохранить после блокировки',
  Cargo_CannotBeSaved: 'Невозможно сохранить',
  Cargo_JobSheetIsLocked: 'Бизнес заблокирован.',
  Cargo_JobSheetIsUnlocked: 'Операция разблокирована.',
  Cargo_CreditLimitExceeded2: 'Доверие превышает',
  Cargo_CreditLimitChanged: 'Контролируемые изменения',
  Cargo_CreditForewarning: 'Раннее предупреждение',
  Cargo_PaymentPeriodForewarning: 'Раннее предупреждение',
  Cargo_CreditControlManager: 'Контролер',
  Cargo_TemplateManagement: 'Управление шаблонами',
  Cargo_TemplateTypeManagement: 'Управление типами шаблонов',
  Cargo_ConfigurationManagement: 'Управление конфигурацией',
  Cargo_MappingManagement: 'Управление отображением',
  Cargo_InitializeTemplateManagement: 'Управление шаблонами инициализации',
  Cargo_BusinessStatusManagement: 'Управление оперативным положением',
  Cargo_TriggerTypeManagement: 'Управление типами запуска',
  Cargo_FileTypeManagement: 'Управление типами файлов',
  Cargo_DefaultValueManagement: 'Управление значениями по умолчанию',
  Cargo_ValidationRuleConfiguration: 'Настройка правил проверки',
  Cargo_EDITemplateSettings: 'Параметры EDI',
  Cargo_OnlineShippingOrderSettings: 'Морские перевозки в режиме онлайн',
  Cargo_RouteAndWarehouseConfiguration: 'Предварительная конфигурация маршрута / порта',
  Cargo_PushServiceConfiguration: 'Настройка службы push',
  Cargo_CustomInvoiceRemarks: 'Пользовательские примечания к счетам - фактурам',
  Cargo_EmailTemplateManagement: 'Управление шаблонами почтовых ящиков',
  Cargo_BillOfLadingConfiguration: 'Параметры размещения',
  Cargo_BranchBankAccount: 'Номер банковского счета филиала',
  Cargo_SetRMBAccount: 'Установить учетную запись RMB по умолчанию',
  Cargo_SetUSDAccount: 'Установить учетную запись USD по умолчанию',
  Cargo_SetReceiveRMBAccount: 'Установить счет поступлений в юанях по умолчанию',
  Cargo_SetReceiveUSDAccount: 'Установить счет поступлений в долларах США по умолчанию',
  Cargo_SetDefaultPaymentAccount: 'Установить счет оплаты по умолчанию',
  Cargo_SetDefaultReceiveAccount: 'Установить счет поступлений по умолчанию',
  Cargo_ShortName: 'Сокращения',
  Cargo_Instructions: 'Примечания',
  Cargo_BankChineseAddress: 'Китайский адрес банка',
  Cargo_BankEnglishAddress: 'Английский адрес банка',
  Cargo_BankCode: 'Номер банковского счета',
  Cargo_HeaderTitle: 'Принадлежащий заголовок',
  Cargo_ClosingAccountRecord: 'Отчет о закрытии счетов',
  Cargo_ClosingAccountReview: 'Проверка закрытия счетов',
  Cargo_EditConfigurationItem: 'Изменить параметр конфигурации',
  Cargo_SelectClosingAccountDate: 'Выберите дату закрытия счета',
  Cargo_EditConfigurationDefinition: 'Изменить определение конфигурации:',
  Cargo_CreditLimitExceededApproval: 'После превышения управления письмом блокируйте рабочий лист до автоматической разблокировки или искусственного выделения',
  Cargo_CreditOnlyReminder: 'После того, как управление письмом превышено, отправьте только напоминание, рабочий лист не будет заблокирован',
  Cargo_OperationExecutive: 'Руководитель операций',
  Cargo_SalesExecutive: 'Руководитель отдела продаж',
  Cargo_CreditControlSupervisor: 'Контролер',
  Cargo_BusinessCustomerService: 'Оперативное обслуживание клиентов',
  Cargo_EmailsAndReminders: 'Почта и напоминания',
  Cargo_Bell2: 'Колокольчик внутри станции',
  Cargo_Email2: 'Почта',
  Cargo_BatchAddRolePermissions: 'Добавление прав на роль в пакете',
  Cargo_RoleName: 'Название роли',
  Cargo_PermissionName: 'Имя прав',
  Cargo_PermissionCategory: 'Класс полномочий',
  Cargo_PermissionType: 'Тип разрешения',
  Cargo_PermissionPoint: 'Точка доступа',
  Cargo_UpdatePermissionGroups: 'Обновить группу прав',
  Cargo_Personal2: 'Персонал',
  Cargo_DepartmentGroups: 'Секторальные группы',
  Cargo_GreaterRemove: 'Удалить > >',
  Cargo_LessAdd: '< < Добавить',
  Cargo_PleaseEnterNameEtc: 'Введите китайское имя, английское имя, почтовый ящик и другие нечеткие запросы...',
  QuickSearchUser: 'Быстрый поиск: логин, китайское имя, английское имя, почтовый ящик',
  Cargo_Expired: 'Срок действия истек',
  Cargo_NearExpiration: 'Предстоящий период',
  Cargo_NotVetDueEytended: 'Срок не истек / продлен',
  Cargo_History: 'История',
  Cargo_QuickSearchContractNumber: 'Быстрый поиск: номер контракта',
  Cargo_Reminder30Day: 'Советы: В течение 30 дней система устанавливается как временная',
  Cargo_PleaseSelectContractRecord: 'Выберите запись контракта.',
  Cargo_ContractAgreement: 'Договорное соглашение',
  Cargo_WhetherBookingConfirmation: 'Загрузили ли вы штамп бронирования',
  Cargo_IsContractAgreementUploaded: 'Загружено ли договорное соглашение',
  Cargo_ContractProhibitedOperated: 'Контракт был продлен, эксплуатация запрещена.',
  Cargo_NeedToUpdateOrNot: 'Требуется ли обновление',
  Cargo_ContractCreator: 'Учредитель договора',
  Cargo_ContractCreationTime: 'Время создания договора',
  Cargo_PartnerCreation: 'Партнеры Создатели',
  Cargo_ContractAuditor: 'Лица, проверяющие контракты',
  Cargo_ContractAuditTime: 'Сроки рассмотрения контрактов',
  Cargo_TimeLeftUntilExpiry: 'Остаток до истечения срока',
  Cargo_DayRemind: 'Небесное напоминание',
  Cargo_NoteReminderMethod: 'Примечание: Способ напоминания:"Системные напоминания"Система будет напоминать об этом за 2 дня до истечения срока действия.',
  Cargo_ProhibitBusinessConfiguration: 'Запрещается создание бизнес - конфигурации:',
  Cargo_SettlementMethodGreaterThan0: 'Способ расчета: указанная дата в месяц или период счета больше 0',
  Cargo_ViewContract: 'Посмотреть контракт',
  Cargo_PaymentTermPeriod: 'Период счета',
  Cargo_WeekSettlement: 'Периодический узел',
  Cargo_EveryMonth: 'Ежемесячно',
  Cargo_Day: 'День',
  Cargo_CAN_NOT_APPROVED: 'Выбранные данные содержат состояние {0} бизнеса, не допускается аудит, пожалуйста, проверьте!',
  Cargo_CAN_NOT_CANCEL_APPROVED: 'Выбранные данные содержат {0} статус бизнеса, статус бизнеса, не позволяет отменить аудит, пожалуйста, проверьте!',
  Cargo_HasOneOnly: 'Пожалуйста, выберите только одну запись!',
  Cargo_CloseAndCopySerialNumber: 'Закрыть и скопировать поточный номер',
  Cargo_QuickSearchBillPayment: 'Быстрый поиск: номер заявки на оплату',
  Cargo_AmsNoTooltip: 'Рекомендуется, чтобы при отправке сообщения EDI количество символов AMS NO не превышало 12 бит.',
  Cargo_AmsNoEFreightTooltip: 'Рекомендуется, чтобы при отправке сообщения EDI количество символов AMS NO не превышало 12 бит, при этом префикс, равный Nvocc Scac, удаляется.',
  Cargo_AmsNoLengthTooltip: 'Количество символов AMS NO превысило 12 бит, продолжается ли отправка?',
  Cargo_AmsShipperLine1tip: 'Совет: Если имя NAME слишком длинное, его можно сразу же заполнить в ADDRESS1.',
  Cargo_AmsUnitTypeTip: 'Может поддерживать код отображения « антитеррористического упаковочного кода» в конфигурации отображения',
  Cargo_VoyageFlightLengthTooltip: 'Voyage не должен превышать 5 символов.',
  Cargo_VoyageFlightSpecialCharactersTooltip: 'В строке Voyage есть специальные символы, которые продолжают отправляться? После внесения изменений рекомендуется продолжить отправку!',
  Cargo_BargeRemarks: 'Реферат баржи',
  Cargo_CalcRuleNotes: 'Примечания к правилам расчета',
  Cargo_NotSupportStartOldApprove: '【Заявки на оплату】 Больше не поддерживается инициирование одобрения, пожалуйста, перейдите в 【Заявки на оплату (новая версия)】, чтобы начать утверждение.',
  Cargo_Pending: 'Подлежит обработке',
  Cargo_Processing: 'В процессе обработки',
  Cargo_Completed1: 'Завершено',
  Cargo_Revoked: 'Отменено',
  Cargo_StartTime: 'Время запуска',
  Cargo_StartDate: 'Дата начала',
  Cargo_ProcessName: 'Название процесса',
  Cargo_ApprovalSerialNumber: 'Утверждение водяного знака',
  Cargo_ApprovalDate: 'Дата утверждения',
  Cargo_Approver: 'Лицо, утверждающее',
  Cargo_ApprovalTemplate: 'Образец утверждения',
  Cargo_ProcessingStatus: 'Режим обработки',
  Cargo_PleaseFill: 'Заполните, пожалуйста.',
  Cargo_PleaseMaintain: 'Поддерживайте, пожалуйста.',
  Cargo_MessageNotificationMethod: 'Форма уведомления',
  Cargo_AreYouSureAboutTheModificationProcess: 'Решили изменить процесс?',
  Cargo_AreYouSureAboutTheModificationProcessTips: 'После подтверждения изменений процесс обработки будет продолжаться в соответствии с процессом, который был запущен. Последующие процессы будут осуществляться в соответствии с измененными процессами.',
  Cargo_SetUpTheProcessTriggerCondition: 'Установите условия запуска процесса.',
  Cargo_CurrentApprover: 'Нынешний утверждающий',
  Cargo_Initiator: 'Инициатор',
  Cargo_ApprovalRecord: 'Отчет об утверждении',
  Cargo_SelectTheApprover: 'Выбор утверждающего',
  Cargo_RoleSelection: 'Выбор роли',
  Cargo_ReviewTheProcessRecord: 'Просмотр записей процессов',
  Cargo_BatchApproval: 'Согласие партии',
  Cargo_BatchReject: 'Массовый отказ',
  Cargo_TerminateTheProcess: 'Прекратить процесс',
  Cargo_ApprovalComments: 'Утверждение заключений',
  Cargo_ApprovalTime: 'Время утверждения',
  Cargo_ApprovalCommentsRecord: 'Отчет об утверждении',
  Cargo_IInitiated: 'Я начал.',
  Cargo_IDealWithIt: 'Я всё уладил.',
  Cargo_SubmitAPaymentRequestForApproval: 'Представление заявок на оплату',
  Cargo_Approving: 'Утверждение',
  Cargo_ThereIsDuplicateData: 'Наличие дублирующих данных',
  Cargo_SelectTheApprovalPosition: 'Выбор должности',
  Cargo_FilterDimension: 'Основа фильтрации',
  Cargo_FilterValue: 'Значение фильтрации',
  Cargo_ReviewTheApprovalProcess: 'Посмотреть процесс утверждения',
  Cargo_Committed: 'Представлено.',
  Cargo_Agreed: 'Согласен',
  Cargo_Opinion: 'Замечания',
  Cargo_ReviewWithdrawal: 'Проверка отозвана',
  Cargo_ProcessRevocation: 'Отмена процесса',
  Cargo_AlreadyWithdraw: 'Снято',
  Cargo_NoHandlingRequired: 'Не требуется',
  Cargo_MyApprovals: 'Мое разрешение.',
  Cargo_ApprovalsThatIInitiated: 'Разрешение, которое я инициировал.',
  Cargo_ApprovalsThatIHandle: 'Разрешение, которым я занимаюсь.',
  Cargo_CreateProcess: 'Создать процесс',
  Cargo_EditProcess: 'Изменить процесс',
  Cargo_CopyProcess: 'Процесс копирования',
  Cargo_DeleteProcess: 'Удалить процесс',
  Cargo_ProcessComment: 'Примечания к процессу',
  Cargo_RevertProcessStatus: 'Статус процесса отмены',
  Cargo_RevertProcess: 'Процесс отмены',
  Cargo_RejectProcess: 'Процесс отказа',
  Cargo_NotificationEmailCC: 'Сообщение отправителю',
  Cargo_Irrevocable: 'Необратимый',
  Cargo_BindApprovalTemplate: 'Шаблон утверждения привязок',
  Cargo_ApplicationBusinessDivision: 'Подразделение прикладных операций',
  Cargo_ProcessTriggerCondition: 'Условия запуска процесса',
  Cargo_TriggerConditionConfiguration: 'Настройка условий запуска',
  Cargo_ApproverSource: 'Источник утверждения',
  Cargo_ApproverExecutionMode: 'Порядок исполнения',
  Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor: 'Первый узел является начальником инициатора, а следующий узел - руководителем утверждающего лица предыдущего узла',
  Cargo_AnyApproverCanHandle: 'С любым из них можно справиться.',
  Cargo_AllApproversAtCurrentNodeRequired: 'Требуются все рецензенты текущего узла.',
  Cargo_TheNumberOfApprovalsInProgress: 'Количество текущих разрешений',
  Cargo_NotNamed: 'Без названия',
  Cargo_AdministratorSettings: 'Настройки администратора',
  Cargo_FormName: 'Название формы',
  Cargo_NumberOfConfigurableBranches: 'Количество настраиваемых ветвей',
  Cargo_ExistDocumentPlatformConfig: 'Этот филиал уже существует в состоянии этой формы для включения, пожалуйста, подтвердите, что операция выполнена после',
  Cargo_InitiateApproval: 'Начало рассмотрения и утверждения',
  Cargo_InitiateApprovalSuccessfully: 'Начало процесса утверждения прошло успешно.',
  Cargo_AreYouSureToInitiateTheApproval: 'Подтверждаете начало проверки?',
  Cargo_AreYouSureToDo: 'Подтвердить {0}?',
  Cargo_AgreeToTheApproval: 'Согласие на утверждение',
  Cargo_RejectApproval: 'Отказ в разрешении',
  Cargo_InitiateBranchCompany: 'Инициировать филиал',
  Cargo_ApplicationBranch1: 'Прикладные филиалы',
  Cargo_InitiateDepartment: 'Инициатор',
  Cargo_WhetherItIsEnabled: 'Включено',
  Cargo_Deactivate: 'Отключение',
  Cargo_PleaseSelectTenantId: 'Выберите ID платформы',
  Cargo_PleaseSelectOfficeIds: 'Пожалуйста, выберите филиал',
  Cargo_PleaseSelectDocumentConfigId: 'Выберите имя формы',
  Cargo_PleaseSelectBranchCount: 'Выберите число разделов',
  Cargo_PleaseSelectUserIds: 'Выберите параметры администратора',
  Cargo_DocumentPlatformConfigNote: 'Примечание: Администратор может просматривать все потоки утверждения, связанные с формой.',
  Cargo_AddBranchProcess: '+ Добавить ветвь процесса',
  Cargo_Priority: 'Приоритеты',
  Cargo_TriggerConditions: 'Условия запуска',
  Cargo_PleaseSelectDocumentConfigId2: 'Выберите форму привязки',
  Cargo_AddBranchProcessCheck: 'Количество разделов текущей формы достигло верхнего предела.',
  Cargo_BindForm: 'Форма привязки',
  Cargo_UnknownProcessProcessing: 'Неизвестный процесс',
  Cargo_AutoWriteOffAfterApproval: 'Автоматическое списание после одобрения',
  Cargo_Bell: 'Колокольчик',
  Cargo_NotifierSource: 'Источник копии',
  Cargo_PreconditionsForApproval: 'Предварительные условия утверждения',
  Cargo_RuleConditions: 'Правило',
  Cargo_ConditionalItem: 'Условия',
  Cargo_ConditionalRule: 'Условия',
  Cargo_ConditionalValue: 'Условное извлечение',
  Cargo_RejectMethod: 'Способ отказа',
  Cargo_AllowDirectReturnToInitiator: 'Разрешить прямой возврат спонсору',
  Cargo_ReturnToTheInitiatingNode: 'Вернуться к стартовому узлу',
  Cargo_Returned2: 'Вернут',
  Cargo_RefuseAndReturnNode: 'Примечание: Отказ = возврат предыдущего узла, возврат = возврат стартового узла.',
  Cargo_RefuseTitle: 'Назад к предыдущему узлу',
  Cargo_ReturnTitle: 'Вернуться к стартовому узлу',
  Cargo_BillPaymentUpdateFail: 'Не удалось обновить платежную заявку.',
  Cargo_OneClickCopy: 'Копирование одним нажатием',
  Cargo_OneClickCopyNote: 'Примечание: Все утвержденные водяные номера могут быть скопированы путем нажатия кнопки « Копирование одним нажатием» для последующего массового запроса.',
  Cargo_OneClickCopyNoteBillPaymentApply: 'Примечание: Все номера заявок могут быть скопированы путем нажатия кнопки « Копирование одним нажатием» для последующего массового запроса.',
  Cargo_SubmitException: 'Отправить аномалию',
  Cargo_ApprovalException: 'Необычное разрешение',
  Cargo_PriceType: 'Пожалуйста, выберите цену перед портом, цену магистральной линии или цену последней мили. Должен быть выбран хотя бы один тип запроса',
  Cargo_AccountPeriodRemainingDays: 'Количество дней, остающихся на счетах',
  Cargo_WorkflowsBranchCountNotNull: 'Количество рабочих процессов не может быть пустым',
  Cargo_WorkflowsPlatformConfigRepeat: 'Этот филиал уже существует в состоянии этой формы для включения, пожалуйста, подтвердите, что операция выполнена после',
  Cargo_PleaseSelectUser: 'Выберите администратора этого процесса',
  Cargo_Initiate: 'Инициирование',
  Cargo_InitiateForm: 'Запуск формы',
  Cargo_ApprovalMatters: 'Вопросы утверждения',
  Cargo_SelectApprovalWithSameTemplate: 'Пожалуйста, выберите одно и то же"Шаблоны утверждения"Вопросы утверждения',
  Cargo_SOPPanelNodeNotDisplayed: 'SOP панель не отображает этот узел',
  Cargo_SOPPanelNoDataHide: 'SOP панель автоматически скрывается, если данных нет',
  Cargo_TaxInputConfig: 'Конфигурация входного налога',
  Cargo_ReceiptInvoiceTitle: 'Заголовок счета',
  Cargo_ReceiptInvoiceChannel: 'Канал выставления счета',
  Cargo_InvoiceAssociation: 'Связь с накладной',
  Cargo_ManualUpdate: 'Ручное обновление',
  Cargo_GetInvoice: 'Получить счет-фактуру',
  Cargo_InvoiceTime: 'Время выставления счета',
  Cargo_SellerName: 'Название продавца',
  Cargo_SellerTaxNumber: 'Налоговый номер продавца',
  Cargo_BuyerName: 'Название покупателя',
  Cargo_BuyerTaxNumber: 'Налоговый номер покупателя',
  Cargo_InvoicePool: 'Пул счетов-фактур',
  Cargo_InvoicePoolReceiving: 'Получение счетов в пуле',
  Cargo_WriteOffBank: 'Банки - кредиторы',
  Cargo_DepartureStation: 'исходящая станция',
  Cargo_DestinationStation: 'Станция назначения',
  Cargo_TransitStation: 'Пункт пересечения границы',
  Cargo_TransferStation: 'Транспортная станция',
  Cargo_QuickApprovalMode: 'Один и тот же подход к утверждению для разных узлов',
  Cargo_AutoAgree: 'Автоматическое согласие',
  Cargo_PressToDo: 'торопить',
  Cargo_CarbonCopy: 'Копировать',
  Cargo_ApplicationDimension: 'Испрашиваемое измерение',
  Cargo_ApplicationCode: 'Код заявки',
  Cargo_TotalReceivable: 'Общая дебиторская задолженность',
  Cargo_TotalDues: 'Общая кредиторская задолженность',
  Cargo_PackingType: 'Тип упаковки',
  Cargo_ViewChargeDetails: 'Посмотреть подробную информацию о расходах',
  Cargo_StartingPort: 'Порт отправления',
  Cargo_SubmitJobChargeForApproval: 'Представление заявок на утверждение оперативных расходов',
  Cargo_SubmitJobChargeTip: 'Этот бизнес билетов должен сначала начать процесс утверждения представления, процесс должен быть автоматически представлен после прохождения, а неудачная подача не удалась. \ n Вы хотите приступить к утверждению сейчас?',
  Cargo_SubmitJobChargeFailTip: 'В отсутствие сопоставимого процесса утверждения расходов, пожалуйста, свяжитесь с руководителем, чтобы улучшить триггерные условия в процессе утверждения, чтобы возобновить представление.',
  Cargo_BillHasBeenInitiatedForApproval: 'Этот счет был инициирован для утверждения, вы можете подписать страницу списка утверждения « Я инициирую», чтобы увидеть прогресс утверждения и детали утверждения.',
  Cargo_SubmitInvoiceFailTip: 'В отсутствие согласованного процесса утверждения выставления счетов, пожалуйста, свяжитесь с руководителем, чтобы улучшить условия запуска в процессе утверждения и перезапустить представление.',
  Cargo_SubmitInvoiceTip: 'Начните процесс утверждения перед выпиской билета, вы хотите начать процесс утверждения сейчас?',
  Cargo_SOURCE_CURRENCY_NOT_NULL: 'Валюта не может быть пустой!',
  Cargo_SOURCE_AMOUNT_NOT_NULL: 'Валюта не может быть пустой!',
  Cargo_imWarning: 'В настоящее время у job недостаточно персонажей, чтобы открыть чат Volbank.',
  Cargo_ReceiptPaymentOffset: 'Возмещение авансовых платежей',
  Cargo_InvoicePayableOffset: 'Возмещение эксплуатационных расходов',
  Cargo_CheckFreightTermOne: '"{0}" В случае условий перевозки {1} и {2} не должны быть пустыми',
  Cargo_CheckFreightTermTwo: '"{0}"  Когда условия перевозки, {1} не должны быть пустыми',
  Cargo_ThirdTableCheck: 'Промежуточная таблица третьей стороны отправлена и не работает',
  Cargo_CheckMergeExport: 'Кредиторская задолженность по счетам - фактурам и авансовым авизо суммируются и экспортируются таким образом, что другие виды документов не могут быть включены в учетную запись. Проверьте, пожалуйста.',
  CargoMsg_QQ: 'QQ',
  CargoMsg_CorporateName: 'Название юридического лица',
  Cargo_DeleteUnApprovedBillTips: 'Удалить только неоплаченные счета!',
  Cargo_EditUnApprovedBillTips: 'Можно редактировать только неоплаченные счета!',
  Cargo_DeleteUnApprovedInvoiceTips: 'Удалить только неутвержденные счета!',
  Cargo_InvalidUnApprovedInvoiceTips: 'Можно отменить только неоплаченные счета!',
  Cargo_InvoiceID: 'Идентификатор счета - фактуры',
  Cargo_PleaseSelectNeedInvalidBillPaymentTip: 'Пожалуйста, выберите платежную заявку, которая должна быть аннулирована.',
  Cargo_Deleted: 'Удалено',
  Cargo_EnableSopTemplate: 'Включить текущий шаблон SOP',
  Cargo_UnableSopTemplate: 'Отключить текущий шаблон SOP',
  Cargo_EnableSopTemplateConfirm: 'Подтвердить включение текущего шаблона SOP?',
  Cargo_UnableSopTemplateConfirm: 'Подтвердить отключение текущего шаблона SOP? После отключения бизнес не может применить этот шаблон. Но это не повлияет на бизнес, который уже использует этот шаблон.',
  Cargo_Disabled2: '(Запрещено)',
  Cargo_Got_It: 'Понял.',
  Cargo_Canceled: 'Отменено',
  Cargo_RepeatGoldenTaxExport: 'Не повторяйте налоговый экспорт.',
  Cargo_UpdateCustomerInfo: 'Обновление информации о клиентах',
  Cargo_SyncCustomerData: 'Синхронизация данных клиентов',
  Cargo_Synchronizing: 'Синхронизируется, пожалуйста, проверьте позже',
  Cargo_Prediction: 'Прогноз',
  Cargo_PlaceOfDeliveryRegion: 'Место доставки (регион)',
  Cargo_IsTransfer: 'Является ли транзитом',
  Cargo_TotalAmountTax: 'Общая сумма налогов (счет - фактура)',
  Cargo_CustomerNotOwn: '【Подразделение - заказчик】 Несоответствие между филиалом и текущей компанией',
  Cargo_SimilarPartners: 'Уже существует 【{0}】 и т. Д. {1} Компании с аналогичными названиями',
  Cargo_GoBackSuccess: 'Вернуть успех!',
  Cargo_SendBackSuccess: 'Оформление успешно!',
  Cargo_AddSignature: 'Подписано',
  Cargo_Appoint2: 'Назначение',
  Cargo_Appointer: 'Назначить кого',
  Cargo_ApproverRepeat: 'Утверждающий не допускает повторения',
  Cargo_ApproverAndAppointerRepeat: 'Пользователь не может одновременно владеть"Лицо, утверждающее"А"Лицо, утверждающее"Личность',
  Cargo_CancelAddSignature: 'Не для себя."Отменить подпись"',
  Cargo_CancelAddSignatureNotSupport: 'Пользователи"Утверждено"Или"Назначен"Не поддерживается"Отменить подпись"',
  Cargo_RuleError: 'Изменение типа формы, ошибка конфигурации правил процесса',
  Cargo_SelectCcTo: 'Выбор отправителя',
  Cargo_SelectSigner: 'Выберите подписавшего',
  Cargo_SelectTransferor: 'Выбрать подписавшего',
  Cargo_TransferSignature: 'Переписано',
  Cargo_Appointed: 'Назначен',
  Cargo_CancelSignature: 'Отменить подпись',
  Cargo_AddSignatureSelf: 'Не для себя."Добавить подпись"',
  Cargo_OnlySupportedFCL: 'Пока поддерживаются только пакеты.',
  Cargo_CannotExceedThree: 'В системе более 3 различных типов ящиков, на этот раз не может отправить соответствующие данные, пожалуйста, свяжитесь с персоналом обслуживания клиентов вовремя.',
  Cargo_TransferSignatureSelf: 'Не разрешается выбирать себя в качестве « переподписчика».',
  Cargo_AddSignatureCurrentNode: 'Не допускается для текущего узла"Добавить подпись"',
  Cargo_ApproverNotEmpty: 'Одобрение не может быть пустым',
  Cargo_AppointerNotEmpty: 'Люди не могут быть пустыми.',
  Cargo_NewWarehouseFee: 'Допускаются только дополнительные складские сборы для действующих предприятий!',
  Cargo_DefaultCurrencyConversion: 'Валюта по умолчанию',
  Cargo_ChargeGroupCheck: 'Группа сборов 【{0}】, не поддерживает повторный выбор, пожалуйста, сохраните его после корректировки.',
  Cargo_RelatedChargeItems: 'Связанные сборы',
  Cargo_IncludeSoc: 'Содержит ли контейнер',
  Cargo_SubsidiaryLedgerDay: 'Ведомость с разбивкой по срокам',
  AccountingDate: 'Дата учета',
  PleaseSelectAccountDate: 'Пожалуйста, выберите дату бухгалтерского учета.',
  CurrentDayAmountTo: 'Всего на сегодняшний день',
  TotalReportingCurrencyOfThisDay: 'Валюта текущего дня',
  Cargo_LastOverseasPort: 'Когда портом разгрузки является порт Соединенных Штатов, он может быть непосредственно равен порту погрузки. \ n' +
      'Если порт разгрузки не является портом США, здесь должен быть указан предыдущий неамериканский порт до Соединенных Штатов.',
  Cargo_FirstPortOfCall: 'Когда порт разгрузки является портом США, он может быть непосредственно равен порту разгрузки. \ n' +
      'Если порт разгрузки не является портом США, он заполняется первым американским портом, проходящим через США.',
  Cargo_PoNoExistTips: 'Номер проекта повторяется, подтверждается ли сохранение?',
  Cargo_Assignment: 'Распределение',
  Cargo_SetMarginReminder: 'Настройка напоминаний',
  Cargo_NumberOfCompanyReminders: 'Остаток напоминания',
  Cargo_CompanyTrackingNumLower: 'Текущий корпоративный запас меньше 【{0}】',
  Cargo_BatchAdd: 'Новые партии',
  Cargo_DownloadTemplate: 'Загрузить шаблон',
  Cargo_AssignCompany: 'Распределительная компания',
  Cargo_MawbSource: 'Основной источник',
  CARGO_CAN_NOT_ASSIGNMENT: 'Поддерживается только выделение дополнительного состояния',
  CARGO_Confirm_Assignment: 'Подтверждение распределения',
  CARGO_Confirm_Assignment_Success: 'Распределение успешно',
  CARGO_Confirm_Assignment_Error: 'Ошибка распределения',
  CARGO_Only_Invalidated: 'Поддерживаются только недействительные первичные листы',
  CARGO_Only_Unbind: 'Поддерживается только снятие привязки к главному листу',
  CARGO_Not_Met_New_Conditions: 'Следующий список не удовлетворяет дополнительным условиям',
  Cargo_Assign_People: 'Распределение',
  AERequiredChecksum: 'Начальный номер основного сингла, количество добавлено должно заполнить один',
  Cargo_DeleteCharge: 'Не выбранные расходы, по умолчанию удалить все выделенные операционные расходы',
  Cargo_BusinessOperationUpdateDynamics: 'Динамика обновления операций',
  Cargo_UpdateDetails: 'Обновить подробности',
  Cargo_UpdateContent: 'Обновить содержимое',
  Cargo_ChangeLogRecord: 'Журнал изменений',
  Cargo_BusinessNoChangeLogRecord: 'Журнал изменения операционного номера',
  Cargo_ResultsDisplayedInRed: 'Результаты будут показаны красным цветом.',
  Cargo_ChangeLocation: 'Изменить местоположение',
  Cargo_TimeQuery: 'Время запроса',
  Cargo_BusinessNotExist: 'Бизнес не существует!',
  Cargo_UserNoRole: 'Этот пользователь не связан с какой - либо ролью, подтвердить сохранение?',
  Cargo_ResultsDisplayedInYellow: 'Результаты будут показаны желтым цветом.',
  Cargo_CreateBillYesOrNo: 'Создается ли счет',
  CurrencyReceivable: '{0} Дебиторская задолженность',
  CurrencyPayable: '{0} Выплачивается',
  CurrencyNotReceived: '{0} Не получено',
  CurrencyUnpaid: '{0} Не выплачено',
  CurrencyReceived: '{0} Получено',
  CurrencyPaid: '{0} Выплачено',
  Cargo_CheckShippingCompanyCargoTracking: 'Вы открыли службу отслеживания грузов судоходной компании, пожалуйста, выберите судоходную компанию после сохранения, чтобы убедиться, что информация о поле была успешно получена.',
  Cargo_PodPortInfoPrompt: 'Если вы открываете услугу отслеживания грузов судоходной компании, базовая подпись страницы - судоходная компания является обязательной, правильно выберите судоходную компанию после сохранения бизнеса, чтобы убедиться, что информация о поле была успешно получена.',
  Cargo_StatementReviewStatus: 'Статус проверки счетов',
  Cargo_StatementReviewer: 'Проверка выверки счетов',
  Cargo_StatementReviewTime: 'Время проверки счетов',
  Cargo_Port_Departure_Sea: 'Порт отправления (морские перевозки)',
  Cargo_Port_Destination_Sea: 'Порт назначения (морские перевозки)',
  Cargo_Port_Departure_Air: 'Порт отправления (воздушный транспорт)',
  Cargo_Port_Destination_Air: 'Порт назначения (воздушный транспорт)',
  Cargo_Port_Departure_Rail: 'Порт отправления (железная дорога)',
  Cargo_Port_Destination_Rail: 'Порт назначения (железная дорога)',
  Cargo_Lob_NEQ_Port: 'Тип операции не соответствует типу порта, нажмите, чтобы убедиться, что выбранный порт пуст',
  Cargo_DuplicateLaneCodePleaseTryItAgain: 'Рейс повторяется, пожалуйста, введите снова.',
  Need: 'Потребности',
  NoNeed: 'Не нужно.',
  Responsible: 'Ответственность',
  No_Responsibility: 'Без ответственности',
  Cargo_VAT_FEI: 'Электронные счета (специальные счета - фактуры по НДС)',
  Cargo_NORMAL_FEI: 'Электронные счета - фактуры (обычные счета - фактуры)',
  Cargo_ViewMoreLogs: 'Посмотреть больше журналов',
  Cargo_ThreeDaysLogs: 'Последние три дня работы.',
  Cargo_CarryForward: 'Перенос',
  Cargo_ReconciliationNewVersion: 'Выверка новых версий',
  Cargo_NuoNuo: 'Ноно',
  Cargo_AISINO_EI: 'Авиасообщение',
  Pigeonhole: 'Архив',
  Unarchive: 'Удалить архив',
  Confirm_Archiving_Business: 'Подтверждение архивирования выбранных операций',
  Confirm_Unarchiving_Business: 'Подтверждение разблокирования выбранных операций',
  Is_Pigeonhole: 'Архивировано ли',
  Financial_Review_Status: 'Статус финансового аудита',
  Other_Reminders: 'Другие напоминания',
  Can_Be_Archived: 'Можно ли архивировать',
  Not_Accrued: 'Не учтено',
  Receivables_Not_Fully_Written_Off: 'Неполное списание дебиторской задолженности',
  Payable_Not_Fully_Written_Off: 'Неполное списание',
  Financial_Archiving_Settings: 'Настройки финансового архива',
  Financial_Filing_Preconditions: 'Предпосылки финансового архивирования',
  Financial_Filing_Effective_Effect: 'Эффективность финансового архивирования',
  WHETHER_FINANCIAL_AUDIT: 'Финансовый аудит:',
  WHETHER_ACCRUED: 'Были ли учтены:',
  CARGO_RECOGNITION_SETTING: 'Параметры распознавания OCR',
  AE_IDENTIFY_VENDORS: 'Новые / редактированные идентификаторы поставщиков',
  TENANT_BUSINESS_NAME: 'Название компании - арендатора',
  OFFSHORE_CONSIGNMENT_IDENTIFICATION_SUPPLIER: 'Идентификация поставщиков',
  OCEAN_BILL_OF_LADING_IDENTIFICATION_SUPPLIER: 'Идентификация поставщиков морских коносаментов',
  DTip: 'Удалить настройки этого арендатора? Идентификация поставщиков, использующих настройки платформы после удаления',
  FormEditTip: 'Выберите параметры идентификации арендаторов, которые необходимо отредактировать',
  FormDeleteTip: 'Выберите параметры идентификации арендаторов, которые необходимо удалить',
  OCRRecognition: 'Идентификация OCR',
  FINANCIAL_RECEIVABLES_VERIFICATION: 'Все списания к получению:',
  FINANCIAL_DUE_VERIFICATION: 'Подлежит ли списанию в полном объеме:',
  FINANCIAL_CHARGE: 'Существуют ли новые / измененные / исключенные расходы:',
  CANCEL_FINANCIAL_AUDIT: 'Отмена финансового аудита:',
  MODIFY_CHARGE: 'Расходы на изменение:',
  MODIFY_JOB: 'Изменение деловой информации:',
  MODIFY_RATE: 'Пересмотр обменного курса:',
  MODIFY_FINANCE_JOB_DATE: 'Изменение финансовых / оперативных дат:',
  GENERATE_RED_INVOICE: 'Формирование счета - фактуры красного цвета:',
  RECEIVABLE_GENERATES_INVOICE: 'Счета - фактуры к получению:',
  COPE_GENERATES_INVOICE: 'К оплате могут быть выставлены счета - фактуры:',
  CANCEL_RECEIVABLE_VERIFICATION: 'Списание дебиторской задолженности:',
  COPE_RECEIVABLE_VERIFICATION: 'Отмена списаний, подлежащих списанию:',
  MODIFY_ACCRUAL: 'Пересмотр:',
  NON_FILEABLE_BUSINESS: 'Наличие незаархивированных операций',
  NOT_FULLY_COMPLETED: 'Есть бизнес, который не полностью завершен, посмотрите напоминание',
  BUSINESS_CAN_ARCHIVED: 'Архив операций',
  ARCHIVE_DATE: 'Дата архивирования',
  NOT_OPERATIONAL: 'Не работает, причина: бизнес архивирован.',
  CHANGE_CHARGE_IN_PROGRESS: 'Существуют Текущие "ревизии расходов на изменение" Пожалуйста, закончите сначала',
  ONLY_NOT_ARCHIVED_TRANSACTIONS: 'Выберите незаархивированные операции',
  ONLY_ARCHIVED_TRANSACTIONS: 'Выберите архивированные операции',
  Cargo_Preplan: 'Предварительное распределение',
  Cargo_SeaManagerSendPreplan: 'Морской дворецкий (посылает предварительный комплект)',
  Cargo_SeaManagerUpdatePreplan: 'Морской дворецкий (изменение предварительного распределения)',
  Cargo_SeaManagerDeletePreplan: 'Морской дворецкий (удаление предоплаты)',
  Cargo_SeaManagerSendingVGM: 'Морской дворецкий (отправить VGM)',
  Cargo_WseSendMPreplanQd: 'CW (накладная на отправку основного манифеста порта Циндао)',
  Cargo_WseSendPreplanQd: 'CW (накладная на отправку в порту Циндао)',
  Cargo_WseSendUpdatePreplanQd: 'CW (изменение манифеста в порту Циндао)',
  Cargo_WseDeletePreplanQd: 'CW (удаление манифеста в порту Циндао)',
  Cargo_WseSendPreplanSh: 'CW (отправка манифеста в порту Шанхая)',
  Cargo_WseSendUpdatePreplanSh: 'CW (изменение манифеста в порту Шанхая)',
  Cargo_WseDeletePreplanSh: 'CW (удаление манифеста в порту Шанхая)',
  Cargo_WseSendingVGM: 'Отправить VGM',
  Cargo_Ams: 'AMS отправить',
  Cargo_Aci: 'ACI отправить',
  Cargo_Afr: 'AFR отправить',
  Cargo_EMainfest: 'eMainfest отправить',
  Cargo_Ens: 'ENS отправить',
  Cargo_Send_error: 'Отправить аномалию',
  Cargo_Confirm_Delete: 'Удалить выбранные данные?',
  Cargo_ApiCallBack: 'API Ответить',
  Cargo_BWJS: 'Тысяча золотых колосьев',
  Cargo_TaxEasy: 'Юнцзинь',
  Cargo_YGSH: 'Скорость движения Солнца',
  Cargo_BaiHui: 'Первейзин',
  Cargo_OverseasSettlementCenter: 'Офшорный расчетный центр',
  Cargo_Receivable2: 'Дебиторская задолженность:',
  Cargo_Payable2: 'Причитается:',
  Cargo_From_Import: 'Синхронизация импорта',
  Cargo_From_Export: 'Синхронизация экспорта',
  Approval_Approved_Time: 'Время утверждения',
  CheckingExportToImport: 'Бизнес не может быть экспортирован для реимпорта, пожалуйста, проверьте и попробуйте снова!',
  OnlySupportOneCustomsInfo: 'При включении интерфейса сигнального флага поддерживается только одна таможенная спецификация',
  CustomsDeclareTime: 'Дата таможенной декларации',
  SendContainer: 'Отправьте список контейнеров в таможенную службу.',
  IsTheLCLListSent: 'Отправить список ящиков',
  LCLList: 'Список упаковок',
  iEPort: 'Выездная таможня',
  OceanBillOfLadingNumber: 'Номер морского коносамента',
  NoticeBgh: 'Таможенная декларация с уведомлением',
  SelfDeclaration: 'Самотаможенная декларация клиента',
  NotSentCustomsFile: 'Таможенные данные не направлялись. (Это напоминание можно проигнорировать, если другие каналы в оффлайн - режиме были отправлены)',
  FilledMustFill: 'При отправке таможенной декларации поле [0] должно быть заполнено',
  NoContainerInfo: 'Под коробкой нет информации.',
  InformationComparison: 'Сравнение информации',
  Diff: 'Разница',
  PostLCLTask: 'Задачи в коробке',
  ForceDeleteCustomsTips: 'Таможенные данные уже отодвинули сигнальный флаг, уверены, что его нужно удалить принудительно?',
  AddCustomerFileFirst: 'Пожалуйста, добавьте таможенные данные.',
  Local: 'Местные',
  CustomsDocumentPreparation: 'Таможенная декларация',
  PleaseCreateSplitBillFirst: 'Пожалуйста, сначала создайте список.',
  Cargo_DisplaySell: 'Показать банковский счет продавца',
  Cargo_DisplayBuyer: 'Показать банковский счет покупателя',
  ItIsRecommendedToFillInWhenTheExitPortIsShanghai: '(Примечание: пункт выезда рекомендуется заполнить, если это Шанхай)',
  PleaseFillInTheIEPort: 'Заполните, пожалуйста, пропуск.',
  CustomsUnFrozen: 'Таможенное разблокирование',
  UnFrozen: 'Оттепель',
  LCLTaskSent: 'Отправлено задание на упаковку',
  LCLTaskNotSent: 'Не отправлена задача упаковки',
  Unfreeze: 'Оттепель.',
  NotUnfreeze: 'Не разморозился',
  CustomerFileHasBeenSent: 'Отправлены таможенные данные',
  NotSendingCustomerFile: 'Таможенные данные не отправлены',
  XhqCustomerState: 'режим декларирования сигнального флага',
  VGMWeighingAddressCannotBeEmpty: 'Адрес взвешивания VGM не может быть пустым',
  unfrozenOffline: 'Оттепло (разморозилось под линией)',
  NotifyCustomsUnfreeze: 'Уведомление о размораживании',
  CargoOwnerSOC: 'Владелец SOC',
  ForwarderSOC: 'Компания SOC',
  SOCType: 'Категория контейнера',
  InvoiceConfig: 'Расписание счетов',
  InvoiceChannel: 'Каналы выставления счетов',
  FEI_NuoNuo: 'Счет - фактура Nono Network за электричество: NUONUO',
  FEI_Bwjsy: 'Облако золотое: BWJSY',
  FEI_Kpzddm: 'Код терминала выдачи билетов (kpzdm)',
  FEI_Yhdm: 'Пользовательский код (yhdm)',
  FEI_NotUse: 'Не включено',
  InvoicerConfig: 'Состав счетоводов',
  Invoicer: 'Счетчик',
  ExtensionNumber: 'добавочный номер',
  OnlyInvoicer: 'Счета выставляются только счетчикам',
  AllInvoicer: 'Все пользователи',
  Cargo_ReceiveAmount: 'Сумма дебиторской задолженности',
  Cargo_BatchDeleteChargeTips: 'Не выбранные расходы, по умолчанию удалить все отмеченные бизнес - расходы, продолжается ли?',
  Cargo_Template_Push: 'Настройка шаблонов',
  Empty: '(Пустой)',
  Cargo_UploadTemplateDataSample: 'Загрузка шаблонов данных',
  Cargo_SureDeleteTheFile: 'Удалить файл?',
  Cargo_DownloadContent: 'Загрузить содержимое',
  Cargo_ImportOrderTemplateFile: ': Импорт файла шаблона заказа',
  Cargo_ImportOrderTemplateDataSampleFile: ': Импорт шаблона заказа в файл образцов данных',
  Cargo_Sample: 'Пример',
  Cargo_Sample_Tip: '* Если HQ загрузил файл образца данных, а другие филиалы не загрузили его, другие филиалы по умолчанию используют файл образца данных HQ',
  OpenXhqChat: 'Открыть письмо',
  OpenXhqChatTips: 'Компания не отправила таможенную декларацию, пожалуйста, сначала отправьте таможенную декларацию',
  CustomsBrokerNotEntered: 'Таможенная декларация не введена',
  Cargo_CanNotSplitMasterJob: 'Тип целой сборки не равен автосборке или Buyer Console и не может быть разделен!',
  RespMsg: 'Вернуться к информации',
  Cargo_BillPaymentRemarkTip: '* Когда примечания пусты, они не будут перекрывать оригинальные заметки данных.',
  Cargo_WarehouseCode: 'Код ввода',
  Cargo_WarehouseCodeLengthLimit: 'Используется для генерации конфигурации кода входящего отсека с кодовым символом до 10 бит.',
  Cargo_ValueSetting: 'Параметры выборки',
  Cargo_SettingValuePriority: 'Установить приоритет',
  Cargo_PleaseToPartnerWarehouseCode: 'Пожалуйста, ознакомьтесь с кодом входа партнера.',
  Cargo_LineSeaAir: 'Маршруты (морские / воздушные)',
  Cargo_LineRailWay: 'Маршруты (железные дороги)',
  Cargo_BatchDeleteCharge: 'Расходы на массовое удаление',
  Cargo_SetDeleteCondition: 'Установить условия удаления',
  Cargo_ToBeDeletedCharge: 'Данные о расходах, подлежащие удалению',
  Cargo_ToBeDeletedChargeSelected: 'Выбрано для удаления данных о расходах:',
  Cargo_MatchCharge: 'Расходы на согласование',
  Cargo_SureDelete: 'Удалить выбранный элемент {0}?',
  Cargo_ShowChargeDeleteResult: 'Показать результат удаления расходов',
  Cargo_DeletedTips: 'Удалено {0} данных',
  Cargo_NotSelectDeletedTips: 'Данные о расходах, которые необходимо удалить, не выбраны!',
  Cargo_PleaseMatchDataFirstTips: 'После согласования данных убедитесь в том, что данные требуют массовой обработки.',
  Cargo_NotSelectDeleteConditionTips: 'Условия удаления платы не выбраны!',
  Cargo_BatchEditCharge: 'Расходы на групповое редактирование',
  Cargo_SetEditCondition: 'Установить условия настройки',
  Cargo_ToBeEditCharge: 'Данные о расходах, подлежащие корректировке',
  Cargo_ToBeEditChargeSelected: 'Были отобраны скорректированные данные о расходах:',
  Cargo_SureEdit: 'Убедитесь, что для корректировки выбран элемент {0} данных?',
  Cargo_ShowChargeEditResult: 'Показать результаты обновления стоимости',
  Cargo_EditTips: 'Обновлены {0} данные',
  Cargo_NotSelectEditTips: 'Данные о расходах, которые необходимо скорректировать, не выбраны!',
  Cargo_NotSelectEditConditionTips: 'Условия корректировки расходов не выбраны!',
  Cargo_EditAmountNoZero: 'Корректировка цены не может быть 0!',
  Cargo_EditUnitRate: 'Корректировка удельной стоимости',
  Cargo_EditSettleAccountsTo: 'Корректировка объекта расчетов',
  Cargo_HandleResult: 'Результаты обработки',
  Cargo_LoadMore: 'Прокрутить больше',
  Cargo_NoMoreData: 'Нет больше данных',
  Cargo_ChargeHasDiffAmount: 'Расходы были обработаны разницей и не могут быть изменены!',
  Cargo_ChargeHasConfirm: 'Стоимость подтверждена, изменения не допускаются!',
  Cargo_ChargeHasVerified: 'Стоимость списана, изменения не допускаются!',
  Cargo_ChargeHasCommit: 'Расходы представлены без изменений!',
  Cargo_ChargeHasCreateBillPayment: 'Платежи были созданы заявка на платеж не может быть изменена!',
  Cargo_ChargeHasCreateInvoice: 'Стоимость выставлена, изменения не допускаются!',
  Cargo_JobStateNotAllowModified: 'Бизнес представлен / проверен Не допускается изменение!',
  Cargo_InvoiceChargeItemSetup: 'Установка расходов (вьетнамский счет)',
  Cargo_InvoiceChargeUnitSetup: 'Установка единицы (вьетнамский счет)',
  Cargo_ChargeItemId: 'Платные статьи (Cargoware)',
  Cargo_ChargeItemName: 'Название (Платформа выдачи билетов)',
  Cargo_ChargeUnitCode: 'Единицы (Cargoware)',
  Cargo_ChargeUnitName: 'Описание (Платформа выдачи билетов)',
  Cargo_InvoicingByTaxRate: 'Оформление билетов по налоговым пунктам',
  Cargo_SureToVoidTheInvoiceVietnam: 'В соответствии с налоговой политикой Вьетнама. Пожалуйста, подтвердите, что вы связались с клиентом и убедитесь, что счет - фактура еще не задекларирован. Если налог гарантирован, не отменяйте счет - фактуру ". br / > < br / > Подтвердить аннулирование счета - фактуры?',
  Cargo_RandomPassword: 'Случайный пароль',
  ChargeSchemeCopy: 'Расходы на размножение программ',
  CompanyCopy: 'Копирование партнерами',
  SourceCompany: 'Компания источника',
  QueryChargeScheme: 'Программа расходов на поиск информации',
  CopyChargeScheme: 'Программа расходов на размножение документов',
  QueryCompany: 'Поиск партнеров',
  CopyCompany: 'Копирование партнеров',
  FuzzyQueryOfIdOrName: 'Запрос с нечетким идентификатором или именем',
  CopyToCompany: 'Копировать в филиал',
  CopySuccessCount: 'Копирование успешно {0}',
  PleaseSelectTargetTenant: 'Выберите целевого арендатора.',
  Cargo_TemplateNodeWorkTaskSetting: 'Настройка задачи для работы узла шаблона',
  Cargo_WorkTaskEnable: 'Открыть настройки рабочего задания узла',
  Cargo_SetNodeResponsible: 'Установить этот узел ответственным',
  Cargo_DesignatedPosition: 'Назначенные должности (в соответствии с позицией, чтобы установить узел, ответственный за работу, может быть выбран только один)',
  Cargo_SetPreNode: 'Настройка переднего узла (состояние переднего узла, необходимое для начала узла)',
  Cargo_SetPreNodeTips: 'Установите передний узел этого узла (до 5 передних узлов для связи)',
  Cargo_HandlingPriorityMarkers: 'Отметка приоритета обработки',
  Cargo_HandlingPriorityMarkersTips: 'Установить приоритет обработки (до 3, если не установлен, по умолчанию низкий приоритет)',
  Cargo_HandlingPriorityMarkersHigh: 'Установить приоритет обработки: высокий',
  Cargo_HandlingPriorityMarkersMedium: 'Установить приоритет обработки для:',
  Cargo_HandlingPriorityMarkersLow: 'Установить приоритет обработки: низкий',
  Cargo_SOPWorkTaskBoard: 'Просмотр РЗ SOP',
  Cargo_High: 'Высокий:',
  Cargo_Medium: 'В:',
  Cargo_Low: 'Низкий:',
  Cargo_SopBusinessFlowDashboard: 'Сервис SOP Business',
  Cargo_WarnTodoList: 'Задач. Ран. предупр.',
  Cargo_BpmTodoList: 'Вопр. утвержд.',
  Cargo_BusinessTime: 'Время работы',
  Cargo_HandleLevel: 'Уровень обработки',
  Cargo_PreNode: 'Передний узел',
  Cargo_PriorityHigh: 'Высокий приоритет',
  Cargo_PriorityMedium: 'Средний приоритет',
  Cargo_PriorityLow: 'Низкий приоритет',
  Cargo_SetDefaultDisplayItem: 'Установить по умолчанию',
  Cargo_PreNodeRepeat: 'Повторение конфигурации переднего узла',
  Cargo_PriorityRepeat: 'Конфигурация приоритетов, [bracket0] не может быть повторена',
  Cargo_TrackingIconTip: 'Этот значок используется в системе B2B и панели просмотра рабочих заданий SOP!',
  Cargo_LoadData: 'Обновить данные',
  Cargo_TemplateNodeMergeShow: 'Показ. Комб. Узл. Шаб.',
  Cargo_MblTip: 'Введите 6 - 30 заглавных символов и цифр.',
  Cargo_VesselTip: 'Введите буквы, цифры, "...", "-", "пробелы"',
  Cargo_VesselTip2: 'Нельзя вводить китайские и полноширинные символы',
  Cargo_VoyageTip: 'Введите без В. Рейс',
  Cargo_ShippingCompanyTip: 'Пожалуйста, выберите судовой отдел.',
  Cargo_CarrierAgentTip: 'Пожалуйста, выберите корабль.',
  Cargo_SailingDateTip: 'Выберите дату вылета.',
  Cargo_PortOfLoadingHgjTip: 'Морской дворецкий поддерживает только Шанхайский порт.',
  Cargo_PortOfLoadingWsTip: 'Пожалуйста, выберите порт отправления, поддержите Шанхай, Циндао',
  Cargo_PortOfLoadingTip: 'Пожалуйста, выберите порт на английском языке.',
  Cargo_PortOfDischargeTip: 'Выберите порт разгрузки.',
  Cargo_PortOfDestinationTip: 'Выберите порт назначения.',
  Cargo_PortOfDestinationTip2: 'Пожалуйста, выберите порт на английском языке.',
  Cargo_BlNumberTip: 'Пожалуйста, выберите форму коносамента.',
  Cargo_DispatchingPlaceCodeTip: 'Если Нанкин получает товар через Шанхай, место отправления заполняет Нанкин',
  Cargo_DispatchingPlaceCodeTip2: 'Пожалуйста, выберите место доставки.',
  Cargo_DispatchingPlaceCodeTip3: 'Поддерживается только доставка в Циндао или солнечныйсяо.',
  Cargo_ShipperEnterpriseNameTip: 'Введите символы в пределах 140',
  Cargo_ShipperEnterpriseNameTip2: 'Введите символы в пределах 70',
  Cargo_ShipperContactsTip: 'Введите номер телефона в пределах 20 символов.',
  Cargo_PortPlaceOfDeparture: 'Порт отправления / место отправления',
  Cargo_PortPlaceOfDischarge: 'Порт разгрузки / место разгрузки',
  Cargo_MsgClassifyManager: 'Управление сортировкой сообщений',
  Cargo_BellMsg: 'Колокольчик новостей',
  QuickSearchMsgClassify: 'Введите имя для нечеткого поиска',
  Cargo_GroupingDimensionForRate: '"Условия группировки" равны "налоговым ставкам," значение "должно быть заполнено как" цифры "!',
  Cargo_CheckAccountSetBranchId: 'Является ли филиал, к которому принадлежит текущий счет, не принадлежащим текущему филиалу или вышестоящему филиалу, продолжать?',
  Cargo_BillPayment: 'Платежные требования',
  Cargo_MakeInvoice: 'Заявка на выставление счета',
  Cargo_JobCharge: 'Заявки на покрытие оперативных расходов',
  Cargo_CopyNotifier: 'Копировать уведомление',
  Cargo_CopyRecipient: 'Копирование грузополучателя',
  Cargo_InputIMO: 'Введите номер IMO.',
  Cargo_InputBLFreightTermTootip: 'Пожалуйста, выберите условия перевозки',
  Cargo_PureNumbers: 'Введите чистые цифры.',
  Cargo_DefaultShanghai: 'По умолчанию Shanghai / CNSHA, без изменений',
  Cargo_IMO: 'ИМО',
  Cargo_DangerousGoodsCheck: 'Вы заполнили {0}, но тип груза выбран как « обычный товар», пожалуйста, проверьте и отправьте его снова',
  ChinaPostProductConfiguration: 'Настройка почтовых продуктов',
  AllowSaleProduct: 'Продается продукция',
  AllowSaleProductNotNull: 'Продавать продукцию без выбора',
  NewChargeGroup: 'Группа расходов & lt; & lt; Новое поколение & gt; & gt;',
  ChargeMapping: 'Отображение расходов нового поколения',
  ChargeMappingFuzzySearch: 'Введите код платы за передачу или расплывчатый запрос имени',
  RailwayUse: 'Использование железных дорог',
  BecameInvalid: 'Неспособность',
  FullOrInside: 'Весь путь / страна',
  FullOrInsideNotNull: 'Весь путь / страна не выбрана',
  TransmitChargeName: 'Группа расходов на передачу',
  TransmitChargeNameNotNull: 'Группа расходов на передачу не выбрана',
  TransmitChargeCode: 'Код группы расходов на передачу',
  MaintainerRemarks: 'Примечания для обслуживающего персонала',
  PushOrNot: 'Перетолкнуть',
  Cargo_BusinessLeaderCompanyPrePort: 'Компания руководителя бизнес-операций до порта',
  Cargo_BusinessLeaderDeptPrePort: 'Отдел руководителя бизнес-операций до порта',
  Cargo_BusinessLeaderCompanyEndPort: 'Компания руководителя бизнес-операций на завершающем участке',
  Cargo_BusinessLeaderDeptEndPort: 'Отдел руководителя бизнес-операций на завершающем участке',
  Cargo_CurrentNode: 'Текущий узел',
  Cargo_WorkNode: 'Рабочий узел',
  Cargo_EditStateTip: 'Изменить состояние узла выбранного элемента данных {0}?',
  Cargo_BpmSubmitDuplicated: 'Текущие документы уже есть аудиторский сертификат, пожалуйста, не представляйте повторно',
  Cargo_TempCreditApply: 'Временная заявка',
  Cargo_PartnerName: 'Название партнера',
  Cargo_ContractAmount: 'Сумма контракта',
  Cargo_ContractAccountingPeriod: 'Срок действия контракта',
  VerificationSheetRequired: 'Требуется контрольный лист',
  Cargo_TransportSource: 'Источник мощности',
  Cargo_CustomerExpandMode: 'Метод экспансии',
  Cargo_SubmitTempCreditTip: 'Поддержание временного контроля письма, чтобы начать процесс утверждения временного контроля письма, вы хотите начать процесс утверждения сейчас?',
  Cargo_CustomFields: 'Настроить поле',
  Cargo_CustomerCode: 'Клиентско - торговый код системы ваучеров',
  Cargo_NoHasFinanceCode: 'Сопоставимые счетафактуры были выставлены без соответствующего пользователю кода клиента системы ваучеров.',
  Cargo_MultiCurrency: 'Счета - фактуры были выставлены в нескольких валютах.',
  Cargo_YongYouDeleteTip: 'Текущие счета - фактуры были отосланы друзьям пользователя, чтобы перейти к системе ваучеров, если требуется операция, и удалить соответствующую запись. Определена операция?',
  Cargo_SyncVerifyDoc: 'Синхронизация документов о списании',
  Cargo_HasSync: 'Указанные данные синхронизированы',
  Cargo_OverseaActualAmount: 'Данные о продажах за рубежом не могут синхронизироваться с друзьями.',
  Cargo_MultiInvoiceTitle: 'Существует поток продаж, который включает в себя несколько выставленных счетов вверх. Невозможно подтолкнуть друга пользователя, пожалуйста, отрегулируйте данные.',
  Cargo_InvoiceTitleMustBeIdentical: 'Счет должен быть таким же.',
  Cargo_ChargeChangeApply: 'Заявки на изменение расходов',
  Cargo_HideUnmodifiedFees: 'Скрытие НР',
  Cargo_ChargeChangeTip: 'Примечание: Существуют изменения, которые подлежат утверждению в настоящее время, и корректировка расходов может быть произведена только после завершения этого изменения.',
  Cargo_UniqueIdentification: 'Уникальный идентификатор',
  Cargo_CostNumber: 'Номер расходов',
  Cargo_OriginalCostUniqueIdentifier: 'Первоначальная стоимость',
  Cargo_OriginalExpenseNumber: 'Первоначальная стоимость',
  Cargo_ChargeChange: 'Изменение расходов',
  Cargo_ApprovalProcessForChargeChange: 'Процедура рассмотрения заявок на изменение стоимости',
  Cargo_ChargeChangeTip2: 'Подтвердите, пожалуйста, изменение стоимости запуска прямо сейчас?',
  Cargo_ChargeChangeTip3: 'Примечание: Изменения в расходах не будут вноситься до завершения процесса утверждения.',
  Cargo_ViewChangeData: 'Просмотреть данные об изменениях',
  Cargo_GrossProfitMarginBeforeChange: 'Валовая процентная ставка до изменения',
  Cargo_GrossProfitMarginAfterChange: 'Валовая процентная ставка после изменения',
  CustomFieldDisplayConfiguration: 'Показать поле',
  Field: 'Поле',
  ChineseDisplayName: 'Китайское имя',
  EnglishDisplayName: 'Английский Показать имя',
  FieldNotEmpty: 'Поле не может быть пустым',
  ChineseDisplayNameNotEmpty: 'Не заполнено имя отображения на китайском языке',
  EnglishDisplayNameNotEmpty: 'Не заполнено имя отображения на английском языке',
  Cargo_ContractRule: 'Прав.конт.',
  Cargo_ApplicationConditions: 'Усл.',
  Cargo_ConditionValue: 'Условное значение',
  Cargo_ContractWarning: 'Раннее предупреждение о контракте',
  Cargo_ApplicationRules: 'Правила применения',
  Cargo_ContractRuleChangeTip: 'Текущие правила уже применяются к некоторым контрактам, прежде чем приступать к работе, измените контракт, в котором они применяются, в новые правила.',
  Cargo_DailySettlement: 'Тяньцзе',
  Cargo_ContractNumber2: 'Номер контракта',
  CheckArApDisparity: 'Настройка проверки счетов, пожалуйста, выполните отдельные операции с дебиторской и кредиторской задолженностью',
  VASChannelSetting: 'Настройка канала обслуживания с добавленной стоимостью',
  ManifestChannel: 'Поставщики, направляющие предварительные накладные',
  VGMChannel: 'Поставщики VGM',
  VASChannelFormEditTip: 'Укажите параметры канала отправки для арендаторов, нуждающихся в редактировании',
  VASChannelFormDeleteTip: 'Укажите параметры канала отправки арендаторов, которые необходимо удалить',
  VASChannelSelectOneTip: 'Поставщик предварительного заказа / Поставщик VGM Выберите по крайней мере один',
  VASChannelDeleteTip: 'Удалить настройки этого арендатора?',
  VASChannelDTip: 'Удалить настройки канала передачи',
  Cargo_PushAddCustomer: 'Нажмите новых клиентов',
  Cargo_ChooseArea: 'Выберите регион',
  Cargo_AllocationSuccessful: 'Распределение успешно',
  Cargo_CreatedSuccessful: 'Создание успешно',
  Cargo_DuplicateCustomerName: 'Имя клиента повторяется',
  Cargo_ExistFinanceCode: 'Код клиента уже существует, его не нужно толкать',
  Cargo_EntrustedReceiveInfo: 'Получение информации по доверенности',
  Cargo_ContainerLoadTypeRailWay: 'Тип поручения (железная дорога)',
  ExclusionOffice: 'Интерфейсы нового поколения',
  Cargo_TransportationType: 'Вид перевозки',
  Cargo_MultiOrderTip: 'При наличии нескольких данных создается заказ.',
  Cargo_IdentifyTemplateName: 'Имя шаблона',
  Cargo_IdentifyTemplateName2: 'Имя шаблона:',
  Cargo_TemplateId: 'Идентификатор шаблона',
  Cargo_CodeProcessing: 'Обработка кода',
  Cargo_TestFile: 'Тестовый файл',
  Cargo_TemplateIdAutomaticallyGenerated: 'Идентификатор шаблона (автоматически генерируется):',
  Cargo_TemplateStatus: 'Статус шаблона:',
  Cargo_DocumentTypeDescription: 'Тип документа',
  Cargo_DocumentTypeDescription2: 'Описание типа документа:',
  Cargo_ReadField: 'Поле чтения',
  Cargo_FieldName: 'Название поля',
  Cargo_FieldRuleDescription: 'Описание правила поля',
  Cargo_PreviewPromptWords: 'Предварительный просмотр подсказок',
  Cargo_Invalid3: 'Неверный',
  Cargo_Sequence: 'Последовательность',
  Cargo_FieldAdd: 'Новое поле',
  Cargo_FieldEdit: 'Редактор поля',
  Cargo_FieldView: 'Просмотр поля',
  Cargo_PlatformEnterpriseName: 'Название компании Платформа',
  Cargo_AccessKey: 'Access Key',
  Cargo_SecretKey: 'Secret Key',
  Cargo_CallBackUrl: 'Адрес обратного вызова',
  Cargo_PlatformEnterpriseInterfaceConfiguration: 'Настройка корпоративного интерфейса платформы',
  Cargo_OcrTemplateConfig: 'Настройка шаблона OCR',
  Cargo_OcrCode: 'Обработка встроенного кода (вторичная обработка встроенного кода возвращает конечный результат как значение вывода API)',
  Cargo_originalValue: 'Первоначальное значение',
  Cargo_DebuggingResults: 'Результаты отладки',
  Cargo_UsageStatistics: 'Статистика использования',
  Cargo_NumberOfSuccessfulCalls: 'Количество успешных вызовов',
  Cargo_UsingFlowingWater: 'Использовать воду',
  Cargo_CallTemplateId: 'Вызвать идентификатор шаблона',
  Cargo_CallResult: 'Результат вызова',
  Cargo_Template: 'Шаблоны:',
  Cargo_QueryFlowingWater: 'Посмотреть Вода',
  Cargo_TemplateId2: 'Идентификатор шаблона:',
  Cargo_FileName2: 'Имя файла:',
  Cargo_IdentifyReturnResult: 'Определить результат возврата:',
  Cargo_CustomsChannel: 'Идентификация поставщиков в таможенной декларации',
  Cargo_PleaseSelectSpecificFields: 'Выберите конкретное поле для редактирования',
  Cargo_ConfirmToDeleteThisField: 'Удалить поле? После удаления интерфейс больше не будет возвращать информацию об этом поле',
  Cargo_ValidThisRecognitionTemplate: 'Вы уверены, что хотите восстановить этот шаблон идентификации?',
  Cargo_InValidThisRecognitionTemplate: 'Вы уверены, что хотите отключить эту конфигурацию? После отказа интерфейс вызова больше не будет возвращать данные',
  Cargo_ValidThisRecognitionEnterprise: 'Вы уверены, что хотите восстановить предприятие?',
  Cargo_InValidThisRecognitionEnterprise: 'Уверены, что предприятие закрывается? Невозможно вызвать интерфейс после отказа',
  Cargo_DateErrorTip: 'Дата истечения срока действия должна превышать дату вступления в силу',
  Cargo_ModifyCodeHandle: 'Изменить "Кодовую обработку"',
  Cargo_ModifyPromptWords: 'Изменения"Подсказка"',
  Cargo_CannotEnable: 'Не в течение срока действия, невозможно нажать [bracket0]',
  Cargo_InputTokenCount: 'Большая модель распознает количество input token',
  Cargo_OutputTokenCount: 'Большая модель распознает количество output token',
  Cargo_PlsGenerate: 'Пожалуйста, создайте',
  Cargo_TemplateUsed: 'Этот шаблон используется клиентами и не подлежит редактированию. Можно снять привязку, а затем отредактировать или скопировать шаблон для редактирования.',
  Cargo_SelectOneData: 'Разрешается копировать только один элемент данных!',
  Cargo_OutputRequirements: 'Требования к экспорту:',
  Cargo_AnalyticMethod: 'Метод анализа:',
  Cargo_BLNoStatistics: 'Номер коносамента',
  Cargo_RemainingQuantity: 'Остаток',
  Cargo_RegistrationDate: 'Дата регистрации',
  AnalyzeChannelSettings: 'Настройка канала',
  EmailParsingSettings: 'Параметры анализа почты',
  EmailPasswordAuthorizationCode: 'Пароль почтового ящика / код авторизации',
  SenderServer: 'Отправительный сервер',
  Port: 'Порт',
  AddOrEditEmail: 'Добавить / изменить почтовый ящик',
  EmailPurpose: 'Использование почтового ящика',
  EnterCorrectEmail: 'Введите правильный адрес почтового ящика',
  SelectDeleteEmail: 'Выберите почтовый ящик для удаления',
  DeleteEmailConfirm: 'Удалить выбранный почтовый ящик? После удаления удалённый почтовый ящик больше не будет читаться',
  ImportMblNo: 'Импорт основного номера',
  ApplicableDepartment: 'Применимые секторы',
  Cargo_QuoteMethod_ExistingRate: 'Котировки с "существующей ставкой" не могут быть отменены',
  Cargo_QuoteMethod: 'Метод расчета стоимости',
  Cargo_ExistingRate: 'Существующая ставка',
  Cargo_CommercialQuote: 'Коммерческая котировка',
  Cargo_PrePortQuoteMethod: 'Метод расчета до порта',
  Cargo_MainlineQuoteMethod: 'Метод расчета на главной линии',
  Cargo_EndlineQuoteMethod: 'Метод расчета на конечном участке',
  PleaseSelectApplicableBranch: 'Пожалуйста, выберите подходящий филиал',
  Cargo_CheckSetting: 'Параметры проверки',
  Cargo_BookNoteFieldName: 'Название поля',
  Cargo_IfRequired: 'Обязательно ли заполнять',
  Cargo_Channel: 'Каналы',
  Cargo_IfSame: 'Несоответствие контрастов',
  Cargo_DefaultValue2: 'Пустое значение по умолчанию',
  Cargo_BookFieldNameRepeat: 'Повторение имени поля',
  Cargo_BookNoteFieldAndSort: 'Показывать поля и порядок',
  Cargo_IfAutoBooking: 'Есть ли автоматический заказ',
  Cargo_BookRecognitionResults: 'Результаты идентификации по доверенности',
  Cargo_ConfirmedBusinessData: 'Регистрационная информация',
  Cargo_OtherData: 'Другие данные',
  Cargo_BranchOffice: 'Подразделение (BranchOffice)',
  Cargo_ShippingCompany: 'Судоходная компания (ShippingCompany)',
  Cargo_IfAutomaticBooking: 'Автоматическое бронирование (IfAutomaticBooking)',
  Cargo_Book: 'Ваше письмо',
  Cargo_GoodNameContainSensitiveWord: 'Содержит чувствительное слово < span style ="color: red"> {0} < / span >, продолжаете ли вы бронирование?',
  Cargo_OnlyGenerateJob: 'Создать только бизнес',
  Cargo_PleaseReceiveCallback: 'Обратите внимание на получение квитанции.',
  Cargo_JobProcess: 'Ход работы',
  Cargo_IdentificationMethod: 'Способ идентификации',
  Cargo_NoNeedSupplementaryInformationBookNote: 'Нет доверенности, требующей дополнительной информации',
  Cargo_SupplementaryInformationTip: 'Выберите [bracket5] для записи [bracket4] и [bracket3] для записи [bracket2] и [bracket1] для записи [bracket0]',
  CannotBeLongerThan35: 'Информация слишком длинная, пожалуйста, отредактируйте ее заново, чтобы получить и получить максимальную {0} строку, максимум 35 символов на строку',
  Cargo_OcrSetTip: 'Вы еще не установили никакой информации, следующие поля и настройки проверки являются системными по умолчанию, в доверенности показаны настройки платформы по умолчанию < br / > < br / > Приоритет извлечения значений: если вы указали главную компанию приложений, то приоритет Главная > Настройки арендатора > Настройки платформы',
  Cargo_AutomaticAllocation: 'Автоматизированное виртуальное распределение расходов',
  Cargo_ChargeAutomaticAllocationConfig: 'Автоматизированное распределение расходов',
  Cargo_EditAutomaticAllocationConfig: 'Настройка автоматического распределения расходов',
  Cargo_AddAutomaticAllocationConfig: 'Автоматическое распределение расходов по новым основным векселям',
  Cargo_MatchingCriteriaSelection: 'Выбор условий соответствия',
  Cargo_AutomaticAllocationRuleConfig: 'Настройка автоматического распределения правил',
  Cargo_AllocationNature: 'Характер начисления взносов',
  Cargo_HblSingleAllocation: 'HBL Поделиться',
  Cargo_OnlyAllocatedToHblSingle: 'Распределены только по',
  Cargo_MasterBill: 'Основной список',
  Cargo_AddEditReceivablePayableFees: 'Добавить/редактировать дебиторские и кредиторские расходы',
  Cargo_AddEditReceivableFees: 'Добавить/редактировать дебиторские расходы',
  Cargo_AddEditPayableFees: 'Добавить/редактировать кредиторские расходы',
  Cargo_AddEditReceivableSpecialFees: 'Добавить/редактировать специальные дебиторские расходы',
  Cargo_AddEditPayableSpecialFees: 'Добавить/редактировать специальные кредиторские расходы',
  Cargo_DeleteReceivablePayableFees: 'Удалить дебиторские и кредиторские расходы',
  Cargo_DeleteReceivableFees: 'Удалить дебиторские расходы',
  Cargo_DeletePayableFees: 'Удалить кредиторские расходы',
  Cargo_ImportReceivablePayableFees: 'Импорт дебиторских и кредиторских расходов',
  Cargo_ImportReceivableFees: 'Импорт дебиторских расходов',
  Cargo_ImportPayableFees: 'Импорт кредиторских расходов',
  Cargo_BusinessTypeError: 'Выбранный тип документа не совпадает и не может быть изменен!',
  Cargo_ReceivableSpecialFee: 'Получаемая специальная плата',
  Cargo_PayableSpecialFee: 'Подлежащая оплате специальная плата',
  Cargo_ReceivablePayableSpecialFee: 'Получаемая и подлежащая оплате специальная плата',
  Cargo_PleaseSetChargeNameAndAllocationType: 'Укажите название и тип распределения расходов',
  Cargo_PleaseSetChargeName: 'Укажите имя расходов',
  Cargo_PleaseSetAllocationType: 'Укажите тип взноса',
  Cargo_HasDuplicateConfigItem: 'Повторяющиеся данные конфигурации уже есть!',
  Cargo_ConfirmDeleteTheConfigItem: 'Удалить элемент конфигурации?',
  Cargo_ConfirmSaveModifiedInfo: 'Сохранить информацию об изменениях?',
  Cargo_InvoiceRepeat: 'Номер счета повторяется',
  Cargo_TurnOffAutomaticAllocation: 'Автоматическое виртуальное распределение расходов по основному векселю будет закрыто, и вместо этого оно будет распределено вручную!',
  Cargo_RemainingAmountNotEnough: 'Недостаточный остаток, пожалуйста, пополните',
  Cargo_RemainingAmountNotEnough2: 'Недостаточный остаток средств, невозможность вновь генерировать бизнес',
  Cargo_ExpandAll: 'Развернуть >',
  Cargo_PackUp: '< Убрать',
  Cargo_OcrTip: 'Теплый совет: Информация о записи относится к данным, записанным в бизнес, где красный шрифт указывает на ошибку, которая не может быть отображена с платформой, необходимо изменить список записи',
  Cargo_OcrTip2: 'Напоминание: информация о записи заказа относится к данным, записанным в бизнес. Красный шрифт указывает на ошибку, которая не может быть сопоставлена с платформой.',
  Cargo_ClaimSettlement: 'Урегулирование требований',
  Cargo_BillStatusDoesNotMeetPaymentRequestRequirements: 'Статус счета не соответствует требованиям к оплате',
  Cargo_GetReceiptSettings: 'Получение параметров квитанции',
  Cargo_AddEditReadReceiptMethod: 'Добавить / изменить способ чтения',
  Cargo_ReadReceiptMethod: 'Прочитать квитанцию',
  Cargo_DeleteReceiptTip: 'Удалить эту конфигурацию? После удаления вы больше не будете читать квитанции по этому правилу.',
  Cargo_PleaseInputTitleOrContentTip: 'Введите заголовок или текст',
  Cargo_BookingState: 'Режим бронирования',
  Cargo_BookingChannelConfig: 'Настройка каналов бронирования',
  Cargo_BookingMode: 'Режим бронирования',
  Cargo_RpaSupplier: 'Поставщики RPA',
  Cargo_BookingChannel: 'Канал бронирования',
  Cargo_ConfirmRejectQuote: 'Вы уверены, что хотите отклонить предложение?',
  Cargo_MainlineRejectReason: 'Причина отклонения на главной линии',
  Cargo_PortRejectReason: 'Причина отклонения до порта',
  Cargo_EndlineRejectReason: 'Причина отклонения на конечном участке',
  Cargo_WebSite: 'Веб - сайт',
  Cargo_CompanyCode: 'Код компании',
  Cargo_ReceiptConfig: 'Настройка квитанций',
  Cargo_EditBookingChannelConfig: 'Изменить параметры канала бронирования',
  Cargo_AddBookingChannelConfig: 'Дополнительные каналы бронирования',
  Cargo_ReceiptConfigCannotBeEmpty: 'Параметры квитанций не могут быть пустыми',
  Cargo_IndiaLineInfo: 'Индийская линия',
  Cargo_CargoAmount: 'Стоимость товаров',
  Cargo_CargoCurrency: 'Валюта',
  Cargo_YdShipCode: 'Судоходная компания',
  Cargo_SendThisPageEDI: 'Отправить эту страницу EDI',
  Cargo_SendAllEDI: 'Отправить все EDI',
  Cargo_SendEDI: 'Отправить EDI?',
  Cargo_IsSendAllEDI: 'Отправить все EDI?',
  Cargo_SendEDISucceeded: 'Отправить EDI успешно',
  Cargo_FailedToSendEDI: 'Ошибка отправки EDI',
  Cargo_CheckCanSendEDI: 'Забронирован или забронирован, не может быть отправлен снова.',
  Cargo_OneKeyBooking: 'Бронирование в один клик',
  Cargo_OneKeyBookingTip1: 'Выполнение условий для начала бронирования: > span style="color: blue">{0}</span>Статья, нажмите【Подтверждение】После этого начнется бронирование, которое можно проверить в EDI или на странице бронирования по морю.',
  Cargo_OneKeyBookingTip2: 'Теплый совет: Заказ, удовлетворяющий следующим условиям, запустит заказ одним нажатием клавиши < br / > 1) Дата вылета > день < br / > 2) Состояние заказа является "зарегистрированным, незарезервированным" < br / > 3) Тип груза: общий груз < br / > 4) Весь тип сборки:',
  Cargo_CanNotBooking: 'Нет бизнеса, соответствующего 【Условия бронирования】',
  Cargo_CurrentlyBooking: 'Уже 2 месяца заказывают:',
  Cargo_SendSuccess2: 'Отправить успешно:',
  Cargo_CallEdiFail: 'Вызов аномалии:',
  Cargo_ValidFail: 'Ошибка проверки:',
  Cargo_TemplateMatchFail: 'Ошибка согласования шаблонов:',
  Cargo_BookingSendMethod: 'Способ отправки заказа',
  Cargo_BookingSendChannel: 'Канал доставки заказов',
  Cargo_BookingSendDate: 'Время отправки заказа',
  Cargo_BookingReceiptDate: 'Время квитанции',
  Cargo_OriginBookingState: 'Первоначальное состояние бронирования',
  Cargo_NotBooking: 'Без бронирования.',
  Cargo_ContinueBooking: 'Продолжайте бронирование.',
  Cargo_ChangeInfo: 'Изменить информацию',
  Cargo_BookingTransportMode: 'Способ бронирования',
  Cargo_EdiBookingExportState: 'Экспорт состояния',
  Cargo_OneKeyBookingTip3: 'Начинается бронирование, и позже вы можете увидеть конкретный статус бронирования.',
  Cargo_BookingInProgress: 'Заказываем каюты.',
  Cargo_NewSpaceCarrier: 'Перевозчик дополнительных мест',
  Cargo_AlreadyExistsCheck: 'Те же данные уже существуют и не нуждаются в сохранении.',
  Cargo_portOfLoadingSeaport: 'Информация о классе проезда Порт отправления (морской порт)',
  Cargo_portOfDestinationSeaport: 'Порт назначения информации о классе проезда (морской порт)',
  Cargo_portOfLoadingAirport: 'Информация о классе проезда Порт отправления (аэропорт)',
  Cargo_portOfDestinationAirport: 'Информация о классе проезда Порт назначения (аэропорт)',
  Cargo_shippingCarrier: 'Перевозчики',
  Cargo_shippingAirline: 'маршрут с информацией о классе проезда',
  Cargo_newEventRecord: 'Дополнительные записи событий',
  Cargo_SelectInquiryToCopy: 'Пожалуйста, выберите запрос для копирования',
  Cargo_VerifyStateReceivableDomestic: 'Списание внутренней дебиторской задолженности',
  Cargo_VerifyStateReceivableOversea: 'Списание дебиторской задолженности за рубежом',
  Cargo_ReturnActualAmountNo: 'Номер ассоциированной воды',
  Cargo_ReturnAmount: 'Возмещенные суммы',
  Cargo_ReturnApplyAmount: 'Сумма возмещения',
  Cargo_ReturnApplyState: 'Статус возврата',
  Cargo_ReturnApply: 'Возврат средств',
  Cargo_ReturnApplyCancel: 'Возврат средств',
  Cargo_ReturnApplyAudit: 'Согласие на возврат',
  Cargo_ReturnApplyReject: 'Отказ возвратить деньги',
  Cargo_RemainingClaimedAmount: 'Оставшаяся сумма требований',
  Cargo_RefundAmount: 'Сумма возмещения',
  Cargo_ReturnApplyCheck: 'Есть записи о возврате денег, которые должны быть одобрены, и новая заявка на возврат не может быть запущена!',
  Cargo_RemainingClaimedAmountZero: 'Оставшаяся заявленная сумма 0, возврат невозможен!',
  Cargo_ReturnApplyAmountZero: 'Сумма возврата 0, возврат невозможен!',
  Cargo_ReturnApplyAuditCheck: 'Только статус для записи в утверждении, пожалуйста, перечеркните!',
  Cargo_WaterRefundedNoWriteOff: 'Записи о возврате счетов за воду, не поддерживаются операции по утверждению!',
  Cargo_WaterRefundingNoWriteOff: 'Статус возврата является записью в процессе утверждения и не поддерживает операцию запроса!',
  Cargo_WaterRefundedNoCancel: 'Записи о возврате счета на воду не поддерживают отмену действия запроса!',
  Cargo_khEntryActTime: 'Въезд воздушным транспортом (фактическое время)',
  Cargo_transferDeclareCompletedActTime: 'Заявление о транзите завершено (фактическое время)',
  Cargo_khExitActTime: 'Выезд воздушным транспортом (фактическое время)',
  Cargo_khDeclareActTime: 'Таможенная очистка по карте (фактическое время)',
  Cargo_khReplacementActTime: 'Перегрузка (фактическое время)',
  Cargo_arrivePodActTime: 'Прибытие в пункт назначения (фактическое время)',
  Cargo_arriveClearActTime: 'Прибытие в пункт таможенной очистки (фактическое время)',
  Cargo_khUnloadingActTime: 'Разгрузка (фактическое время)',
  Cargo_CustomerReserveVoyage: 'Заказчик заказал рейс',
  Cargo_CustomsDeclarationInformation: 'Информация о таможенной декларации',
  Cargo_CustomsDeclarationCommissionNumber: 'Номер таможенного поручения',
  Cargo_CustomsDeclarationNotExist: 'Поддерживайте хотя бы один [bracket0]',
  Cargo_ReferenceNoRepeat: 'Номера ссылок в VGM не повторяются',
  Cargo_QuantityWeightCubageChange: 'Изменение информации о волосах, покрывается ли это?',
  Cargo_CustomerDemandClearanceNumber: 'Потребности клиентов',
  Cargo_Empty2: '(Пустой)',
  Cargo_QuantityWeightCubage: 'Волосатое тело',
  Cargo_CustomsDeclarationDeleteTip: 'Текущий номер таможенной декларации связан с заказом таможенной декларации, не может быть удален',
  Cargo_CustomsDeclarationValidTip: 'Сведения о волосах не могут быть 0',
  Cargo_CustomsDeclarationSoNoRepeat: '【Номер квитанции】 Не допускается дублирование в информации о таможенной накладной в одном и том же билетном бизнесе',
  Cargo_AuditCancel: 'Вы уверены, что хотите отменить аудит?',
  Cargo_AuditCancelReason: 'Причины отмены проверки',
  Cargo_NuoNuoTipOne: 'Когда канал выставления билетов = nono, заполните этот элемент конфигурации 1 для красного импульса, если он не открывается автоматически, без настройки при автоматическом открытии.',
  Cargo_DestinationVehicleNumberOne: 'Автобус номер один.',
  Cargo_DestinationVehicleRegister: 'Регистрационный номер',
  Cargo_ConfirmLockLabelBuyingPrice: 'Определена ли покупная цена блокировки?',
  Cargo_ConfirmLockLabelSellingPrice: 'Определена ли цена блокировки?',
  Cargo_ConfirmUnlockLabelBuyingPrice: 'Определена ли покупная цена разблокировки?',
  Cargo_ConfirmUnlockLabelSellingPrice: 'Определена ли цена разблокировки?',
  Cargo_PurchasePriceLockedStatus: 'Состояние блокировки покупной цены',
  Cargo_SellingPriceLockedStatus: 'Состояние блокировки цены',
  Cargo_BatchPurchasePriceLock: 'Блокирование покупной цены.',
  Cargo_BatchPurchasePriceUnLock: 'Скачать Купить Цена',
  Cargo_BatchSellingPriceUnLock: 'Разблокировать цены',
  Cargo_BatchSellingPriceLock: 'Блокирование цены продажи.',
  Cargo_NotActiveCompanyCleared: 'В этом билетном бизнесе есть неактивные партнеры: система {0} автоматически очищает их, выберите новый вход.',
  Cargo_FBA_SE: 'FBA Морские перевозки',
  Cargo_FBA_AE: 'FBA Воздушный транспорт',
  Cargo_FBA_RE: 'Железнодорожный ФБА',
  Cargo_SyncCreditTip: 'После нажатия на эту кнопку 【Синхронизация】 временный контроль письма, который удовлетворяет требованиям текущей страницы, вступает в силу немедленно, и может быть частичная задержка с перерасчетом суммы и периода счета.',
  Cargo_SyncTempCreditTip: 'Не синхронизируйте сразу, когда существует временный поток утверждения письма.',
  Cargo_OperationInstructions: 'Операционная команда',
  Cargo_InstructionName: 'Название команды',
  Cargo_InstructionType: 'Тип команды',
  Cargo_RuleCode: 'Правильный код',
  Cargo_CodeParameterValues: 'Значение параметра кода',
  Cargo_InstructionCode: 'Код команды',
  Cargo_CommandDisplayName: 'Показать имя команды',
  Cargo_InstructionDescription: 'Инструкции',
  Cargo_InstructionRuleSetting: 'Параметры командных правил',
  Cargo_IfAllowedSendMultipleTimes: 'Допускается ли многократная отправка',
  Cargo_CanOnlyBeSentOnce: 'Можно отправить только один раз.',
  Cargo_CanBeSentMultipleTimes: 'Можно отправлять несколько раз',
  Cargo_TemplateMatching: 'Соответствие шаблонов',
  Cargo_UnifiedBusinessScenario: 'Выберите звено push, когда у разных филиалов есть шаблон независимого обслуживания, соответствующий шаблону филиала',
  Cargo_SelectEmailTemplate: 'Выберите шаблон сообщения',
  Cargo_SelectOperationInstruction: 'Выберите команду операции',
  Cargo_SelectSpecificBusinessRule: 'Выбор конкретных бизнес - правил',
  Cargo_SelectThePushLink: 'Выберите звено толкания',
  Cargo_OperationButtonSettingsAndTip: 'Настройка кнопки управления (до 5 инструкций)',
  Cargo_SelectInstruction: 'Команда выбора',
  Cargo_SetParameters: 'Параметры',
  Cargo_SetParameterValues: 'Установить значение параметра',
  Cargo_InstructionChineseName: 'Китайское имя команды',
  Cargo_InstructionEnglishName: 'Английское название команды',
  Cargo_InstructionJapaneseName: 'Японское имя команды',
  Cargo_CheckRuleNameExist: 'Название существующего правила [bracket0]',
  Cargo_LatestInstructionRecord: 'Выполнение последних оперативных директив',
  Cargo_InstructionRecords: 'Журнал инструкций',
  Cargo_QueryInstructionRecords: 'Просмотреть журнал выполнения команд',
  Cargo_ExecuteResult: 'Результаты осуществления',
  Cargo_OperationInstructionsManagement: 'Управление операционными командами',
  Cargo_PlatformInstructionDisabled: 'Эта директива больше не работает, проверьте правильность конфигурации!',
  Cargo_NotMatchInstruction: 'Операции, не отвечающие требованиям директивы',
  Cargo_SelectJobCount: 'Количество выбранных операций',
  Cargo_MatchInstructionTip: 'Выберите пункт {0}, который соответствует условиям инструкции по эксплуатации {1}',
  Cargo_OperationInstructionSetTip: 'При настройке команды операции значение [bracket0] не может быть пустым!',
  Cargo_OperationInstructionRepeatTip: 'При настройке команды действия выбранная команда не может быть повторена!',
  Cargo_OperationInstructionBatchTip: 'При каждой массовой отправке почты не выбирайте более 30 бизнес - данных.',
  Cargo_CurrentUserRole: 'Текущая роль пользователя',
  Cargo_DisabledUnableToSave: '"{0}" отключен и не может быть сохранен, пожалуйста, удалите соответствующие расходы для сохранения.',
  Cargo_CompanyDateOfCreation: 'Время создания подразделения',
  Cargo_BringInBusinessInformation: 'Дополнительная информация о заказах',
  Cargo_LclSendDestinationPortAgentTip: 'Вы можете выбрать только один основной билет для отправки агента порта назначения',
  Cargo_LclSendPackageAgentTip: 'Вы можете выбрать только один основной билет для отправки единого портового агента',
  Cargo_SetUploadFileType: 'Установить тип файла загрузки',
  Cargo_PillReportData: 'Создание и замена источников данных вручную',
  Cargo_CanOnlyPrintOnce: 'Можно распечатать только один раз.',
  Cargo_CanPrintMultipleTimes: 'Можно печатать несколько раз.',
  Cargo_IfSelectTemplateType: 'Выберите тип файла шаблона, который соответствует шаблону филиала, когда у разных филиалов есть шаблон независимого обслуживания',
  Cargo_PrintMode: 'Режим печати',
  Cargo_SingleJobPrint: 'Однобилетная бизнес - печать',
  Cargo_BatchJobPrint: 'Массовая печать',
  Cargo_SinglePrintFileType: 'Тип файла для печати одного билета',
  Cargo_BatchPrintFileType: 'Тип файла для массовой печати',
  Cargo_SinglePrintFileTemplate: 'Шаблоны файлов для распечатки одного билета',
  Cargo_BatchPrintFileTemplate: 'Шаблоны документов для массовой печати',
  Cargo_SelectPrintFileTemplate: 'Выберите шаблон для печати файла',
  Cargo_SelectPrintFileType: 'Выберите тип файла для печати',
  Cargo_SelectPrintFileTypeTip: 'Выбранный шаблон печати не устанавливает тип файла! Сначала укажите тип файла, соответствующий шаблону печати',
  Cargo_CabinRetrievalSuccessful: 'Успешное восстановление класса',
  Cargo_CabinFlowExitAndNo: 'Наличие данных о потоках и потоках, не связанных с классом, которые не могут использоваться одновременно',
  Cargo_CabinRetrievalAndReturnSuccessful: 'Успешное возвращение и возврат места',
  Cargo_revokeCabinSpace: 'Заказы, которые вы выбрали, выполнят процесс отзыва места',
  Cargo_CancelCabinAtTheSameTime: 'Одновременный выход.',
  Cargo_DeleteConfigTip: 'Убедитесь, что он удалён? После удаления первоначальные настройки функции не будут использоваться!',
  Cargo_PreviewVoucher: 'Предварительный просмотр сертификатов',
  Cargo_InvoiceNotVoucher: 'Счет - фактура не генерирует ваучеров, пожалуйста, выберите заново.',
  Cargo_BankSlipNotVoucher: 'Водный талон не генерирует ваучер, пожалуйста, выберите его заново.',
  Cargo_PleaseChooseDataThatHasVouchered: 'Выберите данные генерированных сертификатов.',
  Cargo_ExportVoucherSuccessfully: '{0} Сертификат успешно экспортирован.',
  Cargo_ExportVoucherFailedByBankSlip: 'Номер водяной накладной {0} не удалось экспортировать, причина {1}, попробуйте снова.',
  Cargo_ExportVoucherFailedByInvoice: 'Счет - фактура {0} Экспорт не удался, причина {1}, пожалуйста, попробуйте снова.',
  Cargo_UpdatePaidOffFlag: 'Обновление списано',
  Cargo_CheckMblSame: 'MB / L NO не совпадает с основной подписью страницы',
  Cargo_IfExistMblNumberRange: 'Есть ли основной номер',
  Cargo_UserName_Password_Maintained: 'Свяжитесь с администратором в службу поддержки "Основные настройки - анализ параметров канала"',
  Cargo_ShipCompany_Maintained: 'Пожалуйста, свяжитесь с администратором в "Партнер" для обслуживания ассоциированных судоходных компаний',
  Cargo_ShippingCompanyCode_Maintained: 'Компания не обслуживает судно отображения, пожалуйста, свяжитесь с платформой обслуживания клиентов',
  Cargo_ShippingCompanyCode_MaintainedTip: 'Пожалуйста, свяжитесь с сервисным обслуживанием платформы.',
  Cargo_BookingChannelConfig_Maintained: 'Не соответствует настройкам канала бронирования, пожалуйста, свяжитесь с администратором для обслуживания "Базовая конфигурация - конфигурация канала бронирования"',
  Cargo_BookingChannelConfig_MaintainedTip: 'Пожалуйста, свяжитесь с администратором для обслуживания "Базовая конфигурация - конфигурация каналов бронирования"',
  Cargo_ErrorMsg: 'Необычные причины',
  Cargo_SelectJumpErrorTip: '【{0}】 Это не переходная страница, выберите страницу, например: 【Основные】',
  Cargo_SelectJumpPage: 'Выберите страницу для перехода',
  Cargo_JumpSet: 'Параметры перехода',
  Cargo_ClickJobNoJumpPage: 'Нажмите номер операции, чтобы перейти на страницу',
  Cargo_JumpPage: 'Перейти на страницу',
  Cargo_TabNotExistTip: 'Невозможно получить доступ к этой странице, убедитесь, что есть права доступа или документ содержит эту страницу.',
  Cargo_CargoValue: 'Системные значения',
  Cargo_YdValue: 'Информация о квитанции',
  Cargo_ConfirmReplace: 'Подтверждение покрытия',
  Cargo_NotReplace: 'Не покрывается.',
  Cargo_ReplaceSystemValue: 'Сведения о системе',
  Cargo_PleaseSelectDataToReplace: 'Выберите поле, которое необходимо заполнить',
  Cargo_YdBookingResultTip: 'Обнаружено расхождение между информацией в квитанции и данными, введенными в систему, пожалуйста, убедитесь',
  Cargo_NoMappingValuesTip: '{0} Значения системы не совпадают, если требуется изменение, выберите вручную',
  Cargo_NonReplaceDataTip: 'Данные, не требующие покрытия',
  Cargo_JobNotFound: 'Не найден бизнес [bracket0]',
  Cargo_AE_IDENTIFICATION_SUPPLIER: 'Идентификация поставщиков',
  Cargo_AIR_BILL_SUPPLIER: 'Идентификация поставщиков авианакладных',
  Cargo_LoadingDate: 'Портовое обслуживание - время доставки',
  Cargo_DoorAddr: 'Сервис точки входа - адрес точки входа',
  Cargo_DoorMan: 'Служба портала - контакты',
  Cargo_DriverTel: 'Служба дверей - контактный телефон',
  Cargo_aeFile: 'Открытый файл',
  Cargo_aiFile: 'Пустой коносамент',
  Cargo_carrierType: 'Категория перевозчика',
  Cargo_DeclaredValue: 'Заявленная стоимость',
  Cargo_DeclaredValueForCustoms: 'Таможенная декларация стоимости',
  Cargo_RateLevel: 'Классификация ставок',
  Cargo_PleaseSelectOperateType: 'Страница [bracket0] Выберите режим работы',
  Cargo_BaoDiCreditInfoNote: 'Примечание: Когда тип даты, настроенный в системе, пуст, расчет производится с использованием гарантийного периода (унифицированный ежемесячный расчет), а дата истечения платежа пересчитывается, когда тип даты в операции имеет значение',
  Cargo_RpaAccount: 'Хостинг - аккаунт RPA',
  Cargo_WechatGroupName: 'Микрогрупповые разговоры о названиях',
  Cargo_TabEnterpriseWechat: 'Хостинг микроучетных записей',
  Cargo_LoginEnterpriseWechat: 'Войти в микро',
  Cargo_LoginEnterpriseWechatTip: 'Пожалуйста, используйте код сканирования корпоративного WeChat для входа в PMI',
  Cargo_RpaAccountSummary: 'Информация об учетной записи хостинга RPA',
  Cargo_RpaAccountSummaryTip: 'При необходимости корректировки вы можете подписать корректировку на странице [Партнеры - контакты].',
  Cargo_RpaAccountColumn: 'Корпоративный WeChat аккаунт',
  Cargo_RpaAccountEnabled: 'Состояние учетной записи',
  Cargo_BatchEditEnterpriseWechat: 'Массовое изменение контакта для микрогруппового разговора',
  Cargo_EditEnterpriseWechatButton: 'Изменить названия групповых разговоров в пакете',
  Cargo_RpaAccountColumn2: 'Хостинг - аккаунт RPA',
  Cargo_EditEnterpriseWechatTitle: 'Изменить контакты для групповых разговоров',
  Cargo_RpaAccountWechatGroupNameCanTBeEmpty: 'Пожалуйста, заполните поле разговора с хостинговой учетной записью RPA / корпоративной группой WeChat для сохранения.',
  Cargo_EnterpriseWechat: 'Корпоративный WeChat',
  Cargo_MessageContent: 'Содержание сообщения',
  Cargo_PushFiles: 'push - файл',
  Cargo_PushFilesTip: 'Файлы будут сжаты в ZIP - файлы и отправлены в корпоративные группы WeChat путем загрузки ссылок на адреса',
  Cargo_EnterpriseWechat2DataServiceReminder: '(Изменения только в плане судна)',
  Cargo_EnterpriseWechatSopTip: 'Пожалуйста, заполните имя группового разговора точно, иначе вы не сможете push. Если есть несколько, пожалуйста, заполните "," разделенные ".',
  Cargo_PleaseInputVerificationCode: 'Введите код проверки',
  Cargo_InputVerificationCodeTip1: 'Устройство для первого входа в систему требует ввода кода проверки, пожалуйста, введите код проверки, полученный клиентом мобильного телефона микроучетной записи',
  Cargo_InputVerificationCodeTip2: 'Ошибка проверки, код проверки не действителен или истек, введите снова',
  Cargo_CaptchaUsing: 'При проверке, пожалуйста, обновите состояние позже...',
  Cargo_LoginSuccess: 'Аккаунт: {0}, высадился успешно.',
  Cargo_PushEnterpriseWechat: 'Является ли это микро - толканием',
  Cargo_PushEnterpriseWechatTip: 'Контактный контакт не устанавливает имя корпоративной микроучетной записи и группового разговора, push - сообщение не сработает',
  Cargo_BottomLineCreditControl: 'Контролировать доверие',
  Cargo_ProfitShareConfig: 'Распределение части прибыли',
  Cargo_CreateRule: 'Правила создания',
  Cargo_EditRule: 'Правила редактирования',
  Cargo_CopyRule: 'Правила копирования',
  Cargo_RuleName: 'Название правила разделения',
  Cargo_RuleConfig: 'Настройка правил',
  Cargo_RuleRole: 'Роль',
  Cargo_ShareMode: 'Режим разделения влаги',
  Cargo_ShareModeJob: 'Распределение прибыли по полной стоимости',
  Cargo_ShareModeCurrency: 'Распределение прибыли по валютам',
  Cargo_UsdRatio: 'Распределение влаги',
  Cargo_NonUsdRatio: 'Доля, выраженная не в долларах США',
  Cargo_ShareModeTip: 'Режим:',
  Cargo_ShareModeJobTip: 'Всего голосов',
  Cargo_BankSlipDateCreated: 'Дата создания водной накладной',
  Cargo_ShareRatio: 'Разделение:',
  Cargo_PleaseSelectSalesBranch: 'Пожалуйста, выберите отдел продаж.',
  Cargo_RuleConfigSubCountNotNull: 'Правила настройки ветвей не могут быть пустыми',
  Cargo_SetUpConfigSubTriggerCondition: 'Пожалуйста, установите условия запуска.',
  Cargo_ConfigSubRuleError: 'Правило шунтирования Изменение условий, ошибка настройки условий запуска',
  Cargo_AddRuleConfigSub: '+ Добавить настройки ветвей',
  Cargo_AreYouSureModifyRuleConfigTips: 'Подтверждаются ли изменения?',
  Cargo_ProfitShare: 'Участвуют ли они в распределении',
  Cargo_ProfitShareColumn: 'Делить ли',
  Cargo_ProfitShareAdjust: 'Корректировка увлажнения',
  Cargo_ProfitShareReset: 'Перераспределение',
  Cargo_NonProfitShareBranch: 'Без участия в отделе',
  Cargo_ProfitShareRatioSumExceed: 'Текущая доля увлажнения превышает 100%, пожалуйста, подтвердите это после корректировки.',
  Cargo_UsdProfit: 'Долларовая прибыль',
  Cargo_NonUsdProfit: 'Прибыль не в долларах США',
  Cargo_JobProfit: 'Полная прибыль',
  Cargo_ShareBranchId: 'Диффузор',
  Cargo_UsdRatioColumn: 'Долларовая доля',
  Cargo_UsdProfitColumn: 'Доллар обещает прибыль',
  Cargo_UsdProfitColumn2: 'Ожидаемая прибыль',
  Cargo_NonUsdRatioColumn: 'Доля увлажнения, выраженная не в долларах США',
  Cargo_NonUsdProfitColumn: 'Ожидаемая прибыль не в долларах',
  Cargo_CheckProfitShareResetTip: '{0} Расходы на увлажнение для последующих финансовых действий (выставление счетов, платежи, счета, списания...), временно невозможно провести повторное увлажнение, до тех пор, пока соответствующее финансовое действие не будет отменено после повторной попытки.',
  Cargo_AdjustColumn: 'Изменения',
  Cargo_UsdProfitAdjustColumn: 'Доллар обещает дополнительную прибыль',
  Cargo_UsdProfitAdjustColumn2: 'Ожидаемая дополнительная прибыль',
  Cargo_NonUsdProfitAdjustColumn: 'Дополнительная прибыль ожидается не в долларах США',
  Cargo_JobProfitShare: 'Завершено ли разделение',
  Cargo_ReceivableFeeLockTime: 'Время фиксации дебиторской задолженности',
  Cargo_ReceivableFeeLockTime2: 'Время фиксации дебиторской задолженности',
  Cargo_EstimatedDeliveryDate: 'Ожидаемая дата доставки',
  Cargo_CheckWarehouseInConfig: 'Пожалуйста, выберите склад',
  Cargo_SelectScales: 'Пожалуйста, выберите весы',
  Cargo_PleaseEnterPieceCount: 'Пожалуйста, введите количество штук',
  Cargo_PleaseConfirm: 'Пожалуйста, подтвердите номер поступления/накладной',
  Cargo_WarehouseInState: 'Статус складского учета',
  Cargo_LocationConfigurationError: 'Поддоны не могут повторяться или уже заняты, пожалуйста, проверьте',
  Cargo_KeyNull: 'appKey не настроен',
  Cargo_TokenNull: 'token пустой',
  Cargo_CameraNull: 'Ошибка конфигурации камеры',
  Cargo_Reading: 'Показания',
  Cargo_ReadingTip: 'Несколько размеров разделяются запятой \',\' или точкой с запятой \';\' формат: длина*ширина*высота/количество;длина×ширина×высота/количество например: 35*40*30/3;35×40×30/3;',
  Cargo_ReadingTip2: 'Пожалуйста, укажите конфигурацию весов на складе',
  Cargo_CargoTerminalGrossWeight: 'Вес брутто терминала (КГ)',
  Cargo_FileUpload: 'Загр. файлов',
  Cargo_inputMblTip: 'Пожалуйста, отсканируйте/введите номер основной накладной',
  Cargo_OutboundWeight2: 'Операция взвешивания при отгрузке',
  Cargo_FileInfo: 'Информация о файле',
  Cargo_DeliveryOperation: 'Операция доставки',
  Cargo_MasterAirwayBill: 'Номер основной авианакладной',
  Cargo_DeliveryCargoStation: 'Терминал доставки',
  Cargo_SplitOrderNumber: 'Количество разделенных заказов',
  Cargo_TotalPieces: 'Общее количество штук',
  Cargo_TotalGrossWeight: 'Общий вес брутто',
  Cargo_TotalChargeableWeight: 'Общий расчетный вес',
  Cargo_TotalVolume: 'Общий объем',
  Cargo_PrintCheck1: 'Диапазон печати или количество копий неверны, пожалуйста, проверьте',
  Cargo_PrintRange: 'Диапазон печати',
  Cargo_PrintNumber: 'Количество копий',
  Cargo_GrossWeight3: 'Вес балласта',
  Cargo_DimensionsEntry: 'Ввод размеров',
  Cargo_WarehouseTip3: 'Отмена команды отгрузки завершена',
  Cargo_WarehouseTip2: 'Команда отгрузки завершена',
  Cargo_WarehouseTip1: 'Комплектация не завершена, пожалуйста, проверьте',
  Cargo_CancelOutboundOrder: 'Отменить команду отгрузки',
  Cargo_OutboundOrder: 'Команда отгрузки',
  Cargo_GoodsArrived: 'Товар прибыл',
  Cargo_Pallet3: 'Поддон',
  Cargo_WeightedInfo: 'Информация о взвешивании',
  Cargo_ScaleReading: 'Показания весов',
  Cargo_ScalePhoto: 'Фото весов',
  Cargo_Tip: 'Подсказка: поддерживает номер поступления/накладной',
  Cargo_ReadScale: 'Считать вес',
  Cargo_TakePhoto: 'Сделать фото',
  Cargo_Weighing: 'Взвешивание',
  Cargo_WeightRecord: 'Запись веса',
  Cargo_WeightHandling: 'Обработка веса',
  Cargo_SaveDone: 'Сохранить и завершить приемку',
  Cargo_DeliverySecurityCheck: 'Доставка',
  Cargo_OutboundWeight: 'Вес отгрузки',
  Cargo_NetGrossWeight: 'Вес нетто-брутто',
  Cargo_VolumeWeight: 'Объемный вес',
  Cargo_BatchEnterDimensions: 'Пакетный ввод размеров',
  Cargo_CoveringSizeAndQuantity: 'Примечание: Полностью перезапишет текущие данные о размере и количестве',
  Cargo_EstimatedDeliveryDateError: 'Ошибка распознавания',
  Cargo_ScaleWeight: 'Вес по весам',
  Cargo_OurPallet: 'Наш поддон',
  Cargo_TareWeight: 'Вес тары',
  Cargo_GrossWeight2: 'Балласт',
  Cargo_Location2: 'Место хранения',
  Cargo_FrontEndWarehouseOperation: 'Операции фронт-склада',
  Cargo_CargoTerminalOperation: 'Операции терминала',
  Cargo_FileSizeCannotExceed20m2: 'Размер файла не может превышать 20 МБ, поддерживаются форматы .xls и .xlsx',
  Cargo_StateUpdate: 'Обновление статуса',
  Cargo_CheckInventory: 'Проверка запасов',
  Cargo_ReleaseLocation: 'Освободить место',
  Cargo_LocationCode: 'Код места',
  Cargo_Warehouse2: 'Принадлежность к складу',
  Cargo_LocationType: 'Тип места',
  Cargo_LocationStatus: 'Статус места',
  Cargo_LocationDeleteTip: 'Место занято, нельзя удалить',
  Cargo_ReadFailure: 'Ошибка чтения',
  Cargo_PalletDeleteTip: 'Текущий поддон занят, нельзя удалить',
  Cargo_NoLocationSelected: 'Место не выбрано',
  Cargo_PackingCondition: 'Состояние упаковки',
  Cargo_SpecialHandling: 'Особая обработка',
  Cargo_PalletNumber: 'Номер листа',
  Cargo_AirlineProductCode: 'Маршрутная продукция',
  Cargo_InventoryCheck: 'Просмотр запасов',
  Cargo_ApplyRuleToAllScenarios: 'Применить настройки правил ко всем сценариям',
  Cargo_DocumentsWithCargo: 'Документы к грузу',
  Cargo_CurrentBusinessAlreadyWeighedOut: 'Данная операция уже выгружена по весу, повторное выполнение запрещено.',
  Cargo_CurrentBusinessAlreadyDelivered: 'Данная операция уже завершена поставкой, повторное выполнение запрещено.',
  Cargo_PalletConfiguration: 'Управление поддонами',
  Cargo_Pallet2: 'Поддон',
  Cargo_PalletID: 'Номер поддона',
  Cargo_PalletStatus: 'Статус поддона',
  Cargo_PalletMaterial: 'Материал поддона',
  Cargo_RecyclingType: 'Тип переработки',
  Cargo_PalletTareWeight: 'Вес тары поддона',
  Cargo_AirCargoTerminal: 'Авиагрузовой терминал',
  Cargo_WarehouseType: 'Тип склада',
  Cargo_WarehouseCode2: 'Код склада',
  Cargo_WarehouseName: 'Название склада',
  Cargo_WarehouseAddress: 'Адрес склада',
  Cargo_Terminal: 'Терминал',
  Cargo_TerminalCode: 'Код терминала',
  Cargo_TerminalName: 'Название терминала',
  Cargo_AirportCode: 'Код аэропорта',
  Cargo_TerminalAddress: 'Адрес терминала',
  Cargo_DeliveryMap: 'Карта доставки',
  Cargo_RecipientContact: 'Контактное лицо получателя',
  Cargo_RecipientContactPhone: 'Контактный телефон получателя',
  Cargo_SecurityCheckMachineWidthLimit: 'Ограничение по ширине досмотрового аппарата',
  Cargo_SecurityCheckMachineHeightLimit: 'Ограничение по высоте досмотрового аппарата',
  Cargo_CustomsCode: 'Таможенный код',
  Cargo_WeighbridgeNumber: 'Номер весов',
  Cargo_WeighbridgeBaudRate: 'Скорость передачи весов',
  Cargo_Checksum: 'Контрольная сумма',
  Cargo_AutoFinanceAuditLockOrder: 'Автоматическая блокировка заказов при финансовом аудите',
  Cargo_UnSubmittedBusinessLockOrder: 'Неотправленные заявки будут автоматически заблокированы (Статус заявки: В процессе -> Проверено)',
  Cargo_PollingFrequency: 'Частота опроса',
  Cargo_SpecificDateMonthly: 'Определенная дата ежемесячно',
  Cargo_DailyOnce: 'Один раз в день',
  Cargo_PhotoTaken: 'Фотографировать',
  Cargo_CameraConfiguration: 'Настройка камеры',
  Cargo_WeighbridgeTest: 'Тест весов',
  Cargo_Test: 'Тест',
  Cargo_MonitoringInterface: 'Интерфейс мониторинга',
  Cargo_DeviceNumber: 'Номер устройства',
  Cargo_MonitoringChannel: 'Канал мониторинга',
  Cargo_MonitoringInterface1: 'Облако Ying Shi',
  Cargo_DeleteTip1: 'Вы собираетесь удалить {0} {1} записей, действуйте с осторожностью',
  Cargo_GeneralCargoWarehouse: 'Склад обычных грузов',
  Cargo_WarehouseStorageLocation: 'Складское место хранения',
  Cargo_EstimatedAmazonArrivalTime: 'Предполагаемое время прибытия на склад Amazon',
  Cargo_SelectCommonShipper: 'Выбрать часто используемого отправителя',
  Cargo_SaveAsCommonShipper: 'Сохранить как часто используемого отправителя',
  Cargo_SelectCommonConsignee: 'Выбрать часто используемого получателя',
  Cargo_SaveAsCommonConsignee: 'Сохранить как часто используемого получателя',
  Cargo_SelectCommonNotifier: 'Выбрать часто используемого уведомляемого',
  Cargo_SaveAsCommonNotifier: 'Сохранить как часто используемого уведомляемого',
  Cargo_BoxQuantity: 'Количество коробок',
  Cargo_OutboundMode: 'Режим отгрузки',
  Cargo_PalletQuantity: 'Количество поддонов',
  Cargo_InventoryAge: 'Срок хранения (дни/недели)',
  Cargo_OutboundOperator: 'Оператор отгрузки',
  Cargo_RemainingBoxes: 'Остаток коробок на складе',
  Cargo_Goods: 'Товары',
  Cargo_InventoryInfo: 'Информация о запасах',
  Cargo_OutboundByPallet: 'Отгрузка по поддонам',
  Cargo_OutboundByBox: 'Отгрузка по коробкам',
  Cargo_Outbound: 'Отгружено',
  Cargo_NotOutbound: 'Не отгружено',
  Cargo_OutboundBatch: 'Партия отгрузки',
  Cargo_BoxesInStock: 'Коробки на складе',
  Cargo_PalletsInStock: 'Поддоны на складе',
  Cargo_PromptWord: '##Приложенный обзор：\n' +
    'Это счет-фактура на потребление. Определите валюту в соответствии с языком счета-фактуры. Пожалуйста, идентифицируйте следующие поля: поставщик услуг (сервисный провайдер), сумма потребления, потребительский налог (сумма налога), ставка налога, валюта.\n' +
    '##Требования к выводу：\n' +
    '1、Вернуть в формате JSON. Все имена полей в JSON должны быть на китайском языке.\n' +
    '2、Пример формата json：\n' +
    '      { \n' +
    '        "data": {\n' +
    '          "Получатель груза": "",\n' +
    '          ……\n' +
    '        }\n' +
    '      }\n' +
    '##Определения и правила для каждого поля следующие：\n' +
    '#1、Поставщик услуг (сервисный провайдер)\n' +
    '#2、Сумма потребления\n' +
    '#3、Потребительский налог (сумма налога)\n' +
    '#4、Ставка налога\n' +
    '#5、Валюта',
  Cargo_PayableFeeLockTime: 'Сроки блокирования кредиторской задолженности',
  Cargo_PayableFeeLockTime2: 'Сроки блокирования кредиторской задолженности',
  Cargo_PayableFeeLockPerson: 'Кто заблокировал кредиторскую задолженность',
  Cargo_PleaseConfirmFinancialDate: 'Просьба подтвердить финансовую дату:',
  Cargo_SoldSlots: 'Количество проданных мест',
  Cargo_RemainingSlots: 'Оставшиеся места',
  Cargo_SoldVolume: 'Объем продаж',
  Cargo_RemainingVolume: 'объемный припуск',
  Cargo_FlightDateError: 'Продолжится ли рейс, дата которого не входит в срок действия продукта маршрута, или рейс, соответствующий дате рейса, не входит в рейс обслуживания продукта маршрута?',
  Cargo_DimensionsExceedRouteProductLimits: 'Размер превышает линейный продукт - ограничение в рейсе, продолжается ли?',
  Cargo_FlightReassignment: 'Перераспределение рейсов',
  Cargo_InformationMaintenance: 'Поддержание информации',
  Cargo_VehicleInformation: 'Информация о транспортном средстве',
  Cargo_CountyDistrict: 'Округ/Район',
  Cargo_TownStreet: 'Город/Улица',
  Cargo_VillageCommunity: 'Деревня/Община',
  Cargo_FleetPhoneNumber: 'Телефон номер автопарка',
  Cargo_DoorPointName: 'Название дверной точки',
  Cargo_DeliveryArea: 'Зона доставки',
  Cargo_EstimatedLoadingTime: 'Ожидаемое время загрузки',
  Cargo_ActualLoadingTime1: 'Фактическое время загрузки',
  Cargo_DeliverySequenceNumber: 'Номер последовательности доставки',
  Cargo_DispatchVehicleNoteFields: 'При выполнении операции отправки транспорта обратите внимание на заполнение следующих полей:',
  Cargo_TTDEG: 'Транспортная компания, плата за тягач, название дверной точки, ожидаемое время загрузки, брутто',
  Cargo_RouteMarking: 'Маршрутные знаки',
  Cargo_SecondaryConfirmation: 'Повторное подтверждение',
  Cargo_BookingCompleted: 'Заказ уже выполнен, проверьте:',
  Cargo_DataNotPendingConfirmation: 'Наличие неподтвержденных данных, пожалуйста, проверьте:',
  Cargo_PortMismatch: 'Порт отправления, порт назначения не полностью совпадают, уверены в продолжении?',
  Cargo_DataNotConfirmed: 'Наличие неподтвержденных данных, проверьте:',
  Cargo_RouteNotConfirmedOrDoubleConfirmed: 'Наличие данных, которые не подтверждены маршрутом или подтверждены дважды, проверьте:',
  Cargo_SelectOneMasterBill: 'Максимум один билет.',
  Cargo_DataNotRouteDoubleConfirmed: 'Наличие данных вторичного подтверждения нелинейности, проверьте:',
  Cargo_GrossProfitAmount: 'Сумма валовой прибыли',
  Cargo_SpecialExpenseIndicator: 'Индикатор специальных расходов',
  Cargo_SpecialExpensePayableTotal: 'Общая сумма специальных расходов к оплате',
  Cargo_SpecialExpensePayableCurrency: 'Валюта для специальных расходов к оплате',
  Cargo_SpecialExpenseReceivableTotal: 'Общая сумма специальных расходов к получению',
  Cargo_SpecialExpenseReceivableCurrency: 'Валюта для специальных расходов к получению',
  Cargo_BookingCompletion: 'Заказ завершен.',
  Cargo_RouteConfirmation: 'Маршрут подтвержден.',
  Cargo_RouteConfirmationStatus: 'Режим подтверждения маршрута',
  Cargo_FlightDateRange: 'Дата рейса',
  Cargo_RouteConfirmationPerson: 'Подтверждение маршрута',
  Cargo_RouteConfirmationTimeRange: 'Время подтверждения маршрута',
  Cargo_IsBookingCompleted: 'Заказ завершен',
  Cargo_OrderNumber: 'Номер заказа',
  Cargo_FlightNumber: 'Номер рейса',
  Cargo_SecondLegFlight: 'Второй рейс',
  Cargo_SecondLegAirline: 'Отдел воздушных перевозок',
  Cargo_SecondLegDocumentNumber: 'Двойной номер.',
  Cargo_SecondLegETD: 'Второй ETD',
  Cargo_SecondLegETA: 'Вторая ETA',
  Cargo_ThirdLegFlight: 'Три рейса.',
  Cargo_ThirdLegAirline: 'Трехрейсовый отдел',
  Cargo_ThirdLegDocumentNumber: 'Тройной номер.',
  Cargo_ThirdLegETD: 'Три ETD',
  Cargo_ThirdLegETA: 'Три ETA',
  Cargo_FreightUnitPrice: 'Цена за единицу фрахта',
  Cargo_SignatureWeight: 'Вес подписи',
  Cargo_SignatureDimensions: 'Размер подписи',
  Cargo_SignatureRemarks: 'Примечания к расписке',
  Cargo_FoldedWeightRemarks: 'Сноски',
  Cargo_TotalPrice: 'Общая стоимость',
  Cargo_TransshipmentFee: 'Транспортные расходы',
  Cargo_HumanResourcePerformance: 'Профессионализм персонала',
  Cargo_AIEngine: 'AI-двигатель',
  Cargo_ProvisionReport: 'Отчет о начислениях',
  Cargo_ScriptName: 'Название скрипта',
  Cargo_ScriptDescription: 'Описание скрипта',
  Cargo_GenerateScript: 'Создать скрипт',
  Cargo_RuleDescription: 'Описание правила',
  Cargo_ScriptPreview: 'Предпросмотр скрипта',
  Cargo_CommissionRole: 'Роль комиссионных',
  Cargo_CommissionPersonnel: 'Персонал комиссионных',
  Cargo_ApplicableScript: 'Применимый скрипт',
  Cargo_RuleApplication: 'Применение правила',
  Cargo_ApplicablePersonnel: 'Применимый персонал',
  Cargo_BusinessVolume: 'Объем бизнеса',
  Cargo_ApplicableRule: 'Применимое правило',
  Cargo_CustomsProvision: 'Начисление таможенных платежей',
  Cargo_OperationProvision: 'Операционное начисление',
  Cargo_CustomerServiceProvision: 'Начисление за услуги клиентам',
  Cargo_BusinessProvision: 'Начисление по бизнесу',
  Cargo_SalesProvision: 'Начисление по продажам',
  Cargo_OperationTicketProvision: 'Начисление операционных билетов',
  Cargo_SalesSupervisorProvision: 'Начисление руководителя продаж',
  Cargo_OperationSupervisorProvision: 'Начисление операционного руководителя',
  Cargo_ConfirmCancelProvision: 'Подтвердить отмену начисления?',
  Cargo_LockLimit: 'Ограничение блокировки',
  Cargo_ReceivableFullWriteOffTime: 'Время полного списания дебиторской задолженности',
  Cargo_LockAccountsReceivableAndPayableEntry: 'Блокировка ввода дебиторской и кредиторской задолженности',
  Cargo_ViewDetailedBusiness: 'Просмотреть подробный бизнес',
  Cargo_TestRun: 'Тестовый запуск',
  Cargo_ProvisionLimit: 'Лимит начисления',
  Cargo_ViewProvisionDetails: 'Просмотр деталей начисления',
  Cargo_ProvisionBatchNumber: 'Номер партии начисления',
  Cargo_ProvisionPerson: 'Лицо, ответственное за начисление',
  Cargo_ProvisionTime: 'Время начисления',
  Cargo_ProvisionRole: 'Роль начисления',
  Cargo_PendingProvision: 'Ожидаемое начисление',
  Cargo_ProvisionHistory: 'История начисления',
  Cargo_ResponsibleCustomerService: 'Ответственный клиент',
  Cargo_ResponsibleOperator: 'Ответственные операции',
  Cargo_ConfirmAndBookingCompleted: 'Подтверждение и бронирование завершено.',
  Cargo_OrderQuantity: 'Количество заказов',
  Cargo_FinancialStatus: 'Финансовое состояние',
  Cargo_FinancialColorTip: 'Диапазон настройки контроля цвета таблицы: \nБронирование авиаперевозок - Список\nОперации авиаперевозок - Список\nИнтегрированные логистические услуги - Список\nОперации железнодорожных перевозок - Список\nУдаленное бронирование - Список\nЗапросы продаж - Список\nМорской экспорт - Список\nМорские операции - Список\nМорской импорт - Прогноз - Список\nЗапросы продаж - Отдел зарубежных продаж - Список\nЗапросы продаж - Отдел продаж - Список\nМорской экспорт - Билль о ладье - Список\nМорской экспорт - EDI - Список\nФинансовый аудит - Список\nФинансовый аудит - Закрытие - Список\nАвиационный экспорт - Декларация таможни - Список\nАвиационный экспорт - Предварительный склад - Список\nЭкспорт авиаперевозок - Склад - Список\nМорской импорт - Операции на складе - Список',
  Cargo_CurrentInvoiceDifferentRates: 'Текущий счет содержит расходы с разными ставками налога. Счета будут разделены по ставкам налога и выставлены отдельно, используя единый код налогообложения по умолчанию. Продолжить эту операцию?',
  Cargo_CurrentSelectionContains9TaxPointsAndOthers: 'Текущий выбор содержит 9 налоговых ставок и другие налоговые ставки. Из-за специфики товарной транспортной накладной, пожалуйста, подайте заявку отдельно. Невозможно подать заявку на счет-фактуру вместе.',
  Cargo_NumberOfOriginalCopies: 'Количество оригиналов',
  Cargo_DisplayDllInformation: 'Показать всю информацию',
  Cargo_DisplayDifferenceInformation: 'Показать информацию о разнице',
  Cargo_OverrideSystemBillOfLading: 'Покрытие системных коносаментов',
  Cargo_ContainerIdTip: 'Информация об упаковке (галочка добавляется в коносамент или покрывает данные коносамента)',
  Cargo_ContainerInfo2: 'Информация о контейнере (если отмечено, она будет добавлена в коносамент или перезапишет данные коносамента)',
  Cargo_ContainerTypeQuantityMismatch: 'Тип/количество контейнеров не соответствует выбранной информации о контейнере, пожалуйста, подтвердите.',
  Cargo_SystemData: 'Системные данные',
  Cargo_RecognitionData: 'Идентификационные данные',
  Cargo_GrossProfit: 'Маори',
  Cargo_MustEnterComplete: 'Запись должна быть завершена.',
  Cargo_CostVirtualImplementationToConsolidationPlan: 'Стоимость виртуального внедрения в план сборки',
  Cargo_ReceivablesWriteoffDate: 'Дата списания дебиторской задолженности',
  Cargo_PayablesWriteoffDate: 'Дата списания',
  Cargo_FeeInvoiceTitle: 'Возвышение счетов - фактур',
  Cargo_PaymentApplicationTitle: 'Рост заявок на оплату',
  Cargo_NotData: 'Данные не найдены',
  Cargo_LclHasMaster: 'Маленький билет уже связан с основным билетом.',
  Cargo_ParamError: 'Ошибка параметра, проверьте',
  Cargo_BillResults: 'Поле идентификации коносамента',
  Cargo_BillResults2: 'Данные системного коносамента',
  Cargo_NotUpdate: 'Без изменений',
  Cargo_UpdateCheck1: 'Обратите внимание, что размер ящика не совпадает с информацией об упаковке, указанной галочкой.',
  Cargo_seaFile2: 'Идентификация оффшорной книги',
  Cargo_siFile2: 'Идентификация морских импортных коносаментов',
  Cargo_seBillFile2: 'Идентификация морских экспортных коносаментов',
  Cargo_aeFile2: 'Идентификация авиаэкспортных накладных',
  Cargo_aiFile2: 'Идентификация импортных коносаментов по воздуху',
  Cargo_OnlyServiceDataLocked: 'Заблокируйте только бизнес - данные, подпись страницы расходов может быть отредактирована',
  Cargo_AutomaticallyLocksServiceData: 'Автоблокировка бизнес - документов',
  Cargo_AutomaticallySubmitServiceData: 'Автоматическое представление оперативной документации',
  Cargo_SystemAutomaticExecution: 'Автоматическое выполнение системы',
  Cargo_ServicesNotSubmittedAutomaticallySubmitted: 'Невыполненные операции, операции доставки будут выполняться автоматически (статус бизнеса: текущая операция - > была представлена)',
  Cargo_IdentifyTheSupplier: 'Идентификация поставщиков',
  Cargo_PleaseSet: 'Пожалуйста, установите',
  Cargo_OnlyOneSupplier: 'Один тип может иметь только одного поставщика.',
  Cargo_IdentificationCannotBePerformedTip: 'Не установлен тип идентификации не может быть идентифицирован, есть потребность связаться с клиентской службой;',
  Cargo_TemplateSettings: 'Параметры шаблона',
  Cargo_IdentificationTip1: 'Установите тип поставщика',
  Cargo_ServiceProductID: 'Сервисные продукты ID',
  Cargo_ServiceProductName: 'Название сервисного продукта',
  Cargo_ForceRoutingBooking: 'Обязательное бронирование по маршруту',
  Cargo_UsedAsRoutingProduct: 'Используется ли в качестве линейного продукта',
  Cargo_AirServiceProduct: 'Услуги по авиаперевозкам',
  Cargo_BusinessManager: 'Ответственный по делам',
  Cargo_AirlinePersonSetting: 'Устанавливать, установить руководителя маршрута',
  Cargo_PrePortFreightRateOfficer: 'Главный грузоотправитель в порт',
  Cargo_PersonChargeTrunkLineFreightRates: 'Главный диспетчер магистрали',
  Cargo_PersonChargeLastMileFreightRates: 'Руководитель грузовых перевозок',
  Cargo_NamePersonResponsible: 'Имя начальника',
  Cargo_ResponsiblePortDeparture: 'Ответственный за порт отправки',
  Cargo_OnlyOneFullPerson: 'Есть только Один человек, отвечающий за полную свободу порта',
  Cargo_OnlyOneFullPersonSameType: 'У одного и того же лица, ответственного за унифицированный тип, может быть только Один',
  Cargo_AdministrativeDivision: 'Административное деление',
  Cargo_StreetTownship: 'Улица/городской уровень',
  Cargo_PostalCodeManagement: 'Управление почтовым редактором',
  Cargo_UsPostalCode: 'Американский почтовый индекс',
  Cargo_preportAudit: 'Предварительное рассмотрение порта',
  Cargo_TrunkLineAudit: 'Проверка магистрали',
  Cargo_TailEndAudit: 'Проверка хвостовой части',
  Cargo_preportAuditStatus: 'Предварительное рассмотрение порта',
  Cargo_TrunkLineAuditStatus: 'Статус проверки магистрали',
  Cargo_TailEndAuditStatus: 'Статус проверки хвостовой части',
  Cargo_NoReviewRequired: 'Нет необходимости в проверке.',
  Cargo_HasBeenReviewed: 'Уже проверено',
  Cargo_NoAuthorityReview: 'Нет допуска для проверки',
  Cargo_AddBasicAirFreightServiceProduct: 'Добавление базовых услуг по авиаперевозкам',
  Cargo_DeleteServiceProductWarning: 'Вы удалите информацию о 【{0}】 сервисных продуктах, пожалуйста, будьте осторожны.',
  Cargo_RouteProductName: 'Название продукта маршрута',
  Cargo_ServiceProduct: 'Услуги',
  Cargo_PurchaseMethod: 'Порядок закупок',
  Cargo_Airline2: 'Отдел воздушных перевозок',
  Cargo_PurchaseSource: 'Источники закупок',
  Cargo_OriginPort: 'Порт отправления',
  Cargo_RouteOfficer: 'Маршрутчик',
  Cargo_IsEffective: 'Вступление в силу',
  Cargo_BaseWeight: 'Базовый вес',
  Cargo_LimitWeight: 'Ограниченный вес',
  Cargo_SellableSpace: 'Продаваемые места',
  Cargo_LengthLimit: 'Ограничение длины',
  Cargo_HeightLimit: 'Ограничение высоты',
  Cargo_TheoreticalVolume: 'Теоретический объем',
  Cargo_SellableVolume: 'Продаваемый объем',
  Cargo_Box: 'Ящик',
  Cargo_PayingParty: 'Платный объект',
  Cargo_UnitPrice_TotalPrice: 'Удельная / общая стоимость',
  Cargo_RouteProductCode: 'Маршрутный код',
  Cargo_BoardCount: 'Количество пластин',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: 'Дата вступления в силу должна быть меньше даты истечения срока действия',
  Cargo_NotAssemblyQuantity: 'Количество упакованных мест',
  Cargo_NotAssemblyGrossWeight: 'Масса брутто в сборке',
  Cargo_NotAssemblyVolume: 'Объем сборки',
  Cargo_NotAssemblyChargeableWeight: 'Сборочный вес',
  Cargo_Density_Weight: 'Плотность / качество',
  Cargo_PreWarehouseStatus: 'Предскладное состояние',
  Cargo_DeliveryStation2: 'станция доставки',
  Cargo_DeliveryStatus: 'Состояние поставки',
  Cargo_PreAssemblyPlanProductionPlan: 'План предварительной сборки - план производства',
  Cargo_ShipmentOrder: 'Приказ о выходе',
  Cargo_GenerateAssemblyPlan: 'Создание плана сборки',
  Cargo_AssemblyPlanNumber: 'План сборки',
  Cargo_AssemblyPlanStatus: 'Запланированное состояние сборки',
  Cargo_AssemblyItemCount: 'Количество упакованных единиц',
  Cargo_AssemblyGrossWeight: 'Вес брутто в сборке',
  Cargo_AssemblyVolume: 'Объем сборки',
  Cargo_AssemblyChargeableWeight: 'Вес сборки',
  Cargo_ContainerGroup: 'Кластеры',
  Cargo_LoadingPool: 'распределительный бассейн',
  Cargo_MergeGroup: 'Объединить группы',
  Cargo_DeleteGroup: 'Удалить группу',
  Cargo_AddToPlan: 'Присоединение к программе',
  Cargo_AssemblyPlan: 'План сборки',
  Cargo_PlanIssued: 'Планируется выпустить',
  Cargo_CancelPlanIssued: 'Отменить план',
  Cargo_PlanPrint: 'Планируемая печать',
  Cargo_AssemblyCompleted: 'Сборка завершена',
  Cargo_CancelAssemblyCompleted: 'Отмена сборки завершена',
  Cargo_ConfirmCompleted: 'Подтвердить завершение',
  Cargo_CancelConfirmCompleted: 'Отмена подтверждения завершения',
  Cargo_ImportAssemblyPlan: 'Импорт плана сборки',
  Cargo_UnifiedError: '【{0}】 Несоответствие, продолжается ли?',
  Cargo_JoinExistingAssemblyPlan: 'Включены ли они в существующий план сборки?',
  Cargo_ExistingPlanIssued: 'Существует выпущенный план сборки, пока не будет слияния, пожалуйста, отмените выпуск после повторного тестирования.',
  Cargo_CostAllocated: 'Расходы были распределены, и пользователям предлагается самостоятельно удалить уже распределенные расходы, продолжается ли?',
  Cargo_MaintainAtLeastOneGroup: 'Поддерживайте хотя бы одну сборку.',
  Cargo_FieldsCannotBeEmpty: '【шт. / брутто / тело / метр】Должно быть больше 0, проверьте',
  Cargo_AssemblyPlanExceedsContainerGroup: '【План сборки - группировка сборщиков】Количество больше【Маршрутная продукция - рейс - ящик】Количество, продолжение？',
  Cargo_PlanIssuedTip: 'План сборки был выпущен, не работает, пожалуйста, отмените выпуск после повторного тестирования.',
  Cargo_PieceWeightVolumeUnit: 'волосомер',
  Cargo_NotInWarehouse: 'Груз не на складе. Выдать досрочное указание на отгрузку? Нажмите "Подтвердить" для выполнения.',
  Cargo_NotInWarehouse2: 'Груз не на складе. Отозвать досрочное указание на отгрузку? Нажмите "Подтвердить" для отмены.',
  Cargo_OutboundInstructionIssued: 'Указание на отгрузку выдано',
  Cargo_AlreadyOutbound: 'Груз уже отгружен, отмена невозможна.',
  CargoMsg_AIAddressRecognition: 'Искусственное распознавание адресов',
  Cargo_ContainerGroupHasOrder: 'В кластере сборщиков есть заказы, которые запрещено удалять, пожалуйста, переместите заказ и удалите',
  Cargo_QuickSearchCustomPage: 'Быстрый поиск: Название формы',
  Cargo_ApplicationScene: 'Сцена применения',
  Cargo_FormId: 'ID формы',
  Cargo_FormType: 'Тип формы',
  Cargo_AddSelectedElements: 'Добавить выбранные',
  Cargo_ElementsAddedSuccessfully: 'Элементы успешно добавлены',
  Cargo_SelectPagePart: 'Выбрать часть страницы',
  Cargo_AddPagePart: 'Добавить часть страницы',
  Cargo_ChatUser: 'Пользователь',
  Cargo_ChatAI: 'AI Помощник',
  Cargo_ChatInputPlaceholder: 'Отправить сообщение... (Enter для новой строки, Ctrl+Enter для отправки)',
  Cargo_ChatThinking: 'Думаю...',
  Cargo_ChatCopySuccess: 'Скопировано в буфер обмена',
  Cargo_ChatConfirmTitle: 'Подсказка',
  Cargo_ChatDeleteConfirm: 'Вы уверены, что хотите удалить это сообщение?',
  Cargo_ChatCopyFailed: 'Ошибка копирования',
  Cargo_ChatDeleteSuccess: 'Удалено',
  Cargo_ChatNoResponse: 'Нет ответа',
  Cargo_ChatConnectionError: 'Извините, произошла ошибка соединения. Пожалуйста, попробуйте снова.',
  Cargo_Debug: 'Отладка',
  Cargo_DebugAndConfig: 'Отладка и настройки',
  Cargo_EnterValue: 'Введите значение',
  Cargo_CreateForm: 'Создать форму',
  Cargo_ConfigForm: 'Настроить форму',
  Cargo_Branch: 'Компания приложения',
  Cargo_FormNamePlaceholder: 'Введите название формы',
  Cargo_BranchPlaceholder: 'Выберите компанию приложения',
  Cargo_ApplicationScenePlaceholder: 'Выберите сцену приложения',
  Cargo_BusinessTypePlaceholder: 'Выберите тип бизнеса',
  Cargo_RemarksPlaceholder: 'Введите примечания',
  Cargo_APIApplication: 'API приложение',
  Cargo_BusinessSingleMode: 'Режим одиночного бизнеса',
  Cargo_BusinessBatchMode: 'Режим пакетного бизнеса',
  Cargo_ConfirmMessageNotEditableAfterCreate: 'Нельзя изменить после создания, подтвердить переход к следующему шагу?',
  Cargo_Tip2: 'Подсказка',
  Cargo_SelectDeleteTip4: 'Пожалуйста, выберите данные, которые вы хотите удалить',
  Cargo_SelectDeleteTip5: 'Вы уверены, что хотите удалить выбранные данные? Это действие нельзя отменить.',
  Cargo_FormDisableWarning: 'Отключенные формы будут недоступны, пожалуйста, своевременно настройте модули, использующие эту форму!',
  Cargo_ElementSettings: 'Настройки элемента',
  Cargo_ElementRules: 'Правила элемента',
  Cargo_IsReadOnly: 'Только для чтения',
  Cargo_IsRequired: 'Обязательное поле',
  Cargo_FormInfo: 'Информация о форме',
  Cargo_InputOutputConfig: 'Настройки ввода/вывода',
  Cargo_FormInputConfigDescription: 'Загрузка формы (Параметры запроса): При загрузке формы последовательно запрашивать интерфейсы для обработки полей формы',
  Cargo_FormInputAPI: 'Входной интерфейс',
  Cargo_FormInputAPIPlaceholder: 'Пожалуйста, введите список входных интерфейсов',
  Cargo_FormOutputConfigDescription: 'Отправка формы (Вызов функции): При отправке формы последовательно запрашивать интерфейсы приложения',
  Cargo_FormOutputAPI: 'Выходной интерфейс',
  Cargo_FormOutputAPIPlaceholder: 'Пожалуйста, введите список выходных интерфейсов',
  Cargo_SaveDraft: 'Сохранить черновик',
  Cargo_PublishForm: 'Опубликовать форму',
  Cargo_LastOperateTime: 'Время последней операции',
  Cargo_Draft: 'Черновик',
  Cargo_Published: 'Опубликовано',
  Cargo_ConfigPagePart: 'Настройка области',
  Cargo_ConfigName: 'Название конфигурации',
  Cargo_PagePartFunction: 'Функция области',
  Cargo_PleaseSelectFunction: 'Выберите функцию',
  Cargo_BusinessElements: 'Бизнес-поля',
  Cargo_ConsigneeShipperAndNotifyInfo: 'Информация о грузополучателе/отправителе/уведомлении',
  Cargo_AccountsReceivable: 'Дебиторская задолженность',
  Cargo_AccountsPayable: 'Кредиторская задолженность',
  Cargo_UploadFile: 'Загрузить файл',
  Cargo_UploadInstruction: 'Инструкция по загрузке',
  Cargo_InstructionParameter: 'Параметр инструкции',
  Cargo_FormPreviewInListViewIsReadOnly: 'Для редактирования отладочных данных, пожалуйста, нажмите "Редактировать", чтобы перейти на страницу сведений.',
  Cargo_BPM: 'BPM',
  Cargo_OCR: 'OCR',
  Cargo_PublishSuccess: 'Успешно опубликовано',
  Cargo_PublishFailed: 'Ошибка публикации',
  Cargo_ValueRequired: 'Это поле не может быть пустым',
  Cargo_FixFormErrors: 'Пожалуйста, проверьте правильность заполнения формы',
  Cargo_ValidationFailed: 'Ошибка валидации, проверьте правильность введенных значений',
  Cargo_ToggleStatusFailed: 'Не удалось изменить статус формы',
  Cargo_CopySucceed: 'Копирование успешно',
  Cargo_CopyFailed: 'Ошибка копирования',
  Cargo_CopyFormConfirm: 'Вы уверены, что хотите скопировать эту форму и все её блоки, макеты элементов и другие настройки?',
  Cargo_CannotDeleteEnabledForm: 'Невозможно удалить активную форму, сначала отключите её',
  Cargo_GetFormConfigFailed: 'Не удалось получить конфигурацию формы',
  Cargo_ConfirmChangeBlockType: 'Изменить функцию области, хотите ли вы очистить содержимое конфигурации исходной области?',
  Cargo_CopyOne: 'Пожалуйста, выберите одну запись для копирования!',
  Cargo_ConfirmDeleteBlock: 'Вы уверены, что хотите удалить эту область и снять выделение с выбранных полей?',
  Carog_ConfirmSaveBeforeGoBack: 'Хотите сохранить текущую конфигурацию?',
  Cargo_FormValidation: 'Проверка формы',
  Cargo_Problem: 'Проблема',
  Cargo_Description: 'Описание',
  Cargo_ValidationSucceed: 'Проверка успешна',
  Cargo_NoChanges: 'Нет изменений данных',
  Cargo_JobUuidRequired: 'UUID бизнес-формы обязателен',
  Cargo_LoadFormDataFailed: 'Не удалось загрузить данные формы',
  Cargo_SyncRuleExecutionFailed: 'Ошибка выполнения правил связывания данных',
  Cargo_PreviewRevision: 'Предпросмотр этой версии',
  Cargo_Current: 'Текущий',
  Cargo_FormPreviewInRevisionViewIsReadOnly: 'Текущий предпросмотр является исторической версией, доступен только режим чтения.',
  Cargo_VisualizationView: 'Визуальный макет',
  Cargo_CodeView: 'Просмотр кода',
  Cargo_ChatView: 'AI-ассистент',
  Cargo_RestoreRevision: 'Восстановить эту версию',
  Cargo_RestoreSucceed: 'Восстановление успешно',
  Cargo_RestoreFailed: 'Ошибка восстановления',
  Cargo_ConfirmRestoreRevision: 'Вы уверены, что хотите восстановить эту версию?',
  Cargo_NeedAtLeastOnePagePart: 'Должна остаться хотя бы одна информационная область',
  Cargo_DataFill: 'Заполнение данных',
  Cargo_CSNInfo_BASIC: 'Информация CSN (Основная вкладка)',
  Cargo_CSNInfo_MBL: 'Информация CSN (MBL)',
  Cargo_CSNInfo_HBL: 'Информация CSN (HBL)',
  Cargo_CSNInfo_HBL2: 'Информация CSN (Раздельный коносамент)',
  Cargo_ReadOnly: 'Только для чтения',
  Cargo_Notify: 'Уведомляющая сторона',
  Cargo_AlsoNotify: 'Вторая уведомляющая сторона',
  Cargo_AgentParty: 'Информация агента',
  Cargo_ShippingExchangeRateBatchConfig: 'Конфигурация партии тарифов на морские перевозки',
  Cargo_DeclarationScope: 'Объем декларирования',
  Cargo_DeclarationBusiness: 'Декларируемый бизнес',
  Cargo_DeclarationFee: 'Декларируемый сбор',
  Cargo_SetBranch: 'Настроить филиал',
  Cargo_FollowHQ: 'Следовать HQ',
  Cargo_FreightRate: 'Фрахтовая ставка',
  Cargo_ContainerLock: 'Плата за замок контейнера',
  Cargo_OtherAdditionalCharges: 'Другие дополнительные сборы',
  Cargo_UpperLimit: 'Верхний предел',
  Cargo_LowerLimit: 'Нижний предел',
  Cargo_AlertNotification: 'Уведомление о тревоге',
  Cargo_RPASettings: 'Настройки RPA',
  Cargo_UnregisteredShippingRate: 'Когда созданный бизнес-тариф не задекларирован в морской бирже',
  Cargo_ExceedMaintainedLimit: 'Когда созданная бизнес-ставка превышает установленный лимит',
  Cargo_RPAPaused: 'Когда RPA приостановлен',
  Cargo_RPACompleted: 'Когда RPA завершен',
  Cargo_ProhibitSaving: 'Запретить сохранение',
  Cargo_RecordOnly: 'Только запись без оповещения',
  Cargo_NoRecordNoAlert: 'Нет записи, нет оповещения',
  Cargo_NotifyRoleByEmail: 'Уведомление по электронной почте указанной роли',
  Cargo_NotifyPersonByEmail: 'Уведомление по электронной почте указанного лица',
  Cargo_NotifyPositionByEmail: 'Уведомление по электронной почте указанной должности',
  Cargo_RPAService: 'Сервис RPA',
  Cargo_EnableRPAService: 'Включить сервис RPA',
  Cargo_ShippingExchangeAccount: 'Аккаунт морской биржи',
  Cargo_ShippingExchangePassword: 'Пароль морской биржи',
  Cargo_RPASubmission: 'Отправка данных через RPA на {0}',
  Cargo_WarningReason: 'Причина предупреждения',
  Cargo_WarningMessage: 'Предупреждающее сообщение',
  Cargo_UnregisteredRateSaveError: 'Наша компания активировала функцию публикации тарифов на морской бирже. Текущий бизнес-тариф не задекларирован на бирже, поэтому его нельзя сохранить. Если вам нужно ввести бизнес, обратитесь к ответственному за регистрацию: <br/>{0}',
  Cargo_UnregisteredRateWarning: 'Наша компания активировала функцию публикации тарифов на морской бирже. Текущий бизнес-тариф не задекларирован на бирже. Во избежание нарушений, немедленно свяжитесь с ответственным за регистрацию: <br/>{0}',
  Cargo_ExceedDeclaredLimitSaveError: 'Наша компания активировала функцию публикации тарифов на морской бирже. Текущий бизнес-тариф превышает задекларированный лимит и поэтому не может быть сохранён. Если вам нужно ввести бизнес, обратитесь к ответственному за регистрацию: <br/>{0}',
  Cargo_ExceedDeclaredLimitWarning: 'Наша компания активировала функцию публикации тарифов на морской бирже. Текущий бизнес-тариф превышает задекларированный лимит. Во избежание нарушений, немедленно свяжитесь с ответственным за регистрацию: <br/>{0}',
  Cargo_GoToProcess: 'Перейти к обработке',
  Cargo_GoToDeclare: 'Перейти к декларации',
  Cargo_CheckWarningToProcess: 'Пожалуйста, отметьте предупреждающую информацию, требующую обработки',
  Cargo_SelectedWarningMarkedProcessed: 'Выбранная предупреждающая информация отмечена как «Обработано»',
  Cargo_SelectInfoToDeclare: 'Пожалуйста, выберите информацию, подлежащую декларации',
  Cargo_SureSaveUnControlledProduct: 'Подтвердить сохранение? После сохранения бизнес будет заблокирован, больше не может работать и не может быть отозван!',
  Cargo_ScmNeedAllowProduct: 'Для экспорта контролируемой продукции требуется предварительное разрешение. За дополнительной информацией обращайтесь в двигательную камеру SCM.',
  Cargo_SureSave: 'Подтвердить сохранение',
  Cargo_DataLoadingPleaseWait: 'Загрузка данных, пожалуйста, подождите.',
  Cargo_RuleID: 'ID правила',
  Cargo_ValidationRule: 'Правило валидации',
  Cargo_TriggerElement: 'Поле триггера',
  Cargo_RelatedElements: 'Связанные поля',
  Cargo_TriggerCondition: 'Условие триггера',
  Cargo_FunctionCode: 'Код функции',
  Cargo_AddedValidationRules: 'Добавлены следующие правила валидации',
  Cargo_AddedSyncRules: 'Добавлены следующие правила синхронизации',
  Cargo_AddedVisibilityRules: 'Добавлены следующие правила видимости',
  Cargo_NoRuleDetected: 'Извините, не обнаружено действительных функций проверки данных или редактирования связей данных. Попробуйте изменить запрос и повторить попытку.',
  Cargo_ConnectionError: 'Извините, возникла проблема с подключением. Пожалуйста, повторите попытку.',
  Cargo_OperationArea: 'Область операций',
  Cargo_BlDataNotFound: 'Данные коносамента не найдены',
  Cargo_SelectBlDocument: 'Пожалуйста, выберите документ коносамента',
  Cargo_SelectHblDocument: 'Пожалуйста, выберите документ HBL',
  Cargo_SelectHawb2Document: 'Пожалуйста, выберите документ формального разделения',
  Cargo_AIChangRulesNumber: 'Успешно изменено правил: {0}',
  Cargo_AIDeleteRulesNumber: 'Успешно удалено правил: {0}',
  Cargo_AIAddRulesNumber: 'Успешно добавлено правил: {0}',
  Cargo_UnknownIntent: 'Ваш запрос не содержит конкретных правил',
  Cargo_AIDeleteUnexistRulesNumber: 'Правило, которое нужно удалить, не существует',
  Cargo_HSCode: 'Код HS',
  Cargo_FilingBatchNo: 'Регистрационная партия',
  Cargo_FilingState: 'Положение партии',
  Cargo_SubmitDate: 'Дата представления',
  Cargo_DeclareFinal: 'Количество заявленных / окончательных строк',
  Cargo_FiletotalRecordPass: 'Общий объем документации / количество хранимых документов / число проверенных документов',
  Cargo_StartRPA: 'Запустить RPA',
  Cargo_SuspendRPA: 'Приостановить RPA',
  Cargo_SuspendRPA2: 'Приостановить',
  Cargo_RpaState: 'Состояние RPA',
  Cargo_ImportFinalResult: 'Импорт конечного результата',
  Cargo_ManuallyExportFile: 'Экспорт файлов вручную',
  Cargo_FilingBatchInfo: 'Thông tin lô',
  Cargo_FilingDate: 'Ngày nộp hồ sơ',
  Cargo_OpenPriceInfo: 'Khai báo giá vận chuyển',
  Cargo_Past6MonthPort: 'Cảng để có được gần 6 tháng kinh doanh',
  Cargo_Past1MonthPrice: 'Nhận giá vận chuyển gần 1 tháng',
  Cargo_CompanyCode2: 'Mã công ty',
  Cargo_Lane: 'Tên đường bay',
  Cargo_DepartureDay: 'Tuần làm việc',
  Cargo_CargoType2: 'Loại hàng hóa',
  Cargo_EqSize: 'Kích thước',
  Cargo_Cost2: 'Giá vận chuyển',
  Cargo_CostRange: 'Тарифный интервал',
  Cargo_CostMin: 'Giới hạn vận chuyển thấp hơn',
  Cargo_CostMax: 'Giới hạn vận chuyển',
  Cargo_EqDeduct: 'Hộp khóa',
  Cargo_BatchReturnPreApproval: 'Массовый возврат к предварительному согласованию/удалённому бронированию',
  Cargo_ReturnPreApprovalRemoteBooking: 'Возврат на предварительное согласование/Удалённое бронирование',
  Cargo_ConfirmReturnResubmit: 'Подтвердить возврат к предварительному согласованию бронирования/удалённому бронированию для повторной отправки?',
  Cargo_ReturnModuleSelection: 'Выбор модуля возврата',
  Cargo_ReturnModule: 'Модуль возврата',
  Cargo_ReturnReason: 'Причина возврата',
  Cargo_MasterTicketRelationError: 'Существует связь мастер-билета, возврат невозможен',
  Cargo_CostStatusReturnError: 'Стоимость уже {0}, возврат невозможен',
  Cargo_RouteManagerEmptyError: 'Бизнес-номер: {0} Ответственный за маршрут отсутствует, возврат невозможен',
  Cargo_FOBReturnRestriction: 'FOB-бизнес можно вернуть только на удалённое бронирование',
  Cargo_SelectedBusiness: 'Выбранный бизнес',
  Cargo_RemoteBooking: 'Удалённое бронирование',
  Cargo_RemoteBookingExportOnly: 'Удалённое бронирование поддерживает возврат только экспортных операций',
  Cargo_ReturnResult: 'Успешно возвращено: {0}, Не удалось: {1}',
  Cargo_MasterTicketRelationAlert: '[{0}] Существует связь мастер-билета',
  Cargo_NotFromRemoteBookingError: '[{0}] Заказы не из удалённого бронирования не могут быть возвращены',
  Cargo_NotFromPreApprovalError: '[{0}] Заказы не из предварительного согласования бронирования не могут быть возвращены',
  Cargo_CostStatusAlert: '[{0}] Стоимость уже {1}',
  Cargo_ReturnCurrentOperationOnly: 'Поддерживает возврат только текущих операционных бизнес-процессов',
  Cargo_MixedBusinessTypeError: 'Выбранные бизнес-процессы содержат FOB и не-FOB типы, невозможен совместный возврат',
  Cargo_CollabBatchRejectError: 'Включая {0} совместный бизнес, пакетный отказ не поддерживается',
  Cargo_OtherSurcharge: 'Phụ phí khác',
  Cargo_MoreDetails: 'Подробнее',
  Cargo_SureToStartRPA: '[{0}] После запуска RPA система автоматически передает данные на веб - сайт Авиационной биржи, перед запуском убедитесь, что данные заполнены полностью.',
  Cargo_SureToSuspendRPA: '[{0}] После приостановки RPA, при повторном запуске, система будет состояние данных на судоходной бирже, если не подтверждена загрузка, система воссоздаст график и загрузит его, если нет серьезных проблем, постарайтесь не приостанавливать RPA.',
  Cargo_SureToDeleteOpenPrice: 'Пожалуйста, убедитесь, что данные партии [{0}] были удалены?',
  Cargo_SureToImportFinalResult: 'Ручной импорт конечного результата означает подтверждение того, что партия завершена и RPA больше не будет выполняться.',
  Cargo_SureToExportFile: 'Пожалуйста, подтвердите, экспортированы ли данные партии [{0}]?',
  FileBeLargerThan10MB: 'Размер файла не должен превышать 10 МБ.',
  FileBeLargerThan5MB: 'Размер файла не должен превышать 5 МБ.',
  Cargo_DeclareFile: 'Объявленные документы',
  Cargo_ImportFinalFile: 'Конечный результат импорта',
  Cargo_FinalPriceInfo: 'Окончательный тариф',
  Cargo_DeclareNumLabel: 'Общая сумма тарифа: {0}',
  Cargo_DeclareFinalLabel: 'Количество заявленных / окончательных строк: {0}',
  Cargo_QuerySuccess: 'Получение данных успешно',
  ChargeHasUpdate: 'Стоимость была изменена {0} в {1}. Пожалуйста, проверьте данные заново и выполните операцию снова!',
  HasDeletedForDeleteJob: 'Выбранный в данный момент бизнес был удален!',
  HasSlaveJobForDeleteJob: '[{0}]Сначала удалите чек!',
  HasChargeForDeleteJob: '[{0}]Расходы уже внесены!',
  HasMergeForDeleteJob: '[{0}]Заказы уже объединены!',
  Cargo_ArCustomerPaidOff: 'Статус списания удельных расходов',
  Cargo_ContainsAdvancePayment: 'Содержит ли авансовый платеж',
  Cargo_JdySendStatus: 'Статус отправки JianDaoYun',
  Cargo_JdySendTime: 'Время отправки JianDaoYun',
  Cargo_DetailsLockedStatus: 'Статус блокировки деталей груза',
  Cargo_InterestAmountCurrency: 'Проценты сверх установленного срока',
  Cargo_CheckRuleResult: 'Результаты проверки',
  DataHasModified: 'Данные были изменены пользователем [{0}] в {1}. Пожалуйста, обновите!',
  Cargo_CheckNeedSynccloud: 'Пожалуйста, выберите счет облачной платформы для синхронизации',
  Cargo_CheckJingdiesynccloud: 'Только иностранные счета и счета на взаиморасчеты можно отправить в Kingdee',
  DisplayReceiptsOnly: 'Показывать только чеки',
  AssignedWorkResponsibleForNode: 'Установленная должность (в соответствии с ответственностью за работу на узле установки должности)',
  Cargo_CheckZySave: 'Просьба подтвердить, относятся ли товары, указанные в заказе, к Закону Китайской Народной Республики об экспортном контроле, Положениям Китайской Народной Республики о контроле за экспортом товаров двойного назначения и Списку контроля за экспортом товаров двойного назначения Китайской Народной Республики. В случае положительного ответа клиенту предлагается представить & quot; Лицензию на экспорт товаров двойного назначения & quot; в качестве сопроводительного материала к экспортной декларации. Поиск товаров в заказах можно осуществлять с помощью наименований товаров и HSCODE, а поиск по базе данных осуществляется на следующих веб - страницах:',
  Cargo_HasVerified: 'Проверено',
  Cargo_ContainSensitiveWord: 'Содержит ли он чувствительные слова',
  Cargo_VoiceRecording: 'Запись... осталось {0} секунд',
  Cargo_VoiceRecordingInput: 'Запись для распознавания речи, пожалуйста, говорите...',
  Cargo_VoiceRecognizing: 'Распознавание...',
  Cargo_VoiceStopRecording: 'Остановить запись',
  Cargo_VoiceStartRecording: 'Начать запись',
  Cargo_VoiceNotInitialized: 'Функция распознавания речи не инициализирована',
  Cargo_VoiceStartRecordingTip: 'Начать запись, пожалуйста, говорите... (максимум 60 секунд)',
  Cargo_VoiceRecordingEnd: 'Запись завершена',
  Cargo_VoiceRecognitionError: 'Ошибка распознавания речи',
  Cargo_VoiceTimeLimitReached: 'Достигнут лимит времени записи 60 секунд, автоматически остановлено',
  Cargo_VoiceBrowserNotSupported: 'Текущий браузер не поддерживает распознавание речи',
  Cargo_JobsSavedSuccessfully: '{0} задач успешно сохранено',
  Cargo_JobsFailedToSave: '{0} задач не удалось сохранить',
  Cargo_BatchSaveFailed: 'Ошибка пакетного сохранения',
  Cargo_BatchFill: 'Массовое заполнение',
  Cargo_PleaseAddGoods: '',
  confirmLock: '',
  confirmUnLock: '',
  Cargo_PleaseselectedGoods: '',
  Cargo_PleaseAddCheck: '',
  PriorityDisplay: 'Отображение приоритета',
  WhenTheNodeAllDisplayed: 'Если для узла не задан приоритет, будут отображаться все данные узлов!',
  DefaultDisplay: 'Отображение по умолчанию:',
  PrioritizationSettings: 'Настройки приоритета',
  Cargo_OperationProvince: 'Операционная компания по месту нахождения провинции',
  Cargo_SalesProvince: 'Провинция сбытовой компании',
  Cargo_PushTime: 'Время нажатия',
  CargoMsg_CheckSecondCustomJobType: 'Когда пользовательский тип бизнеса является вторичным, вышестоящий пользовательский тип бизнеса не может быть пустым!！',
  Cargo_EnterpriseWechatApprovalPayCompany: 'Платящая компания (WeCom)',
  // Заголовки кастомных должностей списка бронирований морского экспорта (по бизнес-роли)
  Cargo_UserDefinedRoleHeader1: 'Сотрудник по бронированию боковой линии',
  Cargo_UserDefinedRoleHeader2: 'Сотрудник по бронированию магистрали',
  Cargo_UserDefinedRoleHeader3: 'Сотрудник по страхованию',
  Cargo_UserDefinedRoleHeader4: 'Сотрудник зарубежного сопровождения',
  Cargo_UserDefinedRoleHeader5: 'Помощник по обслуживанию клиентов'
}
